
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $52cb222a63b7ab42$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1LzKV\",\"index.330f1561.js\",\"hy3rd\",\"tileWorker.ccdb1e17.js\"]"));

"use strict";
function $9a505479d4caa5b0$export$2060d2db72cce88f(a, b) {
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a10 = a[3];
    var a11 = a[4];
    var a12 = a[5];
    var a20 = a[6];
    var a21 = a[7];
    var a22 = a[8];
    var b00 = b[0];
    var b01 = b[1];
    var b02 = b[2];
    var b10 = b[3];
    var b11 = b[4];
    var b12 = b[5];
    var b20 = b[6];
    var b21 = b[7];
    var b22 = b[8];
    return [
        b00 * a00 + b01 * a10 + b02 * a20,
        b00 * a01 + b01 * a11 + b02 * a21,
        b00 * a02 + b01 * a12 + b02 * a22,
        b10 * a00 + b11 * a10 + b12 * a20,
        b10 * a01 + b11 * a11 + b12 * a21,
        b10 * a02 + b11 * a12 + b12 * a22,
        b20 * a00 + b21 * a10 + b22 * a20,
        b20 * a01 + b21 * a11 + b22 * a21,
        b20 * a02 + b21 * a12 + b22 * a22
    ];
}
function $9a505479d4caa5b0$export$f0954fd7d5368655() {
    return [
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
    ];
}
function $9a505479d4caa5b0$export$b74061472fe7c07(width, height) {
    // Note: This matrix flips the Y axis so 0 is at the top.
    return [
        2 / width,
        0,
        0,
        0,
        -2 / height,
        0,
        -1,
        1,
        1
    ];
}
function $9a505479d4caa5b0$export$ab03b6763ed7026f(m, width, height) {
    return $9a505479d4caa5b0$export$2060d2db72cce88f(m, $9a505479d4caa5b0$export$b74061472fe7c07(width, height));
}
function $9a505479d4caa5b0$export$a984e488de492859(tx, ty) {
    return [
        1,
        0,
        0,
        0,
        1,
        0,
        tx,
        ty,
        1
    ];
}
function $9a505479d4caa5b0$export$d73ee8ef04f5226a(m, tx, ty) {
    return $9a505479d4caa5b0$export$2060d2db72cce88f(m, $9a505479d4caa5b0$export$a984e488de492859(tx, ty));
}
function $9a505479d4caa5b0$export$2e1e9e0c5142c9d7(angleInRadians) {
    var c = Math.cos(angleInRadians);
    var s = Math.sin(angleInRadians);
    return [
        c,
        -s,
        0,
        s,
        c,
        0,
        0,
        0,
        1
    ];
}
function $9a505479d4caa5b0$export$bb628a54ab399bc9(m, angleInRadians) {
    return $9a505479d4caa5b0$export$2060d2db72cce88f(m, $9a505479d4caa5b0$export$2e1e9e0c5142c9d7(angleInRadians));
}
function $9a505479d4caa5b0$export$89390739e80eec4a(sx, sy) {
    return [
        sx,
        0,
        0,
        0,
        sy,
        0,
        0,
        0,
        1
    ];
}
function $9a505479d4caa5b0$export$dcdf75081b88279d(m, sx, sy) {
    return $9a505479d4caa5b0$export$2060d2db72cce88f(m, $9a505479d4caa5b0$export$89390739e80eec4a(sx, sy));
}
function $9a505479d4caa5b0$export$94132a0e348806d4(x1, y1, x2, y2) {
    return x1 * x2 + y1 * y2;
}
function $9a505479d4caa5b0$export$9f17032d917177de(x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return Math.sqrt(dx * dx + dy * dy);
}
function $9a505479d4caa5b0$export$a3295358bff77e(x, y) {
    var l = $9a505479d4caa5b0$export$9f17032d917177de(0, 0, x, y);
    if (l > 0.00001) return [
        x / l,
        y / l
    ];
    else return [
        0,
        0
    ];
}
function $9a505479d4caa5b0$export$9debe8cffacea23(ix, iy, nx, ny) {
    // I - 2.0 * dot(N, I) * N.
    var d = $9a505479d4caa5b0$export$94132a0e348806d4(nx, ny, ix, iy);
    return [
        ix - 2 * d * nx,
        iy - 2 * d * ny
    ];
}
function $9a505479d4caa5b0$export$54390e3b44c4a9cb(r) {
    return r * 180 / Math.PI;
}
function $9a505479d4caa5b0$export$e6bfdeff8bfc94f9(d) {
    return d * Math.PI / 180;
}
function $9a505479d4caa5b0$export$c7edbbc40e2d50c3(m, v) {
    var v0 = v[0];
    var v1 = v[1];
    var d = v0 * m[2] + v1 * m[5] + m[8];
    return [
        (v0 * m[0] + v1 * m[3] + m[6]) / d,
        (v0 * m[1] + v1 * m[4] + m[7]) / d
    ];
}
function $9a505479d4caa5b0$export$70ae2c07e401031b(m) {
    var t00 = m[4] * m[8] - m[5] * m[7];
    var t10 = m[1] * m[8] - m[2] * m[7];
    var t20 = m[1] * m[5] - m[2] * m[4];
    var d = 1.0 / (m[0] * t00 - m[3] * t10 + m[6] * t20);
    return [
        d * t00,
        -d * t10,
        d * t20,
        -d * (m[3] * m[8] - m[5] * m[6]),
        d * (m[0] * m[8] - m[2] * m[6]),
        -d * (m[0] * m[5] - m[2] * m[3]),
        d * (m[3] * m[7] - m[4] * m[6]),
        -d * (m[0] * m[7] - m[1] * m[6]),
        d * (m[0] * m[4] - m[1] * m[3])
    ];
}
var $9a505479d4caa5b0$export$2e2bcd8739ae039 = {
    degToRad: $9a505479d4caa5b0$export$e6bfdeff8bfc94f9,
    distance: $9a505479d4caa5b0$export$9f17032d917177de,
    dot: $9a505479d4caa5b0$export$94132a0e348806d4,
    identity: $9a505479d4caa5b0$export$f0954fd7d5368655,
    inverse: $9a505479d4caa5b0$export$70ae2c07e401031b,
    multiply: $9a505479d4caa5b0$export$2060d2db72cce88f,
    normalize: $9a505479d4caa5b0$export$a3295358bff77e,
    projection: $9a505479d4caa5b0$export$b74061472fe7c07,
    radToDeg: $9a505479d4caa5b0$export$54390e3b44c4a9cb,
    reflect: $9a505479d4caa5b0$export$9debe8cffacea23,
    rotation: $9a505479d4caa5b0$export$2e1e9e0c5142c9d7,
    rotate: $9a505479d4caa5b0$export$bb628a54ab399bc9,
    scaling: $9a505479d4caa5b0$export$89390739e80eec4a,
    scale: $9a505479d4caa5b0$export$dcdf75081b88279d,
    transformPoint: $9a505479d4caa5b0$export$c7edbbc40e2d50c3,
    translation: $9a505479d4caa5b0$export$a984e488de492859,
    translate: $9a505479d4caa5b0$export$d73ee8ef04f5226a,
    project: $9a505479d4caa5b0$export$ab03b6763ed7026f
};



class $238457a12dbae9c5$export$79f141de891a5fed {
    // private isTouching: boolean = false;
    // private lastTouchPos: [number, number] | null = null;
    // private lastPinchDist: number | null = null;
    constructor(canvas, minZoom = 0.5, maxZoom = 500){
        this.velocity = [
            0,
            0
        ] // Velocity in world units per second
        ;
        this.animationId = null;
        this.canvas = canvas;
        this.x = -canvas.width / 2;
        this.y = -canvas.height / 2;
        this.zoom = 1;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.viewProjectionMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).identity();
        this.updateViewProjection();
        this.setupTouchHandlers();
    }
    updateViewProjection() {
        const projectionMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).projection(this.canvas.width, this.canvas.height);
        const zoomScale = 1 / this.zoom;
        let cameraMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).identity();
        cameraMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).translate(cameraMat, this.x, this.y);
        cameraMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).scale(cameraMat, zoomScale, zoomScale);
        const viewMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).inverse(cameraMat);
        this.viewProjectionMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).multiply(projectionMat, viewMat);
        return this.viewProjectionMat;
    }
    /**
     * Mouse controls
     */ getClipSpaceMousePosition(e) {
        const rect = this.canvas.getBoundingClientRect();
        const cssX = e.clientX - rect.left;
        const cssY = e.clientY - rect.top;
        return [
            cssX / this.canvas.clientWidth * 2 - 1,
            cssY / this.canvas.clientHeight * -2 + 1
        ];
    }
    onMouseDown(draw) {
        return (e)=>{
            e.preventDefault();
            const startInvViewProjMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).inverse(this.viewProjectionMat);
            const startCamera = {
                x: this.x,
                y: this.y
            };
            const startPos = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(startInvViewProjMat, this.getClipSpaceMousePosition(e));
            const moveCamera = (moveEvent)=>{
                const pos = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(startInvViewProjMat, this.getClipSpaceMousePosition(moveEvent));
                this.x = startCamera.x + startPos[0] - pos[0];
                this.y = startCamera.y + startPos[1] - pos[1];
                this.updateViewProjection();
            // draw();
            };
            const handleMouseUp = ()=>{
                window.removeEventListener("mousemove", moveCamera);
                window.removeEventListener("mouseup", handleMouseUp);
            };
            window.addEventListener("mousemove", moveCamera);
            window.addEventListener("mouseup", handleMouseUp);
        };
    }
    onWheel(draw) {
        return (e)=>{
            e.preventDefault();
            const [clipX, clipY] = this.getClipSpaceMousePosition(e);
            const factor = Math.pow(2, -e.deltaY * 0.01);
            this.adjustZoom(factor, clipX, clipY);
        };
    }
    /**
     * Touch controls
     */ setupTouchHandlers() {
        let startState = null;
        const handleTouchMove = (e)=>{
            e.preventDefault();
            if (!startState) return;
            const currentTime = performance.now();
            if (e.touches.length === 1) {
                const touch = e.touches[0];
                const pos = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(startState.invMat, this.getClipSpaceTouchPosition(touch));
                this.x = startState.camera.x + (startState.pos[0] - pos[0]);
                this.y = startState.camera.y + (startState.pos[1] - pos[1]);
                if (startState.lastTime && startState.lastPos) {
                    const dt = (currentTime - startState.lastTime) / 1000; // time delta in seconds
                    if (dt > 0) {
                        this.velocity[0] = -(pos[0] - startState.lastPos[0]) / dt;
                        this.velocity[1] = -(pos[1] - startState.lastPos[1]) / dt;
                    }
                }
                // update last position and time
                startState.lastPos = pos;
                startState.lastTime = currentTime;
                this.updateViewProjection();
            } else if (e.touches.length === 2) {
                const currentPinchDist = this.getPinchDistance(e);
                const pinchRatio = currentPinchDist / startState.pinchDist;
                const touch1 = e.touches[0];
                const touch2 = e.touches[1];
                const midClipX = (this.getClipSpaceTouchPosition(touch1)[0] + this.getClipSpaceTouchPosition(touch2)[0]) / 2;
                const midClipY = (this.getClipSpaceTouchPosition(touch1)[1] + this.getClipSpaceTouchPosition(touch2)[1]) / 2;
                this.adjustZoom(pinchRatio, midClipX, midClipY);
                startState.pinchDist = currentPinchDist;
            }
        };
        const handleTouchEnd = ()=>{
            window.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("touchend", handleTouchEnd);
            window.removeEventListener("touchcancel", handleTouchEnd);
            if (startState && startState.pos && (this.velocity[0] !== 0 || this.velocity[1] !== 0)) this.startInertiaAnimation();
            startState = null;
        };
        window.addEventListener("touchstart", (e)=>{
            e.preventDefault();
            if (this.animationId) {
                cancelAnimationFrame(this.animationId);
                this.velocity = [
                    0,
                    0
                ];
                this.animationId = null;
            }
            startState = {
                invMat: (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).inverse(this.viewProjectionMat),
                camera: {
                    x: this.x,
                    y: this.y
                },
                lastTime: performance.now()
            };
            if (e.touches.length === 1) {
                const touch = e.touches[0];
                startState.pos = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(startState.invMat, this.getClipSpaceTouchPosition(touch));
                startState.lastPos = startState.pos; // Set initial last position
            } else if (e.touches.length === 2) startState.pinchDist = this.getPinchDistance(e);
            window.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
            window.addEventListener("touchend", handleTouchEnd);
            window.addEventListener("touchcancel", handleTouchEnd);
        }, {
            passive: false
        });
    }
    startInertiaAnimation() {
        const friction = 0.95; // controls deceleration speed (0.9 = faster, 0.99 = slower)
        const minVelocity = 0.01; // stop when velocity drops below this
        const animate = ()=>{
            const dt = 1 / 60; // Fixed time step (assuming 60 FPS)
            this.x += this.velocity[0] * dt;
            this.y += this.velocity[1] * dt;
            this.velocity[0] *= friction;
            this.velocity[1] *= friction;
            this.updateViewProjection();
            // continue animation if velocity is significant
            if (Math.abs(this.velocity[0]) > minVelocity || Math.abs(this.velocity[1]) > minVelocity) this.animationId = requestAnimationFrame(animate);
            else {
                this.velocity = [
                    0,
                    0
                ];
                this.animationId = null;
            }
        };
        this.animationId = requestAnimationFrame(animate);
    }
    getClipSpaceTouchPosition(touch) {
        const rect = this.canvas.getBoundingClientRect();
        const cssX = touch.clientX - rect.left;
        const cssY = touch.clientY - rect.top;
        return [
            cssX / this.canvas.clientWidth * 2 - 1,
            cssY / this.canvas.clientHeight * -2 + 1
        ];
    }
    getPinchDistance(e) {
        if (e.touches.length >= 2) {
            const touch1 = e.touches[0];
            const touch2 = e.touches[1];
            const dx = touch2.clientX - touch1.clientX;
            const dy = touch2.clientY - touch1.clientY;
            return Math.hypot(dx, dy);
        }
        return 0;
    }
    // helper for zoom adjustments (used by both wheel and pinch)
    adjustZoom(factor, clipX, clipY) {
        const invMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).inverse(this.viewProjectionMat);
        const preZoom = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(invMat, [
            clipX,
            clipY
        ]);
        const oldZoom = this.zoom;
        this.zoom *= factor;
        this.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoom));
        const zoomRatio = oldZoom / this.zoom;
        this.x += (preZoom[0] - this.x) * (1 - zoomRatio);
        this.y += (preZoom[1] - this.y) * (1 - zoomRatio);
        this.updateViewProjection();
    }
    getViewProjectionMat() {
        return this.viewProjectionMat;
    }
    // world-space bounds of the visible viewport
    getViewportBounds() {
        const invMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).inverse(this.viewProjectionMat); // Clip to world
        const topLeft = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(invMat, [
            -1,
            1
        ]); // Top-left (-1, 1 in clip space)
        const bottomRight = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(invMat, [
            1,
            -1
        ]); // Bottom-right (1, -1 in clip space)
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
}


/**
 * @module LRUCache
 */ var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


const $90bbefef4dc25bab$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $90bbefef4dc25bab$var$warned = new Set();
/* c8 ignore start */ const $90bbefef4dc25bab$var$PROCESS = typeof $cfae44f0dfdf62c0$exports === 'object' && !!$cfae44f0dfdf62c0$exports ? $cfae44f0dfdf62c0$exports : {};
/* c8 ignore start */ const $90bbefef4dc25bab$var$emitWarning = (msg, type, code, fn)=>{
    typeof $90bbefef4dc25bab$var$PROCESS.emitWarning === 'function' ? $90bbefef4dc25bab$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $90bbefef4dc25bab$var$AC = globalThis.AbortController;
let $90bbefef4dc25bab$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $90bbefef4dc25bab$var$AC === 'undefined') {
    //@ts-ignore
    $90bbefef4dc25bab$var$AS = class AbortSignal {
        onabort;
        _onabort = [];
        reason;
        aborted = false;
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
    };
    //@ts-ignore
    $90bbefef4dc25bab$var$AC = class AbortController {
        constructor(){
            warnACPolyfill();
        }
        signal = new $90bbefef4dc25bab$var$AS();
        abort(reason) {
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            this.signal.onabort?.(reason);
        }
    };
    let printACPolyfillWarning = $90bbefef4dc25bab$var$PROCESS.env?.LRU_CACHE_IGNORE_AC_WARNING !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $90bbefef4dc25bab$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $90bbefef4dc25bab$var$shouldWarn = (code)=>!$90bbefef4dc25bab$var$warned.has(code);
const $90bbefef4dc25bab$var$TYPE = Symbol('type');
const $90bbefef4dc25bab$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $90bbefef4dc25bab$var$getUintArray = (max)=>!$90bbefef4dc25bab$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $90bbefef4dc25bab$var$ZeroArray : null;
/* c8 ignore stop */ class $90bbefef4dc25bab$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $90bbefef4dc25bab$var$Stack {
    heap;
    length;
    // private constructor
    static #constructing = false;
    static create(max) {
        const HeapCls = $90bbefef4dc25bab$var$getUintArray(max);
        if (!HeapCls) return [];
        $90bbefef4dc25bab$var$Stack.#constructing = true;
        const s = new $90bbefef4dc25bab$var$Stack(max, HeapCls);
        $90bbefef4dc25bab$var$Stack.#constructing = false;
        return s;
    }
    constructor(max, HeapCls){
        /* c8 ignore start */ if (!$90bbefef4dc25bab$var$Stack.#constructing) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
class $90bbefef4dc25bab$export$182500e6725aad9a {
    // options that cannot be changed without disaster
    #max;
    #maxSize;
    #dispose;
    #disposeAfter;
    #fetchMethod;
    #memoMethod;
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */ ttl;
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ ttlResolution;
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ ttlAutopurge;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ updateAgeOnGet;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ updateAgeOnHas;
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ allowStale;
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ noDisposeOnSet;
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ noUpdateTTL;
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ maxEntrySize;
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ sizeCalculation;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ noDeleteOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ noDeleteOnStaleGet;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ allowStaleOnFetchAbort;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ allowStaleOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ ignoreFetchAbort;
    // computed properties
    #size;
    #calculatedSize;
    #keyMap;
    #keyList;
    #valList;
    #next;
    #prev;
    #head;
    #tail;
    #free;
    #disposed;
    #sizes;
    #starts;
    #ttls;
    #hasDispose;
    #hasFetchMethod;
    #hasDisposeAfter;
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: c.#starts,
            ttls: c.#ttls,
            sizes: c.#sizes,
            keyMap: c.#keyMap,
            keyList: c.#keyList,
            valList: c.#valList,
            next: c.#next,
            prev: c.#prev,
            get head () {
                return c.#head;
            },
            get tail () {
                return c.#tail;
            },
            free: c.#free,
            // methods
            isBackgroundFetch: (p)=>c.#isBackgroundFetch(p),
            backgroundFetch: (k, index, options, context)=>c.#backgroundFetch(k, index, options, context),
            moveToTail: (index)=>c.#moveToTail(index),
            indexes: (options)=>c.#indexes(options),
            rindexes: (options)=>c.#rindexes(options),
            isStale: (index)=>c.#isStale(index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return this.#max;
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return this.#maxSize;
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return this.#calculatedSize;
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return this.#size;
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return this.#fetchMethod;
    }
    get memoMethod() {
        return this.#memoMethod;
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return this.#dispose;
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return this.#disposeAfter;
    }
    constructor(options){
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$90bbefef4dc25bab$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $90bbefef4dc25bab$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        this.#max = max;
        this.#maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.#maxSize;
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!this.#maxSize && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        this.#memoMethod = memoMethod;
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        this.#fetchMethod = fetchMethod;
        this.#hasFetchMethod = !!fetchMethod;
        this.#keyMap = new Map();
        this.#keyList = new Array(max).fill(undefined);
        this.#valList = new Array(max).fill(undefined);
        this.#next = new UintArray(max);
        this.#prev = new UintArray(max);
        this.#head = 0;
        this.#tail = 0;
        this.#free = $90bbefef4dc25bab$var$Stack.create(max);
        this.#size = 0;
        this.#calculatedSize = 0;
        if (typeof dispose === 'function') this.#dispose = dispose;
        if (typeof disposeAfter === 'function') {
            this.#disposeAfter = disposeAfter;
            this.#disposed = [];
        } else {
            this.#disposeAfter = undefined;
            this.#disposed = undefined;
        }
        this.#hasDispose = !!this.#dispose;
        this.#hasDisposeAfter = !!this.#disposeAfter;
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.#maxSize !== 0) {
                if (!$90bbefef4dc25bab$var$isPosInt(this.#maxSize)) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$90bbefef4dc25bab$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            this.#initializeSizeTracking();
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $90bbefef4dc25bab$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$90bbefef4dc25bab$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            this.#initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.#max === 0 && this.ttl === 0 && this.#maxSize === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !this.#max && !this.#maxSize) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($90bbefef4dc25bab$var$shouldWarn(code)) {
                $90bbefef4dc25bab$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $90bbefef4dc25bab$var$emitWarning(msg, 'UnboundedCacheWarning', code, $90bbefef4dc25bab$export$182500e6725aad9a);
            }
        }
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return this.#keyMap.has(key) ? Infinity : 0;
    }
    #initializeTTLTracking() {
        const ttls = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        const starts = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        this.#ttls = ttls;
        this.#starts = starts;
        this.#setItemTTL = (index, ttl, start = $90bbefef4dc25bab$var$perf.now())=>{
            starts[index] = ttl !== 0 ? start : 0;
            ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(()=>{
                    if (this.#isStale(index)) this.#delete(this.#keyList[index], 'expire');
                }, ttl + 1);
                // unref() not supported on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
        };
        this.#updateItemAge = (index)=>{
            starts[index] = ttls[index] !== 0 ? $90bbefef4dc25bab$var$perf.now() : 0;
        };
        this.#statusTTL = (status, index)=>{
            if (ttls[index]) {
                const ttl = ttls[index];
                const start = starts[index];
                /* c8 ignore next */ if (!ttl || !start) return;
                status.ttl = ttl;
                status.start = start;
                status.now = cachedNow || getNow();
                const age = status.now - start;
                status.remainingTTL = ttl - age;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = ()=>{
            const n = $90bbefef4dc25bab$var$perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
                // not available on all platforms
                /* c8 ignore start */ if (t.unref) t.unref();
            /* c8 ignore stop */ }
            return n;
        };
        this.getRemainingTTL = (key)=>{
            const index = this.#keyMap.get(key);
            if (index === undefined) return 0;
            const ttl = ttls[index];
            const start = starts[index];
            if (!ttl || !start) return Infinity;
            const age = (cachedNow || getNow()) - start;
            return ttl - age;
        };
        this.#isStale = (index)=>{
            const s = starts[index];
            const t = ttls[index];
            return !!t && !!s && (cachedNow || getNow()) - s > t;
        };
    }
    // conditionally set private methods related to TTL
    #updateItemAge = ()=>{};
    #statusTTL = ()=>{};
    #setItemTTL = ()=>{};
    /* c8 ignore stop */ #isStale = ()=>false;
    #initializeSizeTracking() {
        const sizes = new $90bbefef4dc25bab$var$ZeroArray(this.#max);
        this.#calculatedSize = 0;
        this.#sizes = sizes;
        this.#removeItemSize = (index)=>{
            this.#calculatedSize -= sizes[index];
            sizes[index] = 0;
        };
        this.#requireSize = (k, v, size, sizeCalculation)=>{
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.#isBackgroundFetch(v)) return 0;
            if (!$90bbefef4dc25bab$var$isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                    size = sizeCalculation(v, k);
                    if (!$90bbefef4dc25bab$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
                } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
            }
            return size;
        };
        this.#addItemSize = (index, size, status)=>{
            sizes[index] = size;
            if (this.#maxSize) {
                const maxSize = this.#maxSize - sizes[index];
                while(this.#calculatedSize > maxSize)this.#evict(true);
            }
            this.#calculatedSize += sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.#calculatedSize;
            }
        };
    }
    #removeItemSize = (_i)=>{};
    #addItemSize = (_i, _s, _st)=>{};
    #requireSize = (_k, _v, size, sizeCalculation)=>{
        if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
        return 0;
    };
    *#indexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#tail;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#head) break;
            else i = this.#prev[i];
        }
    }
    *#rindexes({ allowStale: allowStale = this.allowStale } = {}) {
        if (this.#size) for(let i = this.#head;;){
            if (!this.#isValidIndex(i)) break;
            if (allowStale || !this.#isStale(i)) yield i;
            if (i === this.#tail) break;
            else i = this.#next[i];
        }
    }
    #isValidIndex(index) {
        return index !== undefined && this.#keyMap.get(this.#keyList[index]) === index;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of this.#indexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of this.#rindexes())if (this.#valList[i] !== undefined && this.#keyList[i] !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield [
            this.#keyList[i],
            this.#valList[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of this.#indexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of this.#rindexes()){
            const k = this.#keyList[i];
            if (k !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            if (v !== undefined && !this.#isBackgroundFetch(this.#valList[i])) yield this.#valList[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ [Symbol.toStringTag] = 'LRUCache';
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, this.#keyList[i], this)) return this.get(this.#keyList[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of this.#indexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of this.#rindexes()){
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of this.#rindexes({
            allowStale: true
        }))if (this.#isStale(i)) {
            this.#delete(this.#keyList[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = this.#keyMap.get(key);
        if (i === undefined) return undefined;
        const v = this.#valList[i];
        const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if (this.#ttls && this.#starts) {
            const ttl = this.#ttls[i];
            const start = this.#starts[i];
            if (ttl && start) {
                const remain = ttl - ($90bbefef4dc25bab$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if (this.#sizes) entry.size = this.#sizes[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of this.#indexes({
            allowStale: true
        })){
            const key = this.#keyList[i];
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if (this.#ttls && this.#starts) {
                entry.ttl = this.#ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $90bbefef4dc25bab$var$perf.now() - this.#starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.#sizes) entry.size = this.#sizes[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $90bbefef4dc25bab$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = this.#requireSize(k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            this.#delete(k, 'set');
            return this;
        }
        let index = this.#size === 0 ? undefined : this.#keyMap.get(k);
        if (index === undefined) {
            // addition
            index = this.#size === 0 ? this.#tail : this.#free.length !== 0 ? this.#free.pop() : this.#size === this.#max ? this.#evict(false) : this.#size;
            this.#keyList[index] = k;
            this.#valList[index] = v;
            this.#keyMap.set(k, index);
            this.#next[this.#tail] = index;
            this.#prev[index] = this.#tail;
            this.#tail = index;
            this.#size++;
            this.#addItemSize(index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            this.#moveToTail(index);
            const oldVal = this.#valList[index];
            if (v !== oldVal) {
                if (this.#hasFetchMethod && this.#isBackgroundFetch(oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        if (this.#hasDispose) this.#dispose?.(s, k, 'set');
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    if (this.#hasDispose) this.#dispose?.(oldVal, k, 'set');
                    if (this.#hasDisposeAfter) this.#disposed?.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                this.#removeItemSize(index);
                this.#addItemSize(index, size, status);
                this.#valList[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && this.#isBackgroundFetch(oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !this.#ttls) this.#initializeTTLTracking();
        if (this.#ttls) {
            if (!noUpdateTTL) this.#setItemTTL(index, ttl, start);
            if (status) this.#statusTTL(status, index);
        }
        if (!noDisposeOnSet && this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        try {
            while(this.#size){
                const val = this.#valList[this.#head];
                this.#evict(true);
                if (this.#isBackgroundFetch(val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if (this.#hasDisposeAfter && this.#disposed) {
                const dt = this.#disposed;
                let task;
                while(task = dt?.shift())this.#disposeAfter?.(...task);
            }
        }
    }
    #evict(free) {
        const head = this.#head;
        const k = this.#keyList[head];
        const v = this.#valList[head];
        if (this.#hasFetchMethod && this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('evicted'));
        else if (this.#hasDispose || this.#hasDisposeAfter) {
            if (this.#hasDispose) this.#dispose?.(v, k, 'evict');
            if (this.#hasDisposeAfter) this.#disposed?.push([
                v,
                k,
                'evict'
            ]);
        }
        this.#removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.#keyList[head] = undefined;
            this.#valList[head] = undefined;
            this.#free.push(head);
        }
        if (this.#size === 1) {
            this.#head = this.#tail = 0;
            this.#free.length = 0;
        } else this.#head = this.#next[head];
        this.#keyMap.delete(k);
        this.#size--;
        return head;
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v) && v.__staleWhileFetching === undefined) return false;
            if (!this.#isStale(index)) {
                if (updateAgeOnHas) this.#updateItemAge(index);
                if (status) {
                    status.has = 'hit';
                    this.#statusTTL(status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                this.#statusTTL(status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = this.#keyMap.get(k);
        if (index === undefined || !allowStale && this.#isStale(index)) return;
        const v = this.#valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
    }
    #backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.#valList[index];
        if (this.#isBackgroundFetch(v)) return v;
        const ac = new $90bbefef4dc25bab$var$AC();
        const { signal: signal } = options;
        // when/if our AC signals, then stop listening to theirs.
        signal?.addEventListener('abort', ()=>ac.abort(signal.reason), {
            signal: ac.signal
        });
        const fetchOpts = {
            signal: ac.signal,
            options: options,
            context: context
        };
        const cb = (v, updateCache = false)=>{
            const { aborted: aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort) options.status.fetchAbortIgnored = true;
                } else options.status.fetchResolved = true;
            }
            if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
            // either we didn't abort, and are still here, or we did, and ignored
            const bf = p;
            if (this.#valList[index] === p) {
                if (v === undefined) {
                    if (bf.__staleWhileFetching) this.#valList[index] = bf.__staleWhileFetching;
                    else this.#delete(k, 'fetch');
                } else {
                    if (options.status) options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er)=>{
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er)=>{
            const { aborted: aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            const bf = p;
            if (this.#valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || bf.__staleWhileFetching === undefined;
                if (del) this.#delete(k, 'fetch');
                else if (!allowStaleAborted) // still replace the *promise* with the stale value,
                // since we are done with the promise at this point.
                // leave it untouched if we're still waiting for an
                // aborted background fetch that hasn't yet returned.
                this.#valList[index] = bf.__staleWhileFetching;
            }
            if (allowStale) {
                if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
                return bf.__staleWhileFetching;
            } else if (bf.__returned === bf) throw er;
        };
        const pcall = (res, rej)=>{
            const fmp = this.#fetchMethod?.(k, v, fetchOpts);
            if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener('abort', ()=>{
                if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                    res(undefined);
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
                }
            });
        };
        if (options.status) options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        const bf = Object.assign(p, {
            __abortController: ac,
            __staleWhileFetching: v,
            __returned: undefined
        });
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, bf, {
                ...fetchOpts.options,
                status: undefined
            });
            index = this.#keyMap.get(k);
        } else this.#valList[index] = bf;
        return bf;
    }
    #isBackgroundFetch(p) {
        if (!this.#hasFetchMethod) return false;
        const b = p;
        return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $90bbefef4dc25bab$var$AC;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!this.#hasFetchMethod) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = this.#keyMap.get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = this.#backgroundFetch(k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.#isStale(index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                if (status) this.#statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.#backgroundFetch(k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = this.#memoMethod;
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh, ...options } = memoOptions;
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const value = this.#valList[index];
            const fetching = this.#isBackgroundFetch(value);
            if (status) this.#statusTTL(status, index);
            if (this.#isStale(index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) this.#delete(k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                this.#moveToTail(index);
                if (updateAgeOnGet) this.#updateItemAge(index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    #connect(p, n) {
        this.#prev[n] = p;
        this.#next[p] = n;
    }
    #moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.#tail) {
            if (index === this.#head) this.#head = this.#next[index];
            else this.#connect(this.#prev[index], this.#next[index]);
            this.#connect(this.#tail, index);
            this.#tail = index;
        }
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return this.#delete(k, 'delete');
    }
    #delete(k, reason) {
        let deleted = false;
        if (this.#size !== 0) {
            const index = this.#keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.#size === 1) this.#clear(reason);
                else {
                    this.#removeItemSize(index);
                    const v = this.#valList[index];
                    if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
                    else if (this.#hasDispose || this.#hasDisposeAfter) {
                        if (this.#hasDispose) this.#dispose?.(v, k, reason);
                        if (this.#hasDisposeAfter) this.#disposed?.push([
                            v,
                            k,
                            reason
                        ]);
                    }
                    this.#keyMap.delete(k);
                    this.#keyList[index] = undefined;
                    this.#valList[index] = undefined;
                    if (index === this.#tail) this.#tail = this.#prev[index];
                    else if (index === this.#head) this.#head = this.#next[index];
                    else {
                        const pi = this.#prev[index];
                        this.#next[pi] = this.#next[index];
                        const ni = this.#next[index];
                        this.#prev[ni] = this.#prev[index];
                    }
                    this.#size--;
                    this.#free.push(index);
                }
            }
        }
        if (this.#hasDisposeAfter && this.#disposed?.length) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
        return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return this.#clear('delete');
    }
    #clear(reason) {
        for (const index of this.#rindexes({
            allowStale: true
        })){
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) v.__abortController.abort(new Error('deleted'));
            else {
                const k = this.#keyList[index];
                if (this.#hasDispose) this.#dispose?.(v, k, reason);
                if (this.#hasDisposeAfter) this.#disposed?.push([
                    v,
                    k,
                    reason
                ]);
            }
        }
        this.#keyMap.clear();
        this.#valList.fill(undefined);
        this.#keyList.fill(undefined);
        if (this.#ttls && this.#starts) {
            this.#ttls.fill(0);
            this.#starts.fill(0);
        }
        if (this.#sizes) this.#sizes.fill(0);
        this.#head = 0;
        this.#tail = 0;
        this.#free.length = 0;
        this.#calculatedSize = 0;
        this.#size = 0;
        if (this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while(task = dt?.shift())this.#disposeAfter?.(...task);
        }
    }
}


var $9329a56f5405a28a$export$8f20bd680b2d2907 = /*#__PURE__*/ function(TileAction) {
    TileAction["FetchTile"] = "FetchTile";
    TileAction["RetrieveTile"] = "RetrieveTile";
    TileAction["StoreTile"] = "StoreTile";
    TileAction["ClearTiles"] = "ClearTiles";
    return TileAction;
}({});
var $9329a56f5405a28a$export$cb1a3bbf76a5156b = /*#__PURE__*/ function(TileResult) {
    TileResult["TileFetched"] = "TileFetched";
    TileResult["TileRetrieved"] = "TileRetrieved";
    TileResult["TileStored"] = "TileStored";
    TileResult["TilesCleared"] = "TilesCleared";
    TileResult["Error"] = "Error";
    return TileResult;
}({});
async function $9329a56f5405a28a$var$fetchTile(id, url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return {
        result: "TileFetched",
        id: id,
        tileBlob: blob
    };
}
async function $9329a56f5405a28a$var$storeTile(id, tileBlob) {
    const db = await $9329a56f5405a28a$var$openDatabase();
    const tx = db.transaction('tiles', 'readwrite');
    const store = tx.objectStore('tiles');
    await new Promise((resolve, reject)=>{
        const req = store.put({
            id: id,
            tileBlob: tileBlob
        });
        req.onsuccess = ()=>resolve();
        req.onerror = ()=>reject(new Error(req.error?.message));
    });
    return {
        result: "TileStored",
        id: id
    };
}
async function $9329a56f5405a28a$var$retrieveTile(id) {
    const db = await $9329a56f5405a28a$var$openDatabase();
    const tx = db.transaction('tiles', 'readonly');
    const store = tx.objectStore('tiles');
    const result = await new Promise((resolve, reject)=>{
        const req = store.get(id);
        req.onsuccess = ()=>resolve(req.result);
        req.onerror = ()=>reject(new Error(req.error?.message));
    });
    return {
        result: "TileRetrieved",
        id: id,
        tileBlob: result?.tileBlob || null
    };
}
async function $9329a56f5405a28a$var$clearTiles() {
    const db = await $9329a56f5405a28a$var$openDatabase();
    const tx = db.transaction('tiles', 'readwrite');
    const store = tx.objectStore('tiles');
    await new Promise((resolve, reject)=>{
        const req = store.clear();
        req.onsuccess = ()=>resolve();
        req.onerror = ()=>reject(new Error(req.error?.message));
    });
    return {
        result: "TilesCleared"
    };
}
async function $9329a56f5405a28a$var$openDatabase() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open('TileDatabase', 1);
        request.onupgradeneeded = ()=>{
            const db = request.result;
            if (!db.objectStoreNames.contains('tiles')) db.createObjectStore('tiles', {
                keyPath: 'id'
            });
        };
        request.onsuccess = ()=>resolve(request.result);
        request.onerror = ()=>reject(new Error(request.error?.message));
    });
}
self.onmessage = async (event)=>{
    const data = event.data;
    try {
        let response;
        switch(data.action){
            case "FetchTile":
                response = await $9329a56f5405a28a$var$fetchTile(data.id, data.url);
                break;
            case "StoreTile":
                response = await $9329a56f5405a28a$var$storeTile(data.id, data.tileBlob);
                break;
            case "RetrieveTile":
                response = await $9329a56f5405a28a$var$retrieveTile(data.id);
                break;
            case "ClearTiles":
                response = await $9329a56f5405a28a$var$clearTiles();
                break;
            default:
                throw new Error(`Unknown action: ${event.data}`);
        }
        self.postMessage(response);
    } catch (error) {
        self.postMessage({
            result: "Error",
            error: error.message
        });
    }
};


var $ac96c40254982197$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $ac96c40254982197$var$url = new URL("tileWorker.ccdb1e17.js", import.meta.url);
$ac96c40254982197$exports = $56b621a6dd25b2cb$exports($ac96c40254982197$var$url.toString(), $ac96c40254982197$var$url.origin, true);


class $e7c30ed3aeaeed56$export$a7bc54e5e52782df {
    constructor(cacheSize = 100){
        this.cache = new (0, $90bbefef4dc25bab$export$182500e6725aad9a)({
            max: cacheSize
        });
        this.worker = new Worker($ac96c40254982197$exports);
    }
    /**
     * Sends a message to the worker and waits for a response that matches the expected result.
     * 
     * @param message - The message to send to the worker, with its action field specifying the type.
     * @param expectedResult - The expected result identifier (TileResponse.result field) for the response.
     * @returns A Promise that resolves with the corresponding response type from TileActionResponseMap.
     */ async sendWorkerMessage(message, expectedResult) {
        return new Promise((resolve, reject)=>{
            const handler = (event)=>{
                const data = event.data;
                if (data.result === expectedResult && (!('id' in message) || 'id' in data && data.id === message.id // If message has no id, skip id check; otherwise, ensure ids match
                )) {
                    this.worker.removeEventListener('message', handler);
                    resolve(data);
                } else if (data.result === (0, $9329a56f5405a28a$export$cb1a3bbf76a5156b).Error) {
                    this.worker.removeEventListener('message', handler);
                    reject(new Error(data.error || 'Unknown worker error'));
                }
            };
            this.worker.addEventListener('message', handler);
            this.worker.postMessage(message);
        });
    }
    /**
     * Fetches a tile from the network and stores it
     * @param id Tile id
     * @param url URL to fetch the tile from
     * @returns Tile as an ImageBitmap
     */ async fetchTileFromNetwork(id, url) {
        const { tileBlob: tileBlob } = await this.sendWorkerMessage({
            action: (0, $9329a56f5405a28a$export$8f20bd680b2d2907).FetchTile,
            id: id,
            url: url
        }, (0, $9329a56f5405a28a$export$cb1a3bbf76a5156b).TileFetched);
        const image = await createImageBitmap(tileBlob);
        await this.storeTile(id, tileBlob, image);
        return image;
    }
    /**
     * Stores a tile in the IndexedDB (as Blob) and in the cache (as ImageBitmap)
     * @param id Tile id.
     * @param tileBlob Tile data as a Blob.
     * @param image Decoded tile as an ImageBitmap.
     */ async storeTile(id, tileBlob, image) {
        this.cache.set(id, image);
        await this.sendWorkerMessage({
            action: (0, $9329a56f5405a28a$export$8f20bd680b2d2907).StoreTile,
            id: id,
            tileBlob: tileBlob
        }, (0, $9329a56f5405a28a$export$cb1a3bbf76a5156b).TileStored);
    }
    /**
     * Retrieves a tile from cache, IndexedDB, or network (in that order).
     * @param id Tile identifier.
     * @param url URL for network fetch if needed.
     * @param forceFetch If true, skips cache and DB.
     * @returns Tile as an ImageBitmap.
     */ async retrieveTile(id, url, forceFetch = false) {
        if (!forceFetch && this.cache.has(id)) return this.cache.get(id);
        if (!forceFetch) {
            const { tileBlob: tileBlob } = await this.sendWorkerMessage({
                action: (0, $9329a56f5405a28a$export$8f20bd680b2d2907).RetrieveTile,
                id: id
            }, (0, $9329a56f5405a28a$export$cb1a3bbf76a5156b).TileRetrieved);
            if (tileBlob) {
                const image = await createImageBitmap(tileBlob);
                this.cache.set(id, image);
                return image;
            }
        }
        return this.fetchTileFromNetwork(id, url);
    }
    clearCache() {
        this.cache.clear();
    }
    /** Clears both cache and IndexedDB storage. */ async clearTiles() {
        this.cache.clear();
        await this.sendWorkerMessage({
            action: (0, $9329a56f5405a28a$export$8f20bd680b2d2907).ClearTiles
        }, (0, $9329a56f5405a28a$export$cb1a3bbf76a5156b).TilesCleared);
    }
    terminateWorker() {
        this.worker.terminate();
    }
}


class $2b43e43ffe2e7db0$export$b03453c3d450d2b7 {
    constructor(gl, tileManager, tileSize, atlasSize, svtDepth){
        this.MAX_LAYERS = 128 // TODO: compute this
        ;
        this.gl = gl;
        this.tileManager = tileManager;
        this.tileSize = tileSize;
        this.atlasSize = atlasSize;
        this.svtDepth = svtDepth;
        this.activeTiles = new Map();
        this.layerAssignment = new Array(this.MAX_LAYERS).fill(null);
        this.tileIdCache = new Map();
        this.uploadQueue = [];
        // texture array
        this.atlasTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D_ARRAY, this.atlasTexture);
        gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, gl.RGBA8, tileSize, tileSize, this.MAX_LAYERS, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        // indirection table
        this.indirectionTable = gl.createTexture();
        const indirectionSize = 2 ** svtDepth;
        gl.bindTexture(gl.TEXTURE_2D, this.indirectionTable);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST_MIPMAP_NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA8, indirectionSize, indirectionSize, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.generateMipmap(gl.TEXTURE_2D);
    }
    // Reserves a free slot in the atlas or evicts an LRU tile if full.
    reserveLayer() {
        for(let i = 1; i < this.MAX_LAYERS; i++){
            if (this.layerAssignment[i] === null) return i;
        }
        return this.evictLRUTile();
    }
    scheduleTileUpload(tileId, tilePath) {
        if (this.activeTiles.has(tileId)) {
            this.touchTile(tileId); // Mark as recently used
            return;
        }
        const layerIndex = this.reserveLayer();
        const [level, col, row] = this.parseTileId(tileId);
        const tileInfo = {
            tileId: tileId,
            layerIndex: layerIndex,
            lastAccessed: Date.now(),
            level: level,
            col: col,
            row: row
        };
        this.activeTiles.set(tileId, tileInfo);
        this.layerAssignment[layerIndex] = tileId;
        this.uploadQueue.push({
            tileId: tileId,
            tilePath: tilePath,
            tileInfo: tileInfo
        });
    }
    async processUploadQueue(limit = 2) {
        const uploads = this.uploadQueue.splice(0, limit);
        for (const upload of uploads)await this.uploadTileNow(upload.tileId, upload.tilePath, upload.tileInfo);
    }
    // Uploads a tile to the atlas and updates the indirection table.
    async uploadTileNow(tileId, tilePath, tileInfo) {
        console.log("uploadTile", tileId, tileInfo.layerIndex);
        const { gl: gl, tileManager: tileManager, tileSize: tileSize, atlasTexture: atlasTexture, indirectionTable: indirectionTable, svtDepth: svtDepth } = this;
        const image = await tileManager.retrieveTile(tileId, tilePath);
        gl.bindTexture(gl.TEXTURE_2D_ARRAY, atlasTexture);
        gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, tileInfo.layerIndex, tileSize, tileSize, 1, gl.RGBA, gl.UNSIGNED_BYTE, image);
        const mipLevel = svtDepth - tileInfo.level;
        const indirectionData = new Uint8Array([
            tileInfo.layerIndex,
            0,
            tileInfo.level,
            255
        ]);
        gl.bindTexture(gl.TEXTURE_2D, indirectionTable);
        gl.texSubImage2D(gl.TEXTURE_2D, mipLevel, tileInfo.col, tileInfo.row, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, indirectionData);
        return image;
    }
    // Evicts the least recently used tile (excluding level 0).
    evictLRUTile() {
        const { gl: gl, svtDepth: svtDepth, activeTiles: activeTiles, layerAssignment: layerAssignment, indirectionTable: indirectionTable } = this;
        const [tileId, info] = this.activeTiles.entries().next().value;
        if (!tileId) throw new Error("No tiles to evict");
        activeTiles.delete(tileId);
        const layerIndex = info.layerIndex;
        layerAssignment[layerIndex] = null;
        const mipLevel = svtDepth - info.level;
        const indirectionData = new Uint8Array([
            0,
            0,
            0,
            0
        ]);
        gl.bindTexture(gl.TEXTURE_2D, indirectionTable);
        gl.texSubImage2D(gl.TEXTURE_2D, mipLevel, info.col, info.row, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, indirectionData);
        console.log(`Evicted tile: ${tileId}, layer: ${layerIndex}`);
        return layerIndex;
    }
    // Parses tile ID into [level, column, row] and caches it
    // TODO: rethink this whole thing
    parseTileId(tileId) {
        if (this.tileIdCache.has(tileId)) return this.tileIdCache.get(tileId);
        const parts = tileId.split("/");
        const level = parseInt(parts[0].replace("level", ""));
        const [_, col, row] = parts[1].split("_").map(Number);
        const result = [
            level,
            col,
            row
        ];
        this.tileIdCache.set(tileId, result);
        return result;
    }
    touchTile(tileId) {
        const info = this.activeTiles.get(tileId);
        if (info) {
            this.activeTiles.delete(tileId);
            this.activeTiles.set(tileId, info);
            info.lastAccessed = Date.now();
        }
    }
    hasTile(tileId) {
        return this.activeTiles.has(tileId);
    }
    // Getters
    getAtlasTexture() {
        return this.atlasTexture;
    }
    getAtlasSize() {
        return this.atlasSize;
    }
    getIndirectionTable() {
        return this.indirectionTable;
    }
}


/* @license twgl.js 5.5.4 Copyright (c) 2015, Gregg Tavares All Rights Reserved.
Available via the MIT license.
see: http://github.com/greggman/twgl.js for details */ /*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /**
 *
 * Vec3 math math functions.
 *
 * Almost all functions take an optional `dst` argument. If it is not passed in the
 * functions will create a new Vec3. In other words you can do this
 *
 *     var v = v3.cross(v1, v2);  // Creates a new Vec3 with the cross product of v1 x v2.
 *
 * or
 *
 *     var v = v3.create();
 *     v3.cross(v1, v2, v);  // Puts the cross product of v1 x v2 in v
 *
 * The first style is often easier but depending on where it's used it generates garbage where
 * as there is almost never allocation with the second style.
 *
 * It is always save to pass any vector as the destination. So for example
 *
 *     v3.cross(v1, v2, v1);  // Puts the cross product of v1 x v2 in v1
 *
 * @module twgl/v3
 */ let $065afaecc735fbee$var$VecType = Float32Array;
/**
 * A JavaScript array with 3 values or a Float32Array with 3 values.
 * When created by the library will create the default type which is `Float32Array`
 * but can be set by calling {@link module:twgl/v3.setDefaultType}.
 * @typedef {(number[]|Float32Array)} Vec3
 * @memberOf module:twgl/v3
 */ /**
 * Sets the type this library creates for a Vec3
 * @param {constructor} ctor the constructor for the type. Either `Float32Array` or `Array`
 * @return {constructor} previous constructor for Vec3
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$setDefaultType$1(ctor) {
    const oldType = $065afaecc735fbee$var$VecType;
    $065afaecc735fbee$var$VecType = ctor;
    return oldType;
}
/**
 * Creates a vec3; may be called with x, y, z to set initial values.
 * @param {number} [x] Initial x value.
 * @param {number} [y] Initial y value.
 * @param {number} [z] Initial z value.
 * @return {module:twgl/v3.Vec3} the created vector
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$create$1(x, y, z) {
    const dst = new $065afaecc735fbee$var$VecType(3);
    if (x) dst[0] = x;
    if (y) dst[1] = y;
    if (z) dst[2] = z;
    return dst;
}
/**
 * Adds two vectors; assumes a and b have the same dimension.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} A vector tha tis the sum of a and b.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$add(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = a[0] + b[0];
    dst[1] = a[1] + b[1];
    dst[2] = a[2] + b[2];
    return dst;
}
/**
 * Subtracts two vectors.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} A vector that is the difference of a and b.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$subtract(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = a[0] - b[0];
    dst[1] = a[1] - b[1];
    dst[2] = a[2] - b[2];
    return dst;
}
/**
 * Performs linear interpolation on two vectors.
 * Given vectors a and b and interpolation coefficient t, returns
 * a + t * (b - a).
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {number} t Interpolation coefficient.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The linear interpolated result.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$lerp(a, b, t, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = a[0] + t * (b[0] - a[0]);
    dst[1] = a[1] + t * (b[1] - a[1]);
    dst[2] = a[2] + t * (b[2] - a[2]);
    return dst;
}
/**
 * Performs linear interpolation on two vectors.
 * Given vectors a and b and interpolation coefficient vector t, returns
 * a + t * (b - a).
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} t Interpolation coefficients vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} the linear interpolated result.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$lerpV(a, b, t, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = a[0] + t[0] * (b[0] - a[0]);
    dst[1] = a[1] + t[1] * (b[1] - a[1]);
    dst[2] = a[2] + t[2] * (b[2] - a[2]);
    return dst;
}
/**
 * Return max values of two vectors.
 * Given vectors a and b returns
 * [max(a[0], b[0]), max(a[1], b[1]), max(a[2], b[2])].
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The max components vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$max(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = Math.max(a[0], b[0]);
    dst[1] = Math.max(a[1], b[1]);
    dst[2] = Math.max(a[2], b[2]);
    return dst;
}
/**
 * Return min values of two vectors.
 * Given vectors a and b returns
 * [min(a[0], b[0]), min(a[1], b[1]), min(a[2], b[2])].
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The min components vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$min(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = Math.min(a[0], b[0]);
    dst[1] = Math.min(a[1], b[1]);
    dst[2] = Math.min(a[2], b[2]);
    return dst;
}
/**
 * Multiplies a vector by a scalar.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {number} k The scalar.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The scaled vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$mulScalar(v, k, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = v[0] * k;
    dst[1] = v[1] * k;
    dst[2] = v[2] * k;
    return dst;
}
/**
 * Divides a vector by a scalar.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {number} k The scalar.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The scaled vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$divScalar(v, k, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = v[0] / k;
    dst[1] = v[1] / k;
    dst[2] = v[2] / k;
    return dst;
}
/**
 * Computes the cross product of two vectors; assumes both vectors have
 * three entries.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The vector of a cross b.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$cross(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    const t1 = a[2] * b[0] - a[0] * b[2];
    const t2 = a[0] * b[1] - a[1] * b[0];
    dst[0] = a[1] * b[2] - a[2] * b[1];
    dst[1] = t1;
    dst[2] = t2;
    return dst;
}
/**
 * Computes the dot product of two vectors; assumes both vectors have
 * three entries.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @return {number} dot product
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$dot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the length of vector
 * @param {module:twgl/v3.Vec3} v vector.
 * @return {number} length of vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$length$1(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
}
/**
 * Computes the square of the length of vector
 * @param {module:twgl/v3.Vec3} v vector.
 * @return {number} square of the length of vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$lengthSq(v) {
    return v[0] * v[0] + v[1] * v[1] + v[2] * v[2];
}
/**
 * Computes the distance between 2 points
 * @param {module:twgl/v3.Vec3} a vector.
 * @param {module:twgl/v3.Vec3} b vector.
 * @return {number} distance between a and b
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$distance(a, b) {
    const dx = a[0] - b[0];
    const dy = a[1] - b[1];
    const dz = a[2] - b[2];
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}
/**
 * Computes the square of the distance between 2 points
 * @param {module:twgl/v3.Vec3} a vector.
 * @param {module:twgl/v3.Vec3} b vector.
 * @return {number} square of the distance between a and b
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$distanceSq(a, b) {
    const dx = a[0] - b[0];
    const dy = a[1] - b[1];
    const dz = a[2] - b[2];
    return dx * dx + dy * dy + dz * dz;
}
/**
 * Divides a vector by its Euclidean length and returns the quotient.
 * @param {module:twgl/v3.Vec3} a The vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The normalized vector.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$normalize(a, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    const lenSq = a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
    const len = Math.sqrt(lenSq);
    if (len > 0.00001) {
        dst[0] = a[0] / len;
        dst[1] = a[1] / len;
        dst[2] = a[2] / len;
    } else {
        dst[0] = 0;
        dst[1] = 0;
        dst[2] = 0;
    }
    return dst;
}
/**
 * Negates a vector.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} -v.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$negate$1(v, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = -v[0];
    dst[1] = -v[1];
    dst[2] = -v[2];
    return dst;
}
/**
 * Copies a vector.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} A copy of v.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$copy$1(v, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = v[0];
    dst[1] = v[1];
    dst[2] = v[2];
    return dst;
}
/**
 * Multiplies a vector by another vector (component-wise); assumes a and
 * b have the same length.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The vector of products of entries of a and
 *     b.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$multiply$1(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = a[0] * b[0];
    dst[1] = a[1] * b[1];
    dst[2] = a[2] * b[2];
    return dst;
}
/**
 * Divides a vector by another vector (component-wise); assumes a and
 * b have the same length.
 * @param {module:twgl/v3.Vec3} a Operand vector.
 * @param {module:twgl/v3.Vec3} b Operand vector.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not new one is created.
 * @return {module:twgl/v3.Vec3} The vector of quotients of entries of a and
 *     b.
 * @memberOf module:twgl/v3
 */ function $065afaecc735fbee$var$divide(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$VecType(3);
    dst[0] = a[0] / b[0];
    dst[1] = a[1] / b[1];
    dst[2] = a[2] / b[2];
    return dst;
}
var $065afaecc735fbee$export$815b03eba529a08e = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    add: $065afaecc735fbee$var$add,
    copy: $065afaecc735fbee$var$copy$1,
    create: $065afaecc735fbee$var$create$1,
    cross: $065afaecc735fbee$var$cross,
    distance: $065afaecc735fbee$var$distance,
    distanceSq: $065afaecc735fbee$var$distanceSq,
    divide: $065afaecc735fbee$var$divide,
    divScalar: $065afaecc735fbee$var$divScalar,
    dot: $065afaecc735fbee$var$dot,
    lerp: $065afaecc735fbee$var$lerp,
    lerpV: $065afaecc735fbee$var$lerpV,
    length: $065afaecc735fbee$var$length$1,
    lengthSq: $065afaecc735fbee$var$lengthSq,
    max: $065afaecc735fbee$var$max,
    min: $065afaecc735fbee$var$min,
    mulScalar: $065afaecc735fbee$var$mulScalar,
    multiply: $065afaecc735fbee$var$multiply$1,
    negate: $065afaecc735fbee$var$negate$1,
    normalize: $065afaecc735fbee$var$normalize,
    setDefaultType: $065afaecc735fbee$var$setDefaultType$1,
    subtract: $065afaecc735fbee$var$subtract
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /**
 * 4x4 Matrix math math functions.
 *
 * Almost all functions take an optional `dst` argument. If it is not passed in the
 * functions will create a new matrix. In other words you can do this
 *
 *     const mat = m4.translation([1, 2, 3]);  // Creates a new translation matrix
 *
 * or
 *
 *     const mat = m4.create();
 *     m4.translation([1, 2, 3], mat);  // Puts translation matrix in mat.
 *
 * The first style is often easier but depending on where it's used it generates garbage where
 * as there is almost never allocation with the second style.
 *
 * It is always save to pass any matrix as the destination. So for example
 *
 *     const mat = m4.identity();
 *     const trans = m4.translation([1, 2, 3]);
 *     m4.multiply(mat, trans, mat);  // Multiplies mat * trans and puts result in mat.
 *
 * @module twgl/m4
 */ let $065afaecc735fbee$var$MatType = Float32Array;
/**
 * A JavaScript array with 16 values or a Float32Array with 16 values.
 * When created by the library will create the default type which is `Float32Array`
 * but can be set by calling {@link module:twgl/m4.setDefaultType}.
 * @typedef {(number[]|Float32Array)} Mat4
 * @memberOf module:twgl/m4
 */ /**
 * Sets the type this library creates for a Mat4
 * @param {constructor} ctor the constructor for the type. Either `Float32Array` or `Array`
 * @return {constructor} previous constructor for Mat4
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$setDefaultType(ctor) {
    const oldType = $065afaecc735fbee$var$MatType;
    $065afaecc735fbee$var$MatType = ctor;
    return oldType;
}
/**
 * Negates a matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} -m.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$negate(m, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    dst[0] = -m[0];
    dst[1] = -m[1];
    dst[2] = -m[2];
    dst[3] = -m[3];
    dst[4] = -m[4];
    dst[5] = -m[5];
    dst[6] = -m[6];
    dst[7] = -m[7];
    dst[8] = -m[8];
    dst[9] = -m[9];
    dst[10] = -m[10];
    dst[11] = -m[11];
    dst[12] = -m[12];
    dst[13] = -m[13];
    dst[14] = -m[14];
    dst[15] = -m[15];
    return dst;
}
/**
 * Creates a matrix.
 * @return {module:twgl/m4.Mat4} A new matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$create() {
    return new $065afaecc735fbee$var$MatType(16).fill(0);
}
/**
 * Copies a matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] The matrix. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} A copy of m.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$copy(m, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    dst[0] = m[0];
    dst[1] = m[1];
    dst[2] = m[2];
    dst[3] = m[3];
    dst[4] = m[4];
    dst[5] = m[5];
    dst[6] = m[6];
    dst[7] = m[7];
    dst[8] = m[8];
    dst[9] = m[9];
    dst[10] = m[10];
    dst[11] = m[11];
    dst[12] = m[12];
    dst[13] = m[13];
    dst[14] = m[14];
    dst[15] = m[15];
    return dst;
}
/**
 * Creates an n-by-n identity matrix.
 *
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} An n-by-n identity matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$identity(dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    dst[0] = 1;
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = 1;
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = 0;
    dst[10] = 1;
    dst[11] = 0;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = 0;
    dst[15] = 1;
    return dst;
}
/**
 * Takes the transpose of a matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The transpose of m.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$transpose(m, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    if (dst === m) {
        let t;
        t = m[1];
        m[1] = m[4];
        m[4] = t;
        t = m[2];
        m[2] = m[8];
        m[8] = t;
        t = m[3];
        m[3] = m[12];
        m[12] = t;
        t = m[6];
        m[6] = m[9];
        m[9] = t;
        t = m[7];
        m[7] = m[13];
        m[13] = t;
        t = m[11];
        m[11] = m[14];
        m[14] = t;
        return dst;
    }
    const m00 = m[0];
    const m01 = m[1];
    const m02 = m[2];
    const m03 = m[3];
    const m10 = m[4];
    const m11 = m[5];
    const m12 = m[6];
    const m13 = m[7];
    const m20 = m[8];
    const m21 = m[9];
    const m22 = m[10];
    const m23 = m[11];
    const m30 = m[12];
    const m31 = m[13];
    const m32 = m[14];
    const m33 = m[15];
    dst[0] = m00;
    dst[1] = m10;
    dst[2] = m20;
    dst[3] = m30;
    dst[4] = m01;
    dst[5] = m11;
    dst[6] = m21;
    dst[7] = m31;
    dst[8] = m02;
    dst[9] = m12;
    dst[10] = m22;
    dst[11] = m32;
    dst[12] = m03;
    dst[13] = m13;
    dst[14] = m23;
    dst[15] = m33;
    return dst;
}
/**
 * Computes the inverse of a 4-by-4 matrix.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The inverse of m.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$inverse(m, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const m00 = m[0];
    const m01 = m[1];
    const m02 = m[2];
    const m03 = m[3];
    const m10 = m[4];
    const m11 = m[5];
    const m12 = m[6];
    const m13 = m[7];
    const m20 = m[8];
    const m21 = m[9];
    const m22 = m[10];
    const m23 = m[11];
    const m30 = m[12];
    const m31 = m[13];
    const m32 = m[14];
    const m33 = m[15];
    const tmp_0 = m22 * m33;
    const tmp_1 = m32 * m23;
    const tmp_2 = m12 * m33;
    const tmp_3 = m32 * m13;
    const tmp_4 = m12 * m23;
    const tmp_5 = m22 * m13;
    const tmp_6 = m02 * m33;
    const tmp_7 = m32 * m03;
    const tmp_8 = m02 * m23;
    const tmp_9 = m22 * m03;
    const tmp_10 = m02 * m13;
    const tmp_11 = m12 * m03;
    const tmp_12 = m20 * m31;
    const tmp_13 = m30 * m21;
    const tmp_14 = m10 * m31;
    const tmp_15 = m30 * m11;
    const tmp_16 = m10 * m21;
    const tmp_17 = m20 * m11;
    const tmp_18 = m00 * m31;
    const tmp_19 = m30 * m01;
    const tmp_20 = m00 * m21;
    const tmp_21 = m20 * m01;
    const tmp_22 = m00 * m11;
    const tmp_23 = m10 * m01;
    const t0 = tmp_0 * m11 + tmp_3 * m21 + tmp_4 * m31 - (tmp_1 * m11 + tmp_2 * m21 + tmp_5 * m31);
    const t1 = tmp_1 * m01 + tmp_6 * m21 + tmp_9 * m31 - (tmp_0 * m01 + tmp_7 * m21 + tmp_8 * m31);
    const t2 = tmp_2 * m01 + tmp_7 * m11 + tmp_10 * m31 - (tmp_3 * m01 + tmp_6 * m11 + tmp_11 * m31);
    const t3 = tmp_5 * m01 + tmp_8 * m11 + tmp_11 * m21 - (tmp_4 * m01 + tmp_9 * m11 + tmp_10 * m21);
    const d = 1.0 / (m00 * t0 + m10 * t1 + m20 * t2 + m30 * t3);
    dst[0] = d * t0;
    dst[1] = d * t1;
    dst[2] = d * t2;
    dst[3] = d * t3;
    dst[4] = d * (tmp_1 * m10 + tmp_2 * m20 + tmp_5 * m30 - (tmp_0 * m10 + tmp_3 * m20 + tmp_4 * m30));
    dst[5] = d * (tmp_0 * m00 + tmp_7 * m20 + tmp_8 * m30 - (tmp_1 * m00 + tmp_6 * m20 + tmp_9 * m30));
    dst[6] = d * (tmp_3 * m00 + tmp_6 * m10 + tmp_11 * m30 - (tmp_2 * m00 + tmp_7 * m10 + tmp_10 * m30));
    dst[7] = d * (tmp_4 * m00 + tmp_9 * m10 + tmp_10 * m20 - (tmp_5 * m00 + tmp_8 * m10 + tmp_11 * m20));
    dst[8] = d * (tmp_12 * m13 + tmp_15 * m23 + tmp_16 * m33 - (tmp_13 * m13 + tmp_14 * m23 + tmp_17 * m33));
    dst[9] = d * (tmp_13 * m03 + tmp_18 * m23 + tmp_21 * m33 - (tmp_12 * m03 + tmp_19 * m23 + tmp_20 * m33));
    dst[10] = d * (tmp_14 * m03 + tmp_19 * m13 + tmp_22 * m33 - (tmp_15 * m03 + tmp_18 * m13 + tmp_23 * m33));
    dst[11] = d * (tmp_17 * m03 + tmp_20 * m13 + tmp_23 * m23 - (tmp_16 * m03 + tmp_21 * m13 + tmp_22 * m23));
    dst[12] = d * (tmp_14 * m22 + tmp_17 * m32 + tmp_13 * m12 - (tmp_16 * m32 + tmp_12 * m12 + tmp_15 * m22));
    dst[13] = d * (tmp_20 * m32 + tmp_12 * m02 + tmp_19 * m22 - (tmp_18 * m22 + tmp_21 * m32 + tmp_13 * m02));
    dst[14] = d * (tmp_18 * m12 + tmp_23 * m32 + tmp_15 * m02 - (tmp_22 * m32 + tmp_14 * m02 + tmp_19 * m12));
    dst[15] = d * (tmp_22 * m22 + tmp_16 * m02 + tmp_21 * m12 - (tmp_20 * m12 + tmp_23 * m22 + tmp_17 * m02));
    return dst;
}
/**
 * Multiplies two 4-by-4 matrices with a on the left and b on the right
 * @param {module:twgl/m4.Mat4} a The matrix on the left.
 * @param {module:twgl/m4.Mat4} b The matrix on the right.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The matrix product of a and b.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$multiply(a, b, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const a00 = a[0];
    const a01 = a[1];
    const a02 = a[2];
    const a03 = a[3];
    const a10 = a[4];
    const a11 = a[5];
    const a12 = a[6];
    const a13 = a[7];
    const a20 = a[8];
    const a21 = a[9];
    const a22 = a[10];
    const a23 = a[11];
    const a30 = a[12];
    const a31 = a[13];
    const a32 = a[14];
    const a33 = a[15];
    const b00 = b[0];
    const b01 = b[1];
    const b02 = b[2];
    const b03 = b[3];
    const b10 = b[4];
    const b11 = b[5];
    const b12 = b[6];
    const b13 = b[7];
    const b20 = b[8];
    const b21 = b[9];
    const b22 = b[10];
    const b23 = b[11];
    const b30 = b[12];
    const b31 = b[13];
    const b32 = b[14];
    const b33 = b[15];
    dst[0] = a00 * b00 + a10 * b01 + a20 * b02 + a30 * b03;
    dst[1] = a01 * b00 + a11 * b01 + a21 * b02 + a31 * b03;
    dst[2] = a02 * b00 + a12 * b01 + a22 * b02 + a32 * b03;
    dst[3] = a03 * b00 + a13 * b01 + a23 * b02 + a33 * b03;
    dst[4] = a00 * b10 + a10 * b11 + a20 * b12 + a30 * b13;
    dst[5] = a01 * b10 + a11 * b11 + a21 * b12 + a31 * b13;
    dst[6] = a02 * b10 + a12 * b11 + a22 * b12 + a32 * b13;
    dst[7] = a03 * b10 + a13 * b11 + a23 * b12 + a33 * b13;
    dst[8] = a00 * b20 + a10 * b21 + a20 * b22 + a30 * b23;
    dst[9] = a01 * b20 + a11 * b21 + a21 * b22 + a31 * b23;
    dst[10] = a02 * b20 + a12 * b21 + a22 * b22 + a32 * b23;
    dst[11] = a03 * b20 + a13 * b21 + a23 * b22 + a33 * b23;
    dst[12] = a00 * b30 + a10 * b31 + a20 * b32 + a30 * b33;
    dst[13] = a01 * b30 + a11 * b31 + a21 * b32 + a31 * b33;
    dst[14] = a02 * b30 + a12 * b31 + a22 * b32 + a32 * b33;
    dst[15] = a03 * b30 + a13 * b31 + a23 * b32 + a33 * b33;
    return dst;
}
/**
 * Sets the translation component of a 4-by-4 matrix to the given
 * vector.
 * @param {module:twgl/m4.Mat4} a The matrix.
 * @param {module:twgl/v3.Vec3} v The vector.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The matrix with translation set.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$setTranslation(a, v, dst) {
    dst = dst || $065afaecc735fbee$var$identity();
    if (a !== dst) {
        dst[0] = a[0];
        dst[1] = a[1];
        dst[2] = a[2];
        dst[3] = a[3];
        dst[4] = a[4];
        dst[5] = a[5];
        dst[6] = a[6];
        dst[7] = a[7];
        dst[8] = a[8];
        dst[9] = a[9];
        dst[10] = a[10];
        dst[11] = a[11];
    }
    dst[12] = v[0];
    dst[13] = v[1];
    dst[14] = v[2];
    dst[15] = 1;
    return dst;
}
/**
 * Returns the translation component of a 4-by-4 matrix as a vector with 3
 * entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} [dst] vector to hold result. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The translation component of m.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$getTranslation(m, dst) {
    dst = dst || $065afaecc735fbee$var$create$1();
    dst[0] = m[12];
    dst[1] = m[13];
    dst[2] = m[14];
    return dst;
}
/**
 * Returns an axis of a 4x4 matrix as a vector with 3 entries
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} axis The axis 0 = x, 1 = y, 2 = z;
 * @return {module:twgl/v3.Vec3} [dst] vector.
 * @return {module:twgl/v3.Vec3} The axis component of m.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$getAxis(m, axis, dst) {
    dst = dst || $065afaecc735fbee$var$create$1();
    const off = axis * 4;
    dst[0] = m[off + 0];
    dst[1] = m[off + 1];
    dst[2] = m[off + 2];
    return dst;
}
/**
 * Sets an axis of a 4x4 matrix as a vector with 3 entries
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v the axis vector
 * @param {number} axis The axis  0 = x, 1 = y, 2 = z;
 * @param {module:twgl/m4.Mat4} [dst] The matrix to set. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The matrix with axis set.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$setAxis(a, v, axis, dst) {
    if (dst !== a) dst = $065afaecc735fbee$var$copy(a, dst);
    const off = axis * 4;
    dst[off + 0] = v[0];
    dst[off + 1] = v[1];
    dst[off + 2] = v[2];
    return dst;
}
/**
 * Computes a 4-by-4 perspective transformation matrix given the angular height
 * of the frustum, the aspect ratio, and the near and far clipping planes.  The
 * arguments define a frustum extending in the negative z direction.  The given
 * angle is the vertical angle of the frustum, and the horizontal angle is
 * determined to produce the given aspect ratio.  The arguments near and far are
 * the distances to the near and far clipping planes.  Note that near and far
 * are not z coordinates, but rather they are distances along the negative
 * z-axis.  The matrix generated sends the viewing frustum to the unit box.
 * We assume a unit box extending from -1 to 1 in the x and y dimensions and
 * from 0 to 1 in the z dimension.
 * @param {number} fieldOfViewYInRadians The camera angle from top to bottom (in radians).
 * @param {number} aspect The aspect ratio width / height.
 * @param {number} zNear The depth (negative z coordinate)
 *     of the near clipping plane.
 * @param {number} zFar The depth (negative z coordinate)
 *     of the far clipping plane.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The perspective matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$perspective(fieldOfViewYInRadians, aspect, zNear, zFar, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const f = Math.tan(Math.PI * 0.5 - 0.5 * fieldOfViewYInRadians);
    const rangeInv = 1.0 / (zNear - zFar);
    dst[0] = f / aspect;
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = f;
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = 0;
    dst[10] = (zNear + zFar) * rangeInv;
    dst[11] = -1;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = zNear * zFar * rangeInv * 2;
    dst[15] = 0;
    return dst;
}
/**
 * Computes a 4-by-4 orthogonal transformation matrix given the left, right,
 * bottom, and top dimensions of the near clipping plane as well as the
 * near and far clipping plane distances.
 * @param {number} left Left side of the near clipping plane viewport.
 * @param {number} right Right side of the near clipping plane viewport.
 * @param {number} bottom Bottom of the near clipping plane viewport.
 * @param {number} top Top of the near clipping plane viewport.
 * @param {number} near The depth (negative z coordinate)
 *     of the near clipping plane.
 * @param {number} far The depth (negative z coordinate)
 *     of the far clipping plane.
 * @param {module:twgl/m4.Mat4} [dst] Output matrix. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The perspective matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$ortho(left, right, bottom, top, near, far, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    dst[0] = 2 / (right - left);
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = 2 / (top - bottom);
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = 0;
    dst[10] = 2 / (near - far);
    dst[11] = 0;
    dst[12] = (right + left) / (left - right);
    dst[13] = (top + bottom) / (bottom - top);
    dst[14] = (far + near) / (near - far);
    dst[15] = 1;
    return dst;
}
/**
 * Computes a 4-by-4 perspective transformation matrix given the left, right,
 * top, bottom, near and far clipping planes. The arguments define a frustum
 * extending in the negative z direction. The arguments near and far are the
 * distances to the near and far clipping planes. Note that near and far are not
 * z coordinates, but rather they are distances along the negative z-axis. The
 * matrix generated sends the viewing frustum to the unit box. We assume a unit
 * box extending from -1 to 1 in the x and y dimensions and from 0 to 1 in the z
 * dimension.
 * @param {number} left The x coordinate of the left plane of the box.
 * @param {number} right The x coordinate of the right plane of the box.
 * @param {number} bottom The y coordinate of the bottom plane of the box.
 * @param {number} top The y coordinate of the right plane of the box.
 * @param {number} near The negative z coordinate of the near plane of the box.
 * @param {number} far The negative z coordinate of the far plane of the box.
 * @param {module:twgl/m4.Mat4} [dst] Output matrix. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The perspective projection matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$frustum(left, right, bottom, top, near, far, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const dx = right - left;
    const dy = top - bottom;
    const dz = near - far;
    dst[0] = 2 * near / dx;
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = 2 * near / dy;
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = (left + right) / dx;
    dst[9] = (top + bottom) / dy;
    dst[10] = far / dz;
    dst[11] = -1;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = near * far / dz;
    dst[15] = 0;
    return dst;
}
let $065afaecc735fbee$var$xAxis;
let $065afaecc735fbee$var$yAxis;
let $065afaecc735fbee$var$zAxis;
/**
 * Computes a 4-by-4 look-at transformation.
 *
 * This is a matrix which positions the camera itself. If you want
 * a view matrix (a matrix which moves things in front of the camera)
 * take the inverse of this.
 *
 * @param {module:twgl/v3.Vec3} eye The position of the eye.
 * @param {module:twgl/v3.Vec3} target The position meant to be viewed.
 * @param {module:twgl/v3.Vec3} up A vector pointing up.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The look-at matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$lookAt(eye, target, up, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    $065afaecc735fbee$var$xAxis = $065afaecc735fbee$var$xAxis || $065afaecc735fbee$var$create$1();
    $065afaecc735fbee$var$yAxis = $065afaecc735fbee$var$yAxis || $065afaecc735fbee$var$create$1();
    $065afaecc735fbee$var$zAxis = $065afaecc735fbee$var$zAxis || $065afaecc735fbee$var$create$1();
    $065afaecc735fbee$var$normalize($065afaecc735fbee$var$subtract(eye, target, $065afaecc735fbee$var$zAxis), $065afaecc735fbee$var$zAxis);
    $065afaecc735fbee$var$normalize($065afaecc735fbee$var$cross(up, $065afaecc735fbee$var$zAxis, $065afaecc735fbee$var$xAxis), $065afaecc735fbee$var$xAxis);
    $065afaecc735fbee$var$normalize($065afaecc735fbee$var$cross($065afaecc735fbee$var$zAxis, $065afaecc735fbee$var$xAxis, $065afaecc735fbee$var$yAxis), $065afaecc735fbee$var$yAxis);
    dst[0] = $065afaecc735fbee$var$xAxis[0];
    dst[1] = $065afaecc735fbee$var$xAxis[1];
    dst[2] = $065afaecc735fbee$var$xAxis[2];
    dst[3] = 0;
    dst[4] = $065afaecc735fbee$var$yAxis[0];
    dst[5] = $065afaecc735fbee$var$yAxis[1];
    dst[6] = $065afaecc735fbee$var$yAxis[2];
    dst[7] = 0;
    dst[8] = $065afaecc735fbee$var$zAxis[0];
    dst[9] = $065afaecc735fbee$var$zAxis[1];
    dst[10] = $065afaecc735fbee$var$zAxis[2];
    dst[11] = 0;
    dst[12] = eye[0];
    dst[13] = eye[1];
    dst[14] = eye[2];
    dst[15] = 1;
    return dst;
}
/**
 * Creates a 4-by-4 matrix which translates by the given vector v.
 * @param {module:twgl/v3.Vec3} v The vector by
 *     which to translate.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The translation matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$translation(v, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    dst[0] = 1;
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = 1;
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = 0;
    dst[10] = 1;
    dst[11] = 0;
    dst[12] = v[0];
    dst[13] = v[1];
    dst[14] = v[2];
    dst[15] = 1;
    return dst;
}
/**
 * Translates the given 4-by-4 matrix by the given vector v.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The vector by
 *     which to translate.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The translated matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$translate(m, v, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const v0 = v[0];
    const v1 = v[1];
    const v2 = v[2];
    const m00 = m[0];
    const m01 = m[1];
    const m02 = m[2];
    const m03 = m[3];
    const m10 = m[4];
    const m11 = m[5];
    const m12 = m[6];
    const m13 = m[7];
    const m20 = m[8];
    const m21 = m[9];
    const m22 = m[10];
    const m23 = m[11];
    const m30 = m[12];
    const m31 = m[13];
    const m32 = m[14];
    const m33 = m[15];
    if (m !== dst) {
        dst[0] = m00;
        dst[1] = m01;
        dst[2] = m02;
        dst[3] = m03;
        dst[4] = m10;
        dst[5] = m11;
        dst[6] = m12;
        dst[7] = m13;
        dst[8] = m20;
        dst[9] = m21;
        dst[10] = m22;
        dst[11] = m23;
    }
    dst[12] = m00 * v0 + m10 * v1 + m20 * v2 + m30;
    dst[13] = m01 * v0 + m11 * v1 + m21 * v2 + m31;
    dst[14] = m02 * v0 + m12 * v1 + m22 * v2 + m32;
    dst[15] = m03 * v0 + m13 * v1 + m23 * v2 + m33;
    return dst;
}
/**
 * Creates a 4-by-4 matrix which rotates around the x-axis by the given angle.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotation matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$rotationX(angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    dst[0] = 1;
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = c;
    dst[6] = s;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = -s;
    dst[10] = c;
    dst[11] = 0;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = 0;
    dst[15] = 1;
    return dst;
}
/**
 * Rotates the given 4-by-4 matrix around the x-axis by the given
 * angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$rotateX(m, angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const m10 = m[4];
    const m11 = m[5];
    const m12 = m[6];
    const m13 = m[7];
    const m20 = m[8];
    const m21 = m[9];
    const m22 = m[10];
    const m23 = m[11];
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    dst[4] = c * m10 + s * m20;
    dst[5] = c * m11 + s * m21;
    dst[6] = c * m12 + s * m22;
    dst[7] = c * m13 + s * m23;
    dst[8] = c * m20 - s * m10;
    dst[9] = c * m21 - s * m11;
    dst[10] = c * m22 - s * m12;
    dst[11] = c * m23 - s * m13;
    if (m !== dst) {
        dst[0] = m[0];
        dst[1] = m[1];
        dst[2] = m[2];
        dst[3] = m[3];
        dst[12] = m[12];
        dst[13] = m[13];
        dst[14] = m[14];
        dst[15] = m[15];
    }
    return dst;
}
/**
 * Creates a 4-by-4 matrix which rotates around the y-axis by the given angle.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotation matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$rotationY(angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    dst[0] = c;
    dst[1] = 0;
    dst[2] = -s;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = 1;
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = s;
    dst[9] = 0;
    dst[10] = c;
    dst[11] = 0;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = 0;
    dst[15] = 1;
    return dst;
}
/**
 * Rotates the given 4-by-4 matrix around the y-axis by the given
 * angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$rotateY(m, angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const m00 = m[0];
    const m01 = m[1];
    const m02 = m[2];
    const m03 = m[3];
    const m20 = m[8];
    const m21 = m[9];
    const m22 = m[10];
    const m23 = m[11];
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    dst[0] = c * m00 - s * m20;
    dst[1] = c * m01 - s * m21;
    dst[2] = c * m02 - s * m22;
    dst[3] = c * m03 - s * m23;
    dst[8] = c * m20 + s * m00;
    dst[9] = c * m21 + s * m01;
    dst[10] = c * m22 + s * m02;
    dst[11] = c * m23 + s * m03;
    if (m !== dst) {
        dst[4] = m[4];
        dst[5] = m[5];
        dst[6] = m[6];
        dst[7] = m[7];
        dst[12] = m[12];
        dst[13] = m[13];
        dst[14] = m[14];
        dst[15] = m[15];
    }
    return dst;
}
/**
 * Creates a 4-by-4 matrix which rotates around the z-axis by the given angle.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotation matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$rotationZ(angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    dst[0] = c;
    dst[1] = s;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = -s;
    dst[5] = c;
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = 0;
    dst[10] = 1;
    dst[11] = 0;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = 0;
    dst[15] = 1;
    return dst;
}
/**
 * Rotates the given 4-by-4 matrix around the z-axis by the given
 * angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$rotateZ(m, angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const m00 = m[0];
    const m01 = m[1];
    const m02 = m[2];
    const m03 = m[3];
    const m10 = m[4];
    const m11 = m[5];
    const m12 = m[6];
    const m13 = m[7];
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    dst[0] = c * m00 + s * m10;
    dst[1] = c * m01 + s * m11;
    dst[2] = c * m02 + s * m12;
    dst[3] = c * m03 + s * m13;
    dst[4] = c * m10 - s * m00;
    dst[5] = c * m11 - s * m01;
    dst[6] = c * m12 - s * m02;
    dst[7] = c * m13 - s * m03;
    if (m !== dst) {
        dst[8] = m[8];
        dst[9] = m[9];
        dst[10] = m[10];
        dst[11] = m[11];
        dst[12] = m[12];
        dst[13] = m[13];
        dst[14] = m[14];
        dst[15] = m[15];
    }
    return dst;
}
/**
 * Creates a 4-by-4 matrix which rotates around the given axis by the given
 * angle.
 * @param {module:twgl/v3.Vec3} axis The axis
 *     about which to rotate.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} A matrix which rotates angle radians
 *     around the axis.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$axisRotation(axis, angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    let x = axis[0];
    let y = axis[1];
    let z = axis[2];
    const n = Math.sqrt(x * x + y * y + z * z);
    x /= n;
    y /= n;
    z /= n;
    const xx = x * x;
    const yy = y * y;
    const zz = z * z;
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    const oneMinusCosine = 1 - c;
    dst[0] = xx + (1 - xx) * c;
    dst[1] = x * y * oneMinusCosine + z * s;
    dst[2] = x * z * oneMinusCosine - y * s;
    dst[3] = 0;
    dst[4] = x * y * oneMinusCosine - z * s;
    dst[5] = yy + (1 - yy) * c;
    dst[6] = y * z * oneMinusCosine + x * s;
    dst[7] = 0;
    dst[8] = x * z * oneMinusCosine + y * s;
    dst[9] = y * z * oneMinusCosine - x * s;
    dst[10] = zz + (1 - zz) * c;
    dst[11] = 0;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = 0;
    dst[15] = 1;
    return dst;
}
/**
 * Rotates the given 4-by-4 matrix around the given axis by the
 * given angle.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} axis The axis
 *     about which to rotate.
 * @param {number} angleInRadians The angle by which to rotate (in radians).
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The rotated matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$axisRotate(m, axis, angleInRadians, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    let x = axis[0];
    let y = axis[1];
    let z = axis[2];
    const n = Math.sqrt(x * x + y * y + z * z);
    x /= n;
    y /= n;
    z /= n;
    const xx = x * x;
    const yy = y * y;
    const zz = z * z;
    const c = Math.cos(angleInRadians);
    const s = Math.sin(angleInRadians);
    const oneMinusCosine = 1 - c;
    const r00 = xx + (1 - xx) * c;
    const r01 = x * y * oneMinusCosine + z * s;
    const r02 = x * z * oneMinusCosine - y * s;
    const r10 = x * y * oneMinusCosine - z * s;
    const r11 = yy + (1 - yy) * c;
    const r12 = y * z * oneMinusCosine + x * s;
    const r20 = x * z * oneMinusCosine + y * s;
    const r21 = y * z * oneMinusCosine - x * s;
    const r22 = zz + (1 - zz) * c;
    const m00 = m[0];
    const m01 = m[1];
    const m02 = m[2];
    const m03 = m[3];
    const m10 = m[4];
    const m11 = m[5];
    const m12 = m[6];
    const m13 = m[7];
    const m20 = m[8];
    const m21 = m[9];
    const m22 = m[10];
    const m23 = m[11];
    dst[0] = r00 * m00 + r01 * m10 + r02 * m20;
    dst[1] = r00 * m01 + r01 * m11 + r02 * m21;
    dst[2] = r00 * m02 + r01 * m12 + r02 * m22;
    dst[3] = r00 * m03 + r01 * m13 + r02 * m23;
    dst[4] = r10 * m00 + r11 * m10 + r12 * m20;
    dst[5] = r10 * m01 + r11 * m11 + r12 * m21;
    dst[6] = r10 * m02 + r11 * m12 + r12 * m22;
    dst[7] = r10 * m03 + r11 * m13 + r12 * m23;
    dst[8] = r20 * m00 + r21 * m10 + r22 * m20;
    dst[9] = r20 * m01 + r21 * m11 + r22 * m21;
    dst[10] = r20 * m02 + r21 * m12 + r22 * m22;
    dst[11] = r20 * m03 + r21 * m13 + r22 * m23;
    if (m !== dst) {
        dst[12] = m[12];
        dst[13] = m[13];
        dst[14] = m[14];
        dst[15] = m[15];
    }
    return dst;
}
/**
 * Creates a 4-by-4 matrix which scales in each dimension by an amount given by
 * the corresponding entry in the given vector; assumes the vector has three
 * entries.
 * @param {module:twgl/v3.Vec3} v A vector of
 *     three entries specifying the factor by which to scale in each dimension.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The scaling matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$scaling(v, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    dst[0] = v[0];
    dst[1] = 0;
    dst[2] = 0;
    dst[3] = 0;
    dst[4] = 0;
    dst[5] = v[1];
    dst[6] = 0;
    dst[7] = 0;
    dst[8] = 0;
    dst[9] = 0;
    dst[10] = v[2];
    dst[11] = 0;
    dst[12] = 0;
    dst[13] = 0;
    dst[14] = 0;
    dst[15] = 1;
    return dst;
}
/**
 * Scales the given 4-by-4 matrix in each dimension by an amount
 * given by the corresponding entry in the given vector; assumes the vector has
 * three entries.
 * @param {module:twgl/m4.Mat4} m The matrix to be modified.
 * @param {module:twgl/v3.Vec3} v A vector of three entries specifying the
 *     factor by which to scale in each dimension.
 * @param {module:twgl/m4.Mat4} [dst] matrix to hold result. If not passed a new one is created.
 * @return {module:twgl/m4.Mat4} The scaled matrix.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$scale(m, v, dst) {
    dst = dst || new $065afaecc735fbee$var$MatType(16);
    const v0 = v[0];
    const v1 = v[1];
    const v2 = v[2];
    dst[0] = v0 * m[0];
    dst[1] = v0 * m[1];
    dst[2] = v0 * m[2];
    dst[3] = v0 * m[3];
    dst[4] = v1 * m[4];
    dst[5] = v1 * m[5];
    dst[6] = v1 * m[6];
    dst[7] = v1 * m[7];
    dst[8] = v2 * m[8];
    dst[9] = v2 * m[9];
    dst[10] = v2 * m[10];
    dst[11] = v2 * m[11];
    if (m !== dst) {
        dst[12] = m[12];
        dst[13] = m[13];
        dst[14] = m[14];
        dst[15] = m[15];
    }
    return dst;
}
/**
 * Takes a 4-by-4 matrix and a vector with 3 entries,
 * interprets the vector as a point, transforms that point by the matrix, and
 * returns the result as a vector with 3 entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The point.
 * @param {module:twgl/v3.Vec3} [dst] optional vec3 to store result. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The transformed point.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$transformPoint(m, v, dst) {
    dst = dst || $065afaecc735fbee$var$create$1();
    const v0 = v[0];
    const v1 = v[1];
    const v2 = v[2];
    const d = v0 * m[3] + v1 * m[7] + v2 * m[11] + m[15];
    dst[0] = (v0 * m[0] + v1 * m[4] + v2 * m[8] + m[12]) / d;
    dst[1] = (v0 * m[1] + v1 * m[5] + v2 * m[9] + m[13]) / d;
    dst[2] = (v0 * m[2] + v1 * m[6] + v2 * m[10] + m[14]) / d;
    return dst;
}
/**
 * Takes a 4-by-4 matrix and a vector with 3 entries, interprets the vector as a
 * direction, transforms that direction by the matrix, and returns the result;
 * assumes the transformation of 3-dimensional space represented by the matrix
 * is parallel-preserving, i.e. any combination of rotation, scaling and
 * translation, but not a perspective distortion. Returns a vector with 3
 * entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The direction.
 * @param {module:twgl/v3.Vec3} [dst] optional Vec3 to store result. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The transformed direction.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$transformDirection(m, v, dst) {
    dst = dst || $065afaecc735fbee$var$create$1();
    const v0 = v[0];
    const v1 = v[1];
    const v2 = v[2];
    dst[0] = v0 * m[0] + v1 * m[4] + v2 * m[8];
    dst[1] = v0 * m[1] + v1 * m[5] + v2 * m[9];
    dst[2] = v0 * m[2] + v1 * m[6] + v2 * m[10];
    return dst;
}
/**
 * Takes a 4-by-4 matrix m and a vector v with 3 entries, interprets the vector
 * as a normal to a surface, and computes a vector which is normal upon
 * transforming that surface by the matrix. The effect of this function is the
 * same as transforming v (as a direction) by the inverse-transpose of m.  This
 * function assumes the transformation of 3-dimensional space represented by the
 * matrix is parallel-preserving, i.e. any combination of rotation, scaling and
 * translation, but not a perspective distortion.  Returns a vector with 3
 * entries.
 * @param {module:twgl/m4.Mat4} m The matrix.
 * @param {module:twgl/v3.Vec3} v The normal.
 * @param {module:twgl/v3.Vec3} [dst] The direction. If not passed a new one is created.
 * @return {module:twgl/v3.Vec3} The transformed normal.
 * @memberOf module:twgl/m4
 */ function $065afaecc735fbee$var$transformNormal$1(m, v, dst) {
    dst = dst || $065afaecc735fbee$var$create$1();
    const mi = $065afaecc735fbee$var$inverse(m);
    const v0 = v[0];
    const v1 = v[1];
    const v2 = v[2];
    dst[0] = v0 * mi[0] + v1 * mi[1] + v2 * mi[2];
    dst[1] = v0 * mi[4] + v1 * mi[5] + v2 * mi[6];
    dst[2] = v0 * mi[8] + v1 * mi[9] + v2 * mi[10];
    return dst;
}
var $065afaecc735fbee$export$e318184adb044c73 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    axisRotate: $065afaecc735fbee$var$axisRotate,
    axisRotation: $065afaecc735fbee$var$axisRotation,
    copy: $065afaecc735fbee$var$copy,
    create: $065afaecc735fbee$var$create,
    frustum: $065afaecc735fbee$var$frustum,
    getAxis: $065afaecc735fbee$var$getAxis,
    getTranslation: $065afaecc735fbee$var$getTranslation,
    identity: $065afaecc735fbee$var$identity,
    inverse: $065afaecc735fbee$var$inverse,
    lookAt: $065afaecc735fbee$var$lookAt,
    multiply: $065afaecc735fbee$var$multiply,
    negate: $065afaecc735fbee$var$negate,
    ortho: $065afaecc735fbee$var$ortho,
    perspective: $065afaecc735fbee$var$perspective,
    rotateX: $065afaecc735fbee$var$rotateX,
    rotateY: $065afaecc735fbee$var$rotateY,
    rotateZ: $065afaecc735fbee$var$rotateZ,
    rotationX: $065afaecc735fbee$var$rotationX,
    rotationY: $065afaecc735fbee$var$rotationY,
    rotationZ: $065afaecc735fbee$var$rotationZ,
    scale: $065afaecc735fbee$var$scale,
    scaling: $065afaecc735fbee$var$scaling,
    setAxis: $065afaecc735fbee$var$setAxis,
    setDefaultType: $065afaecc735fbee$var$setDefaultType,
    setTranslation: $065afaecc735fbee$var$setTranslation,
    transformDirection: $065afaecc735fbee$var$transformDirection,
    transformNormal: $065afaecc735fbee$var$transformNormal$1,
    transformPoint: $065afaecc735fbee$var$transformPoint,
    translate: $065afaecc735fbee$var$translate,
    translation: $065afaecc735fbee$var$translation,
    transpose: $065afaecc735fbee$var$transpose
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /* DataType */ const $065afaecc735fbee$var$BYTE$2 = 0x1400;
const $065afaecc735fbee$var$UNSIGNED_BYTE$3 = 0x1401;
const $065afaecc735fbee$var$SHORT$2 = 0x1402;
const $065afaecc735fbee$var$UNSIGNED_SHORT$3 = 0x1403;
const $065afaecc735fbee$var$INT$3 = 0x1404;
const $065afaecc735fbee$var$UNSIGNED_INT$3 = 0x1405;
const $065afaecc735fbee$var$FLOAT$3 = 0x1406;
const $065afaecc735fbee$var$UNSIGNED_SHORT_4_4_4_4$1 = 0x8033;
const $065afaecc735fbee$var$UNSIGNED_SHORT_5_5_5_1$1 = 0x8034;
const $065afaecc735fbee$var$UNSIGNED_SHORT_5_6_5$1 = 0x8363;
const $065afaecc735fbee$var$HALF_FLOAT$1 = 0x140B;
const $065afaecc735fbee$var$UNSIGNED_INT_2_10_10_10_REV$1 = 0x8368;
const $065afaecc735fbee$var$UNSIGNED_INT_10F_11F_11F_REV$1 = 0x8C3B;
const $065afaecc735fbee$var$UNSIGNED_INT_5_9_9_9_REV$1 = 0x8C3E;
const $065afaecc735fbee$var$FLOAT_32_UNSIGNED_INT_24_8_REV$1 = 0x8DAD;
const $065afaecc735fbee$var$UNSIGNED_INT_24_8$1 = 0x84FA;
const $065afaecc735fbee$var$glTypeToTypedArray = {};
{
    const tt = $065afaecc735fbee$var$glTypeToTypedArray;
    tt[$065afaecc735fbee$var$BYTE$2] = Int8Array;
    tt[$065afaecc735fbee$var$UNSIGNED_BYTE$3] = Uint8Array;
    tt[$065afaecc735fbee$var$SHORT$2] = Int16Array;
    tt[$065afaecc735fbee$var$UNSIGNED_SHORT$3] = Uint16Array;
    tt[$065afaecc735fbee$var$INT$3] = Int32Array;
    tt[$065afaecc735fbee$var$UNSIGNED_INT$3] = Uint32Array;
    tt[$065afaecc735fbee$var$FLOAT$3] = Float32Array;
    tt[$065afaecc735fbee$var$UNSIGNED_SHORT_4_4_4_4$1] = Uint16Array;
    tt[$065afaecc735fbee$var$UNSIGNED_SHORT_5_5_5_1$1] = Uint16Array;
    tt[$065afaecc735fbee$var$UNSIGNED_SHORT_5_6_5$1] = Uint16Array;
    tt[$065afaecc735fbee$var$HALF_FLOAT$1] = Uint16Array;
    tt[$065afaecc735fbee$var$UNSIGNED_INT_2_10_10_10_REV$1] = Uint32Array;
    tt[$065afaecc735fbee$var$UNSIGNED_INT_10F_11F_11F_REV$1] = Uint32Array;
    tt[$065afaecc735fbee$var$UNSIGNED_INT_5_9_9_9_REV$1] = Uint32Array;
    tt[$065afaecc735fbee$var$FLOAT_32_UNSIGNED_INT_24_8_REV$1] = Uint32Array;
    tt[$065afaecc735fbee$var$UNSIGNED_INT_24_8$1] = Uint32Array;
}/**
 * Get the GL type for a typedArray
 * @param {ArrayBufferView} typedArray a typedArray
 * @return {number} the GL type for array. For example pass in an `Int8Array` and `gl.BYTE` will
 *   be returned. Pass in a `Uint32Array` and `gl.UNSIGNED_INT` will be returned
 * @memberOf module:twgl/typedArray
 */ function $065afaecc735fbee$export$bddf845047a0e959(typedArray) {
    if (typedArray instanceof Int8Array) return $065afaecc735fbee$var$BYTE$2;
     // eslint-disable-line
    if (typedArray instanceof Uint8Array) return $065afaecc735fbee$var$UNSIGNED_BYTE$3;
     // eslint-disable-line
    if (typedArray instanceof Uint8ClampedArray) return $065afaecc735fbee$var$UNSIGNED_BYTE$3;
     // eslint-disable-line
    if (typedArray instanceof Int16Array) return $065afaecc735fbee$var$SHORT$2;
     // eslint-disable-line
    if (typedArray instanceof Uint16Array) return $065afaecc735fbee$var$UNSIGNED_SHORT$3;
     // eslint-disable-line
    if (typedArray instanceof Int32Array) return $065afaecc735fbee$var$INT$3;
     // eslint-disable-line
    if (typedArray instanceof Uint32Array) return $065afaecc735fbee$var$UNSIGNED_INT$3;
     // eslint-disable-line
    if (typedArray instanceof Float32Array) return $065afaecc735fbee$var$FLOAT$3;
     // eslint-disable-line
    throw new Error('unsupported typed array type');
}
/**
 * Get the GL type for a typedArray type
 * @param {ArrayBufferView} typedArrayType a typedArray constructor
 * @return {number} the GL type for type. For example pass in `Int8Array` and `gl.BYTE` will
 *   be returned. Pass in `Uint32Array` and `gl.UNSIGNED_INT` will be returned
 * @memberOf module:twgl/typedArray
 */ function $065afaecc735fbee$export$9546290c15d36fce(typedArrayType) {
    if (typedArrayType === Int8Array) return $065afaecc735fbee$var$BYTE$2;
     // eslint-disable-line
    if (typedArrayType === Uint8Array) return $065afaecc735fbee$var$UNSIGNED_BYTE$3;
     // eslint-disable-line
    if (typedArrayType === Uint8ClampedArray) return $065afaecc735fbee$var$UNSIGNED_BYTE$3;
     // eslint-disable-line
    if (typedArrayType === Int16Array) return $065afaecc735fbee$var$SHORT$2;
     // eslint-disable-line
    if (typedArrayType === Uint16Array) return $065afaecc735fbee$var$UNSIGNED_SHORT$3;
     // eslint-disable-line
    if (typedArrayType === Int32Array) return $065afaecc735fbee$var$INT$3;
     // eslint-disable-line
    if (typedArrayType === Uint32Array) return $065afaecc735fbee$var$UNSIGNED_INT$3;
     // eslint-disable-line
    if (typedArrayType === Float32Array) return $065afaecc735fbee$var$FLOAT$3;
     // eslint-disable-line
    throw new Error('unsupported typed array type');
}
/**
 * Get the typed array constructor for a given GL type
 * @param {number} type the GL type. (eg: `gl.UNSIGNED_INT`)
 * @return {function} the constructor for a the corresponding typed array. (eg. `Uint32Array`).
 * @memberOf module:twgl/typedArray
 */ function $065afaecc735fbee$export$3dc63662699923fc(type) {
    const CTOR = $065afaecc735fbee$var$glTypeToTypedArray[type];
    if (!CTOR) throw new Error('unknown gl type');
    return CTOR;
}
const $065afaecc735fbee$export$9dd3754ae86f0017 = typeof SharedArrayBuffer !== 'undefined' ? function isArrayBufferOrSharedArrayBuffer(a) {
    return a && a.buffer && (a.buffer instanceof ArrayBuffer || a.buffer instanceof SharedArrayBuffer);
} : function isArrayBuffer(a) {
    return a && a.buffer && a.buffer instanceof ArrayBuffer;
};
var $065afaecc735fbee$export$f3712bedb282625f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getGLTypeForTypedArray: $065afaecc735fbee$export$bddf845047a0e959,
    getGLTypeForTypedArrayType: $065afaecc735fbee$export$9546290c15d36fce,
    getTypedArrayTypeForGLType: $065afaecc735fbee$export$3dc63662699923fc,
    isArrayBuffer: $065afaecc735fbee$export$9dd3754ae86f0017
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /* eslint no-console: "off" */ /**
 * Copy named properties
 *
 * @param {string[]} names names of properties to copy
 * @param {object} src object to copy properties from
 * @param {object} dst object to copy properties to
 * @private
 */ function $065afaecc735fbee$var$copyNamedProperties(names, src, dst) {
    names.forEach(function(name) {
        const value = src[name];
        if (value !== undefined) dst[name] = value;
    });
}
/**
 * Copies properties from source to dest only if a matching key is in dest
 *
 * @param {Object.<string, ?>} src the source
 * @param {Object.<string, ?>} dst the dest
 * @private
 */ function $065afaecc735fbee$var$copyExistingProperties(src, dst) {
    Object.keys(dst).forEach(function(key) {
        if (dst.hasOwnProperty(key) && src.hasOwnProperty(key)) dst[key] = src[key];
    });
}
function $065afaecc735fbee$var$error$1(...args) {
    console.error(...args);
}
function $065afaecc735fbee$var$warn$1(...args) {
    console.warn(...args);
}
const $065afaecc735fbee$var$isTypeWeakMaps = new Map();
function $065afaecc735fbee$var$isType(object, type) {
    if (!object || typeof object !== 'object') return false;
    let weakMap = $065afaecc735fbee$var$isTypeWeakMaps.get(type);
    if (!weakMap) {
        weakMap = new WeakMap();
        $065afaecc735fbee$var$isTypeWeakMaps.set(type, weakMap);
    }
    let isOfType = weakMap.get(object);
    if (isOfType === undefined) {
        const s = Object.prototype.toString.call(object);
        isOfType = s.substring(8, s.length - 1) === type;
        weakMap.set(object, isOfType);
    }
    return isOfType;
}
function $065afaecc735fbee$var$isBuffer(gl, t) {
    return typeof WebGLBuffer !== 'undefined' && $065afaecc735fbee$var$isType(t, 'WebGLBuffer');
}
function $065afaecc735fbee$var$isRenderbuffer(gl, t) {
    return typeof WebGLRenderbuffer !== 'undefined' && $065afaecc735fbee$var$isType(t, 'WebGLRenderbuffer');
}
function $065afaecc735fbee$var$isTexture(gl, t) {
    return typeof WebGLTexture !== 'undefined' && $065afaecc735fbee$var$isType(t, 'WebGLTexture');
}
function $065afaecc735fbee$var$isSampler(gl, t) {
    return typeof WebGLSampler !== 'undefined' && $065afaecc735fbee$var$isType(t, 'WebGLSampler');
}
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ const $065afaecc735fbee$var$STATIC_DRAW = 0x88e4;
const $065afaecc735fbee$var$ARRAY_BUFFER$1 = 0x8892;
const $065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER$2 = 0x8893;
const $065afaecc735fbee$var$BUFFER_SIZE = 0x8764;
const $065afaecc735fbee$var$BYTE$1 = 0x1400;
const $065afaecc735fbee$var$UNSIGNED_BYTE$2 = 0x1401;
const $065afaecc735fbee$var$SHORT$1 = 0x1402;
const $065afaecc735fbee$var$UNSIGNED_SHORT$2 = 0x1403;
const $065afaecc735fbee$var$INT$2 = 0x1404;
const $065afaecc735fbee$var$UNSIGNED_INT$2 = 0x1405;
const $065afaecc735fbee$var$FLOAT$2 = 0x1406;
const $065afaecc735fbee$var$defaults$2 = {
    attribPrefix: ""
};
/**
 * Sets the default attrib prefix
 *
 * When writing shaders I prefer to name attributes with `a_`, uniforms with `u_` and varyings with `v_`
 * as it makes it clear where they came from. But, when building geometry I prefer using un-prefixed names.
 *
 * In other words I'll create arrays of geometry like this
 *
 *     var arrays = {
 *       position: ...
 *       normal: ...
 *       texcoord: ...
 *     };
 *
 * But need those mapped to attributes and my attributes start with `a_`.
 *
 * @deprecated see {@link module:twgl.setDefaults}
 * @param {string} prefix prefix for attribs
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$8a79157a77253422(prefix) {
    $065afaecc735fbee$var$defaults$2.attribPrefix = prefix;
}
function $065afaecc735fbee$export$81400a733c5c400b(newDefaults) {
    $065afaecc735fbee$var$copyExistingProperties(newDefaults, $065afaecc735fbee$var$defaults$2);
}
function $065afaecc735fbee$var$setBufferFromTypedArray(gl, type, buffer, array, drawType) {
    gl.bindBuffer(type, buffer);
    gl.bufferData(type, array, drawType || $065afaecc735fbee$var$STATIC_DRAW);
}
/**
 * Given typed array creates a WebGLBuffer and copies the typed array
 * into it.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {ArrayBuffer|SharedArrayBuffer|ArrayBufferView|WebGLBuffer} typedArray the typed array. Note: If a WebGLBuffer is passed in it will just be returned. No action will be taken
 * @param {number} [type] the GL bind type for the buffer. Default = `gl.ARRAY_BUFFER`.
 * @param {number} [drawType] the GL draw type for the buffer. Default = 'gl.STATIC_DRAW`.
 * @return {WebGLBuffer} the created WebGLBuffer
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$6ea00fe9d038b3f9(gl, typedArray, type, drawType) {
    if ($065afaecc735fbee$var$isBuffer(gl, typedArray)) return typedArray;
    type = type || $065afaecc735fbee$var$ARRAY_BUFFER$1;
    const buffer = gl.createBuffer();
    $065afaecc735fbee$var$setBufferFromTypedArray(gl, type, buffer, typedArray, drawType);
    return buffer;
}
function $065afaecc735fbee$var$isIndices(name) {
    return name === "indices";
}
// This is really just a guess. Though I can't really imagine using
// anything else? Maybe for some compression?
function $065afaecc735fbee$var$getNormalizationForTypedArrayType(typedArrayType) {
    if (typedArrayType === Int8Array) return true;
     // eslint-disable-line
    if (typedArrayType === Uint8Array) return true;
     // eslint-disable-line
    return false;
}
function $065afaecc735fbee$export$251e3bdee27f62a4(array) {
    return array.length ? array : array.data;
}
const $065afaecc735fbee$var$texcoordRE = /coord|texture/i;
const $065afaecc735fbee$var$colorRE = /color|colour/i;
function $065afaecc735fbee$var$guessNumComponentsFromName(name, length1) {
    let numComponents;
    if ($065afaecc735fbee$var$texcoordRE.test(name)) numComponents = 2;
    else if ($065afaecc735fbee$var$colorRE.test(name)) numComponents = 4;
    else numComponents = 3; // position, normals, indices ...
    if (length1 % numComponents > 0) throw new Error(`Can not guess numComponents for attribute '${name}'. Tried ${numComponents} but ${length1} values is not evenly divisible by ${numComponents}. You should specify it.`);
    return numComponents;
}
function $065afaecc735fbee$export$bfceede8dab24cbd(array, arrayName, numValues) {
    return array.numComponents || array.size || $065afaecc735fbee$var$guessNumComponentsFromName(arrayName, numValues || $065afaecc735fbee$export$251e3bdee27f62a4(array).length);
}
function $065afaecc735fbee$var$makeTypedArray(array, name) {
    if ($065afaecc735fbee$export$9dd3754ae86f0017(array)) return array;
    if ($065afaecc735fbee$export$9dd3754ae86f0017(array.data)) return array.data;
    if (Array.isArray(array)) array = {
        data: array
    };
    let Type = array.type ? $065afaecc735fbee$var$typedArrayTypeFromGLTypeOrTypedArrayCtor(array.type) : undefined;
    if (!Type) {
        if ($065afaecc735fbee$var$isIndices(name)) Type = Uint16Array;
        else Type = Float32Array;
    }
    return new Type(array.data);
}
function $065afaecc735fbee$var$glTypeFromGLTypeOrTypedArrayType(glTypeOrTypedArrayCtor) {
    return typeof glTypeOrTypedArrayCtor === 'number' ? glTypeOrTypedArrayCtor : glTypeOrTypedArrayCtor ? $065afaecc735fbee$export$9546290c15d36fce(glTypeOrTypedArrayCtor) : $065afaecc735fbee$var$FLOAT$2;
}
function $065afaecc735fbee$var$typedArrayTypeFromGLTypeOrTypedArrayCtor(glTypeOrTypedArrayCtor) {
    return typeof glTypeOrTypedArrayCtor === 'number' ? $065afaecc735fbee$export$3dc63662699923fc(glTypeOrTypedArrayCtor) : glTypeOrTypedArrayCtor || Float32Array;
}
function $065afaecc735fbee$var$attribBufferFromBuffer(gl, array /*, arrayName */ ) {
    return {
        buffer: array.buffer,
        numValues: 24,
        type: $065afaecc735fbee$var$glTypeFromGLTypeOrTypedArrayType(array.type),
        arrayType: $065afaecc735fbee$var$typedArrayTypeFromGLTypeOrTypedArrayCtor(array.type)
    };
}
function $065afaecc735fbee$var$attribBufferFromSize(gl, array /*, arrayName*/ ) {
    const numValues = array.data || array;
    const arrayType = $065afaecc735fbee$var$typedArrayTypeFromGLTypeOrTypedArrayCtor(array.type);
    const numBytes = numValues * arrayType.BYTES_PER_ELEMENT;
    const buffer = gl.createBuffer();
    gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER$1, buffer);
    gl.bufferData($065afaecc735fbee$var$ARRAY_BUFFER$1, numBytes, array.drawType || $065afaecc735fbee$var$STATIC_DRAW);
    return {
        buffer: buffer,
        numValues: numValues,
        type: $065afaecc735fbee$export$9546290c15d36fce(arrayType),
        arrayType: arrayType
    };
}
function $065afaecc735fbee$var$attribBufferFromArrayLike(gl, array, arrayName) {
    const typedArray = $065afaecc735fbee$var$makeTypedArray(array, arrayName);
    return {
        arrayType: typedArray.constructor,
        buffer: $065afaecc735fbee$export$6ea00fe9d038b3f9(gl, typedArray, undefined, array.drawType),
        type: $065afaecc735fbee$export$bddf845047a0e959(typedArray),
        numValues: 0
    };
}
/**
 * The info for an attribute. This is effectively just the arguments to `gl.vertexAttribPointer` plus the WebGLBuffer
 * for the attribute.
 *
 * @typedef {Object} AttribInfo
 * @property {number[]|ArrayBufferView} [value] a constant value for the attribute. Note: if this is set the attribute will be
 *    disabled and set to this constant value and all other values will be ignored.
 * @property {number} [numComponents] the number of components for this attribute.
 * @property {number} [size] synonym for `numComponents`.
 * @property {number} [type] the type of the attribute (eg. `gl.FLOAT`, `gl.UNSIGNED_BYTE`, etc...) Default = `gl.FLOAT`
 * @property {boolean} [normalize] whether or not to normalize the data. Default = false
 * @property {number} [offset] offset into buffer in bytes. Default = 0
 * @property {number} [stride] the stride in bytes per element. Default = 0
 * @property {number} [divisor] the divisor in instances. Default = 0.
 *    Requires WebGL2 or the ANGLE_instanced_arrays extension.
 *    and, if you're using WebGL1 you must have called {@link module:twgl.addExtensionsToContext}
 * @property {WebGLBuffer} buffer the buffer that contains the data for this attribute
 * @property {number} [drawType] the draw type passed to gl.bufferData. Default = gl.STATIC_DRAW
 * @memberOf module:twgl
 */ /**
 * @typedef {(Int8ArrayConstructor|Uint8ArrayConstructor|Int16ArrayConstructor|Uint16ArrayConstructor|Int32ArrayConstructor|Uint32ArrayConstructor|Float32ArrayConstructor)} TypedArrayConstructor
 */ /**
 * Use this type of array spec when TWGL can't guess the type or number of components of an array
 * @typedef {Object} FullArraySpec
 * @property {number[]|ArrayBufferView} [value] a constant value for the attribute. Note: if this is set the attribute will be
 *    disabled and set to this constant value and all other values will be ignored.
 * @property {(number|number[]|ArrayBufferView)} [data] The data of the array. A number alone becomes the number of elements of type.
 * @property {number} [numComponents] number of components for `vertexAttribPointer`. Default is based on the name of the array.
 *    If `coord` is in the name assumes `numComponents = 2`.
 *    If `color` is in the name assumes `numComponents = 4`.
 *    otherwise assumes `numComponents = 3`
 * @property {number|TypedArrayConstructor} [type] type. This is used if `data` is a JavaScript array, or `buffer` is passed in, or `data` is a number.
 *   It can either be the constructor for a typedarray. (eg. `Uint8Array`) OR a WebGL type, (eg `gl.UNSIGNED_BYTE`).
 *   For example if you want colors in a `Uint8Array` you might have a `FullArraySpec` like `{ type: gl.UNSIGNED_BYTE, data: [255,0,255,255, ...], }`.
 * @property {number} [size] synonym for `numComponents`.
 * @property {boolean} [normalize] normalize for `vertexAttribPointer`. Default is true if type is `Int8Array` or `Uint8Array` otherwise false.
 * @property {number} [stride] stride for `vertexAttribPointer`. Default = 0
 * @property {number} [offset] offset for `vertexAttribPointer`. Default = 0
 * @property {number} [divisor] divisor for `vertexAttribDivisor`. Default = 0.
 *     Requires WebGL2 or the ANGLE_instanced_arrays extension.
 *     and, if you using WebGL1 you must have called {@link module:twgl.addExtensionsToContext}
 * @property {string} [attrib] name of attribute this array maps to. Defaults to same name as array prefixed by the default attribPrefix.
 * @property {string} [name] synonym for `attrib`.
 * @property {string} [attribName] synonym for `attrib`.
 * @property {WebGLBuffer} [buffer] Buffer to use for this attribute. This lets you use your own buffer
 *    but you will need to supply `numComponents` and `type`. You can effectively pass an `AttribInfo`
 *    to provide this. Example:
 *
 *         const bufferInfo1 = twgl.createBufferInfoFromArrays(gl, {
 *           position: [1, 2, 3, ... ],
 *         });
 *         const bufferInfo2 = twgl.createBufferInfoFromArrays(gl, {
 *           position: bufferInfo1.attribs.position,  // use the same buffer from bufferInfo1
 *         });
 *
 * @property {number} [drawType] the draw type passed to gl.bufferData. Default = gl.STATIC_DRAW
 * @memberOf module:twgl
 */ /**
 * An individual array in {@link module:twgl.Arrays}
 *
 * When passed to {@link module:twgl.createBufferInfoFromArrays} if an ArraySpec is `number[]` or `ArrayBufferView`
 * the types will be guessed based on the name. `indices` will be `Uint16Array`, everything else will
 * be `Float32Array`. If an ArraySpec is a number it's the number of floats for an empty (zeroed) buffer.
 *
 * @typedef {(number|number[]|ArrayBufferView|module:twgl.FullArraySpec)} ArraySpec
 * @memberOf module:twgl
 */ /**
 * This is a JavaScript object of arrays by name. The names should match your shader's attributes. If your
 * attributes have a common prefix you can specify it by calling {@link module:twgl.setAttributePrefix}.
 *
 *     Bare JavaScript Arrays
 *
 *         var arrays = {
 *            position: [-1, 1, 0],
 *            normal: [0, 1, 0],
 *            ...
 *         }
 *
 *     Bare TypedArrays
 *
 *         var arrays = {
 *            position: new Float32Array([-1, 1, 0]),
 *            color: new Uint8Array([255, 128, 64, 255]),
 *            ...
 *         }
 *
 * *   Will guess at `numComponents` if not specified based on name.
 *
 *     If `coord` is in the name assumes `numComponents = 2`
 *
 *     If `color` is in the name assumes `numComponents = 4`
 *
 *     otherwise assumes `numComponents = 3`
 *
 * Objects with various fields. See {@link module:twgl.FullArraySpec}.
 *
 *     var arrays = {
 *       position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *       texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *       normal:   { numComponents: 3, data: [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],     },
 *       indices:  { numComponents: 3, data: [0, 1, 2, 1, 2, 3],                       },
 *     };
 *
 * @typedef {Object.<string, module:twgl.ArraySpec>} Arrays
 * @memberOf module:twgl
 */ /**
 * Creates a set of attribute data and WebGLBuffers from set of arrays
 *
 * Given
 *
 *      var arrays = {
 *        position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *        texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *        normal:   { numComponents: 3, data: [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],     },
 *        color:    { numComponents: 4, data: [255, 255, 255, 255, 255, 0, 0, 255, 0, 0, 255, 255], type: Uint8Array, },
 *        indices:  { numComponents: 3, data: [0, 1, 2, 1, 2, 3],                       },
 *      };
 *
 * returns something like
 *
 *      var attribs = {
 *        position: { numComponents: 3, type: gl.FLOAT,         normalize: false, buffer: WebGLBuffer, },
 *        texcoord: { numComponents: 2, type: gl.FLOAT,         normalize: false, buffer: WebGLBuffer, },
 *        normal:   { numComponents: 3, type: gl.FLOAT,         normalize: false, buffer: WebGLBuffer, },
 *        color:    { numComponents: 4, type: gl.UNSIGNED_BYTE, normalize: true,  buffer: WebGLBuffer, },
 *      };
 *
 * notes:
 *
 * *   Arrays can take various forms
 *
 *     Bare JavaScript Arrays
 *
 *         var arrays = {
 *            position: [-1, 1, 0],
 *            normal: [0, 1, 0],
 *            ...
 *         }
 *
 *     Bare TypedArrays
 *
 *         var arrays = {
 *            position: new Float32Array([-1, 1, 0]),
 *            color: new Uint8Array([255, 128, 64, 255]),
 *            ...
 *         }
 *
 * *   Will guess at `numComponents` if not specified based on name.
 *
 *     If `coord` is in the name assumes `numComponents = 2`
 *
 *     If `color` is in the name assumes `numComponents = 4`
 *
 *     otherwise assumes `numComponents = 3`
 *
 * @param {WebGLRenderingContext} gl The webgl rendering context.
 * @param {module:twgl.Arrays} arrays The arrays
 * @param {module:twgl.BufferInfo} [srcBufferInfo] a BufferInfo to copy from
 *   This lets you share buffers. Any arrays you supply will override
 *   the buffers from srcBufferInfo.
 * @return {Object.<string, module:twgl.AttribInfo>} the attribs
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$df835e2df67be3fe(gl, arrays) {
    const attribs = {};
    Object.keys(arrays).forEach(function(arrayName) {
        if (!$065afaecc735fbee$var$isIndices(arrayName)) {
            const array = arrays[arrayName];
            const attribName = array.attrib || array.name || array.attribName || $065afaecc735fbee$var$defaults$2.attribPrefix + arrayName;
            if (array.value) {
                if (!Array.isArray(array.value) && !$065afaecc735fbee$export$9dd3754ae86f0017(array.value)) throw new Error('array.value is not array or typedarray');
                attribs[attribName] = {
                    value: array.value
                };
            } else {
                let fn;
                if (array.buffer && array.buffer instanceof WebGLBuffer) fn = $065afaecc735fbee$var$attribBufferFromBuffer;
                else if (typeof array === "number" || typeof array.data === "number") fn = $065afaecc735fbee$var$attribBufferFromSize;
                else fn = $065afaecc735fbee$var$attribBufferFromArrayLike;
                const { buffer: buffer, type: type, numValues: numValues, arrayType: arrayType } = fn(gl, array, arrayName);
                const normalization = array.normalize !== undefined ? array.normalize : $065afaecc735fbee$var$getNormalizationForTypedArrayType(arrayType);
                const numComponents = $065afaecc735fbee$export$bfceede8dab24cbd(array, arrayName, numValues);
                attribs[attribName] = {
                    buffer: buffer,
                    numComponents: numComponents,
                    type: type,
                    normalize: normalization,
                    stride: array.stride || 0,
                    offset: array.offset || 0,
                    divisor: array.divisor === undefined ? undefined : array.divisor,
                    drawType: array.drawType
                };
            }
        }
    });
    gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER$1, null);
    return attribs;
}
/**
 * Sets the contents of a buffer attached to an attribInfo
 *
 * This is helper function to dynamically update a buffer.
 *
 * Let's say you make a bufferInfo
 *
 *     var arrays = {
 *        position: new Float32Array([0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0]),
 *        texcoord: new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]),
 *        normal:   new Float32Array([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]),
 *        indices:  new Uint16Array([0, 1, 2, 1, 2, 3]),
 *     };
 *     var bufferInfo = twgl.createBufferInfoFromArrays(gl, arrays);
 *
 *  And you want to dynamically update the positions. You could do this
 *
 *     // assuming arrays.position has already been updated with new data.
 *     twgl.setAttribInfoBufferFromArray(gl, bufferInfo.attribs.position, arrays.position);
 *
 * @param {WebGLRenderingContext} gl
 * @param {AttribInfo} attribInfo The attribInfo who's buffer contents to set. NOTE: If you have an attribute prefix
 *   the name of the attribute will include the prefix.
 * @param {ArraySpec} array Note: it is arguably inefficient to pass in anything but a typed array because anything
 *    else will have to be converted to a typed array before it can be used by WebGL. During init time that
 *    inefficiency is usually not important but if you're updating data dynamically best to be efficient.
 * @param {number} [offset] an optional offset into the buffer. This is only an offset into the WebGL buffer
 *    not the array. To pass in an offset into the array itself use a typed array and create an `ArrayBufferView`
 *    for the portion of the array you want to use.
 *
 *        var someArray = new Float32Array(1000); // an array with 1000 floats
 *        var someSubArray = new Float32Array(someArray.buffer, offsetInBytes, sizeInUnits); // a view into someArray
 *
 *    Now you can pass `someSubArray` into setAttribInfoBufferFromArray`
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$22dc7d5fce8749be(gl, attribInfo, array, offset) {
    array = $065afaecc735fbee$var$makeTypedArray(array);
    if (offset !== undefined) {
        gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER$1, attribInfo.buffer);
        gl.bufferSubData($065afaecc735fbee$var$ARRAY_BUFFER$1, offset, array);
    } else $065afaecc735fbee$var$setBufferFromTypedArray(gl, $065afaecc735fbee$var$ARRAY_BUFFER$1, attribInfo.buffer, array, attribInfo.drawType);
}
function $065afaecc735fbee$var$getBytesPerValueForGLType(gl, type) {
    if (type === $065afaecc735fbee$var$BYTE$1) return 1; // eslint-disable-line
    if (type === $065afaecc735fbee$var$UNSIGNED_BYTE$2) return 1; // eslint-disable-line
    if (type === $065afaecc735fbee$var$SHORT$1) return 2; // eslint-disable-line
    if (type === $065afaecc735fbee$var$UNSIGNED_SHORT$2) return 2; // eslint-disable-line
    if (type === $065afaecc735fbee$var$INT$2) return 4; // eslint-disable-line
    if (type === $065afaecc735fbee$var$UNSIGNED_INT$2) return 4; // eslint-disable-line
    if (type === $065afaecc735fbee$var$FLOAT$2) return 4; // eslint-disable-line
    return 0;
}
// Tries to get the number of elements from a set of arrays.
const $065afaecc735fbee$var$positionKeys = [
    'position',
    'positions',
    'a_position'
];
function $065afaecc735fbee$var$getNumElementsFromNonIndexedArrays(arrays) {
    let key;
    let ii;
    for(ii = 0; ii < $065afaecc735fbee$var$positionKeys.length; ++ii){
        key = $065afaecc735fbee$var$positionKeys[ii];
        if (key in arrays) break;
    }
    if (ii === $065afaecc735fbee$var$positionKeys.length) key = Object.keys(arrays)[0];
    const array = arrays[key];
    const length1 = $065afaecc735fbee$export$251e3bdee27f62a4(array).length;
    if (length1 === undefined) return 1; // There's no arrays
    const numComponents = $065afaecc735fbee$export$bfceede8dab24cbd(array, key);
    const numElements = length1 / numComponents;
    if (length1 % numComponents > 0) throw new Error(`numComponents ${numComponents} not correct for length ${length1}`);
    return numElements;
}
function $065afaecc735fbee$var$getNumElementsFromAttributes(gl, attribs) {
    let key;
    let ii;
    for(ii = 0; ii < $065afaecc735fbee$var$positionKeys.length; ++ii){
        key = $065afaecc735fbee$var$positionKeys[ii];
        if (key in attribs) break;
        key = $065afaecc735fbee$var$defaults$2.attribPrefix + key;
        if (key in attribs) break;
    }
    if (ii === $065afaecc735fbee$var$positionKeys.length) key = Object.keys(attribs)[0];
    const attrib = attribs[key];
    if (!attrib.buffer) return 1; // There's no buffer
    gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER$1, attrib.buffer);
    const numBytes = gl.getBufferParameter($065afaecc735fbee$var$ARRAY_BUFFER$1, $065afaecc735fbee$var$BUFFER_SIZE);
    gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER$1, null);
    const bytesPerValue = $065afaecc735fbee$var$getBytesPerValueForGLType(gl, attrib.type);
    const totalElements = numBytes / bytesPerValue;
    const numComponents = attrib.numComponents || attrib.size;
    // TODO: check stride
    const numElements = totalElements / numComponents;
    if (numElements % 1 !== 0) throw new Error(`numComponents ${numComponents} not correct for length ${length}`);
    return numElements;
}
/**
 * @typedef {Object} BufferInfo
 * @property {number} numElements The number of elements to pass to `gl.drawArrays` or `gl.drawElements`.
 * @property {number} [elementType] The type of indices `UNSIGNED_BYTE`, `UNSIGNED_SHORT` etc..
 * @property {WebGLBuffer} [indices] The indices `ELEMENT_ARRAY_BUFFER` if any indices exist.
 * @property {Object.<string, module:twgl.AttribInfo>} [attribs] The attribs appropriate to call `setAttributes`
 * @memberOf module:twgl
 */ /**
 * Creates a BufferInfo from an object of arrays.
 *
 * This can be passed to {@link module:twgl.setBuffersAndAttributes} and to
 * {@link module:twgl:drawBufferInfo}.
 *
 * Given an object like
 *
 *     var arrays = {
 *       position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *       texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *       normal:   { numComponents: 3, data: [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],     },
 *       indices:  { numComponents: 3, data: [0, 1, 2, 1, 2, 3],                       },
 *     };
 *
 *  Creates an BufferInfo like this
 *
 *     bufferInfo = {
 *       numElements: 4,        // or whatever the number of elements is
 *       indices: WebGLBuffer,  // this property will not exist if there are no indices
 *       attribs: {
 *         position: { buffer: WebGLBuffer, numComponents: 3, },
 *         normal:   { buffer: WebGLBuffer, numComponents: 3, },
 *         texcoord: { buffer: WebGLBuffer, numComponents: 2, },
 *       },
 *     };
 *
 *  The properties of arrays can be JavaScript arrays in which case the number of components
 *  will be guessed.
 *
 *     var arrays = {
 *        position: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0],
 *        texcoord: [0, 0, 0, 1, 1, 0, 1, 1],
 *        normal:   [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],
 *        indices:  [0, 1, 2, 1, 2, 3],
 *     };
 *
 *  They can also be TypedArrays
 *
 *     var arrays = {
 *        position: new Float32Array([0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0]),
 *        texcoord: new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]),
 *        normal:   new Float32Array([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]),
 *        indices:  new Uint16Array([0, 1, 2, 1, 2, 3]),
 *     };
 *
 *  Or AugmentedTypedArrays
 *
 *     var positions = createAugmentedTypedArray(3, 4);
 *     var texcoords = createAugmentedTypedArray(2, 4);
 *     var normals   = createAugmentedTypedArray(3, 4);
 *     var indices   = createAugmentedTypedArray(3, 2, Uint16Array);
 *
 *     positions.push([0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0]);
 *     texcoords.push([0, 0, 0, 1, 1, 0, 1, 1]);
 *     normals.push([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]);
 *     indices.push([0, 1, 2, 1, 2, 3]);
 *
 *     var arrays = {
 *        position: positions,
 *        texcoord: texcoords,
 *        normal:   normals,
 *        indices:  indices,
 *     };
 *
 * For the last example it is equivalent to
 *
 *     var bufferInfo = {
 *       attribs: {
 *         position: { numComponents: 3, buffer: gl.createBuffer(), },
 *         texcoord: { numComponents: 2, buffer: gl.createBuffer(), },
 *         normal: { numComponents: 3, buffer: gl.createBuffer(), },
 *       },
 *       indices: gl.createBuffer(),
 *       numElements: 6,
 *     };
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo.attribs.position.buffer);
 *     gl.bufferData(gl.ARRAY_BUFFER, arrays.position, gl.STATIC_DRAW);
 *     gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo.attribs.texcoord.buffer);
 *     gl.bufferData(gl.ARRAY_BUFFER, arrays.texcoord, gl.STATIC_DRAW);
 *     gl.bindBuffer(gl.ARRAY_BUFFER, bufferInfo.attribs.normal.buffer);
 *     gl.bufferData(gl.ARRAY_BUFFER, arrays.normal, gl.STATIC_DRAW);
 *     gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, bufferInfo.indices);
 *     gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, arrays.indices, gl.STATIC_DRAW);
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {module:twgl.Arrays} arrays Your data
 * @param {module:twgl.BufferInfo} [srcBufferInfo] An existing
 *        buffer info to start from. WebGLBuffers etc specified
 *        in the srcBufferInfo will be used in a new BufferInfo
 *        with any arrays specified overriding the ones in
 *        srcBufferInfo.
 * @return {module:twgl.BufferInfo} A BufferInfo
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$140f5b0225138840(gl, arrays, srcBufferInfo) {
    const newAttribs = $065afaecc735fbee$export$df835e2df67be3fe(gl, arrays);
    const bufferInfo = Object.assign({}, srcBufferInfo ? srcBufferInfo : {});
    bufferInfo.attribs = Object.assign({}, srcBufferInfo ? srcBufferInfo.attribs : {}, newAttribs);
    const indices = arrays.indices;
    if (indices) {
        const newIndices = $065afaecc735fbee$var$makeTypedArray(indices, "indices");
        bufferInfo.indices = $065afaecc735fbee$export$6ea00fe9d038b3f9(gl, newIndices, $065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER$2);
        bufferInfo.numElements = newIndices.length;
        bufferInfo.elementType = $065afaecc735fbee$export$bddf845047a0e959(newIndices);
    } else if (!bufferInfo.numElements) bufferInfo.numElements = $065afaecc735fbee$var$getNumElementsFromAttributes(gl, bufferInfo.attribs);
    return bufferInfo;
}
/**
 * Creates a buffer from an array, typed array, or array spec
 *
 * Given something like this
 *
 *     [1, 2, 3],
 *
 * or
 *
 *     new Uint16Array([1,2,3]);
 *
 * or
 *
 *     {
 *        data: [1, 2, 3],
 *        type: Uint8Array,
 *     }
 *
 * returns a WebGLBuffer that contains the given data.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext.
 * @param {module:twgl.ArraySpec} array an array, typed array, or array spec.
 * @param {string} arrayName name of array. Used to guess the type if type can not be derived otherwise.
 * @return {WebGLBuffer} a WebGLBuffer containing the data in array.
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$2750db2b7c74f6a0(gl, array, arrayName) {
    const type = arrayName === "indices" ? $065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER$2 : $065afaecc735fbee$var$ARRAY_BUFFER$1;
    const typedArray = $065afaecc735fbee$var$makeTypedArray(array, arrayName);
    return $065afaecc735fbee$export$6ea00fe9d038b3f9(gl, typedArray, type);
}
/**
 * Creates buffers from arrays or typed arrays
 *
 * Given something like this
 *
 *     var arrays = {
 *        positions: [1, 2, 3],
 *        normals: [0, 0, 1],
 *     }
 *
 * returns something like
 *
 *     buffers = {
 *       positions: WebGLBuffer,
 *       normals: WebGLBuffer,
 *     }
 *
 * If the buffer is named 'indices' it will be made an ELEMENT_ARRAY_BUFFER.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext.
 * @param {module:twgl.Arrays} arrays
 * @return {Object<string, WebGLBuffer>} returns an object with one WebGLBuffer per array
 * @memberOf module:twgl/attributes
 */ function $065afaecc735fbee$export$69d8acce17089372(gl, arrays) {
    const buffers = {};
    Object.keys(arrays).forEach(function(key) {
        buffers[key] = $065afaecc735fbee$export$2750db2b7c74f6a0(gl, arrays[key], key);
    });
    // Ugh!
    if (arrays.indices) {
        buffers.numElements = arrays.indices.length;
        buffers.elementType = $065afaecc735fbee$export$bddf845047a0e959($065afaecc735fbee$var$makeTypedArray(arrays.indices));
    } else buffers.numElements = $065afaecc735fbee$var$getNumElementsFromNonIndexedArrays(arrays);
    return buffers;
}
var $065afaecc735fbee$export$16bd37df0047a29c = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createAttribsFromArrays: $065afaecc735fbee$export$df835e2df67be3fe,
    createBuffersFromArrays: $065afaecc735fbee$export$69d8acce17089372,
    createBufferFromArray: $065afaecc735fbee$export$2750db2b7c74f6a0,
    createBufferFromTypedArray: $065afaecc735fbee$export$6ea00fe9d038b3f9,
    createBufferInfoFromArrays: $065afaecc735fbee$export$140f5b0225138840,
    setAttribInfoBufferFromArray: $065afaecc735fbee$export$22dc7d5fce8749be,
    setAttributePrefix: $065afaecc735fbee$export$8a79157a77253422,
    setAttributeDefaults_: $065afaecc735fbee$export$81400a733c5c400b,
    getNumComponents_: $065afaecc735fbee$export$bfceede8dab24cbd,
    getArray_: $065afaecc735fbee$export$251e3bdee27f62a4
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ const $065afaecc735fbee$var$getArray = $065afaecc735fbee$export$251e3bdee27f62a4; // eslint-disable-line
const $065afaecc735fbee$var$getNumComponents = $065afaecc735fbee$export$bfceede8dab24cbd; // eslint-disable-line
/**
 * @typedef {(Int8Array|Uint8Array|Int16Array|Uint16Array|Int32Array|Uint32Array|Float32Array)} TypedArray
 */ /**
 * Add `push` to a typed array. It just keeps a 'cursor'
 * and allows use to `push` values into the array so we
 * don't have to manually compute offsets
 * @param {TypedArray} typedArray TypedArray to augment
 * @param {number} numComponents number of components.
 * @private
 */ function $065afaecc735fbee$var$augmentTypedArray(typedArray, numComponents) {
    let cursor = 0;
    typedArray.push = function() {
        for(let ii = 0; ii < arguments.length; ++ii){
            const value = arguments[ii];
            if (value instanceof Array || $065afaecc735fbee$export$9dd3754ae86f0017(value)) for(let jj = 0; jj < value.length; ++jj)typedArray[cursor++] = value[jj];
            else typedArray[cursor++] = value;
        }
    };
    typedArray.reset = function(opt_index) {
        cursor = opt_index || 0;
    };
    typedArray.numComponents = numComponents;
    Object.defineProperty(typedArray, 'numElements', {
        get: function() {
            return this.length / this.numComponents | 0;
        }
    });
    return typedArray;
}
/**
 * creates a typed array with a `push` function attached
 * so that you can easily *push* values.
 *
 * `push` can take multiple arguments. If an argument is an array each element
 * of the array will be added to the typed array.
 *
 * Example:
 *
 *     const array = createAugmentedTypedArray(3, 2);  // creates a Float32Array with 6 values
 *     array.push(1, 2, 3);
 *     array.push([4, 5, 6]);
 *     // array now contains [1, 2, 3, 4, 5, 6]
 *
 * Also has `numComponents` and `numElements` properties.
 *
 * @param {number} numComponents number of components
 * @param {number} numElements number of elements. The total size of the array will be `numComponents * numElements`.
 * @param {constructor} opt_type A constructor for the type. Default = `Float32Array`.
 * @return {ArrayBufferView} A typed array.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createAugmentedTypedArray(numComponents, numElements, opt_type) {
    const Type = opt_type || Float32Array;
    return $065afaecc735fbee$var$augmentTypedArray(new Type(numComponents * numElements), numComponents);
}
function $065afaecc735fbee$var$allButIndices(name) {
    return name !== "indices";
}
/**
 * Given indexed vertices creates a new set of vertices un-indexed by expanding the indexed vertices.
 * @param {Object.<string, TypedArray>} vertices The indexed vertices to deindex
 * @return {Object.<string, TypedArray>} The deindexed vertices
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$deindexVertices(vertices) {
    const indices = vertices.indices;
    const newVertices = {};
    const numElements = indices.length;
    function expandToUnindexed(channel) {
        const srcBuffer = vertices[channel];
        const numComponents = srcBuffer.numComponents;
        const dstBuffer = $065afaecc735fbee$var$createAugmentedTypedArray(numComponents, numElements, srcBuffer.constructor);
        for(let ii = 0; ii < numElements; ++ii){
            const ndx = indices[ii];
            const offset = ndx * numComponents;
            for(let jj = 0; jj < numComponents; ++jj)dstBuffer.push(srcBuffer[offset + jj]);
        }
        newVertices[channel] = dstBuffer;
    }
    Object.keys(vertices).filter($065afaecc735fbee$var$allButIndices).forEach(expandToUnindexed);
    return newVertices;
}
/**
 * flattens the normals of deindexed vertices in place.
 * @param {Object.<string, TypedArray>} vertices The deindexed vertices who's normals to flatten
 * @return {Object.<string, TypedArray>} The flattened vertices (same as was passed in)
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$flattenNormals(vertices) {
    if (vertices.indices) throw new Error('can not flatten normals of indexed vertices. deindex them first');
    const normals = vertices.normal;
    const numNormals = normals.length;
    for(let ii = 0; ii < numNormals; ii += 9){
        // pull out the 3 normals for this triangle
        const nax = normals[ii + 0];
        const nay = normals[ii + 1];
        const naz = normals[ii + 2];
        const nbx = normals[ii + 3];
        const nby = normals[ii + 4];
        const nbz = normals[ii + 5];
        const ncx = normals[ii + 6];
        const ncy = normals[ii + 7];
        const ncz = normals[ii + 8];
        // add them
        let nx = nax + nbx + ncx;
        let ny = nay + nby + ncy;
        let nz = naz + nbz + ncz;
        // normalize them
        const length1 = Math.sqrt(nx * nx + ny * ny + nz * nz);
        nx /= length1;
        ny /= length1;
        nz /= length1;
        // copy them back in
        normals[ii + 0] = nx;
        normals[ii + 1] = ny;
        normals[ii + 2] = nz;
        normals[ii + 3] = nx;
        normals[ii + 4] = ny;
        normals[ii + 5] = nz;
        normals[ii + 6] = nx;
        normals[ii + 7] = ny;
        normals[ii + 8] = nz;
    }
    return vertices;
}
function $065afaecc735fbee$var$applyFuncToV3Array(array, matrix, fn) {
    const len = array.length;
    const tmp = new Float32Array(3);
    for(let ii = 0; ii < len; ii += 3){
        fn(matrix, [
            array[ii],
            array[ii + 1],
            array[ii + 2]
        ], tmp);
        array[ii] = tmp[0];
        array[ii + 1] = tmp[1];
        array[ii + 2] = tmp[2];
    }
}
function $065afaecc735fbee$var$transformNormal(mi, v, dst) {
    dst = dst || $065afaecc735fbee$var$create$1();
    const v0 = v[0];
    const v1 = v[1];
    const v2 = v[2];
    dst[0] = v0 * mi[0] + v1 * mi[1] + v2 * mi[2];
    dst[1] = v0 * mi[4] + v1 * mi[5] + v2 * mi[6];
    dst[2] = v0 * mi[8] + v1 * mi[9] + v2 * mi[10];
    return dst;
}
/**
 * Reorients directions by the given matrix..
 * @param {(number[]|TypedArray)} array The array. Assumes value floats per element.
 * @param {module:twgl/m4.Mat4} matrix A matrix to multiply by.
 * @return {(number[]|TypedArray)} the same array that was passed in
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$reorientDirections(array, matrix) {
    $065afaecc735fbee$var$applyFuncToV3Array(array, matrix, $065afaecc735fbee$var$transformDirection);
    return array;
}
/**
 * Reorients normals by the inverse-transpose of the given
 * matrix..
 * @param {(number[]|TypedArray)} array The array. Assumes value floats per element.
 * @param {module:twgl/m4.Mat4} matrix A matrix to multiply by.
 * @return {(number[]|TypedArray)} the same array that was passed in
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$reorientNormals(array, matrix) {
    $065afaecc735fbee$var$applyFuncToV3Array(array, $065afaecc735fbee$var$inverse(matrix), $065afaecc735fbee$var$transformNormal);
    return array;
}
/**
 * Reorients positions by the given matrix. In other words, it
 * multiplies each vertex by the given matrix.
 * @param {(number[]|TypedArray)} array The array. Assumes value floats per element.
 * @param {module:twgl/m4.Mat4} matrix A matrix to multiply by.
 * @return {(number[]|TypedArray)} the same array that was passed in
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$reorientPositions(array, matrix) {
    $065afaecc735fbee$var$applyFuncToV3Array(array, matrix, $065afaecc735fbee$var$transformPoint);
    return array;
}
/**
 * @typedef {(number[]|TypedArray)} NativeArrayOrTypedArray
 */ /**
 * Reorients arrays by the given matrix. Assumes arrays have
 * names that contains 'pos' could be reoriented as positions,
 * 'binorm' or 'tan' as directions, and 'norm' as normals.
 *
 * @param {Object.<string, NativeArrayOrTypedArray>} arrays The vertices to reorient
 * @param {module:twgl/m4.Mat4} matrix matrix to reorient by.
 * @return {Object.<string, NativeArrayOrTypedArray>} same arrays that were passed in.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$reorientVertices(arrays, matrix) {
    Object.keys(arrays).forEach(function(name) {
        const array = arrays[name];
        if (name.indexOf("pos") >= 0) $065afaecc735fbee$var$reorientPositions(array, matrix);
        else if (name.indexOf("tan") >= 0 || name.indexOf("binorm") >= 0) $065afaecc735fbee$var$reorientDirections(array, matrix);
        else if (name.indexOf("norm") >= 0) $065afaecc735fbee$var$reorientNormals(array, matrix);
    });
    return arrays;
}
/**
 * Creates XY quad BufferInfo
 *
 * The default with no parameters will return a 2x2 quad with values from -1 to +1.
 * If you want a unit quad with that goes from 0 to 1 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0.5, 0.5);
 *
 * If you want a unit quad centered above 0,0 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0, 0.5);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] the size across the quad. Defaults to 2 which means vertices will go from -1 to +1
 * @param {number} [xOffset] the amount to offset the quad in X
 * @param {number} [yOffset] the amount to offset the quad in Y
 * @return {Object.<string, WebGLBuffer>} the created XY Quad BufferInfo
 * @memberOf module:twgl/primitives
 * @function createXYQuadBuffers
 */ /**
 * Creates XY quad Buffers
 *
 * The default with no parameters will return a 2x2 quad with values from -1 to +1.
 * If you want a unit quad with that goes from 0 to 1 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0.5, 0.5);
 *
 * If you want a unit quad centered above 0,0 you'd call it with
 *
 *     twgl.primitives.createXYQuadBufferInfo(gl, 1, 0, 0.5);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] the size across the quad. Defaults to 2 which means vertices will go from -1 to +1
 * @param {number} [xOffset] the amount to offset the quad in X
 * @param {number} [yOffset] the amount to offset the quad in Y
 * @return {module:twgl.BufferInfo} the created XY Quad buffers
 * @memberOf module:twgl/primitives
 * @function createXYQuadBufferInfo
 */ /**
 * Creates XY quad vertices
 *
 * The default with no parameters will return a 2x2 quad with values from -1 to +1.
 * If you want a unit quad with that goes from 0 to 1 you'd call it with
 *
 *     twgl.primitives.createXYQuadVertices(1, 0.5, 0.5);
 *
 * If you want a unit quad centered above 0,0 you'd call it with
 *
 *     twgl.primitives.createXYQuadVertices(1, 0, 0.5);
 *
 * @param {number} [size] the size across the quad. Defaults to 2 which means vertices will go from -1 to +1
 * @param {number} [xOffset] the amount to offset the quad in X
 * @param {number} [yOffset] the amount to offset the quad in Y
 * @return {Object.<string, TypedArray>} the created XY Quad vertices
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createXYQuadVertices(size, xOffset, yOffset) {
    size = size || 2;
    xOffset = xOffset || 0;
    yOffset = yOffset || 0;
    size *= 0.5;
    return {
        position: {
            numComponents: 2,
            data: [
                xOffset + -1 * size,
                yOffset + -1 * size,
                xOffset + 1 * size,
                yOffset + -1 * size,
                xOffset + -1 * size,
                yOffset + 1 * size,
                xOffset + 1 * size,
                yOffset + 1 * size
            ]
        },
        normal: [
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            1
        ],
        texcoord: [
            0,
            0,
            1,
            0,
            0,
            1,
            1,
            1
        ],
        indices: [
            0,
            1,
            2,
            2,
            1,
            3
        ]
    };
}
/**
 * Creates XZ plane BufferInfo.
 *
 * The created plane has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [width] Width of the plane. Default = 1
 * @param {number} [depth] Depth of the plane. Default = 1
 * @param {number} [subdivisionsWidth] Number of steps across the plane. Default = 1
 * @param {number} [subdivisionsDepth] Number of steps down the plane. Default = 1
 * @param {module:twgl/m4.Mat4} [matrix] A matrix by which to multiply all the vertices.
 * @return {module:twgl.BufferInfo} The created plane BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createPlaneBufferInfo
 */ /**
 * Creates XZ plane buffers.
 *
 * The created plane has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [width] Width of the plane. Default = 1
 * @param {number} [depth] Depth of the plane. Default = 1
 * @param {number} [subdivisionsWidth] Number of steps across the plane. Default = 1
 * @param {number} [subdivisionsDepth] Number of steps down the plane. Default = 1
 * @param {module:twgl/m4.Mat4} [matrix] A matrix by which to multiply all the vertices.
 * @return {Object.<string, WebGLBuffer>} The created plane buffers.
 * @memberOf module:twgl/primitives
 * @function createPlaneBuffers
 */ /**
 * Creates XZ plane vertices.
 *
 * The created plane has position, normal, and texcoord data
 *
 * @param {number} [width] Width of the plane. Default = 1
 * @param {number} [depth] Depth of the plane. Default = 1
 * @param {number} [subdivisionsWidth] Number of steps across the plane. Default = 1
 * @param {number} [subdivisionsDepth] Number of steps down the plane. Default = 1
 * @param {module:twgl/m4.Mat4} [matrix] A matrix by which to multiply all the vertices.
 * @return {Object.<string, TypedArray>} The created plane vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createPlaneVertices(width, depth, subdivisionsWidth, subdivisionsDepth, matrix) {
    width = width || 1;
    depth = depth || 1;
    subdivisionsWidth = subdivisionsWidth || 1;
    subdivisionsDepth = subdivisionsDepth || 1;
    matrix = matrix || $065afaecc735fbee$var$identity();
    const numVertices = (subdivisionsWidth + 1) * (subdivisionsDepth + 1);
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    for(let z = 0; z <= subdivisionsDepth; z++)for(let x = 0; x <= subdivisionsWidth; x++){
        const u = x / subdivisionsWidth;
        const v = z / subdivisionsDepth;
        positions.push(width * u - width * 0.5, 0, depth * v - depth * 0.5);
        normals.push(0, 1, 0);
        texcoords.push(u, v);
    }
    const numVertsAcross = subdivisionsWidth + 1;
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, subdivisionsWidth * subdivisionsDepth * 2, Uint16Array);
    for(let z = 0; z < subdivisionsDepth; z++)for(let x = 0; x < subdivisionsWidth; x++){
        // Make triangle 1 of quad.
        indices.push((z + 0) * numVertsAcross + x, (z + 1) * numVertsAcross + x, (z + 0) * numVertsAcross + x + 1);
        // Make triangle 2 of quad.
        indices.push((z + 1) * numVertsAcross + x, (z + 1) * numVertsAcross + x + 1, (z + 0) * numVertsAcross + x + 1);
    }
    const arrays = $065afaecc735fbee$var$reorientVertices({
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    }, matrix);
    return arrays;
}
/**
 * Creates sphere BufferInfo.
 *
 * The created sphere has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of the sphere.
 * @param {number} subdivisionsAxis number of steps around the sphere.
 * @param {number} subdivisionsHeight number of vertically on the sphere.
 * @param {number} [opt_startLatitudeInRadians] where to start the
 *     top of the sphere. Default = 0.
 * @param {number} [opt_endLatitudeInRadians] Where to end the
 *     bottom of the sphere. Default = Math.PI.
 * @param {number} [opt_startLongitudeInRadians] where to start
 *     wrapping the sphere. Default = 0.
 * @param {number} [opt_endLongitudeInRadians] where to end
 *     wrapping the sphere. Default = 2 * Math.PI.
 * @return {module:twgl.BufferInfo} The created sphere BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createSphereBufferInfo
 */ /**
 * Creates sphere buffers.
 *
 * The created sphere has position, normal, and texcoord data
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of the sphere.
 * @param {number} subdivisionsAxis number of steps around the sphere.
 * @param {number} subdivisionsHeight number of vertically on the sphere.
 * @param {number} [opt_startLatitudeInRadians] where to start the
 *     top of the sphere. Default = 0.
 * @param {number} [opt_endLatitudeInRadians] Where to end the
 *     bottom of the sphere. Default = Math.PI.
 * @param {number} [opt_startLongitudeInRadians] where to start
 *     wrapping the sphere. Default = 0.
 * @param {number} [opt_endLongitudeInRadians] where to end
 *     wrapping the sphere. Default = 2 * Math.PI.
 * @return {Object.<string, WebGLBuffer>} The created sphere buffers.
 * @memberOf module:twgl/primitives
 * @function createSphereBuffers
 */ /**
 * Creates sphere vertices.
 *
 * The created sphere has position, normal, and texcoord data
 *
 * @param {number} radius radius of the sphere.
 * @param {number} subdivisionsAxis number of steps around the sphere.
 * @param {number} subdivisionsHeight number of vertically on the sphere.
 * @param {number} [opt_startLatitudeInRadians] where to start the
 *     top of the sphere. Default = 0.
 * @param {number} [opt_endLatitudeInRadians] Where to end the
 *     bottom of the sphere. Default = Math.PI.
 * @param {number} [opt_startLongitudeInRadians] where to start
 *     wrapping the sphere. Default = 0.
 * @param {number} [opt_endLongitudeInRadians] where to end
 *     wrapping the sphere. Default = 2 * Math.PI.
 * @return {Object.<string, TypedArray>} The created sphere vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createSphereVertices(radius, subdivisionsAxis, subdivisionsHeight, opt_startLatitudeInRadians, opt_endLatitudeInRadians, opt_startLongitudeInRadians, opt_endLongitudeInRadians) {
    if (subdivisionsAxis <= 0 || subdivisionsHeight <= 0) throw new Error('subdivisionAxis and subdivisionHeight must be > 0');
    opt_startLatitudeInRadians = opt_startLatitudeInRadians || 0;
    opt_endLatitudeInRadians = opt_endLatitudeInRadians || Math.PI;
    opt_startLongitudeInRadians = opt_startLongitudeInRadians || 0;
    opt_endLongitudeInRadians = opt_endLongitudeInRadians || Math.PI * 2;
    const latRange = opt_endLatitudeInRadians - opt_startLatitudeInRadians;
    const longRange = opt_endLongitudeInRadians - opt_startLongitudeInRadians;
    // We are going to generate our sphere by iterating through its
    // spherical coordinates and generating 2 triangles for each quad on a
    // ring of the sphere.
    const numVertices = (subdivisionsAxis + 1) * (subdivisionsHeight + 1);
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    // Generate the individual vertices in our vertex buffer.
    for(let y = 0; y <= subdivisionsHeight; y++)for(let x = 0; x <= subdivisionsAxis; x++){
        // Generate a vertex based on its spherical coordinates
        const u = x / subdivisionsAxis;
        const v = y / subdivisionsHeight;
        const theta = longRange * u + opt_startLongitudeInRadians;
        const phi = latRange * v + opt_startLatitudeInRadians;
        const sinTheta = Math.sin(theta);
        const cosTheta = Math.cos(theta);
        const sinPhi = Math.sin(phi);
        const cosPhi = Math.cos(phi);
        const ux = cosTheta * sinPhi;
        const uy = cosPhi;
        const uz = sinTheta * sinPhi;
        positions.push(radius * ux, radius * uy, radius * uz);
        normals.push(ux, uy, uz);
        texcoords.push(1 - u, v);
    }
    const numVertsAround = subdivisionsAxis + 1;
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, subdivisionsAxis * subdivisionsHeight * 2, Uint16Array);
    for(let x = 0; x < subdivisionsAxis; x++)for(let y = 0; y < subdivisionsHeight; y++){
        // Make triangle 1 of quad.
        indices.push((y + 0) * numVertsAround + x, (y + 0) * numVertsAround + x + 1, (y + 1) * numVertsAround + x);
        // Make triangle 2 of quad.
        indices.push((y + 1) * numVertsAround + x, (y + 0) * numVertsAround + x + 1, (y + 1) * numVertsAround + x + 1);
    }
    return {
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    };
}
/**
 * Array of the indices of corners of each face of a cube.
 * @type {Array.<number[]>}
 * @private
 */ const $065afaecc735fbee$var$CUBE_FACE_INDICES = [
    [
        3,
        7,
        5,
        1
    ],
    [
        6,
        2,
        0,
        4
    ],
    [
        6,
        7,
        3,
        2
    ],
    [
        0,
        1,
        5,
        4
    ],
    [
        7,
        6,
        4,
        5
    ],
    [
        2,
        3,
        1,
        0
    ]
];
/**
 * Creates a BufferInfo for a cube.
 *
 * The cube is created around the origin. (-size / 2, size / 2).
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] width, height and depth of the cube.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCubeBufferInfo
 */ /**
 * Creates the buffers and indices for a cube.
 *
 * The cube is created around the origin. (-size / 2, size / 2).
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} [size] width, height and depth of the cube.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createCubeBuffers
 */ /**
 * Creates the vertices and indices for a cube.
 *
 * The cube is created around the origin. (-size / 2, size / 2).
 *
 * @param {number} [size] width, height and depth of the cube.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createCubeVertices(size) {
    size = size || 1;
    const k = size / 2;
    const cornerVertices = [
        [
            -k,
            -k,
            -k
        ],
        [
            +k,
            -k,
            -k
        ],
        [
            -k,
            +k,
            -k
        ],
        [
            +k,
            +k,
            -k
        ],
        [
            -k,
            -k,
            +k
        ],
        [
            +k,
            -k,
            +k
        ],
        [
            -k,
            +k,
            +k
        ],
        [
            +k,
            +k,
            +k
        ]
    ];
    const faceNormals = [
        [
            1,
            0,
            0
        ],
        [
            -1,
            0,
            0
        ],
        [
            0,
            1,
            0
        ],
        [
            0,
            -1,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            0,
            -1
        ]
    ];
    const uvCoords = [
        [
            1,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ];
    const numVertices = 24;
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, 12, Uint16Array);
    for(let f = 0; f < 6; ++f){
        const faceIndices = $065afaecc735fbee$var$CUBE_FACE_INDICES[f];
        for(let v = 0; v < 4; ++v){
            const position = cornerVertices[faceIndices[v]];
            const normal = faceNormals[f];
            const uv = uvCoords[v];
            // Each face needs all four vertices because the normals and texture
            // coordinates are not all the same.
            positions.push(position);
            normals.push(normal);
            texcoords.push(uv);
        }
        // Two triangles make a square face.
        const offset = 4 * f;
        indices.push(offset + 0, offset + 1, offset + 2);
        indices.push(offset + 0, offset + 2, offset + 3);
    }
    return {
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    };
}
/**
 * Creates a BufferInfo for a truncated cone, which is like a cylinder
 * except that it has different top and bottom radii. A truncated cone
 * can also be used to create cylinders and regular cones. The
 * truncated cone will be created centered about the origin, with the
 * y axis as its vertical axis.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} bottomRadius Bottom radius of truncated cone.
 * @param {number} topRadius Top radius of truncated cone.
 * @param {number} height Height of truncated cone.
 * @param {number} radialSubdivisions The number of subdivisions around the
 *     truncated cone.
 * @param {number} verticalSubdivisions The number of subdivisions down the
 *     truncated cone.
 * @param {boolean} [opt_topCap] Create top cap. Default = true.
 * @param {boolean} [opt_bottomCap] Create bottom cap. Default = true.
 * @return {module:twgl.BufferInfo} The created cone BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createTruncatedConeBufferInfo
 */ /**
 * Creates buffers for a truncated cone, which is like a cylinder
 * except that it has different top and bottom radii. A truncated cone
 * can also be used to create cylinders and regular cones. The
 * truncated cone will be created centered about the origin, with the
 * y axis as its vertical axis.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} bottomRadius Bottom radius of truncated cone.
 * @param {number} topRadius Top radius of truncated cone.
 * @param {number} height Height of truncated cone.
 * @param {number} radialSubdivisions The number of subdivisions around the
 *     truncated cone.
 * @param {number} verticalSubdivisions The number of subdivisions down the
 *     truncated cone.
 * @param {boolean} [opt_topCap] Create top cap. Default = true.
 * @param {boolean} [opt_bottomCap] Create bottom cap. Default = true.
 * @return {Object.<string, WebGLBuffer>} The created cone buffers.
 * @memberOf module:twgl/primitives
 * @function createTruncatedConeBuffers
 */ /**
 * Creates vertices for a truncated cone, which is like a cylinder
 * except that it has different top and bottom radii. A truncated cone
 * can also be used to create cylinders and regular cones. The
 * truncated cone will be created centered about the origin, with the
 * y axis as its vertical axis. .
 *
 * @param {number} bottomRadius Bottom radius of truncated cone.
 * @param {number} topRadius Top radius of truncated cone.
 * @param {number} height Height of truncated cone.
 * @param {number} radialSubdivisions The number of subdivisions around the
 *     truncated cone.
 * @param {number} verticalSubdivisions The number of subdivisions down the
 *     truncated cone.
 * @param {boolean} [opt_topCap] Create top cap. Default = true.
 * @param {boolean} [opt_bottomCap] Create bottom cap. Default = true.
 * @return {Object.<string, TypedArray>} The created cone vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createTruncatedConeVertices(bottomRadius, topRadius, height, radialSubdivisions, verticalSubdivisions, opt_topCap, opt_bottomCap) {
    if (radialSubdivisions < 3) throw new Error('radialSubdivisions must be 3 or greater');
    if (verticalSubdivisions < 1) throw new Error('verticalSubdivisions must be 1 or greater');
    const topCap = opt_topCap === undefined ? true : opt_topCap;
    const bottomCap = opt_bottomCap === undefined ? true : opt_bottomCap;
    const extra = (topCap ? 2 : 0) + (bottomCap ? 2 : 0);
    const numVertices = (radialSubdivisions + 1) * (verticalSubdivisions + 1 + extra);
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, radialSubdivisions * (verticalSubdivisions + extra / 2) * 2, Uint16Array);
    const vertsAroundEdge = radialSubdivisions + 1;
    // The slant of the cone is constant across its surface
    const slant = Math.atan2(bottomRadius - topRadius, height);
    const cosSlant = Math.cos(slant);
    const sinSlant = Math.sin(slant);
    const start = topCap ? -2 : 0;
    const end = verticalSubdivisions + (bottomCap ? 2 : 0);
    for(let yy = start; yy <= end; ++yy){
        let v = yy / verticalSubdivisions;
        let y = height * v;
        let ringRadius;
        if (yy < 0) {
            y = 0;
            v = 1;
            ringRadius = bottomRadius;
        } else if (yy > verticalSubdivisions) {
            y = height;
            v = 1;
            ringRadius = topRadius;
        } else ringRadius = bottomRadius + (topRadius - bottomRadius) * (yy / verticalSubdivisions);
        if (yy === -2 || yy === verticalSubdivisions + 2) {
            ringRadius = 0;
            v = 0;
        }
        y -= height / 2;
        for(let ii = 0; ii < vertsAroundEdge; ++ii){
            const sin = Math.sin(ii * Math.PI * 2 / radialSubdivisions);
            const cos = Math.cos(ii * Math.PI * 2 / radialSubdivisions);
            positions.push(sin * ringRadius, y, cos * ringRadius);
            if (yy < 0) normals.push(0, -1, 0);
            else if (yy > verticalSubdivisions) normals.push(0, 1, 0);
            else if (ringRadius === 0.0) normals.push(0, 0, 0);
            else normals.push(sin * cosSlant, sinSlant, cos * cosSlant);
            texcoords.push(ii / radialSubdivisions, 1 - v);
        }
    }
    for(let yy = 0; yy < verticalSubdivisions + extra; ++yy){
        if (yy === 1 && topCap || yy === verticalSubdivisions + extra - 2 && bottomCap) continue;
        for(let ii = 0; ii < radialSubdivisions; ++ii){
            indices.push(vertsAroundEdge * (yy + 0) + 0 + ii, vertsAroundEdge * (yy + 0) + 1 + ii, vertsAroundEdge * (yy + 1) + 1 + ii);
            indices.push(vertsAroundEdge * (yy + 0) + 0 + ii, vertsAroundEdge * (yy + 1) + 1 + ii, vertsAroundEdge * (yy + 1) + 0 + ii);
        }
    }
    return {
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    };
}
/**
 * Expands RLE data
 * @param {number[]} rleData data in format of run-length, x, y, z, run-length, x, y, z
 * @param {number[]} [padding] value to add each entry with.
 * @return {number[]} the expanded rleData
 * @private
 */ function $065afaecc735fbee$var$expandRLEData(rleData, padding) {
    padding = padding || [];
    const data = [];
    for(let ii = 0; ii < rleData.length; ii += 4){
        const runLength = rleData[ii];
        const element = rleData.slice(ii + 1, ii + 4);
        element.push.apply(element, padding);
        for(let jj = 0; jj < runLength; ++jj)data.push.apply(data, element);
    }
    return data;
}
/**
 * Creates 3D 'F' BufferInfo.
 * An 'F' is useful because you can easily tell which way it is oriented.
 * The created 'F' has position, normal, texcoord, and color buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function create3DFBufferInfo
 */ /**
 * Creates 3D 'F' buffers.
 * An 'F' is useful because you can easily tell which way it is oriented.
 * The created 'F' has position, normal, texcoord, and color buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function create3DFBuffers
 */ /**
 * Creates 3D 'F' vertices.
 * An 'F' is useful because you can easily tell which way it is oriented.
 * The created 'F' has position, normal, texcoord, and color arrays.
 *
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$create3DFVertices() {
    const positions = [
        // left column front
        0,
        0,
        0,
        0,
        150,
        0,
        30,
        0,
        0,
        0,
        150,
        0,
        30,
        150,
        0,
        30,
        0,
        0,
        // top rung front
        30,
        0,
        0,
        30,
        30,
        0,
        100,
        0,
        0,
        30,
        30,
        0,
        100,
        30,
        0,
        100,
        0,
        0,
        // middle rung front
        30,
        60,
        0,
        30,
        90,
        0,
        67,
        60,
        0,
        30,
        90,
        0,
        67,
        90,
        0,
        67,
        60,
        0,
        // left column back
        0,
        0,
        30,
        30,
        0,
        30,
        0,
        150,
        30,
        0,
        150,
        30,
        30,
        0,
        30,
        30,
        150,
        30,
        // top rung back
        30,
        0,
        30,
        100,
        0,
        30,
        30,
        30,
        30,
        30,
        30,
        30,
        100,
        0,
        30,
        100,
        30,
        30,
        // middle rung back
        30,
        60,
        30,
        67,
        60,
        30,
        30,
        90,
        30,
        30,
        90,
        30,
        67,
        60,
        30,
        67,
        90,
        30,
        // top
        0,
        0,
        0,
        100,
        0,
        0,
        100,
        0,
        30,
        0,
        0,
        0,
        100,
        0,
        30,
        0,
        0,
        30,
        // top rung front
        100,
        0,
        0,
        100,
        30,
        0,
        100,
        30,
        30,
        100,
        0,
        0,
        100,
        30,
        30,
        100,
        0,
        30,
        // under top rung
        30,
        30,
        0,
        30,
        30,
        30,
        100,
        30,
        30,
        30,
        30,
        0,
        100,
        30,
        30,
        100,
        30,
        0,
        // between top rung and middle
        30,
        30,
        0,
        30,
        60,
        30,
        30,
        30,
        30,
        30,
        30,
        0,
        30,
        60,
        0,
        30,
        60,
        30,
        // top of middle rung
        30,
        60,
        0,
        67,
        60,
        30,
        30,
        60,
        30,
        30,
        60,
        0,
        67,
        60,
        0,
        67,
        60,
        30,
        // front of middle rung
        67,
        60,
        0,
        67,
        90,
        30,
        67,
        60,
        30,
        67,
        60,
        0,
        67,
        90,
        0,
        67,
        90,
        30,
        // bottom of middle rung.
        30,
        90,
        0,
        30,
        90,
        30,
        67,
        90,
        30,
        30,
        90,
        0,
        67,
        90,
        30,
        67,
        90,
        0,
        // front of bottom
        30,
        90,
        0,
        30,
        150,
        30,
        30,
        90,
        30,
        30,
        90,
        0,
        30,
        150,
        0,
        30,
        150,
        30,
        // bottom
        0,
        150,
        0,
        0,
        150,
        30,
        30,
        150,
        30,
        0,
        150,
        0,
        30,
        150,
        30,
        30,
        150,
        0,
        // left side
        0,
        0,
        0,
        0,
        0,
        30,
        0,
        150,
        30,
        0,
        0,
        0,
        0,
        150,
        30,
        0,
        150,
        0
    ];
    const texcoords = [
        // left column front
        0.22,
        0.19,
        0.22,
        0.79,
        0.34,
        0.19,
        0.22,
        0.79,
        0.34,
        0.79,
        0.34,
        0.19,
        // top rung front
        0.34,
        0.19,
        0.34,
        0.31,
        0.62,
        0.19,
        0.34,
        0.31,
        0.62,
        0.31,
        0.62,
        0.19,
        // middle rung front
        0.34,
        0.43,
        0.34,
        0.55,
        0.49,
        0.43,
        0.34,
        0.55,
        0.49,
        0.55,
        0.49,
        0.43,
        // left column back
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        // top rung back
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        // middle rung back
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        1,
        // top
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        // top rung front
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        1,
        // under top rung
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        // between top rung and middle
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        // top of middle rung
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        // front of middle rung
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        // bottom of middle rung.
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        // front of bottom
        0,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        // bottom
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0,
        // left side
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ];
    const normals = $065afaecc735fbee$var$expandRLEData([
        // left column front
        // top rung front
        // middle rung front
        18,
        0,
        0,
        1,
        // left column back
        // top rung back
        // middle rung back
        18,
        0,
        0,
        -1,
        // top
        6,
        0,
        1,
        0,
        // top rung front
        6,
        1,
        0,
        0,
        // under top rung
        6,
        0,
        -1,
        0,
        // between top rung and middle
        6,
        1,
        0,
        0,
        // top of middle rung
        6,
        0,
        1,
        0,
        // front of middle rung
        6,
        1,
        0,
        0,
        // bottom of middle rung.
        6,
        0,
        -1,
        0,
        // front of bottom
        6,
        1,
        0,
        0,
        // bottom
        6,
        0,
        -1,
        0,
        // left side
        6,
        -1,
        0,
        0
    ]);
    const colors = $065afaecc735fbee$var$expandRLEData([
        // left column front
        // top rung front
        // middle rung front
        18,
        200,
        70,
        120,
        // left column back
        // top rung back
        // middle rung back
        18,
        80,
        70,
        200,
        // top
        6,
        70,
        200,
        210,
        // top rung front
        6,
        200,
        200,
        70,
        // under top rung
        6,
        210,
        100,
        70,
        // between top rung and middle
        6,
        210,
        160,
        70,
        // top of middle rung
        6,
        70,
        180,
        210,
        // front of middle rung
        6,
        100,
        70,
        210,
        // bottom of middle rung.
        6,
        76,
        210,
        100,
        // front of bottom
        6,
        140,
        210,
        80,
        // bottom
        6,
        90,
        130,
        110,
        // left side
        6,
        160,
        160,
        220
    ], [
        255
    ]);
    const numVerts = positions.length / 3;
    const arrays = {
        position: $065afaecc735fbee$var$createAugmentedTypedArray(3, numVerts),
        texcoord: $065afaecc735fbee$var$createAugmentedTypedArray(2, numVerts),
        normal: $065afaecc735fbee$var$createAugmentedTypedArray(3, numVerts),
        color: $065afaecc735fbee$var$createAugmentedTypedArray(4, numVerts, Uint8Array),
        indices: $065afaecc735fbee$var$createAugmentedTypedArray(3, numVerts / 3, Uint16Array)
    };
    arrays.position.push(positions);
    arrays.texcoord.push(texcoords);
    arrays.normal.push(normals);
    arrays.color.push(colors);
    for(let ii = 0; ii < numVerts; ++ii)arrays.indices.push(ii);
    return arrays;
}
/**
 * Creates crescent BufferInfo.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCresentBufferInfo
 */ /**
 * Creates crescent buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createCresentBuffers
 */ /**
 * Creates crescent vertices.
 *
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 * @function createCresentBuffers
 */ /**
 * Creates crescent BufferInfo.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCrescentBufferInfo
 */ /**
 * Creates crescent buffers.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createCrescentBuffers
 */ /**
 * Creates crescent vertices.
 *
 * @param {number} verticalRadius The vertical radius of the crescent.
 * @param {number} outerRadius The outer radius of the crescent.
 * @param {number} innerRadius The inner radius of the crescent.
 * @param {number} thickness The thickness of the crescent.
 * @param {number} subdivisionsDown number of steps around the crescent.
 * @param {number} [startOffset] Where to start arc. Default 0.
 * @param {number} [endOffset] Where to end arg. Default 1.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createCrescentVertices(verticalRadius, outerRadius, innerRadius, thickness, subdivisionsDown, startOffset, endOffset) {
    if (subdivisionsDown <= 0) throw new Error('subdivisionDown must be > 0');
    startOffset = startOffset || 0;
    endOffset = endOffset || 1;
    const subdivisionsThick = 2;
    const offsetRange = endOffset - startOffset;
    const numVertices = (subdivisionsDown + 1) * 2 * (2 + subdivisionsThick);
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    function lerp(a, b, s) {
        return a + (b - a) * s;
    }
    function createArc(arcRadius, x, normalMult, normalAdd, uMult, uAdd) {
        for(let z = 0; z <= subdivisionsDown; z++){
            const uBack = x / (subdivisionsThick - 1);
            const v = z / subdivisionsDown;
            const xBack = (uBack - 0.5) * 2;
            const angle = (startOffset + v * offsetRange) * Math.PI;
            const s = Math.sin(angle);
            const c = Math.cos(angle);
            const radius = lerp(verticalRadius, arcRadius, s);
            const px = xBack * thickness;
            const py = c * verticalRadius;
            const pz = s * radius;
            positions.push(px, py, pz);
            const n = $065afaecc735fbee$var$add($065afaecc735fbee$var$multiply$1([
                0,
                s,
                c
            ], normalMult), normalAdd);
            normals.push(n);
            texcoords.push(uBack * uMult + uAdd, v);
        }
    }
    // Generate the individual vertices in our vertex buffer.
    for(let x = 0; x < subdivisionsThick; x++){
        const uBack = (x / (subdivisionsThick - 1) - 0.5) * 2;
        createArc(outerRadius, x, [
            1,
            1,
            1
        ], [
            0,
            0,
            0
        ], 1, 0);
        createArc(outerRadius, x, [
            0,
            0,
            0
        ], [
            uBack,
            0,
            0
        ], 0, 0);
        createArc(innerRadius, x, [
            1,
            1,
            1
        ], [
            0,
            0,
            0
        ], 1, 0);
        createArc(innerRadius, x, [
            0,
            0,
            0
        ], [
            uBack,
            0,
            0
        ], 0, 1);
    }
    // Do outer surface.
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, subdivisionsDown * 2 * (2 + subdivisionsThick), Uint16Array);
    function createSurface(leftArcOffset, rightArcOffset) {
        for(let z = 0; z < subdivisionsDown; ++z){
            // Make triangle 1 of quad.
            indices.push(leftArcOffset + z + 0, leftArcOffset + z + 1, rightArcOffset + z + 0);
            // Make triangle 2 of quad.
            indices.push(leftArcOffset + z + 1, rightArcOffset + z + 1, rightArcOffset + z + 0);
        }
    }
    const numVerticesDown = subdivisionsDown + 1;
    // front
    createSurface(numVerticesDown * 0, numVerticesDown * 4);
    // right
    createSurface(numVerticesDown * 5, numVerticesDown * 7);
    // back
    createSurface(numVerticesDown * 6, numVerticesDown * 2);
    // left
    createSurface(numVerticesDown * 3, numVerticesDown * 1);
    return {
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    };
}
/**
 * Creates cylinder BufferInfo. The cylinder will be created around the origin
 * along the y-axis.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius Radius of cylinder.
 * @param {number} height Height of cylinder.
 * @param {number} radialSubdivisions The number of subdivisions around the cylinder.
 * @param {number} verticalSubdivisions The number of subdivisions down the cylinder.
 * @param {boolean} [topCap] Create top cap. Default = true.
 * @param {boolean} [bottomCap] Create bottom cap. Default = true.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createCylinderBufferInfo
 */ /**
  * Creates cylinder buffers. The cylinder will be created around the origin
  * along the y-axis.
  *
  * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
  * @param {number} radius Radius of cylinder.
  * @param {number} height Height of cylinder.
  * @param {number} radialSubdivisions The number of subdivisions around the cylinder.
  * @param {number} verticalSubdivisions The number of subdivisions down the cylinder.
  * @param {boolean} [topCap] Create top cap. Default = true.
  * @param {boolean} [bottomCap] Create bottom cap. Default = true.
  * @return {Object.<string, WebGLBuffer>} The created buffers.
  * @memberOf module:twgl/primitives
  * @function createCylinderBuffers
  */ /**
  * Creates cylinder vertices. The cylinder will be created around the origin
  * along the y-axis.
  *
  * @param {number} radius Radius of cylinder.
  * @param {number} height Height of cylinder.
  * @param {number} radialSubdivisions The number of subdivisions around the cylinder.
  * @param {number} verticalSubdivisions The number of subdivisions down the cylinder.
  * @param {boolean} [topCap] Create top cap. Default = true.
  * @param {boolean} [bottomCap] Create bottom cap. Default = true.
  * @return {Object.<string, TypedArray>} The created vertices.
  * @memberOf module:twgl/primitives
  */ function $065afaecc735fbee$var$createCylinderVertices(radius, height, radialSubdivisions, verticalSubdivisions, topCap, bottomCap) {
    return $065afaecc735fbee$var$createTruncatedConeVertices(radius, radius, height, radialSubdivisions, verticalSubdivisions, topCap, bottomCap);
}
/**
 * Creates BufferInfo for a torus
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of center of torus circle.
 * @param {number} thickness radius of torus ring.
 * @param {number} radialSubdivisions The number of subdivisions around the torus.
 * @param {number} bodySubdivisions The number of subdivisions around the body torus.
 * @param {boolean} [startAngle] start angle in radians. Default = 0.
 * @param {boolean} [endAngle] end angle in radians. Default = Math.PI * 2.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createTorusBufferInfo
 */ /**
 * Creates buffers for a torus
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius radius of center of torus circle.
 * @param {number} thickness radius of torus ring.
 * @param {number} radialSubdivisions The number of subdivisions around the torus.
 * @param {number} bodySubdivisions The number of subdivisions around the body torus.
 * @param {boolean} [startAngle] start angle in radians. Default = 0.
 * @param {boolean} [endAngle] end angle in radians. Default = Math.PI * 2.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createTorusBuffers
 */ /**
 * Creates vertices for a torus
 *
 * @param {number} radius radius of center of torus circle.
 * @param {number} thickness radius of torus ring.
 * @param {number} radialSubdivisions The number of subdivisions around the torus.
 * @param {number} bodySubdivisions The number of subdivisions around the body torus.
 * @param {boolean} [startAngle] start angle in radians. Default = 0.
 * @param {boolean} [endAngle] end angle in radians. Default = Math.PI * 2.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createTorusVertices(radius, thickness, radialSubdivisions, bodySubdivisions, startAngle, endAngle) {
    if (radialSubdivisions < 3) throw new Error('radialSubdivisions must be 3 or greater');
    if (bodySubdivisions < 3) throw new Error('verticalSubdivisions must be 3 or greater');
    startAngle = startAngle || 0;
    endAngle = endAngle || Math.PI * 2;
    const range = endAngle - startAngle;
    const radialParts = radialSubdivisions + 1;
    const bodyParts = bodySubdivisions + 1;
    const numVertices = radialParts * bodyParts;
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, radialSubdivisions * bodySubdivisions * 2, Uint16Array);
    for(let slice = 0; slice < bodyParts; ++slice){
        const v = slice / bodySubdivisions;
        const sliceAngle = v * Math.PI * 2;
        const sliceSin = Math.sin(sliceAngle);
        const ringRadius = radius + sliceSin * thickness;
        const ny = Math.cos(sliceAngle);
        const y = ny * thickness;
        for(let ring = 0; ring < radialParts; ++ring){
            const u = ring / radialSubdivisions;
            const ringAngle = startAngle + u * range;
            const xSin = Math.sin(ringAngle);
            const zCos = Math.cos(ringAngle);
            const x = xSin * ringRadius;
            const z = zCos * ringRadius;
            const nx = xSin * sliceSin;
            const nz = zCos * sliceSin;
            positions.push(x, y, z);
            normals.push(nx, ny, nz);
            texcoords.push(u, 1 - v);
        }
    }
    for(let slice = 0; slice < bodySubdivisions; ++slice)for(let ring = 0; ring < radialSubdivisions; ++ring){
        const nextRingIndex = 1 + ring;
        const nextSliceIndex = 1 + slice;
        indices.push(radialParts * slice + ring, radialParts * nextSliceIndex + ring, radialParts * slice + nextRingIndex);
        indices.push(radialParts * nextSliceIndex + ring, radialParts * nextSliceIndex + nextRingIndex, radialParts * slice + nextRingIndex);
    }
    return {
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    };
}
/**
 * Creates a disc BufferInfo. The disc will be in the xz plane, centered at
 * the origin. When creating, at least 3 divisions, or pie
 * pieces, need to be specified, otherwise the triangles making
 * up the disc will be degenerate. You can also specify the
 * number of radial pieces `stacks`. A value of 1 for
 * stacks will give you a simple disc of pie pieces.  If you
 * want to create an annulus you can set `innerRadius` to a
 * value > 0. Finally, `stackPower` allows you to have the widths
 * increase or decrease as you move away from the center. This
 * is particularly useful when using the disc as a ground plane
 * with a fixed camera such that you don't need the resolution
 * of small triangles near the perimeter. For example, a value
 * of 2 will produce stacks whose outside radius increases with
 * the square of the stack index. A value of 1 will give uniform
 * stacks.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius Radius of the ground plane.
 * @param {number} divisions Number of triangles in the ground plane (at least 3).
 * @param {number} [stacks] Number of radial divisions (default=1).
 * @param {number} [innerRadius] Default 0.
 * @param {number} [stackPower] Power to raise stack size to for decreasing width.
 * @return {module:twgl.BufferInfo} The created BufferInfo.
 * @memberOf module:twgl/primitives
 * @function createDiscBufferInfo
 */ /**
 * Creates disc buffers. The disc will be in the xz plane, centered at
 * the origin. When creating, at least 3 divisions, or pie
 * pieces, need to be specified, otherwise the triangles making
 * up the disc will be degenerate. You can also specify the
 * number of radial pieces `stacks`. A value of 1 for
 * stacks will give you a simple disc of pie pieces.  If you
 * want to create an annulus you can set `innerRadius` to a
 * value > 0. Finally, `stackPower` allows you to have the widths
 * increase or decrease as you move away from the center. This
 * is particularly useful when using the disc as a ground plane
 * with a fixed camera such that you don't need the resolution
 * of small triangles near the perimeter. For example, a value
 * of 2 will produce stacks whose outside radius increases with
 * the square of the stack index. A value of 1 will give uniform
 * stacks.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext.
 * @param {number} radius Radius of the ground plane.
 * @param {number} divisions Number of triangles in the ground plane (at least 3).
 * @param {number} [stacks] Number of radial divisions (default=1).
 * @param {number} [innerRadius] Default 0.
 * @param {number} [stackPower] Power to raise stack size to for decreasing width.
 * @return {Object.<string, WebGLBuffer>} The created buffers.
 * @memberOf module:twgl/primitives
 * @function createDiscBuffers
 */ /**
 * Creates disc vertices. The disc will be in the xz plane, centered at
 * the origin. When creating, at least 3 divisions, or pie
 * pieces, need to be specified, otherwise the triangles making
 * up the disc will be degenerate. You can also specify the
 * number of radial pieces `stacks`. A value of 1 for
 * stacks will give you a simple disc of pie pieces.  If you
 * want to create an annulus you can set `innerRadius` to a
 * value > 0. Finally, `stackPower` allows you to have the widths
 * increase or decrease as you move away from the center. This
 * is particularly useful when using the disc as a ground plane
 * with a fixed camera such that you don't need the resolution
 * of small triangles near the perimeter. For example, a value
 * of 2 will produce stacks whose outside radius increases with
 * the square of the stack index. A value of 1 will give uniform
 * stacks.
 *
 * @param {number} radius Radius of the ground plane.
 * @param {number} divisions Number of triangles in the ground plane (at least 3).
 * @param {number} [stacks] Number of radial divisions (default=1).
 * @param {number} [innerRadius] Default 0.
 * @param {number} [stackPower] Power to raise stack size to for decreasing width.
 * @return {Object.<string, TypedArray>} The created vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$createDiscVertices(radius, divisions, stacks, innerRadius, stackPower) {
    if (divisions < 3) throw new Error('divisions must be at least 3');
    stacks = stacks ? stacks : 1;
    stackPower = stackPower ? stackPower : 1;
    innerRadius = innerRadius ? innerRadius : 0;
    // Note: We don't share the center vertex because that would
    // mess up texture coordinates.
    const numVertices = (divisions + 1) * (stacks + 1);
    const positions = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const normals = $065afaecc735fbee$var$createAugmentedTypedArray(3, numVertices);
    const texcoords = $065afaecc735fbee$var$createAugmentedTypedArray(2, numVertices);
    const indices = $065afaecc735fbee$var$createAugmentedTypedArray(3, stacks * divisions * 2, Uint16Array);
    let firstIndex = 0;
    const radiusSpan = radius - innerRadius;
    const pointsPerStack = divisions + 1;
    // Build the disk one stack at a time.
    for(let stack = 0; stack <= stacks; ++stack){
        const stackRadius = innerRadius + radiusSpan * Math.pow(stack / stacks, stackPower);
        for(let i = 0; i <= divisions; ++i){
            const theta = 2.0 * Math.PI * i / divisions;
            const x = stackRadius * Math.cos(theta);
            const z = stackRadius * Math.sin(theta);
            positions.push(x, 0, z);
            normals.push(0, 1, 0);
            texcoords.push(1 - i / divisions, stack / stacks);
            if (stack > 0 && i !== divisions) {
                // a, b, c and d are the indices of the vertices of a quad.  unless
                // the current stack is the one closest to the center, in which case
                // the vertices a and b connect to the center vertex.
                const a = firstIndex + (i + 1);
                const b = firstIndex + i;
                const c = firstIndex + i - pointsPerStack;
                const d = firstIndex + (i + 1) - pointsPerStack;
                // Make a quad of the vertices a, b, c, d.
                indices.push(a, b, c);
                indices.push(a, c, d);
            }
        }
        firstIndex += divisions + 1;
    }
    return {
        position: positions,
        normal: normals,
        texcoord: texcoords,
        indices: indices
    };
}
/**
 * creates a random integer between 0 and range - 1 inclusive.
 * @param {number} range
 * @return {number} random value between 0 and range - 1 inclusive.
 * @private
 */ function $065afaecc735fbee$var$randInt(range) {
    return Math.random() * range | 0;
}
/**
 * Used to supply random colors
 * @callback RandomColorFunc
 * @param {number} ndx index of triangle/quad if unindexed or index of vertex if indexed
 * @param {number} channel 0 = red, 1 = green, 2 = blue, 3 = alpha
 * @return {number} a number from 0 to 255
 * @memberOf module:twgl/primitives
 */ /**
 * @typedef {Object} RandomVerticesOptions
 * @property {number} [vertsPerColor] Defaults to 3 for non-indexed vertices
 * @property {module:twgl/primitives.RandomColorFunc} [rand] A function to generate random numbers
 * @memberOf module:twgl/primitives
 */ /**
 * Creates an augmentedTypedArray of random vertex colors.
 * If the vertices are indexed (have an indices array) then will
 * just make random colors. Otherwise assumes they are triangles
 * and makes one random color for every 3 vertices.
 * @param {Object.<string, AugmentedTypedArray>} vertices Vertices as returned from one of the createXXXVertices functions.
 * @param {module:twgl/primitives.RandomVerticesOptions} [options] options.
 * @return {Object.<string, AugmentedTypedArray>} same vertices as passed in with `color` added.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$makeRandomVertexColors(vertices, options) {
    options = options || {};
    const numElements = vertices.position.numElements;
    const vColors = $065afaecc735fbee$var$createAugmentedTypedArray(4, numElements, Uint8Array);
    const rand = options.rand || function(ndx, channel) {
        return channel < 3 ? $065afaecc735fbee$var$randInt(256) : 255;
    };
    vertices.color = vColors;
    if (vertices.indices) // just make random colors if index
    for(let ii = 0; ii < numElements; ++ii)vColors.push(rand(ii, 0), rand(ii, 1), rand(ii, 2), rand(ii, 3));
    else {
        // make random colors per triangle
        const numVertsPerColor = options.vertsPerColor || 3;
        const numSets = numElements / numVertsPerColor;
        for(let ii = 0; ii < numSets; ++ii){
            const color = [
                rand(ii, 0),
                rand(ii, 1),
                rand(ii, 2),
                rand(ii, 3)
            ];
            for(let jj = 0; jj < numVertsPerColor; ++jj)vColors.push(color);
        }
    }
    return vertices;
}
/**
 * creates a function that calls fn to create vertices and then
 * creates a buffers for them
 * @private
 */ function $065afaecc735fbee$var$createBufferFunc(fn) {
    return function(gl) {
        const arrays = fn.apply(this, Array.prototype.slice.call(arguments, 1));
        return $065afaecc735fbee$export$69d8acce17089372(gl, arrays);
    };
}
/**
 * creates a function that calls fn to create vertices and then
 * creates a bufferInfo object for them
 * @private
 */ function $065afaecc735fbee$var$createBufferInfoFunc(fn) {
    return function(gl) {
        const arrays = fn.apply(null, Array.prototype.slice.call(arguments, 1));
        return $065afaecc735fbee$export$140f5b0225138840(gl, arrays);
    };
}
const $065afaecc735fbee$var$arraySpecPropertyNames = [
    "numComponents",
    "size",
    "type",
    "normalize",
    "stride",
    "offset",
    "attrib",
    "name",
    "attribName"
];
/**
 * Copy elements from one array to another
 *
 * @param {Array|TypedArray} src source array
 * @param {Array|TypedArray} dst dest array
 * @param {number} dstNdx index in dest to copy src
 * @param {number} [offset] offset to add to copied values
 * @private
 */ function $065afaecc735fbee$var$copyElements(src, dst, dstNdx, offset) {
    offset = offset || 0;
    const length1 = src.length;
    for(let ii = 0; ii < length1; ++ii)dst[dstNdx + ii] = src[ii] + offset;
}
/**
 * Creates an array of the same time
 *
 * @param {(number[]|ArrayBufferView|module:twgl.FullArraySpec)} srcArray array who's type to copy
 * @param {number} length size of new array
 * @return {(number[]|ArrayBufferView|module:twgl.FullArraySpec)} array with same type as srcArray
 * @private
 */ function $065afaecc735fbee$var$createArrayOfSameType(srcArray, length1) {
    const arraySrc = $065afaecc735fbee$var$getArray(srcArray);
    const newArray = new arraySrc.constructor(length1);
    let newArraySpec = newArray;
    // If it appears to have been augmented make new one augmented
    if (arraySrc.numComponents && arraySrc.numElements) $065afaecc735fbee$var$augmentTypedArray(newArray, arraySrc.numComponents);
    // If it was a full spec make new one a full spec
    if (srcArray.data) {
        newArraySpec = {
            data: newArray
        };
        $065afaecc735fbee$var$copyNamedProperties($065afaecc735fbee$var$arraySpecPropertyNames, srcArray, newArraySpec);
    }
    return newArraySpec;
}
/**
 * Concatenates sets of vertices
 *
 * Assumes the vertices match in composition. For example
 * if one set of vertices has positions, normals, and indices
 * all sets of vertices must have positions, normals, and indices
 * and of the same type.
 *
 * Example:
 *
 *      const cubeVertices = twgl.primitives.createCubeVertices(2);
 *      const sphereVertices = twgl.primitives.createSphereVertices(1, 10, 10);
 *      // move the sphere 2 units up
 *      twgl.primitives.reorientVertices(
 *          sphereVertices, twgl.m4.translation([0, 2, 0]));
 *      // merge the sphere with the cube
 *      const cubeSphereVertices = twgl.primitives.concatVertices(
 *          [cubeVertices, sphereVertices]);
 *      // turn them into WebGL buffers and attrib data
 *      const bufferInfo = twgl.createBufferInfoFromArrays(gl, cubeSphereVertices);
 *
 * @param {module:twgl.Arrays[]} arrays Array of arrays of vertices
 * @return {module:twgl.Arrays} The concatenated vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$concatVertices(arrayOfArrays) {
    const names = {};
    let baseName;
    // get names of all arrays.
    // and numElements for each set of vertices
    for(let ii = 0; ii < arrayOfArrays.length; ++ii){
        const arrays = arrayOfArrays[ii];
        Object.keys(arrays).forEach(function(name) {
            if (!names[name]) names[name] = [];
            if (!baseName && name !== 'indices') baseName = name;
            const arrayInfo = arrays[name];
            const numComponents = $065afaecc735fbee$var$getNumComponents(arrayInfo, name);
            const array = $065afaecc735fbee$var$getArray(arrayInfo);
            const numElements = array.length / numComponents;
            names[name].push(numElements);
        });
    }
    // compute length of combined array
    // and return one for reference
    function getLengthOfCombinedArrays(name) {
        let length1 = 0;
        let arraySpec;
        for(let ii = 0; ii < arrayOfArrays.length; ++ii){
            const arrays = arrayOfArrays[ii];
            const arrayInfo = arrays[name];
            const array = $065afaecc735fbee$var$getArray(arrayInfo);
            length1 += array.length;
            if (!arraySpec || arrayInfo.data) arraySpec = arrayInfo;
        }
        return {
            length: length1,
            spec: arraySpec
        };
    }
    function copyArraysToNewArray(name, base, newArray) {
        let baseIndex = 0;
        let offset = 0;
        for(let ii = 0; ii < arrayOfArrays.length; ++ii){
            const arrays = arrayOfArrays[ii];
            const arrayInfo = arrays[name];
            const array = $065afaecc735fbee$var$getArray(arrayInfo);
            if (name === 'indices') {
                $065afaecc735fbee$var$copyElements(array, newArray, offset, baseIndex);
                baseIndex += base[ii];
            } else $065afaecc735fbee$var$copyElements(array, newArray, offset);
            offset += array.length;
        }
    }
    const base = names[baseName];
    const newArrays = {};
    Object.keys(names).forEach(function(name) {
        const info = getLengthOfCombinedArrays(name);
        const newArraySpec = $065afaecc735fbee$var$createArrayOfSameType(info.spec, info.length);
        copyArraysToNewArray(name, base, $065afaecc735fbee$var$getArray(newArraySpec));
        newArrays[name] = newArraySpec;
    });
    return newArrays;
}
/**
 * Creates a duplicate set of vertices
 *
 * This is useful for calling reorientVertices when you
 * also want to keep the original available
 *
 * @param {module:twgl.Arrays} arrays of vertices
 * @return {module:twgl.Arrays} The duplicated vertices.
 * @memberOf module:twgl/primitives
 */ function $065afaecc735fbee$var$duplicateVertices(arrays) {
    const newArrays = {};
    Object.keys(arrays).forEach(function(name) {
        const arraySpec = arrays[name];
        const srcArray = $065afaecc735fbee$var$getArray(arraySpec);
        const newArraySpec = $065afaecc735fbee$var$createArrayOfSameType(arraySpec, srcArray.length);
        $065afaecc735fbee$var$copyElements(srcArray, $065afaecc735fbee$var$getArray(newArraySpec), 0);
        newArrays[name] = newArraySpec;
    });
    return newArrays;
}
const $065afaecc735fbee$var$create3DFBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$create3DFVertices);
const $065afaecc735fbee$var$create3DFBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$create3DFVertices);
const $065afaecc735fbee$var$createCubeBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createCubeVertices);
const $065afaecc735fbee$var$createCubeBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createCubeVertices);
const $065afaecc735fbee$var$createPlaneBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createPlaneVertices);
const $065afaecc735fbee$var$createPlaneBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createPlaneVertices);
const $065afaecc735fbee$var$createSphereBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createSphereVertices);
const $065afaecc735fbee$var$createSphereBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createSphereVertices);
const $065afaecc735fbee$var$createTruncatedConeBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createTruncatedConeVertices);
const $065afaecc735fbee$var$createTruncatedConeBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createTruncatedConeVertices);
const $065afaecc735fbee$var$createXYQuadBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createXYQuadVertices);
const $065afaecc735fbee$var$createXYQuadBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createXYQuadVertices);
const $065afaecc735fbee$var$createCrescentBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createCrescentVertices);
const $065afaecc735fbee$var$createCrescentBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createCrescentVertices);
const $065afaecc735fbee$var$createCylinderBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createCylinderVertices);
const $065afaecc735fbee$var$createCylinderBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createCylinderVertices);
const $065afaecc735fbee$var$createTorusBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createTorusVertices);
const $065afaecc735fbee$var$createTorusBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createTorusVertices);
const $065afaecc735fbee$var$createDiscBufferInfo = $065afaecc735fbee$var$createBufferInfoFunc($065afaecc735fbee$var$createDiscVertices);
const $065afaecc735fbee$var$createDiscBuffers = $065afaecc735fbee$var$createBufferFunc($065afaecc735fbee$var$createDiscVertices);
// these were mis-spelled until 4.12
const $065afaecc735fbee$var$createCresentBufferInfo = $065afaecc735fbee$var$createCrescentBufferInfo;
const $065afaecc735fbee$var$createCresentBuffers = $065afaecc735fbee$var$createCrescentBuffers;
const $065afaecc735fbee$var$createCresentVertices = $065afaecc735fbee$var$createCrescentVertices;
var $065afaecc735fbee$export$67635360ab47a385 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    create3DFBufferInfo: $065afaecc735fbee$var$create3DFBufferInfo,
    create3DFBuffers: $065afaecc735fbee$var$create3DFBuffers,
    create3DFVertices: $065afaecc735fbee$var$create3DFVertices,
    createAugmentedTypedArray: $065afaecc735fbee$var$createAugmentedTypedArray,
    createCubeBufferInfo: $065afaecc735fbee$var$createCubeBufferInfo,
    createCubeBuffers: $065afaecc735fbee$var$createCubeBuffers,
    createCubeVertices: $065afaecc735fbee$var$createCubeVertices,
    createPlaneBufferInfo: $065afaecc735fbee$var$createPlaneBufferInfo,
    createPlaneBuffers: $065afaecc735fbee$var$createPlaneBuffers,
    createPlaneVertices: $065afaecc735fbee$var$createPlaneVertices,
    createSphereBufferInfo: $065afaecc735fbee$var$createSphereBufferInfo,
    createSphereBuffers: $065afaecc735fbee$var$createSphereBuffers,
    createSphereVertices: $065afaecc735fbee$var$createSphereVertices,
    createTruncatedConeBufferInfo: $065afaecc735fbee$var$createTruncatedConeBufferInfo,
    createTruncatedConeBuffers: $065afaecc735fbee$var$createTruncatedConeBuffers,
    createTruncatedConeVertices: $065afaecc735fbee$var$createTruncatedConeVertices,
    createXYQuadBufferInfo: $065afaecc735fbee$var$createXYQuadBufferInfo,
    createXYQuadBuffers: $065afaecc735fbee$var$createXYQuadBuffers,
    createXYQuadVertices: $065afaecc735fbee$var$createXYQuadVertices,
    createCresentBufferInfo: $065afaecc735fbee$var$createCresentBufferInfo,
    createCresentBuffers: $065afaecc735fbee$var$createCresentBuffers,
    createCresentVertices: $065afaecc735fbee$var$createCresentVertices,
    createCrescentBufferInfo: $065afaecc735fbee$var$createCrescentBufferInfo,
    createCrescentBuffers: $065afaecc735fbee$var$createCrescentBuffers,
    createCrescentVertices: $065afaecc735fbee$var$createCrescentVertices,
    createCylinderBufferInfo: $065afaecc735fbee$var$createCylinderBufferInfo,
    createCylinderBuffers: $065afaecc735fbee$var$createCylinderBuffers,
    createCylinderVertices: $065afaecc735fbee$var$createCylinderVertices,
    createTorusBufferInfo: $065afaecc735fbee$var$createTorusBufferInfo,
    createTorusBuffers: $065afaecc735fbee$var$createTorusBuffers,
    createTorusVertices: $065afaecc735fbee$var$createTorusVertices,
    createDiscBufferInfo: $065afaecc735fbee$var$createDiscBufferInfo,
    createDiscBuffers: $065afaecc735fbee$var$createDiscBuffers,
    createDiscVertices: $065afaecc735fbee$var$createDiscVertices,
    deindexVertices: $065afaecc735fbee$var$deindexVertices,
    flattenNormals: $065afaecc735fbee$var$flattenNormals,
    makeRandomVertexColors: $065afaecc735fbee$var$makeRandomVertexColors,
    reorientDirections: $065afaecc735fbee$var$reorientDirections,
    reorientNormals: $065afaecc735fbee$var$reorientNormals,
    reorientPositions: $065afaecc735fbee$var$reorientPositions,
    reorientVertices: $065afaecc735fbee$var$reorientVertices,
    concatVertices: $065afaecc735fbee$var$concatVertices,
    duplicateVertices: $065afaecc735fbee$var$duplicateVertices
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /**
 * Gets the gl version as a number
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @return {number} version of gl
 * @private
 */ //function getVersionAsNumber(gl) {
//  return parseFloat(gl.getParameter(gl.VERSION).substr(6));
//}
/**
 * Check if context is WebGL 2.0
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @return {bool} true if it's WebGL 2.0
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$e3518b1ac7891039(gl) {
    // This is the correct check but it's slow
    //  return gl.getParameter(gl.VERSION).indexOf("WebGL 2.0") === 0;
    // This might also be the correct check but I'm assuming it's slow-ish
    // return gl instanceof WebGL2RenderingContext;
    return !!gl.texStorage2D;
}
/**
 * Check if context is WebGL 1.0
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @return {bool} true if it's WebGL 1.0
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$6fee3240cb824186(gl) {
    // This is the correct check but it's slow
    // const version = getVersionAsNumber(gl);
    // return version <= 1.0 && version > 0.0;  // because as of 2016/5 Edge returns 0.96
    // This might also be the correct check but I'm assuming it's slow-ish
    // return gl instanceof WebGLRenderingContext;
    return !gl.texStorage2D;
}
/**
 * Gets a string for WebGL enum
 *
 * Note: Several enums are the same. Without more
 * context (which function) it's impossible to always
 * give the correct enum. As it is, for matching values
 * it gives all enums. Checking the WebGL2RenderingContext
 * that means
 *
 *      0     = ZERO | POINT | NONE | NO_ERROR
 *      1     = ONE | LINES | SYNC_FLUSH_COMMANDS_BIT
 *      32777 = BLEND_EQUATION_RGB | BLEND_EQUATION_RGB
 *      36662 = COPY_READ_BUFFER | COPY_READ_BUFFER_BINDING
 *      36663 = COPY_WRITE_BUFFER | COPY_WRITE_BUFFER_BINDING
 *      36006 = FRAMEBUFFER_BINDING | DRAW_FRAMEBUFFER_BINDING
 *
 * It's also not useful for bits really unless you pass in individual bits.
 * In other words
 *
 *     const bits = gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT;
 *     twgl.glEnumToString(gl, bits);  // not going to work
 *
 * Note that some enums only exist on extensions. If you
 * want them to show up you need to pass the extension at least
 * once. For example
 *
 *     const ext = gl.getExtension('WEBGL_compressed_texture_s3tc');
 *     if (ext) {
 *        twgl.glEnumToString(ext, 0);  // just prime the function
 *
 *        ..later..
 *
 *        const internalFormat = ext.COMPRESSED_RGB_S3TC_DXT1_EXT;
 *        console.log(twgl.glEnumToString(gl, internalFormat));
 *
 * Notice I didn't have to pass the extension the second time. This means
 * you can have place that generically gets an enum for texture formats for example.
 * and as long as you primed the function with the extensions
 *
 * If you're using `twgl.addExtensionsToContext` to enable your extensions
 * then twgl will automatically get the extension's enums.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext or any extension object
 * @param {number} value the value of the enum you want to look up.
 * @return {string} enum string or hex value
 * @memberOf module:twgl
 * @function glEnumToString
 */ const $065afaecc735fbee$export$e97753eae63e4e62 = function() {
    const haveEnumsForType = {};
    const enums = {};
    function addEnums(gl) {
        const type = gl.constructor.name;
        if (!haveEnumsForType[type]) {
            for(const key in gl)if (typeof gl[key] === 'number') {
                const existing = enums[gl[key]];
                enums[gl[key]] = existing ? `${existing} | ${key}` : key;
            }
            haveEnumsForType[type] = true;
        }
    }
    return function glEnumToString(gl, value) {
        addEnums(gl);
        return enums[value] || (typeof value === 'number' ? `0x${value.toString(16)}` : value);
    };
}();
var $065afaecc735fbee$export$eab97d15b1788b8d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    glEnumToString: $065afaecc735fbee$export$e97753eae63e4e62,
    isWebGL1: $065afaecc735fbee$export$6fee3240cb824186,
    isWebGL2: $065afaecc735fbee$export$e3518b1ac7891039
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ const $065afaecc735fbee$var$defaults$1 = {
    textureColor: new Uint8Array([
        128,
        192,
        255,
        255
    ]),
    textureOptions: {},
    crossOrigin: undefined
};
const $065afaecc735fbee$var$isArrayBuffer = $065afaecc735fbee$export$9dd3754ae86f0017;
// Should we make this on demand?
const $065afaecc735fbee$var$getShared2DContext = function() {
    let s_ctx;
    return function getShared2DContext() {
        s_ctx = s_ctx || (typeof document !== 'undefined' && document.createElement ? document.createElement("canvas").getContext("2d") : null);
        return s_ctx;
    };
}();
// NOTE: Chrome supports 2D canvas in a Worker (behind flag as of v64 but
//       not only does Firefox NOT support it but Firefox freezes immediately
//       if you try to create one instead of just returning null and continuing.
//  : (global.OffscreenCanvas && (new global.OffscreenCanvas(1, 1)).getContext("2d"));  // OffscreenCanvas may not support 2d
// NOTE: We can maybe remove some of the need for the 2d canvas. In WebGL2
// we can use the various unpack settings. Otherwise we could try using
// the ability of an ImageBitmap to be cut. Unfortunately cutting an ImageBitmap
// is async and the current TWGL code expects a non-Async result though that
// might not be a problem. ImageBitmap though is not available in Edge or Safari
// as of 2018-01-02
/* PixelFormat */ const $065afaecc735fbee$var$ALPHA = 0x1906;
const $065afaecc735fbee$var$RGB = 0x1907;
const $065afaecc735fbee$var$RGBA$1 = 0x1908;
const $065afaecc735fbee$var$LUMINANCE = 0x1909;
const $065afaecc735fbee$var$LUMINANCE_ALPHA = 0x190A;
const $065afaecc735fbee$var$DEPTH_COMPONENT$1 = 0x1902;
const $065afaecc735fbee$var$DEPTH_STENCIL$1 = 0x84F9;
/* TextureWrapMode */ // const REPEAT                         = 0x2901;
// const MIRRORED_REPEAT                = 0x8370;
const $065afaecc735fbee$var$CLAMP_TO_EDGE$1 = 0x812f;
/* TextureMagFilter */ const $065afaecc735fbee$var$NEAREST = 0x2600;
const $065afaecc735fbee$var$LINEAR$1 = 0x2601;
/* TextureMinFilter */ // const NEAREST_MIPMAP_NEAREST         = 0x2700;
// const LINEAR_MIPMAP_NEAREST          = 0x2701;
// const NEAREST_MIPMAP_LINEAR          = 0x2702;
// const LINEAR_MIPMAP_LINEAR           = 0x2703;
/* Texture Target */ const $065afaecc735fbee$var$TEXTURE_2D$2 = 0x0de1;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1 = 0x8513;
const $065afaecc735fbee$var$TEXTURE_3D$1 = 0x806f;
const $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1 = 0x8c1a;
/* Cubemap Targets */ const $065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_X = 0x8515;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP_NEGATIVE_X = 0x8516;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_Y = 0x8517;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP_NEGATIVE_Y = 0x8518;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_Z = 0x8519;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP_NEGATIVE_Z = 0x851a;
/* Texture Parameters */ const $065afaecc735fbee$var$TEXTURE_MIN_FILTER = 0x2801;
const $065afaecc735fbee$var$TEXTURE_MAG_FILTER = 0x2800;
const $065afaecc735fbee$var$TEXTURE_WRAP_S = 0x2802;
const $065afaecc735fbee$var$TEXTURE_WRAP_T = 0x2803;
const $065afaecc735fbee$var$TEXTURE_WRAP_R = 0x8072;
const $065afaecc735fbee$var$TEXTURE_MIN_LOD = 0x813a;
const $065afaecc735fbee$var$TEXTURE_MAX_LOD = 0x813b;
const $065afaecc735fbee$var$TEXTURE_BASE_LEVEL = 0x813c;
const $065afaecc735fbee$var$TEXTURE_MAX_LEVEL = 0x813d;
const $065afaecc735fbee$var$TEXTURE_COMPARE_MODE = 0x884C;
const $065afaecc735fbee$var$TEXTURE_COMPARE_FUNC = 0x884D;
/* Pixel store */ const $065afaecc735fbee$var$UNPACK_ALIGNMENT = 0x0cf5;
const $065afaecc735fbee$var$UNPACK_ROW_LENGTH = 0x0cf2;
const $065afaecc735fbee$var$UNPACK_IMAGE_HEIGHT = 0x806e;
const $065afaecc735fbee$var$UNPACK_SKIP_PIXELS = 0x0cf4;
const $065afaecc735fbee$var$UNPACK_SKIP_ROWS = 0x0cf3;
const $065afaecc735fbee$var$UNPACK_SKIP_IMAGES = 0x806d;
const $065afaecc735fbee$var$UNPACK_COLORSPACE_CONVERSION_WEBGL = 0x9243;
const $065afaecc735fbee$var$UNPACK_PREMULTIPLY_ALPHA_WEBGL = 0x9241;
const $065afaecc735fbee$var$UNPACK_FLIP_Y_WEBGL = 0x9240;
const $065afaecc735fbee$var$R8 = 0x8229;
const $065afaecc735fbee$var$R8_SNORM = 0x8F94;
const $065afaecc735fbee$var$R16F = 0x822D;
const $065afaecc735fbee$var$R32F = 0x822E;
const $065afaecc735fbee$var$R8UI = 0x8232;
const $065afaecc735fbee$var$R8I = 0x8231;
const $065afaecc735fbee$var$RG16UI = 0x823A;
const $065afaecc735fbee$var$RG16I = 0x8239;
const $065afaecc735fbee$var$RG32UI = 0x823C;
const $065afaecc735fbee$var$RG32I = 0x823B;
const $065afaecc735fbee$var$RG8 = 0x822B;
const $065afaecc735fbee$var$RG8_SNORM = 0x8F95;
const $065afaecc735fbee$var$RG16F = 0x822F;
const $065afaecc735fbee$var$RG32F = 0x8230;
const $065afaecc735fbee$var$RG8UI = 0x8238;
const $065afaecc735fbee$var$RG8I = 0x8237;
const $065afaecc735fbee$var$R16UI = 0x8234;
const $065afaecc735fbee$var$R16I = 0x8233;
const $065afaecc735fbee$var$R32UI = 0x8236;
const $065afaecc735fbee$var$R32I = 0x8235;
const $065afaecc735fbee$var$RGB8 = 0x8051;
const $065afaecc735fbee$var$SRGB8 = 0x8C41;
const $065afaecc735fbee$var$RGB565$1 = 0x8D62;
const $065afaecc735fbee$var$RGB8_SNORM = 0x8F96;
const $065afaecc735fbee$var$R11F_G11F_B10F = 0x8C3A;
const $065afaecc735fbee$var$RGB9_E5 = 0x8C3D;
const $065afaecc735fbee$var$RGB16F = 0x881B;
const $065afaecc735fbee$var$RGB32F = 0x8815;
const $065afaecc735fbee$var$RGB8UI = 0x8D7D;
const $065afaecc735fbee$var$RGB8I = 0x8D8F;
const $065afaecc735fbee$var$RGB16UI = 0x8D77;
const $065afaecc735fbee$var$RGB16I = 0x8D89;
const $065afaecc735fbee$var$RGB32UI = 0x8D71;
const $065afaecc735fbee$var$RGB32I = 0x8D83;
const $065afaecc735fbee$var$RGBA8 = 0x8058;
const $065afaecc735fbee$var$SRGB8_ALPHA8 = 0x8C43;
const $065afaecc735fbee$var$RGBA8_SNORM = 0x8F97;
const $065afaecc735fbee$var$RGB5_A1$1 = 0x8057;
const $065afaecc735fbee$var$RGBA4$1 = 0x8056;
const $065afaecc735fbee$var$RGB10_A2 = 0x8059;
const $065afaecc735fbee$var$RGBA16F = 0x881A;
const $065afaecc735fbee$var$RGBA32F = 0x8814;
const $065afaecc735fbee$var$RGBA8UI = 0x8D7C;
const $065afaecc735fbee$var$RGBA8I = 0x8D8E;
const $065afaecc735fbee$var$RGB10_A2UI = 0x906F;
const $065afaecc735fbee$var$RGBA16UI = 0x8D76;
const $065afaecc735fbee$var$RGBA16I = 0x8D88;
const $065afaecc735fbee$var$RGBA32I = 0x8D82;
const $065afaecc735fbee$var$RGBA32UI = 0x8D70;
const $065afaecc735fbee$var$DEPTH_COMPONENT16$1 = 0x81A5;
const $065afaecc735fbee$var$DEPTH_COMPONENT24$1 = 0x81A6;
const $065afaecc735fbee$var$DEPTH_COMPONENT32F$1 = 0x8CAC;
const $065afaecc735fbee$var$DEPTH32F_STENCIL8$1 = 0x8CAD;
const $065afaecc735fbee$var$DEPTH24_STENCIL8$1 = 0x88F0;
/* DataType */ const $065afaecc735fbee$var$BYTE = 0x1400;
const $065afaecc735fbee$var$UNSIGNED_BYTE$1 = 0x1401;
const $065afaecc735fbee$var$SHORT = 0x1402;
const $065afaecc735fbee$var$UNSIGNED_SHORT$1 = 0x1403;
const $065afaecc735fbee$var$INT$1 = 0x1404;
const $065afaecc735fbee$var$UNSIGNED_INT$1 = 0x1405;
const $065afaecc735fbee$var$FLOAT$1 = 0x1406;
const $065afaecc735fbee$var$UNSIGNED_SHORT_4_4_4_4 = 0x8033;
const $065afaecc735fbee$var$UNSIGNED_SHORT_5_5_5_1 = 0x8034;
const $065afaecc735fbee$var$UNSIGNED_SHORT_5_6_5 = 0x8363;
const $065afaecc735fbee$var$HALF_FLOAT = 0x140B;
const $065afaecc735fbee$var$HALF_FLOAT_OES = 0x8D61; // Thanks Khronos for making this different >:(
const $065afaecc735fbee$var$UNSIGNED_INT_2_10_10_10_REV = 0x8368;
const $065afaecc735fbee$var$UNSIGNED_INT_10F_11F_11F_REV = 0x8C3B;
const $065afaecc735fbee$var$UNSIGNED_INT_5_9_9_9_REV = 0x8C3E;
const $065afaecc735fbee$var$FLOAT_32_UNSIGNED_INT_24_8_REV = 0x8DAD;
const $065afaecc735fbee$var$UNSIGNED_INT_24_8 = 0x84FA;
const $065afaecc735fbee$var$RG = 0x8227;
const $065afaecc735fbee$var$RG_INTEGER = 0x8228;
const $065afaecc735fbee$var$RED = 0x1903;
const $065afaecc735fbee$var$RED_INTEGER = 0x8D94;
const $065afaecc735fbee$var$RGB_INTEGER = 0x8D98;
const $065afaecc735fbee$var$RGBA_INTEGER = 0x8D99;
const $065afaecc735fbee$var$formatInfo = {};
{
    // NOTE: this is named `numColorComponents` vs `numComponents` so we can let Uglify mangle
    // the name.
    const f = $065afaecc735fbee$var$formatInfo;
    f[$065afaecc735fbee$var$ALPHA] = {
        numColorComponents: 1
    };
    f[$065afaecc735fbee$var$LUMINANCE] = {
        numColorComponents: 1
    };
    f[$065afaecc735fbee$var$LUMINANCE_ALPHA] = {
        numColorComponents: 2
    };
    f[$065afaecc735fbee$var$RGB] = {
        numColorComponents: 3
    };
    f[$065afaecc735fbee$var$RGBA$1] = {
        numColorComponents: 4
    };
    f[$065afaecc735fbee$var$RED] = {
        numColorComponents: 1
    };
    f[$065afaecc735fbee$var$RED_INTEGER] = {
        numColorComponents: 1
    };
    f[$065afaecc735fbee$var$RG] = {
        numColorComponents: 2
    };
    f[$065afaecc735fbee$var$RG_INTEGER] = {
        numColorComponents: 2
    };
    f[$065afaecc735fbee$var$RGB] = {
        numColorComponents: 3
    };
    f[$065afaecc735fbee$var$RGB_INTEGER] = {
        numColorComponents: 3
    };
    f[$065afaecc735fbee$var$RGBA$1] = {
        numColorComponents: 4
    };
    f[$065afaecc735fbee$var$RGBA_INTEGER] = {
        numColorComponents: 4
    };
    f[$065afaecc735fbee$var$DEPTH_COMPONENT$1] = {
        numColorComponents: 1
    };
    f[$065afaecc735fbee$var$DEPTH_STENCIL$1] = {
        numColorComponents: 2
    };
}/**
 * @typedef {Object} TextureFormatDetails
 * @property {number} textureFormat format to pass texImage2D and similar functions.
 * @property {boolean} colorRenderable true if you can render to this format of texture.
 * @property {boolean} textureFilterable true if you can filter the texture, false if you can ony use `NEAREST`.
 * @property {number[]} type Array of possible types you can pass to texImage2D and similar function
 * @property {Object.<number,number>} bytesPerElementMap A map of types to bytes per element
 * @private
 */ let $065afaecc735fbee$var$s_textureInternalFormatInfo;
function $065afaecc735fbee$var$getTextureInternalFormatInfo(internalFormat) {
    if (!$065afaecc735fbee$var$s_textureInternalFormatInfo) {
        // NOTE: these properties need unique names so we can let Uglify mangle the name.
        const t = {};
        // unsized formats
        t[$065afaecc735fbee$var$ALPHA] = {
            textureFormat: $065afaecc735fbee$var$ALPHA,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                1,
                2,
                2,
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$HALF_FLOAT_OES,
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$LUMINANCE] = {
            textureFormat: $065afaecc735fbee$var$LUMINANCE,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                1,
                2,
                2,
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$HALF_FLOAT_OES,
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$LUMINANCE_ALPHA] = {
            textureFormat: $065afaecc735fbee$var$LUMINANCE_ALPHA,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                2,
                4,
                4,
                8
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$HALF_FLOAT_OES,
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$RGB] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                3,
                6,
                6,
                12,
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$HALF_FLOAT_OES,
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$UNSIGNED_SHORT_5_6_5
            ]
        };
        t[$065afaecc735fbee$var$RGBA$1] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                4,
                8,
                8,
                16,
                2,
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$HALF_FLOAT_OES,
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$UNSIGNED_SHORT_4_4_4_4,
                $065afaecc735fbee$var$UNSIGNED_SHORT_5_5_5_1
            ]
        };
        t[$065afaecc735fbee$var$DEPTH_COMPONENT$1] = {
            textureFormat: $065afaecc735fbee$var$DEPTH_COMPONENT$1,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                2,
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT$1,
                $065afaecc735fbee$var$UNSIGNED_SHORT$1
            ]
        };
        // sized formats
        t[$065afaecc735fbee$var$R8] = {
            textureFormat: $065afaecc735fbee$var$RED,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                1
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$R8_SNORM] = {
            textureFormat: $065afaecc735fbee$var$RED,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                1
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$R16F] = {
            textureFormat: $065afaecc735fbee$var$RED,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                4,
                2
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$HALF_FLOAT
            ]
        };
        t[$065afaecc735fbee$var$R32F] = {
            textureFormat: $065afaecc735fbee$var$RED,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$R8UI] = {
            textureFormat: $065afaecc735fbee$var$RED_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                1
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$R8I] = {
            textureFormat: $065afaecc735fbee$var$RED_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                1
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$R16UI] = {
            textureFormat: $065afaecc735fbee$var$RED_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_SHORT$1
            ]
        };
        t[$065afaecc735fbee$var$R16I] = {
            textureFormat: $065afaecc735fbee$var$RED_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                2
            ],
            type: [
                $065afaecc735fbee$var$SHORT
            ]
        };
        t[$065afaecc735fbee$var$R32UI] = {
            textureFormat: $065afaecc735fbee$var$RED_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT$1
            ]
        };
        t[$065afaecc735fbee$var$R32I] = {
            textureFormat: $065afaecc735fbee$var$RED_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$INT$1
            ]
        };
        t[$065afaecc735fbee$var$RG8] = {
            textureFormat: $065afaecc735fbee$var$RG,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$RG8_SNORM] = {
            textureFormat: $065afaecc735fbee$var$RG,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                2
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$RG16F] = {
            textureFormat: $065afaecc735fbee$var$RG,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                8,
                4
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$HALF_FLOAT
            ]
        };
        t[$065afaecc735fbee$var$RG32F] = {
            textureFormat: $065afaecc735fbee$var$RG,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                8
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$RG8UI] = {
            textureFormat: $065afaecc735fbee$var$RG_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$RG8I] = {
            textureFormat: $065afaecc735fbee$var$RG_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                2
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$RG16UI] = {
            textureFormat: $065afaecc735fbee$var$RG_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_SHORT$1
            ]
        };
        t[$065afaecc735fbee$var$RG16I] = {
            textureFormat: $065afaecc735fbee$var$RG_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$SHORT
            ]
        };
        t[$065afaecc735fbee$var$RG32UI] = {
            textureFormat: $065afaecc735fbee$var$RG_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                8
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT$1
            ]
        };
        t[$065afaecc735fbee$var$RG32I] = {
            textureFormat: $065afaecc735fbee$var$RG_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                8
            ],
            type: [
                $065afaecc735fbee$var$INT$1
            ]
        };
        t[$065afaecc735fbee$var$RGB8] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                3
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$SRGB8] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                3
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$RGB565$1] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                3,
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$UNSIGNED_SHORT_5_6_5
            ]
        };
        t[$065afaecc735fbee$var$RGB8_SNORM] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                3
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$R11F_G11F_B10F] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                12,
                6,
                4
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$UNSIGNED_INT_10F_11F_11F_REV
            ]
        };
        t[$065afaecc735fbee$var$RGB9_E5] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                12,
                6,
                4
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$HALF_FLOAT,
                $065afaecc735fbee$var$UNSIGNED_INT_5_9_9_9_REV
            ]
        };
        t[$065afaecc735fbee$var$RGB16F] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                12,
                6
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$HALF_FLOAT
            ]
        };
        t[$065afaecc735fbee$var$RGB32F] = {
            textureFormat: $065afaecc735fbee$var$RGB,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                12
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$RGB8UI] = {
            textureFormat: $065afaecc735fbee$var$RGB_INTEGER,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                3
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$RGB8I] = {
            textureFormat: $065afaecc735fbee$var$RGB_INTEGER,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                3
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$RGB16UI] = {
            textureFormat: $065afaecc735fbee$var$RGB_INTEGER,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                6
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_SHORT$1
            ]
        };
        t[$065afaecc735fbee$var$RGB16I] = {
            textureFormat: $065afaecc735fbee$var$RGB_INTEGER,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                6
            ],
            type: [
                $065afaecc735fbee$var$SHORT
            ]
        };
        t[$065afaecc735fbee$var$RGB32UI] = {
            textureFormat: $065afaecc735fbee$var$RGB_INTEGER,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                12
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT$1
            ]
        };
        t[$065afaecc735fbee$var$RGB32I] = {
            textureFormat: $065afaecc735fbee$var$RGB_INTEGER,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                12
            ],
            type: [
                $065afaecc735fbee$var$INT$1
            ]
        };
        t[$065afaecc735fbee$var$RGBA8] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$SRGB8_ALPHA8] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$RGBA8_SNORM] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$RGB5_A1$1] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                4,
                2,
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$UNSIGNED_SHORT_5_5_5_1,
                $065afaecc735fbee$var$UNSIGNED_INT_2_10_10_10_REV
            ]
        };
        t[$065afaecc735fbee$var$RGBA4$1] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                4,
                2
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1,
                $065afaecc735fbee$var$UNSIGNED_SHORT_4_4_4_4
            ]
        };
        t[$065afaecc735fbee$var$RGB10_A2] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: true,
            textureFilterable: true,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT_2_10_10_10_REV
            ]
        };
        t[$065afaecc735fbee$var$RGBA16F] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: false,
            textureFilterable: true,
            bytesPerElement: [
                16,
                8
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1,
                $065afaecc735fbee$var$HALF_FLOAT
            ]
        };
        t[$065afaecc735fbee$var$RGBA32F] = {
            textureFormat: $065afaecc735fbee$var$RGBA$1,
            colorRenderable: false,
            textureFilterable: false,
            bytesPerElement: [
                16
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$RGBA8UI] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_BYTE$1
            ]
        };
        t[$065afaecc735fbee$var$RGBA8I] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$BYTE
            ]
        };
        t[$065afaecc735fbee$var$RGB10_A2UI] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT_2_10_10_10_REV
            ]
        };
        t[$065afaecc735fbee$var$RGBA16UI] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                8
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_SHORT$1
            ]
        };
        t[$065afaecc735fbee$var$RGBA16I] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                8
            ],
            type: [
                $065afaecc735fbee$var$SHORT
            ]
        };
        t[$065afaecc735fbee$var$RGBA32I] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                16
            ],
            type: [
                $065afaecc735fbee$var$INT$1
            ]
        };
        t[$065afaecc735fbee$var$RGBA32UI] = {
            textureFormat: $065afaecc735fbee$var$RGBA_INTEGER,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                16
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT$1
            ]
        };
        // Sized Internal
        t[$065afaecc735fbee$var$DEPTH_COMPONENT16$1] = {
            textureFormat: $065afaecc735fbee$var$DEPTH_COMPONENT$1,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                2,
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_SHORT$1,
                $065afaecc735fbee$var$UNSIGNED_INT$1
            ]
        };
        t[$065afaecc735fbee$var$DEPTH_COMPONENT24$1] = {
            textureFormat: $065afaecc735fbee$var$DEPTH_COMPONENT$1,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT$1
            ]
        };
        t[$065afaecc735fbee$var$DEPTH_COMPONENT32F$1] = {
            textureFormat: $065afaecc735fbee$var$DEPTH_COMPONENT$1,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$FLOAT$1
            ]
        };
        t[$065afaecc735fbee$var$DEPTH24_STENCIL8$1] = {
            textureFormat: $065afaecc735fbee$var$DEPTH_STENCIL$1,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$UNSIGNED_INT_24_8
            ]
        };
        t[$065afaecc735fbee$var$DEPTH32F_STENCIL8$1] = {
            textureFormat: $065afaecc735fbee$var$DEPTH_STENCIL$1,
            colorRenderable: true,
            textureFilterable: false,
            bytesPerElement: [
                4
            ],
            type: [
                $065afaecc735fbee$var$FLOAT_32_UNSIGNED_INT_24_8_REV
            ]
        };
        Object.keys(t).forEach(function(internalFormat) {
            const info = t[internalFormat];
            info.bytesPerElementMap = {};
            info.bytesPerElement.forEach(function(bytesPerElement, ndx) {
                const type = info.type[ndx];
                info.bytesPerElementMap[type] = bytesPerElement;
            });
        });
        $065afaecc735fbee$var$s_textureInternalFormatInfo = t;
    }
    return $065afaecc735fbee$var$s_textureInternalFormatInfo[internalFormat];
}
/**
 * Gets the number of bytes per element for a given internalFormat / type
 * @param {number} internalFormat The internalFormat parameter from texImage2D etc..
 * @param {number} type The type parameter for texImage2D etc..
 * @return {number} the number of bytes per element for the given internalFormat, type combo
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$df2d41bf86d3b760(internalFormat, type) {
    const info = $065afaecc735fbee$var$getTextureInternalFormatInfo(internalFormat);
    if (!info) throw "unknown internal format";
    const bytesPerElement = info.bytesPerElementMap[type];
    if (bytesPerElement === undefined) throw "unknown internal format";
    return bytesPerElement;
}
/**
 * Info related to a specific texture internalFormat as returned
 * from {@link module:twgl/textures.getFormatAndTypeForInternalFormat}.
 *
 * @typedef {Object} TextureFormatInfo
 * @property {number} format Format to pass to texImage2D and related functions
 * @property {number} type Type to pass to texImage2D and related functions
 * @memberOf module:twgl/textures
 */ /**
 * Gets the format and type for a given internalFormat
 *
 * @param {number} internalFormat The internal format
 * @return {module:twgl/textures.TextureFormatInfo} the corresponding format and type,
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$7972c3060d7259fe(internalFormat) {
    const info = $065afaecc735fbee$var$getTextureInternalFormatInfo(internalFormat);
    if (!info) throw "unknown internal format";
    return {
        format: info.textureFormat,
        type: info.type[0]
    };
}
/**
 * Returns true if value is power of 2
 * @param {number} value number to check.
 * @return true if value is power of 2
 * @private
 */ function $065afaecc735fbee$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}
/**
 * Gets whether or not we can generate mips for the given
 * internal format.
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {number} width The width parameter from texImage2D etc..
 * @param {number} height The height parameter from texImage2D etc..
 * @param {number} internalFormat The internalFormat parameter from texImage2D etc..
 * @return {boolean} true if we can generate mips
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$2058af87f75a4771(gl, width, height, internalFormat) {
    if (!$065afaecc735fbee$export$e3518b1ac7891039(gl)) return $065afaecc735fbee$var$isPowerOf2(width) && $065afaecc735fbee$var$isPowerOf2(height);
    const info = $065afaecc735fbee$var$getTextureInternalFormatInfo(internalFormat);
    if (!info) throw "unknown internal format";
    return info.colorRenderable && info.textureFilterable;
}
/**
 * Gets whether or not we can generate mips for the given format
 * @param {number} internalFormat The internalFormat parameter from texImage2D etc..
 * @return {boolean} true if we can generate mips
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$586e511f2aeecefd(internalFormat) {
    const info = $065afaecc735fbee$var$getTextureInternalFormatInfo(internalFormat);
    if (!info) throw "unknown internal format";
    return info.textureFilterable;
}
/**
 * Gets the number of components for a given image format.
 * @param {number} format the format.
 * @return {number} the number of components for the format.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$4ef22c3eb774ec7f(format) {
    const info = $065afaecc735fbee$var$formatInfo[format];
    if (!info) throw "unknown format: " + format;
    return info.numColorComponents;
}
/**
 * Gets the texture type for a given array type.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @return {number} the gl texture type
 * @private
 */ function $065afaecc735fbee$var$getTextureTypeForArrayType(gl, src, defaultType) {
    if ($065afaecc735fbee$var$isArrayBuffer(src)) return $065afaecc735fbee$export$bddf845047a0e959(src);
    return defaultType || $065afaecc735fbee$var$UNSIGNED_BYTE$1;
}
function $065afaecc735fbee$var$guessDimensions(gl, target, width, height, numElements) {
    if (numElements % 1 !== 0) throw "can't guess dimensions";
    if (!width && !height) {
        const size = Math.sqrt(numElements / (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1 ? 6 : 1));
        if (size % 1 === 0) {
            width = size;
            height = size;
        } else {
            width = numElements;
            height = 1;
        }
    } else if (!height) {
        height = numElements / width;
        if (height % 1) throw "can't guess dimensions";
    } else if (!width) {
        width = numElements / height;
        if (width % 1) throw "can't guess dimensions";
    }
    return {
        width: width,
        height: height
    };
}
/**
 * Sets the default texture color.
 *
 * The default texture color is used when loading textures from
 * urls. Because the URL will be loaded async we'd like to be
 * able to use the texture immediately. By putting a 1x1 pixel
 * color in the texture we can start using the texture before
 * the URL has loaded.
 *
 * @param {number[]} color Array of 4 values in the range 0 to 1
 * @deprecated see {@link module:twgl.setDefaults}
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$37b57533fe0ca238(color) {
    $065afaecc735fbee$var$defaults$1.textureColor = new Uint8Array([
        color[0] * 255,
        color[1] * 255,
        color[2] * 255,
        color[3] * 255
    ]);
}
function $065afaecc735fbee$export$13a00e79c3b46a21(newDefaults) {
    $065afaecc735fbee$var$copyExistingProperties(newDefaults, $065afaecc735fbee$var$defaults$1);
    if (newDefaults.textureColor) $065afaecc735fbee$export$37b57533fe0ca238(newDefaults.textureColor);
}
/**
 * A function to generate the source for a texture.
 * @callback TextureFunc
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {module:twgl.TextureOptions} options the texture options
 * @return {*} Returns any of the things documented for `src` for {@link module:twgl.TextureOptions}.
 * @memberOf module:twgl
 */ /**
 * Texture options passed to most texture functions. Each function will use whatever options
 * are appropriate for its needs. This lets you pass the same options to all functions.
 *
 * Note: A `TexImageSource` is defined in the WebGL spec as a `HTMLImageElement`, `HTMLVideoElement`,
 * `HTMLCanvasElement`, `ImageBitmap`, or `ImageData`.
 *
 * @typedef {Object} TextureOptions
 * @property {number} [target] the type of texture `gl.TEXTURE_2D` or `gl.TEXTURE_CUBE_MAP`. Defaults to `gl.TEXTURE_2D`.
 * @property {number} [level] the mip level to affect. Defaults to 0. Note, if set auto will be considered false unless explicitly set to true.
 * @property {number} [width] the width of the texture. Only used if src is an array or typed array or null.
 * @property {number} [height] the height of a texture. Only used if src is an array or typed array or null.
 * @property {number} [depth] the depth of a texture. Only used if src is an array or type array or null and target is `TEXTURE_3D` .
 * @property {number} [min] the min filter setting (eg. `gl.LINEAR`). Defaults to `gl.NEAREST_MIPMAP_LINEAR`
 *     or if texture is not a power of 2 on both dimensions then defaults to `gl.LINEAR`.
 * @property {number} [mag] the mag filter setting (eg. `gl.LINEAR`). Defaults to `gl.LINEAR`
 * @property {number} [minMag] both the min and mag filter settings.
 * @property {number} [internalFormat] internal format for texture. Defaults to `gl.RGBA`
 * @property {number} [format] format for texture. Defaults to `gl.RGBA`.
 * @property {number} [type] type for texture. Defaults to `gl.UNSIGNED_BYTE` unless `src` is ArrayBufferView. If `src`
 *     is ArrayBufferView defaults to type that matches ArrayBufferView type.
 * @property {number} [wrap] Texture wrapping for both S and T (and R if TEXTURE_3D or WebGLSampler). Defaults to `gl.REPEAT` for 2D unless src is WebGL1 and src not npot and `gl.CLAMP_TO_EDGE` for cube
 * @property {number} [wrapS] Texture wrapping for S. Defaults to `gl.REPEAT` and `gl.CLAMP_TO_EDGE` for cube. If set takes precedence over `wrap`.
 * @property {number} [wrapT] Texture wrapping for T. Defaults to `gl.REPEAT` and `gl.CLAMP_TO_EDGE` for cube. If set takes precedence over `wrap`.
 * @property {number} [wrapR] Texture wrapping for R. Defaults to `gl.REPEAT` and `gl.CLAMP_TO_EDGE` for cube. If set takes precedence over `wrap`.
 * @property {number} [minLod] TEXTURE_MIN_LOD setting
 * @property {number} [maxLod] TEXTURE_MAX_LOD setting
 * @property {number} [baseLevel] TEXTURE_BASE_LEVEL setting
 * @property {number} [maxLevel] TEXTURE_MAX_LEVEL setting
 * @property {number} [compareFunc] TEXTURE_COMPARE_FUNC setting
 * @property {number} [compareMode] TEXTURE_COMPARE_MODE setting
 * @property {number} [unpackAlignment] The `gl.UNPACK_ALIGNMENT` used when uploading an array. Defaults to 1.
 * @property {number[]|ArrayBufferView} [color] Color to initialize this texture with if loading an image asynchronously.
 *     The default use a blue 1x1 pixel texture. You can set another default by calling `twgl.setDefaults`
 *     or you can set an individual texture's initial color by setting this property. Example: `[1, .5, .5, 1]` = pink
 * @property {number} [premultiplyAlpha] Whether or not to premultiply alpha. Defaults to whatever the current setting is.
 *     This lets you set it once before calling `twgl.createTexture` or `twgl.createTextures` and only override
 *     the current setting for specific textures.
 * @property {number} [flipY] Whether or not to flip the texture vertically on upload. Defaults to whatever the current setting is.
 *     This lets you set it once before calling `twgl.createTexture` or `twgl.createTextures` and only override
 *     the current setting for specific textures.
 * @property {number} [colorspaceConversion] Whether or not to let the browser do colorspace conversion of the texture on upload. Defaults to whatever the current setting is.
 *     This lets you set it once before calling `twgl.createTexture` or `twgl.createTextures` and only override
 *     the current setting for specific textures.
 * @property {boolean} [auto] If `undefined` or `true`, in WebGL1, texture filtering is set automatically for non-power of 2 images and
 *    mips are generated for power of 2 images. In WebGL2 mips are generated if they can be. Note: if `level` is set above
 *    then then `auto` is assumed to be `false` unless explicity set to `true`.
 * @property {number[]} [cubeFaceOrder] The order that cube faces are pulled out of an img or set of images. The default is
 *
 *     [gl.TEXTURE_CUBE_MAP_POSITIVE_X,
 *      gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
 *      gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
 *      gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
 *      gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
 *      gl.TEXTURE_CUBE_MAP_NEGATIVE_Z]
 *
 * @property {(number[]|ArrayBufferView|TexImageSource|TexImageSource[]|string|string[]|module:twgl.TextureFunc)} [src] source for texture
 *
 *    If `string` then it's assumed to be a URL to an image. The image will be downloaded async. A usable
 *    1x1 pixel texture will be returned immediately. The texture will be updated once the image has downloaded.
 *    If `target` is `gl.TEXTURE_CUBE_MAP` will attempt to divide image into 6 square pieces. 1x6, 6x1, 3x2, 2x3.
 *    The pieces will be uploaded in `cubeFaceOrder`
 *
 *    If `string[]` or `TexImageSource[]` and target is `gl.TEXTURE_CUBE_MAP` then it must have 6 entries, one for each face of a cube map.
 *
 *    If `string[]` or `TexImageSource[]` and target is `gl.TEXTURE_2D_ARRAY` then each entry is a slice of the a 2d array texture
 *    and will be scaled to the specified width and height OR to the size of the first image that loads.
 *
 *    If `TexImageSource` then it wil be used immediately to create the contents of the texture. Examples `HTMLImageElement`,
 *    `HTMLCanvasElement`, `HTMLVideoElement`.
 *
 *    If `number[]` or `ArrayBufferView` it's assumed to be data for a texture. If `width` or `height` is
 *    not specified it is guessed as follows. First the number of elements is computed by `src.length / numComponents`
 *    where `numComponents` is derived from `format`. If `target` is `gl.TEXTURE_CUBE_MAP` then `numElements` is divided
 *    by 6. Then
 *
 *    *   If neither `width` nor `height` are specified and `sqrt(numElements)` is an integer then width and height
 *        are set to `sqrt(numElements)`. Otherwise `width = numElements` and `height = 1`.
 *
 *    *   If only one of `width` or `height` is specified then the other equals `numElements / specifiedDimension`.
 *
 * If `number[]` will be converted to `type`.
 *
 * If `src` is a function it will be called with a `WebGLRenderingContext` and these options.
 * Whatever it returns is subject to these rules. So it can return a string url, an `HTMLElement`
 * an array etc...
 *
 * If `src` is undefined then an empty texture will be created of size `width` by `height`.
 *
 * @property {string} [crossOrigin] What to set the crossOrigin property of images when they are downloaded.
 *    default: undefined. Also see {@link module:twgl.setDefaults}.
 *
 * @memberOf module:twgl
 */ /**
 * Sets any packing state that will be set based on the options.
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @private
 */ function $065afaecc735fbee$var$setPackState(gl, options) {
    if (options.colorspaceConversion !== undefined) gl.pixelStorei($065afaecc735fbee$var$UNPACK_COLORSPACE_CONVERSION_WEBGL, options.colorspaceConversion);
    if (options.premultiplyAlpha !== undefined) gl.pixelStorei($065afaecc735fbee$var$UNPACK_PREMULTIPLY_ALPHA_WEBGL, options.premultiplyAlpha);
    if (options.flipY !== undefined) gl.pixelStorei($065afaecc735fbee$var$UNPACK_FLIP_Y_WEBGL, options.flipY);
}
/**
 * Set skip state to defaults
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @private
 */ function $065afaecc735fbee$var$setSkipStateToDefault(gl) {
    gl.pixelStorei($065afaecc735fbee$var$UNPACK_ALIGNMENT, 4);
    if ($065afaecc735fbee$export$e3518b1ac7891039(gl)) {
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_ROW_LENGTH, 0);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_IMAGE_HEIGHT, 0);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_SKIP_PIXELS, 0);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_SKIP_ROWS, 0);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_SKIP_IMAGES, 0);
    }
}
/**
 * Sets the parameters of a texture or sampler
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {number|WebGLSampler} target texture target or sampler
 * @param {function()} parameteriFn texParameteri or samplerParameteri fn
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @private
 */ function $065afaecc735fbee$var$setTextureSamplerParameters(gl, target, parameteriFn, options) {
    if (options.minMag) {
        parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MIN_FILTER, options.minMag);
        parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MAG_FILTER, options.minMag);
    }
    if (options.min) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MIN_FILTER, options.min);
    if (options.mag) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MAG_FILTER, options.mag);
    if (options.wrap) {
        parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_WRAP_S, options.wrap);
        parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_WRAP_T, options.wrap);
        if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || $065afaecc735fbee$var$isSampler(gl, target)) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_WRAP_R, options.wrap);
    }
    if (options.wrapR) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_WRAP_R, options.wrapR);
    if (options.wrapS) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_WRAP_S, options.wrapS);
    if (options.wrapT) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_WRAP_T, options.wrapT);
    if (options.minLod !== undefined) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MIN_LOD, options.minLod);
    if (options.maxLod !== undefined) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MAX_LOD, options.maxLod);
    if (options.baseLevel !== undefined) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_BASE_LEVEL, options.baseLevel);
    if (options.maxLevel !== undefined) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_MAX_LEVEL, options.maxLevel);
    if (options.compareFunc !== undefined) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_COMPARE_FUNC, options.compareFunc);
    if (options.compareMode !== undefined) parameteriFn.call(gl, target, $065afaecc735fbee$var$TEXTURE_COMPARE_MODE, options.compareMode);
}
/**
 * Sets the texture parameters of a texture.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$145d4976a6287cac(gl, tex, options) {
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    gl.bindTexture(target, tex);
    $065afaecc735fbee$var$setTextureSamplerParameters(gl, target, gl.texParameteri, options);
}
/**
 * Sets the sampler parameters of a sampler.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLSampler} sampler the WebGLSampler to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$9473ec3d6ac9f748(gl, sampler, options) {
    $065afaecc735fbee$var$setTextureSamplerParameters(gl, sampler, gl.samplerParameteri, options);
}
/**
 * Creates a new sampler object and sets parameters.
 *
 * Example:
 *
 *      const sampler = twgl.createSampler(gl, {
 *        minMag: gl.NEAREST,         // sets both TEXTURE_MIN_FILTER and TEXTURE_MAG_FILTER
 *        wrap: gl.CLAMP_TO_NEAREST,  // sets both TEXTURE_WRAP_S and TEXTURE_WRAP_T and TEXTURE_WRAP_R
 *      });
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string,module:twgl.TextureOptions>} options A object of TextureOptions one per sampler.
 * @return {Object.<string,WebGLSampler>} the created samplers by name
 * @private
 */ function $065afaecc735fbee$export$9128f6a54e671ebe(gl, options) {
    const sampler = gl.createSampler();
    $065afaecc735fbee$export$9473ec3d6ac9f748(gl, sampler, options);
    return sampler;
}
/**
 * Creates a multiple sampler objects and sets parameters on each.
 *
 * Example:
 *
 *      const samplers = twgl.createSamplers(gl, {
 *        nearest: {
 *          minMag: gl.NEAREST,
 *        },
 *        nearestClampS: {
 *          minMag: gl.NEAREST,
 *          wrapS: gl.CLAMP_TO_NEAREST,
 *        },
 *        linear: {
 *          minMag: gl.LINEAR,
 *        },
 *        nearestClamp: {
 *          minMag: gl.NEAREST,
 *          wrap: gl.CLAMP_TO_EDGE,
 *        },
 *        linearClamp: {
 *          minMag: gl.LINEAR,
 *          wrap: gl.CLAMP_TO_EDGE,
 *        },
 *        linearClampT: {
 *          minMag: gl.LINEAR,
 *          wrapT: gl.CLAMP_TO_EDGE,
 *        },
 *      });
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set on the sampler
 * @private
 */ function $065afaecc735fbee$export$7f108a4cd20bc0(gl, samplerOptions) {
    const samplers = {};
    Object.keys(samplerOptions).forEach(function(name) {
        samplers[name] = $065afaecc735fbee$export$9128f6a54e671ebe(gl, samplerOptions[name]);
    });
    return samplers;
}
/**
 * Makes a 1x1 pixel
 * If no color is passed in uses the default color which can be set by calling `setDefaultTextureColor`.
 * @param {(number[]|ArrayBufferView)} [color] The color using 0-1 values
 * @return {Uint8Array} Unit8Array with color.
 * @private
 */ function $065afaecc735fbee$var$make1Pixel(color) {
    color = color || $065afaecc735fbee$var$defaults$1.textureColor;
    if ($065afaecc735fbee$var$isArrayBuffer(color)) return color;
    return new Uint8Array([
        color[0] * 255,
        color[1] * 255,
        color[2] * 255,
        color[3] * 255
    ]);
}
/**
 * Sets filtering or generates mips for texture based on width or height
 * If width or height is not passed in uses `options.width` and//or `options.height`
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @param {number} [width] width of texture
 * @param {number} [height] height of texture
 * @param {number} [internalFormat] The internalFormat parameter from texImage2D etc..
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$494a924bf2d77d9a(gl, tex, options, width, height, internalFormat) {
    options = options || $065afaecc735fbee$var$defaults$1.textureOptions;
    internalFormat = internalFormat || $065afaecc735fbee$var$RGBA$1;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    width = width || options.width;
    height = height || options.height;
    gl.bindTexture(target, tex);
    if ($065afaecc735fbee$export$2058af87f75a4771(gl, width, height, internalFormat)) gl.generateMipmap(target);
    else {
        const filtering = $065afaecc735fbee$export$586e511f2aeecefd(internalFormat) ? $065afaecc735fbee$var$LINEAR$1 : $065afaecc735fbee$var$NEAREST;
        gl.texParameteri(target, $065afaecc735fbee$var$TEXTURE_MIN_FILTER, filtering);
        gl.texParameteri(target, $065afaecc735fbee$var$TEXTURE_MAG_FILTER, filtering);
        gl.texParameteri(target, $065afaecc735fbee$var$TEXTURE_WRAP_S, $065afaecc735fbee$var$CLAMP_TO_EDGE$1);
        gl.texParameteri(target, $065afaecc735fbee$var$TEXTURE_WRAP_T, $065afaecc735fbee$var$CLAMP_TO_EDGE$1);
    }
}
function $065afaecc735fbee$var$shouldAutomaticallySetTextureFilteringForSize(options) {
    return options.auto === true || options.auto === undefined && options.level === undefined;
}
/**
 * Gets an array of cubemap face enums
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @return {number[]} cubemap face enums
 * @private
 */ function $065afaecc735fbee$var$getCubeFaceOrder(gl, options) {
    options = options || {};
    return options.cubeFaceOrder || [
        $065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_X,
        $065afaecc735fbee$var$TEXTURE_CUBE_MAP_NEGATIVE_X,
        $065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_Y,
        $065afaecc735fbee$var$TEXTURE_CUBE_MAP_NEGATIVE_Y,
        $065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_Z,
        $065afaecc735fbee$var$TEXTURE_CUBE_MAP_NEGATIVE_Z
    ];
}
/**
 * @typedef {Object} FaceInfo
 * @property {number} face gl enum for texImage2D
 * @property {number} ndx face index (0 - 5) into source data
 * @ignore
 */ /**
 * Gets an array of FaceInfos
 * There's a bug in some NVidia drivers that will crash the driver if
 * `gl.TEXTURE_CUBE_MAP_POSITIVE_X` is not uploaded first. So, we take
 * the user's desired order from his faces to WebGL and make sure we
 * do the faces in WebGL order
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @return {FaceInfo[]} cubemap face infos. Arguably the `face` property of each element is redundant but
 *    it's needed internally to sort the array of `ndx` properties by `face`.
 * @private
 */ function $065afaecc735fbee$var$getCubeFacesWithNdx(gl, options) {
    const faces = $065afaecc735fbee$var$getCubeFaceOrder(gl, options);
    // work around bug in NVidia drivers. We have to upload the first face first else the driver crashes :(
    const facesWithNdx = faces.map(function(face, ndx) {
        return {
            face: face,
            ndx: ndx
        };
    });
    facesWithNdx.sort(function(a, b) {
        return a.face - b.face;
    });
    return facesWithNdx;
}
/**
 * Set a texture from the contents of an element. Will also set
 * texture filtering or generate mips based on the dimensions of the element
 * unless `options.auto === false`. If `target === gl.TEXTURE_CUBE_MAP` will
 * attempt to slice image into 1x6, 2x3, 3x2, or 6x1 images, one for each face.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {HTMLElement} element a canvas, img, or video element.
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 * @kind function
 */ function $065afaecc735fbee$export$8119aa4cbf12798b(gl, tex, element, options) {
    options = options || $065afaecc735fbee$var$defaults$1.textureOptions;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    const level = options.level || 0;
    let width = element.width;
    let height = element.height;
    const internalFormat = options.internalFormat || options.format || $065afaecc735fbee$var$RGBA$1;
    const formatType = $065afaecc735fbee$export$7972c3060d7259fe(internalFormat);
    const format = options.format || formatType.format;
    const type = options.type || formatType.type;
    $065afaecc735fbee$var$setPackState(gl, options);
    gl.bindTexture(target, tex);
    if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) {
        // guess the parts
        const imgWidth = element.width;
        const imgHeight = element.height;
        let size;
        let slices;
        if (imgWidth / 6 === imgHeight) {
            // It's 6x1
            size = imgHeight;
            slices = [
                0,
                0,
                1,
                0,
                2,
                0,
                3,
                0,
                4,
                0,
                5,
                0
            ];
        } else if (imgHeight / 6 === imgWidth) {
            // It's 1x6
            size = imgWidth;
            slices = [
                0,
                0,
                0,
                1,
                0,
                2,
                0,
                3,
                0,
                4,
                0,
                5
            ];
        } else if (imgWidth / 3 === imgHeight / 2) {
            // It's 3x2
            size = imgWidth / 3;
            slices = [
                0,
                0,
                1,
                0,
                2,
                0,
                0,
                1,
                1,
                1,
                2,
                1
            ];
        } else if (imgWidth / 2 === imgHeight / 3) {
            // It's 2x3
            size = imgWidth / 2;
            slices = [
                0,
                0,
                1,
                0,
                0,
                1,
                1,
                1,
                0,
                2,
                1,
                2
            ];
        } else throw "can't figure out cube map from element: " + (element.src ? element.src : element.nodeName);
        const ctx = $065afaecc735fbee$var$getShared2DContext();
        if (ctx) {
            ctx.canvas.width = size;
            ctx.canvas.height = size;
            width = size;
            height = size;
            $065afaecc735fbee$var$getCubeFacesWithNdx(gl, options).forEach(function(f) {
                const xOffset = slices[f.ndx * 2 + 0] * size;
                const yOffset = slices[f.ndx * 2 + 1] * size;
                ctx.drawImage(element, xOffset, yOffset, size, size, 0, 0, size, size);
                gl.texImage2D(f.face, level, internalFormat, format, type, ctx.canvas);
            });
            // Free up the canvas memory
            ctx.canvas.width = 1;
            ctx.canvas.height = 1;
        } else if (typeof createImageBitmap !== 'undefined') {
            // NOTE: It seems like we should prefer ImageBitmap because unlike canvas it's
            // note lossy? (alpha is not premultiplied? although I'm not sure what
            width = size;
            height = size;
            $065afaecc735fbee$var$getCubeFacesWithNdx(gl, options).forEach(function(f) {
                const xOffset = slices[f.ndx * 2 + 0] * size;
                const yOffset = slices[f.ndx * 2 + 1] * size;
                // We can't easily use a default texture color here as it would have to match
                // the type across all faces where as with a 2D one there's only one face
                // so we're replacing everything all at once. It also has to be the correct size.
                // On the other hand we need all faces to be the same size so as one face loads
                // the rest match else the texture will be un-renderable.
                gl.texImage2D(f.face, level, internalFormat, size, size, 0, format, type, null);
                createImageBitmap(element, xOffset, yOffset, size, size, {
                    premultiplyAlpha: 'none',
                    colorSpaceConversion: 'none'
                }).then(function(imageBitmap) {
                    $065afaecc735fbee$var$setPackState(gl, options);
                    gl.bindTexture(target, tex);
                    gl.texImage2D(f.face, level, internalFormat, format, type, imageBitmap);
                    if ($065afaecc735fbee$var$shouldAutomaticallySetTextureFilteringForSize(options)) $065afaecc735fbee$export$494a924bf2d77d9a(gl, tex, options, width, height, internalFormat);
                });
            });
        }
    } else if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || target === $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) {
        const smallest = Math.min(element.width, element.height);
        const largest = Math.max(element.width, element.height);
        const depth = largest / smallest;
        if (depth % 1 !== 0) throw "can not compute 3D dimensions of element";
        const xMult = element.width === largest ? 1 : 0;
        const yMult = element.height === largest ? 1 : 0;
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_ALIGNMENT, 1);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_ROW_LENGTH, element.width);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_IMAGE_HEIGHT, 0);
        gl.pixelStorei($065afaecc735fbee$var$UNPACK_SKIP_IMAGES, 0);
        gl.texImage3D(target, level, internalFormat, smallest, smallest, smallest, 0, format, type, null);
        for(let d = 0; d < depth; ++d){
            const srcX = d * smallest * xMult;
            const srcY = d * smallest * yMult;
            gl.pixelStorei($065afaecc735fbee$var$UNPACK_SKIP_PIXELS, srcX);
            gl.pixelStorei($065afaecc735fbee$var$UNPACK_SKIP_ROWS, srcY);
            gl.texSubImage3D(target, level, 0, 0, d, smallest, smallest, 1, format, type, element);
        }
        $065afaecc735fbee$var$setSkipStateToDefault(gl);
    } else gl.texImage2D(target, level, internalFormat, format, type, element);
    if ($065afaecc735fbee$var$shouldAutomaticallySetTextureFilteringForSize(options)) $065afaecc735fbee$export$494a924bf2d77d9a(gl, tex, options, width, height, internalFormat);
    $065afaecc735fbee$export$145d4976a6287cac(gl, tex, options);
}
function $065afaecc735fbee$var$noop() {}
/**
 * Checks whether the url's origin is the same so that we can set the `crossOrigin`
 * @param {string} url url to image
 * @returns {boolean} true if the window's origin is the same as image's url
 * @private
 */ function $065afaecc735fbee$var$urlIsSameOrigin(url) {
    if (typeof document !== 'undefined') {
        // for IE really
        const a = document.createElement('a');
        a.href = url;
        return a.hostname === location.hostname && a.port === location.port && a.protocol === location.protocol;
    } else {
        const localOrigin = new URL(location.href).origin;
        const urlOrigin = new URL(url, location.href).origin;
        return urlOrigin === localOrigin;
    }
}
function $065afaecc735fbee$var$setToAnonymousIfUndefinedAndURLIsNotSameOrigin(url, crossOrigin) {
    return crossOrigin === undefined && !$065afaecc735fbee$var$urlIsSameOrigin(url) ? 'anonymous' : crossOrigin;
}
/**
 * Loads an image
 * @param {string} url url to image
 * @param {string} crossOrigin
 * @param {function(err, img)} [callback] a callback that's passed an error and the image. The error will be non-null
 *     if there was an error
 * @return {HTMLImageElement} the image being loaded.
 * @private
 */ function $065afaecc735fbee$var$loadImage(url, crossOrigin, callback) {
    callback = callback || $065afaecc735fbee$var$noop;
    let img;
    crossOrigin = crossOrigin !== undefined ? crossOrigin : $065afaecc735fbee$var$defaults$1.crossOrigin;
    crossOrigin = $065afaecc735fbee$var$setToAnonymousIfUndefinedAndURLIsNotSameOrigin(url, crossOrigin);
    if (typeof Image !== 'undefined') {
        img = new Image();
        if (crossOrigin !== undefined) img.crossOrigin = crossOrigin;
        const clearEventHandlers = function clearEventHandlers() {
            img.removeEventListener('error', onError); // eslint-disable-line
            img.removeEventListener('load', onLoad); // eslint-disable-line
            img = null;
        };
        const onError = function onError() {
            const msg = "couldn't load image: " + url;
            $065afaecc735fbee$var$error$1(msg);
            callback(msg, img);
            clearEventHandlers();
        };
        const onLoad = function onLoad() {
            callback(null, img);
            clearEventHandlers();
        };
        img.addEventListener('error', onError);
        img.addEventListener('load', onLoad);
        img.src = url;
        return img;
    } else if (typeof ImageBitmap !== 'undefined') {
        let err;
        let bm;
        const cb = function cb() {
            callback(err, bm);
        };
        const options = {};
        if (crossOrigin) options.mode = 'cors'; // TODO: not sure how to translate image.crossOrigin
        fetch(url, options).then(function(response) {
            if (!response.ok) throw response;
            return response.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, {
                premultiplyAlpha: 'none',
                colorSpaceConversion: 'none'
            });
        }).then(function(bitmap) {
            // not sure if this works. We don't want
            // to catch the user's error. So, call
            // the callback in a timeout so we're
            // not in this scope inside the promise.
            bm = bitmap;
            setTimeout(cb);
        }).catch(function(e) {
            err = e;
            setTimeout(cb);
        });
        img = null;
    }
    return img;
}
/**
 * check if object is a TexImageSource
 *
 * @param {Object} obj Object to test
 * @return {boolean} true if object is a TexImageSource
 * @private
 */ function $065afaecc735fbee$var$isTexImageSource(obj) {
    return typeof ImageBitmap !== 'undefined' && obj instanceof ImageBitmap || typeof ImageData !== 'undefined' && obj instanceof ImageData || typeof HTMLElement !== 'undefined' && obj instanceof HTMLElement;
}
/**
 * if obj is an TexImageSource then just
 * uses it otherwise if obj is a string
 * then load it first.
 *
 * @param {string|TexImageSource} obj
 * @param {string} crossOrigin
 * @param {function(err, img)} [callback] a callback that's passed an error and the image. The error will be non-null
 *     if there was an error
 * @private
 */ function $065afaecc735fbee$var$loadAndUseImage(obj, crossOrigin, callback) {
    if ($065afaecc735fbee$var$isTexImageSource(obj)) {
        setTimeout(function() {
            callback(null, obj);
        });
        return obj;
    }
    return $065afaecc735fbee$var$loadImage(obj, crossOrigin, callback);
}
/**
 * Sets a texture to a 1x1 pixel color. If `options.color === false` is nothing happens. If it's not set
 * the default texture color is used which can be set by calling `setDefaultTextureColor`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 * @private
 */ function $065afaecc735fbee$var$setTextureTo1PixelColor(gl, tex, options) {
    options = options || $065afaecc735fbee$var$defaults$1.textureOptions;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    gl.bindTexture(target, tex);
    if (options.color === false) return;
    // Assume it's a URL
    // Put 1x1 pixels in texture. That makes it renderable immediately regardless of filtering.
    const color = $065afaecc735fbee$var$make1Pixel(options.color);
    if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) for(let ii = 0; ii < 6; ++ii)gl.texImage2D($065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_X + ii, 0, $065afaecc735fbee$var$RGBA$1, 1, 1, 0, $065afaecc735fbee$var$RGBA$1, $065afaecc735fbee$var$UNSIGNED_BYTE$1, color);
    else if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || target === $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) gl.texImage3D(target, 0, $065afaecc735fbee$var$RGBA$1, 1, 1, 1, 0, $065afaecc735fbee$var$RGBA$1, $065afaecc735fbee$var$UNSIGNED_BYTE$1, color);
    else gl.texImage2D(target, 0, $065afaecc735fbee$var$RGBA$1, 1, 1, 0, $065afaecc735fbee$var$RGBA$1, $065afaecc735fbee$var$UNSIGNED_BYTE$1, color);
}
/**
 * The src image(s) used to create a texture.
 *
 * When you call {@link module:twgl.createTexture} or {@link module:twgl.createTextures}
 * you can pass in urls for images to load into the textures. If it's a single url
 * then this will be a single HTMLImageElement. If it's an array of urls used for a cubemap
 * this will be a corresponding array of images for the cubemap.
 *
 * @typedef {HTMLImageElement|HTMLImageElement[]} TextureSrc
 * @memberOf module:twgl
 */ /**
 * A callback for when an image finished downloading and been uploaded into a texture
 * @callback TextureReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {WebGLTexture} texture the texture.
 * @param {module:twgl.TextureSrc} source image(s) used to as the src for the texture
 * @memberOf module:twgl
 */ /**
 * A callback for when all images have finished downloading and been uploaded into their respective textures
 * @callback TexturesReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {Object.<string, WebGLTexture>} textures the created textures by name. Same as returned by {@link module:twgl.createTextures}.
 * @param {Object.<string, module:twgl.TextureSrc>} sources the image(s) used for the texture by name.
 * @memberOf module:twgl
 */ /**
 * A callback for when an image finished downloading and been uploaded into a texture
 * @callback CubemapReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {WebGLTexture} tex the texture.
 * @param {HTMLImageElement[]} imgs the images for each face.
 * @memberOf module:twgl
 */ /**
 * A callback for when an image finished downloading and been uploaded into a texture
 * @callback ThreeDReadyCallback
 * @param {*} err If truthy there was an error.
 * @param {WebGLTexture} tex the texture.
 * @param {HTMLImageElement[]} imgs the images for each slice.
 * @memberOf module:twgl
 */ /**
 * Loads a texture from an image from a Url as specified in `options.src`
 * If `options.color !== false` will set the texture to a 1x1 pixel color so that the texture is
 * immediately useable. It will be updated with the contents of the image once the image has finished
 * downloading. Filtering options will be set as appropriate for image unless `options.auto === false`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.TextureReadyCallback} [callback] A function to be called when the image has finished loading. err will
 *    be non null if there was an error.
 * @return {HTMLImageElement} the image being downloaded.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$a0ce1a7e01ad3b32(gl, tex, options, callback) {
    callback = callback || $065afaecc735fbee$var$noop;
    options = options || $065afaecc735fbee$var$defaults$1.textureOptions;
    $065afaecc735fbee$var$setTextureTo1PixelColor(gl, tex, options);
    // Because it's async we need to copy the options.
    options = Object.assign({}, options);
    const img = $065afaecc735fbee$var$loadAndUseImage(options.src, options.crossOrigin, function(err, img) {
        if (err) callback(err, tex, img);
        else {
            $065afaecc735fbee$export$8119aa4cbf12798b(gl, tex, img, options);
            callback(null, tex, img);
        }
    });
    return img;
}
/**
 * Loads a cubemap from 6 urls or TexImageSources as specified in `options.src`. Will set the cubemap to a 1x1 pixel color
 * so that it is usable immediately unless `option.color === false`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.CubemapReadyCallback} [callback] A function to be called when all the images have finished loading. err will
 *    be non null if there was an error.
 * @memberOf module:twgl/textures
 * @private
 */ function $065afaecc735fbee$var$loadCubemapFromUrls(gl, tex, options, callback) {
    callback = callback || $065afaecc735fbee$var$noop;
    const urls = options.src;
    if (urls.length !== 6) throw "there must be 6 urls for a cubemap";
    const level = options.level || 0;
    const internalFormat = options.internalFormat || options.format || $065afaecc735fbee$var$RGBA$1;
    const formatType = $065afaecc735fbee$export$7972c3060d7259fe(internalFormat);
    const format = options.format || formatType.format;
    const type = options.type || $065afaecc735fbee$var$UNSIGNED_BYTE$1;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    if (target !== $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) throw "target must be TEXTURE_CUBE_MAP";
    $065afaecc735fbee$var$setTextureTo1PixelColor(gl, tex, options);
    // Because it's async we need to copy the options.
    options = Object.assign({}, options);
    let numToLoad = 6;
    const errors = [];
    const faces = $065afaecc735fbee$var$getCubeFaceOrder(gl, options);
    let imgs; // eslint-disable-line
    function uploadImg(faceTarget) {
        return function(err, img) {
            --numToLoad;
            if (err) errors.push(err);
            else if (img.width !== img.height) errors.push("cubemap face img is not a square: " + img.src);
            else {
                $065afaecc735fbee$var$setPackState(gl, options);
                gl.bindTexture(target, tex);
                // So assuming this is the first image we now have one face that's img sized
                // and 5 faces that are 1x1 pixel so size the other faces
                if (numToLoad === 5) // use the default order
                $065afaecc735fbee$var$getCubeFaceOrder().forEach(function(otherTarget) {
                    // Should we re-use the same face or a color?
                    gl.texImage2D(otherTarget, level, internalFormat, format, type, img);
                });
                else gl.texImage2D(faceTarget, level, internalFormat, format, type, img);
                if ($065afaecc735fbee$var$shouldAutomaticallySetTextureFilteringForSize(options)) gl.generateMipmap(target);
            }
            if (numToLoad === 0) callback(errors.length ? errors : undefined, tex, imgs);
        };
    }
    imgs = urls.map(function(url, ndx) {
        return $065afaecc735fbee$var$loadAndUseImage(url, options.crossOrigin, uploadImg(faces[ndx]));
    });
}
/**
 * Loads a 2d array or 3d texture from urls OR TexImageSources as specified in `options.src`.
 * Will set the texture to a 1x1 pixel color
 * so that it is usable immediately unless `option.color === false`.
 *
 * If the width and height is not specified the width and height of the first
 * image loaded will be used. Note that since images are loaded async
 * which image downloads first is unknown.
 *
 * If an image is not the same size as the width and height it will be scaled
 * to that width and height.
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.ThreeDReadyCallback} [callback] A function to be called when all the images have finished loading. err will
 *    be non null if there was an error.
 * @memberOf module:twgl/textures
 * @private
 */ function $065afaecc735fbee$var$loadSlicesFromUrls(gl, tex, options, callback) {
    callback = callback || $065afaecc735fbee$var$noop;
    const urls = options.src;
    const internalFormat = options.internalFormat || options.format || $065afaecc735fbee$var$RGBA$1;
    const formatType = $065afaecc735fbee$export$7972c3060d7259fe(internalFormat);
    const format = options.format || formatType.format;
    const type = options.type || $065afaecc735fbee$var$UNSIGNED_BYTE$1;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1;
    if (target !== $065afaecc735fbee$var$TEXTURE_3D$1 && target !== $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) throw "target must be TEXTURE_3D or TEXTURE_2D_ARRAY";
    $065afaecc735fbee$var$setTextureTo1PixelColor(gl, tex, options);
    // Because it's async we need to copy the options.
    options = Object.assign({}, options);
    let numToLoad = urls.length;
    const errors = [];
    let imgs; // eslint-disable-line
    const level = options.level || 0;
    let width = options.width;
    let height = options.height;
    const depth = urls.length;
    let firstImage = true;
    function uploadImg(slice) {
        return function(err, img) {
            --numToLoad;
            if (err) errors.push(err);
            else {
                $065afaecc735fbee$var$setPackState(gl, options);
                gl.bindTexture(target, tex);
                if (firstImage) {
                    firstImage = false;
                    width = options.width || img.width;
                    height = options.height || img.height;
                    gl.texImage3D(target, level, internalFormat, width, height, depth, 0, format, type, null);
                    // put it in every slice otherwise some slices will be 0,0,0,0
                    for(let s = 0; s < depth; ++s)gl.texSubImage3D(target, level, 0, 0, s, width, height, 1, format, type, img);
                } else {
                    let src = img;
                    let ctx;
                    if (img.width !== width || img.height !== height) {
                        // Size the image to fix
                        ctx = $065afaecc735fbee$var$getShared2DContext();
                        src = ctx.canvas;
                        ctx.canvas.width = width;
                        ctx.canvas.height = height;
                        ctx.drawImage(img, 0, 0, width, height);
                    }
                    gl.texSubImage3D(target, level, 0, 0, slice, width, height, 1, format, type, src);
                    // free the canvas memory
                    if (ctx && src === ctx.canvas) {
                        ctx.canvas.width = 0;
                        ctx.canvas.height = 0;
                    }
                }
                if ($065afaecc735fbee$var$shouldAutomaticallySetTextureFilteringForSize(options)) gl.generateMipmap(target);
            }
            if (numToLoad === 0) callback(errors.length ? errors : undefined, tex, imgs);
        };
    }
    imgs = urls.map(function(url, ndx) {
        return $065afaecc735fbee$var$loadAndUseImage(url, options.crossOrigin, uploadImg(ndx));
    });
}
/**
 * Sets a texture from an array or typed array. If the width or height is not provided will attempt to
 * guess the size. See {@link module:twgl.TextureOptions}.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {(number[]|ArrayBufferView)} src An array or typed arry with texture data.
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 *   This is often the same options you passed in when you created the texture.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$3d91b74019c3ded9(gl, tex, src, options) {
    options = options || $065afaecc735fbee$var$defaults$1.textureOptions;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    gl.bindTexture(target, tex);
    let width = options.width;
    let height = options.height;
    let depth = options.depth;
    const level = options.level || 0;
    const internalFormat = options.internalFormat || options.format || $065afaecc735fbee$var$RGBA$1;
    const formatType = $065afaecc735fbee$export$7972c3060d7259fe(internalFormat);
    const format = options.format || formatType.format;
    const type = options.type || $065afaecc735fbee$var$getTextureTypeForArrayType(gl, src, formatType.type);
    if (!$065afaecc735fbee$var$isArrayBuffer(src)) {
        const Type = $065afaecc735fbee$export$3dc63662699923fc(type);
        src = new Type(src);
    } else if (src instanceof Uint8ClampedArray) src = new Uint8Array(src.buffer);
    const bytesPerElement = $065afaecc735fbee$export$df2d41bf86d3b760(internalFormat, type);
    const numElements = src.byteLength / bytesPerElement; // TODO: check UNPACK_ALIGNMENT?
    if (numElements % 1) throw "length wrong size for format: " + $065afaecc735fbee$export$e97753eae63e4e62(gl, format);
    let dimensions;
    if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || target === $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) {
        if (!width && !height && !depth) {
            const size = Math.cbrt(numElements);
            if (size % 1 !== 0) throw "can't guess cube size of array of numElements: " + numElements;
            width = size;
            height = size;
            depth = size;
        } else if (width && (!height || !depth)) {
            dimensions = $065afaecc735fbee$var$guessDimensions(gl, target, height, depth, numElements / width);
            height = dimensions.width;
            depth = dimensions.height;
        } else if (height && (!width || !depth)) {
            dimensions = $065afaecc735fbee$var$guessDimensions(gl, target, width, depth, numElements / height);
            width = dimensions.width;
            depth = dimensions.height;
        } else {
            dimensions = $065afaecc735fbee$var$guessDimensions(gl, target, width, height, numElements / depth);
            width = dimensions.width;
            height = dimensions.height;
        }
    } else {
        dimensions = $065afaecc735fbee$var$guessDimensions(gl, target, width, height, numElements);
        width = dimensions.width;
        height = dimensions.height;
    }
    $065afaecc735fbee$var$setSkipStateToDefault(gl);
    gl.pixelStorei($065afaecc735fbee$var$UNPACK_ALIGNMENT, options.unpackAlignment || 1);
    $065afaecc735fbee$var$setPackState(gl, options);
    if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) {
        const elementsPerElement = bytesPerElement / src.BYTES_PER_ELEMENT;
        const faceSize = numElements / 6 * elementsPerElement;
        $065afaecc735fbee$var$getCubeFacesWithNdx(gl, options).forEach((f)=>{
            const offset = faceSize * f.ndx;
            const data = src.subarray(offset, offset + faceSize);
            gl.texImage2D(f.face, level, internalFormat, width, height, 0, format, type, data);
        });
    } else if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || target === $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) gl.texImage3D(target, level, internalFormat, width, height, depth, 0, format, type, src);
    else gl.texImage2D(target, level, internalFormat, width, height, 0, format, type, src);
    return {
        width: width,
        height: height,
        depth: depth,
        type: type
    };
}
/**
 * Sets a texture with no contents of a certain size. In other words calls `gl.texImage2D` with `null`.
 * You must set `options.width` and `options.height`.
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the WebGLTexture to set parameters for
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$541fcc5ad0f34e5a(gl, tex, options) {
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    gl.bindTexture(target, tex);
    const level = options.level || 0;
    const internalFormat = options.internalFormat || options.format || $065afaecc735fbee$var$RGBA$1;
    const formatType = $065afaecc735fbee$export$7972c3060d7259fe(internalFormat);
    const format = options.format || formatType.format;
    const type = options.type || formatType.type;
    $065afaecc735fbee$var$setPackState(gl, options);
    if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) for(let ii = 0; ii < 6; ++ii)gl.texImage2D($065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_X + ii, level, internalFormat, options.width, options.height, 0, format, type, null);
    else if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || target === $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) gl.texImage3D(target, level, internalFormat, options.width, options.height, options.depth, 0, format, type, null);
    else gl.texImage2D(target, level, internalFormat, options.width, options.height, 0, format, type, null);
}
/**
 * Creates a texture based on the options passed in.
 *
 * Note: may reset UNPACK_ALIGNMENT, UNPACK_ROW_LENGTH, UNPACK_IMAGE_HEIGHT, UNPACK_SKIP_IMAGES
 * UNPACK_SKIP_PIXELS, and UNPACK_SKIP_ROWS
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.TextureOptions} [options] A TextureOptions object with whatever parameters you want set.
 * @param {module:twgl.TextureReadyCallback} [callback] A callback called when an image has been downloaded and uploaded to the texture.
 * @return {WebGLTexture} the created texture.
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$37b981a8c575f415(gl, options, callback) {
    callback = callback || $065afaecc735fbee$var$noop;
    options = options || $065afaecc735fbee$var$defaults$1.textureOptions;
    const tex = gl.createTexture();
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    let width = options.width || 1;
    let height = options.height || 1;
    const internalFormat = options.internalFormat || $065afaecc735fbee$var$RGBA$1;
    gl.bindTexture(target, tex);
    if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) {
        // this should have been the default for cubemaps :(
        gl.texParameteri(target, $065afaecc735fbee$var$TEXTURE_WRAP_S, $065afaecc735fbee$var$CLAMP_TO_EDGE$1);
        gl.texParameteri(target, $065afaecc735fbee$var$TEXTURE_WRAP_T, $065afaecc735fbee$var$CLAMP_TO_EDGE$1);
    }
    let src = options.src;
    if (src) {
        if (typeof src === "function") src = src(gl, options);
        if (typeof src === "string") $065afaecc735fbee$export$a0ce1a7e01ad3b32(gl, tex, options, callback);
        else if ($065afaecc735fbee$var$isArrayBuffer(src) || Array.isArray(src) && (typeof src[0] === 'number' || Array.isArray(src[0]) || $065afaecc735fbee$var$isArrayBuffer(src[0]))) {
            const dimensions = $065afaecc735fbee$export$3d91b74019c3ded9(gl, tex, src, options);
            width = dimensions.width;
            height = dimensions.height;
        } else if (Array.isArray(src) && (typeof src[0] === 'string' || $065afaecc735fbee$var$isTexImageSource(src[0]))) {
            if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) $065afaecc735fbee$var$loadCubemapFromUrls(gl, tex, options, callback);
            else $065afaecc735fbee$var$loadSlicesFromUrls(gl, tex, options, callback);
        } else {
            $065afaecc735fbee$export$8119aa4cbf12798b(gl, tex, src, options);
            width = src.width;
            height = src.height;
        }
    } else $065afaecc735fbee$export$541fcc5ad0f34e5a(gl, tex, options);
    if ($065afaecc735fbee$var$shouldAutomaticallySetTextureFilteringForSize(options)) $065afaecc735fbee$export$494a924bf2d77d9a(gl, tex, options, width, height, internalFormat);
    $065afaecc735fbee$export$145d4976a6287cac(gl, tex, options);
    return tex;
}
/**
 * Resizes a texture based on the options passed in.
 *
 * Note: This is not a generic resize anything function.
 * It's mostly used by {@link module:twgl.resizeFramebufferInfo}
 * It will use `options.src` if it exists to try to determine a `type`
 * otherwise it will assume `gl.UNSIGNED_BYTE`. No data is provided
 * for the texture. Texture parameters will be set accordingly
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {WebGLTexture} tex the texture to resize
 * @param {module:twgl.TextureOptions} options A TextureOptions object with whatever parameters you want set.
 * @param {number} [width] the new width. If not passed in will use `options.width`
 * @param {number} [height] the new height. If not passed in will use `options.height`
 * @param {number} [depth] the new depth. If not passed in will use `options.depth`
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$1d581f00cfe12937(gl, tex, options, width, height, depth) {
    width = width || options.width;
    height = height || options.height;
    depth = depth || options.depth;
    const target = options.target || $065afaecc735fbee$var$TEXTURE_2D$2;
    gl.bindTexture(target, tex);
    const level = options.level || 0;
    const internalFormat = options.internalFormat || options.format || $065afaecc735fbee$var$RGBA$1;
    const formatType = $065afaecc735fbee$export$7972c3060d7259fe(internalFormat);
    const format = options.format || formatType.format;
    let type;
    const src = options.src;
    if (!src) type = options.type || formatType.type;
    else if ($065afaecc735fbee$var$isArrayBuffer(src) || Array.isArray(src) && typeof src[0] === 'number') type = options.type || $065afaecc735fbee$var$getTextureTypeForArrayType(gl, src, formatType.type);
    else type = options.type || formatType.type;
    if (target === $065afaecc735fbee$var$TEXTURE_CUBE_MAP$1) for(let ii = 0; ii < 6; ++ii)gl.texImage2D($065afaecc735fbee$var$TEXTURE_CUBE_MAP_POSITIVE_X + ii, level, internalFormat, width, height, 0, format, type, null);
    else if (target === $065afaecc735fbee$var$TEXTURE_3D$1 || target === $065afaecc735fbee$var$TEXTURE_2D_ARRAY$1) gl.texImage3D(target, level, internalFormat, width, height, depth, 0, format, type, null);
    else gl.texImage2D(target, level, internalFormat, width, height, 0, format, type, null);
}
/**
 * Check if a src is an async request.
 * if src is a string we're going to download an image
 * if src is an array of strings we're going to download cubemap images
 * @param {*} src The src from a TextureOptions
 * @returns {bool} true if src is async.
 * @private
 */ function $065afaecc735fbee$var$isAsyncSrc(src) {
    return typeof src === 'string' || Array.isArray(src) && typeof src[0] === 'string';
}
/**
 * Creates a bunch of textures based on the passed in options.
 *
 * Example:
 *
 *     const textures = twgl.createTextures(gl, {
 *       // a power of 2 image
 *       hftIcon: { src: "images/hft-icon-16.png", mag: gl.NEAREST },
 *       // a non-power of 2 image
 *       clover: { src: "images/clover.jpg" },
 *       // From a canvas
 *       fromCanvas: { src: ctx.canvas },
 *       // A cubemap from 6 images
 *       yokohama: {
 *         target: gl.TEXTURE_CUBE_MAP,
 *         src: [
 *           'images/yokohama/posx.jpg',
 *           'images/yokohama/negx.jpg',
 *           'images/yokohama/posy.jpg',
 *           'images/yokohama/negy.jpg',
 *           'images/yokohama/posz.jpg',
 *           'images/yokohama/negz.jpg',
 *         ],
 *       },
 *       // A cubemap from 1 image (can be 1x6, 2x3, 3x2, 6x1)
 *       goldengate: {
 *         target: gl.TEXTURE_CUBE_MAP,
 *         src: 'images/goldengate.jpg',
 *       },
 *       // A 2x2 pixel texture from a JavaScript array
 *       checker: {
 *         mag: gl.NEAREST,
 *         min: gl.LINEAR,
 *         src: [
 *           255,255,255,255,
 *           192,192,192,255,
 *           192,192,192,255,
 *           255,255,255,255,
 *         ],
 *       },
 *       // a 1x2 pixel texture from a typed array.
 *       stripe: {
 *         mag: gl.NEAREST,
 *         min: gl.LINEAR,
 *         format: gl.LUMINANCE,
 *         src: new Uint8Array([
 *           255,
 *           128,
 *           255,
 *           128,
 *           255,
 *           128,
 *           255,
 *           128,
 *         ]),
 *         width: 1,
 *       },
 *     });
 *
 * Now
 *
 * *   `textures.hftIcon` will be a 2d texture
 * *   `textures.clover` will be a 2d texture
 * *   `textures.fromCanvas` will be a 2d texture
 * *   `textures.yohohama` will be a cubemap texture
 * *   `textures.goldengate` will be a cubemap texture
 * *   `textures.checker` will be a 2d texture
 * *   `textures.stripe` will be a 2d texture
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string,module:twgl.TextureOptions>} options A object of TextureOptions one per texture.
 * @param {module:twgl.TexturesReadyCallback} [callback] A callback called when all textures have been downloaded.
 * @return {Object.<string,WebGLTexture>} the created textures by name
 * @memberOf module:twgl/textures
 */ function $065afaecc735fbee$export$a1d6112a62597a1b(gl, textureOptions, callback) {
    callback = callback || $065afaecc735fbee$var$noop;
    let numDownloading = 0;
    const errors = [];
    const textures = {};
    const images = {};
    function callCallbackIfReady() {
        if (numDownloading === 0) setTimeout(function() {
            callback(errors.length ? errors : undefined, textures, images);
        }, 0);
    }
    Object.keys(textureOptions).forEach(function(name) {
        const options = textureOptions[name];
        let onLoadFn;
        if ($065afaecc735fbee$var$isAsyncSrc(options.src)) {
            onLoadFn = function(err, tex, img) {
                images[name] = img;
                --numDownloading;
                if (err) errors.push(err);
                callCallbackIfReady();
            };
            ++numDownloading;
        }
        textures[name] = $065afaecc735fbee$export$37b981a8c575f415(gl, options, onLoadFn);
    });
    // queue the callback if there are no images to download.
    // We do this because if your code is structured to wait for
    // images to download but then you comment out all the async
    // images your code would break.
    callCallbackIfReady();
    return textures;
}
var $065afaecc735fbee$export$c3bd26ce2da80660 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setTextureDefaults_: $065afaecc735fbee$export$13a00e79c3b46a21,
    createSampler: $065afaecc735fbee$export$9128f6a54e671ebe,
    createSamplers: $065afaecc735fbee$export$7f108a4cd20bc0,
    setSamplerParameters: $065afaecc735fbee$export$9473ec3d6ac9f748,
    createTexture: $065afaecc735fbee$export$37b981a8c575f415,
    setEmptyTexture: $065afaecc735fbee$export$541fcc5ad0f34e5a,
    setTextureFromArray: $065afaecc735fbee$export$3d91b74019c3ded9,
    loadTextureFromUrl: $065afaecc735fbee$export$a0ce1a7e01ad3b32,
    setTextureFromElement: $065afaecc735fbee$export$8119aa4cbf12798b,
    setTextureFilteringForSize: $065afaecc735fbee$export$494a924bf2d77d9a,
    setTextureParameters: $065afaecc735fbee$export$145d4976a6287cac,
    setDefaultTextureColor: $065afaecc735fbee$export$37b57533fe0ca238,
    createTextures: $065afaecc735fbee$export$a1d6112a62597a1b,
    resizeTexture: $065afaecc735fbee$export$1d581f00cfe12937,
    canGenerateMipmap: $065afaecc735fbee$export$2058af87f75a4771,
    canFilter: $065afaecc735fbee$export$586e511f2aeecefd,
    getNumComponentsForFormat: $065afaecc735fbee$export$4ef22c3eb774ec7f,
    getBytesPerElementForInternalFormat: $065afaecc735fbee$export$df2d41bf86d3b760,
    getFormatAndTypeForInternalFormat: $065afaecc735fbee$export$7972c3060d7259fe
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /**
 * Low level shader program related functions
 *
 * You should generally not need to use these functions. They are provided
 * for those cases where you're doing something out of the ordinary
 * and you need lower level access.
 *
 * For backward compatibility they are available at both `twgl.programs` and `twgl`
 * itself
 *
 * See {@link module:twgl} for core functions
 *
 * @module twgl/programs
 */ const $065afaecc735fbee$var$error = $065afaecc735fbee$var$error$1;
const $065afaecc735fbee$var$warn = $065afaecc735fbee$var$warn$1;
function $065afaecc735fbee$var$getElementById(id) {
    return typeof document !== 'undefined' && document.getElementById ? document.getElementById(id) : null;
}
const $065afaecc735fbee$var$TEXTURE0 = 0x84c0;
const $065afaecc735fbee$var$DYNAMIC_DRAW = 0x88e8;
const $065afaecc735fbee$var$ARRAY_BUFFER = 0x8892;
const $065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER$1 = 0x8893;
const $065afaecc735fbee$var$UNIFORM_BUFFER = 0x8a11;
const $065afaecc735fbee$var$TRANSFORM_FEEDBACK_BUFFER = 0x8c8e;
const $065afaecc735fbee$var$TRANSFORM_FEEDBACK = 0x8e22;
const $065afaecc735fbee$var$COMPILE_STATUS = 0x8b81;
const $065afaecc735fbee$var$LINK_STATUS = 0x8b82;
const $065afaecc735fbee$var$FRAGMENT_SHADER = 0x8b30;
const $065afaecc735fbee$var$VERTEX_SHADER = 0x8b31;
const $065afaecc735fbee$var$SEPARATE_ATTRIBS = 0x8c8d;
const $065afaecc735fbee$var$ACTIVE_UNIFORMS = 0x8b86;
const $065afaecc735fbee$var$ACTIVE_ATTRIBUTES = 0x8b89;
const $065afaecc735fbee$var$TRANSFORM_FEEDBACK_VARYINGS = 0x8c83;
const $065afaecc735fbee$var$ACTIVE_UNIFORM_BLOCKS = 0x8a36;
const $065afaecc735fbee$var$UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER = 0x8a44;
const $065afaecc735fbee$var$UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER = 0x8a46;
const $065afaecc735fbee$var$UNIFORM_BLOCK_DATA_SIZE = 0x8a40;
const $065afaecc735fbee$var$UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES = 0x8a43;
const $065afaecc735fbee$var$FLOAT = 0x1406;
const $065afaecc735fbee$var$FLOAT_VEC2 = 0x8B50;
const $065afaecc735fbee$var$FLOAT_VEC3 = 0x8B51;
const $065afaecc735fbee$var$FLOAT_VEC4 = 0x8B52;
const $065afaecc735fbee$var$INT = 0x1404;
const $065afaecc735fbee$var$INT_VEC2 = 0x8B53;
const $065afaecc735fbee$var$INT_VEC3 = 0x8B54;
const $065afaecc735fbee$var$INT_VEC4 = 0x8B55;
const $065afaecc735fbee$var$BOOL = 0x8B56;
const $065afaecc735fbee$var$BOOL_VEC2 = 0x8B57;
const $065afaecc735fbee$var$BOOL_VEC3 = 0x8B58;
const $065afaecc735fbee$var$BOOL_VEC4 = 0x8B59;
const $065afaecc735fbee$var$FLOAT_MAT2 = 0x8B5A;
const $065afaecc735fbee$var$FLOAT_MAT3 = 0x8B5B;
const $065afaecc735fbee$var$FLOAT_MAT4 = 0x8B5C;
const $065afaecc735fbee$var$SAMPLER_2D = 0x8B5E;
const $065afaecc735fbee$var$SAMPLER_CUBE = 0x8B60;
const $065afaecc735fbee$var$SAMPLER_3D = 0x8B5F;
const $065afaecc735fbee$var$SAMPLER_2D_SHADOW = 0x8B62;
const $065afaecc735fbee$var$FLOAT_MAT2x3 = 0x8B65;
const $065afaecc735fbee$var$FLOAT_MAT2x4 = 0x8B66;
const $065afaecc735fbee$var$FLOAT_MAT3x2 = 0x8B67;
const $065afaecc735fbee$var$FLOAT_MAT3x4 = 0x8B68;
const $065afaecc735fbee$var$FLOAT_MAT4x2 = 0x8B69;
const $065afaecc735fbee$var$FLOAT_MAT4x3 = 0x8B6A;
const $065afaecc735fbee$var$SAMPLER_2D_ARRAY = 0x8DC1;
const $065afaecc735fbee$var$SAMPLER_2D_ARRAY_SHADOW = 0x8DC4;
const $065afaecc735fbee$var$SAMPLER_CUBE_SHADOW = 0x8DC5;
const $065afaecc735fbee$var$UNSIGNED_INT = 0x1405;
const $065afaecc735fbee$var$UNSIGNED_INT_VEC2 = 0x8DC6;
const $065afaecc735fbee$var$UNSIGNED_INT_VEC3 = 0x8DC7;
const $065afaecc735fbee$var$UNSIGNED_INT_VEC4 = 0x8DC8;
const $065afaecc735fbee$var$INT_SAMPLER_2D = 0x8DCA;
const $065afaecc735fbee$var$INT_SAMPLER_3D = 0x8DCB;
const $065afaecc735fbee$var$INT_SAMPLER_CUBE = 0x8DCC;
const $065afaecc735fbee$var$INT_SAMPLER_2D_ARRAY = 0x8DCF;
const $065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_2D = 0x8DD2;
const $065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_3D = 0x8DD3;
const $065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_CUBE = 0x8DD4;
const $065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_2D_ARRAY = 0x8DD7;
const $065afaecc735fbee$var$TEXTURE_2D$1 = 0x0DE1;
const $065afaecc735fbee$var$TEXTURE_CUBE_MAP = 0x8513;
const $065afaecc735fbee$var$TEXTURE_3D = 0x806F;
const $065afaecc735fbee$var$TEXTURE_2D_ARRAY = 0x8C1A;
const $065afaecc735fbee$var$typeMap = {};
/**
 * Returns the corresponding bind point for a given sampler type
 * @private
 */ function $065afaecc735fbee$var$getBindPointForSamplerType(gl, type) {
    return $065afaecc735fbee$var$typeMap[type].bindPoint;
}
// This kind of sucks! If you could compose functions as in `var fn = gl[name];`
// this code could be a lot smaller but that is sadly really slow (T_T)
function $065afaecc735fbee$var$floatSetter(gl, location1) {
    return function(v) {
        gl.uniform1f(location1, v);
    };
}
function $065afaecc735fbee$var$floatArraySetter(gl, location1) {
    return function(v) {
        gl.uniform1fv(location1, v);
    };
}
function $065afaecc735fbee$var$floatVec2Setter(gl, location1) {
    return function(v) {
        gl.uniform2fv(location1, v);
    };
}
function $065afaecc735fbee$var$floatVec3Setter(gl, location1) {
    return function(v) {
        gl.uniform3fv(location1, v);
    };
}
function $065afaecc735fbee$var$floatVec4Setter(gl, location1) {
    return function(v) {
        gl.uniform4fv(location1, v);
    };
}
function $065afaecc735fbee$var$intSetter(gl, location1) {
    return function(v) {
        gl.uniform1i(location1, v);
    };
}
function $065afaecc735fbee$var$intArraySetter(gl, location1) {
    return function(v) {
        gl.uniform1iv(location1, v);
    };
}
function $065afaecc735fbee$var$intVec2Setter(gl, location1) {
    return function(v) {
        gl.uniform2iv(location1, v);
    };
}
function $065afaecc735fbee$var$intVec3Setter(gl, location1) {
    return function(v) {
        gl.uniform3iv(location1, v);
    };
}
function $065afaecc735fbee$var$intVec4Setter(gl, location1) {
    return function(v) {
        gl.uniform4iv(location1, v);
    };
}
function $065afaecc735fbee$var$uintSetter(gl, location1) {
    return function(v) {
        gl.uniform1ui(location1, v);
    };
}
function $065afaecc735fbee$var$uintArraySetter(gl, location1) {
    return function(v) {
        gl.uniform1uiv(location1, v);
    };
}
function $065afaecc735fbee$var$uintVec2Setter(gl, location1) {
    return function(v) {
        gl.uniform2uiv(location1, v);
    };
}
function $065afaecc735fbee$var$uintVec3Setter(gl, location1) {
    return function(v) {
        gl.uniform3uiv(location1, v);
    };
}
function $065afaecc735fbee$var$uintVec4Setter(gl, location1) {
    return function(v) {
        gl.uniform4uiv(location1, v);
    };
}
function $065afaecc735fbee$var$floatMat2Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix2fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat3Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix3fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat4Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix4fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat23Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix2x3fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat32Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix3x2fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat24Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix2x4fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat42Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix4x2fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat34Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix3x4fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$floatMat43Setter(gl, location1) {
    return function(v) {
        gl.uniformMatrix4x3fv(location1, false, v);
    };
}
function $065afaecc735fbee$var$samplerSetter(gl, type, unit, location1) {
    const bindPoint = $065afaecc735fbee$var$getBindPointForSamplerType(gl, type);
    return $065afaecc735fbee$export$e3518b1ac7891039(gl) ? function(textureOrPair) {
        let texture;
        let sampler;
        if (!textureOrPair || $065afaecc735fbee$var$isTexture(gl, textureOrPair)) {
            texture = textureOrPair;
            sampler = null;
        } else {
            texture = textureOrPair.texture;
            sampler = textureOrPair.sampler;
        }
        gl.uniform1i(location1, unit);
        gl.activeTexture($065afaecc735fbee$var$TEXTURE0 + unit);
        gl.bindTexture(bindPoint, texture);
        gl.bindSampler(unit, sampler);
    } : function(texture) {
        gl.uniform1i(location1, unit);
        gl.activeTexture($065afaecc735fbee$var$TEXTURE0 + unit);
        gl.bindTexture(bindPoint, texture);
    };
}
function $065afaecc735fbee$var$samplerArraySetter(gl, type, unit, location1, size) {
    const bindPoint = $065afaecc735fbee$var$getBindPointForSamplerType(gl, type);
    const units = new Int32Array(size);
    for(let ii = 0; ii < size; ++ii)units[ii] = unit + ii;
    return $065afaecc735fbee$export$e3518b1ac7891039(gl) ? function(textures) {
        gl.uniform1iv(location1, units);
        textures.forEach(function(textureOrPair, index) {
            gl.activeTexture($065afaecc735fbee$var$TEXTURE0 + units[index]);
            let texture;
            let sampler;
            if (!textureOrPair || $065afaecc735fbee$var$isTexture(gl, textureOrPair)) {
                texture = textureOrPair;
                sampler = null;
            } else {
                texture = textureOrPair.texture;
                sampler = textureOrPair.sampler;
            }
            gl.bindSampler(unit, sampler);
            gl.bindTexture(bindPoint, texture);
        });
    } : function(textures) {
        gl.uniform1iv(location1, units);
        textures.forEach(function(texture, index) {
            gl.activeTexture($065afaecc735fbee$var$TEXTURE0 + units[index]);
            gl.bindTexture(bindPoint, texture);
        });
    };
}
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT] = {
    Type: Float32Array,
    size: 4,
    setter: $065afaecc735fbee$var$floatSetter,
    arraySetter: $065afaecc735fbee$var$floatArraySetter
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_VEC2] = {
    Type: Float32Array,
    size: 8,
    setter: $065afaecc735fbee$var$floatVec2Setter,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_VEC3] = {
    Type: Float32Array,
    size: 12,
    setter: $065afaecc735fbee$var$floatVec3Setter,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_VEC4] = {
    Type: Float32Array,
    size: 16,
    setter: $065afaecc735fbee$var$floatVec4Setter,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT] = {
    Type: Int32Array,
    size: 4,
    setter: $065afaecc735fbee$var$intSetter,
    arraySetter: $065afaecc735fbee$var$intArraySetter
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_VEC2] = {
    Type: Int32Array,
    size: 8,
    setter: $065afaecc735fbee$var$intVec2Setter,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_VEC3] = {
    Type: Int32Array,
    size: 12,
    setter: $065afaecc735fbee$var$intVec3Setter,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_VEC4] = {
    Type: Int32Array,
    size: 16,
    setter: $065afaecc735fbee$var$intVec4Setter,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT] = {
    Type: Uint32Array,
    size: 4,
    setter: $065afaecc735fbee$var$uintSetter,
    arraySetter: $065afaecc735fbee$var$uintArraySetter
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_VEC2] = {
    Type: Uint32Array,
    size: 8,
    setter: $065afaecc735fbee$var$uintVec2Setter,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_VEC3] = {
    Type: Uint32Array,
    size: 12,
    setter: $065afaecc735fbee$var$uintVec3Setter,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_VEC4] = {
    Type: Uint32Array,
    size: 16,
    setter: $065afaecc735fbee$var$uintVec4Setter,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$BOOL] = {
    Type: Uint32Array,
    size: 4,
    setter: $065afaecc735fbee$var$intSetter,
    arraySetter: $065afaecc735fbee$var$intArraySetter
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$BOOL_VEC2] = {
    Type: Uint32Array,
    size: 8,
    setter: $065afaecc735fbee$var$intVec2Setter,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$BOOL_VEC3] = {
    Type: Uint32Array,
    size: 12,
    setter: $065afaecc735fbee$var$intVec3Setter,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$BOOL_VEC4] = {
    Type: Uint32Array,
    size: 16,
    setter: $065afaecc735fbee$var$intVec4Setter,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT2] = {
    Type: Float32Array,
    size: 32,
    setter: $065afaecc735fbee$var$floatMat2Setter,
    rows: 2,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT3] = {
    Type: Float32Array,
    size: 48,
    setter: $065afaecc735fbee$var$floatMat3Setter,
    rows: 3,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT4] = {
    Type: Float32Array,
    size: 64,
    setter: $065afaecc735fbee$var$floatMat4Setter,
    rows: 4,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT2x3] = {
    Type: Float32Array,
    size: 32,
    setter: $065afaecc735fbee$var$floatMat23Setter,
    rows: 2,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT2x4] = {
    Type: Float32Array,
    size: 32,
    setter: $065afaecc735fbee$var$floatMat24Setter,
    rows: 2,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT3x2] = {
    Type: Float32Array,
    size: 48,
    setter: $065afaecc735fbee$var$floatMat32Setter,
    rows: 3,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT3x4] = {
    Type: Float32Array,
    size: 48,
    setter: $065afaecc735fbee$var$floatMat34Setter,
    rows: 3,
    cols: 4
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT4x2] = {
    Type: Float32Array,
    size: 64,
    setter: $065afaecc735fbee$var$floatMat42Setter,
    rows: 4,
    cols: 2
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$FLOAT_MAT4x3] = {
    Type: Float32Array,
    size: 64,
    setter: $065afaecc735fbee$var$floatMat43Setter,
    rows: 4,
    cols: 3
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_2D] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D$1
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_CUBE] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_CUBE_MAP
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_3D] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_3D
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_2D_SHADOW] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D$1
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_2D_ARRAY] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D_ARRAY
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_2D_ARRAY_SHADOW] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D_ARRAY
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$SAMPLER_CUBE_SHADOW] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_CUBE_MAP
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_SAMPLER_2D] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D$1
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_SAMPLER_3D] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_3D
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_SAMPLER_CUBE] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_CUBE_MAP
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$INT_SAMPLER_2D_ARRAY] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D_ARRAY
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_2D] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D$1
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_3D] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_3D
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_CUBE] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_CUBE_MAP
};
$065afaecc735fbee$var$typeMap[$065afaecc735fbee$var$UNSIGNED_INT_SAMPLER_2D_ARRAY] = {
    Type: null,
    size: 0,
    setter: $065afaecc735fbee$var$samplerSetter,
    arraySetter: $065afaecc735fbee$var$samplerArraySetter,
    bindPoint: $065afaecc735fbee$var$TEXTURE_2D_ARRAY
};
function $065afaecc735fbee$var$floatAttribSetter(gl, index) {
    return function(b) {
        if (b.value) {
            gl.disableVertexAttribArray(index);
            switch(b.value.length){
                case 4:
                    gl.vertexAttrib4fv(index, b.value);
                    break;
                case 3:
                    gl.vertexAttrib3fv(index, b.value);
                    break;
                case 2:
                    gl.vertexAttrib2fv(index, b.value);
                    break;
                case 1:
                    gl.vertexAttrib1fv(index, b.value);
                    break;
                default:
                    throw new Error('the length of a float constant value must be between 1 and 4!');
            }
        } else {
            gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER, b.buffer);
            gl.enableVertexAttribArray(index);
            gl.vertexAttribPointer(index, b.numComponents || b.size, b.type || $065afaecc735fbee$var$FLOAT, b.normalize || false, b.stride || 0, b.offset || 0);
            if (gl.vertexAttribDivisor) gl.vertexAttribDivisor(index, b.divisor || 0);
        }
    };
}
function $065afaecc735fbee$var$intAttribSetter(gl, index) {
    return function(b) {
        if (b.value) {
            gl.disableVertexAttribArray(index);
            if (b.value.length === 4) gl.vertexAttrib4iv(index, b.value);
            else throw new Error('The length of an integer constant value must be 4!');
        } else {
            gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER, b.buffer);
            gl.enableVertexAttribArray(index);
            gl.vertexAttribIPointer(index, b.numComponents || b.size, b.type || $065afaecc735fbee$var$INT, b.stride || 0, b.offset || 0);
            if (gl.vertexAttribDivisor) gl.vertexAttribDivisor(index, b.divisor || 0);
        }
    };
}
function $065afaecc735fbee$var$uintAttribSetter(gl, index) {
    return function(b) {
        if (b.value) {
            gl.disableVertexAttribArray(index);
            if (b.value.length === 4) gl.vertexAttrib4uiv(index, b.value);
            else throw new Error('The length of an unsigned integer constant value must be 4!');
        } else {
            gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER, b.buffer);
            gl.enableVertexAttribArray(index);
            gl.vertexAttribIPointer(index, b.numComponents || b.size, b.type || $065afaecc735fbee$var$UNSIGNED_INT, b.stride || 0, b.offset || 0);
            if (gl.vertexAttribDivisor) gl.vertexAttribDivisor(index, b.divisor || 0);
        }
    };
}
function $065afaecc735fbee$var$matAttribSetter(gl, index, typeInfo) {
    const defaultSize = typeInfo.size;
    const count = typeInfo.count;
    return function(b) {
        gl.bindBuffer($065afaecc735fbee$var$ARRAY_BUFFER, b.buffer);
        const numComponents = b.size || b.numComponents || defaultSize;
        const size = numComponents / count;
        const type = b.type || $065afaecc735fbee$var$FLOAT;
        const typeInfo = $065afaecc735fbee$var$typeMap[type];
        const stride = typeInfo.size * numComponents;
        const normalize = b.normalize || false;
        const offset = b.offset || 0;
        const rowOffset = stride / count;
        for(let i = 0; i < count; ++i){
            gl.enableVertexAttribArray(index + i);
            gl.vertexAttribPointer(index + i, size, type, normalize, stride, offset + rowOffset * i);
            if (gl.vertexAttribDivisor) gl.vertexAttribDivisor(index + i, b.divisor || 0);
        }
    };
}
const $065afaecc735fbee$var$attrTypeMap = {};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT] = {
    size: 4,
    setter: $065afaecc735fbee$var$floatAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT_VEC2] = {
    size: 8,
    setter: $065afaecc735fbee$var$floatAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT_VEC3] = {
    size: 12,
    setter: $065afaecc735fbee$var$floatAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT_VEC4] = {
    size: 16,
    setter: $065afaecc735fbee$var$floatAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$INT] = {
    size: 4,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$INT_VEC2] = {
    size: 8,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$INT_VEC3] = {
    size: 12,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$INT_VEC4] = {
    size: 16,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$UNSIGNED_INT] = {
    size: 4,
    setter: $065afaecc735fbee$var$uintAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$UNSIGNED_INT_VEC2] = {
    size: 8,
    setter: $065afaecc735fbee$var$uintAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$UNSIGNED_INT_VEC3] = {
    size: 12,
    setter: $065afaecc735fbee$var$uintAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$UNSIGNED_INT_VEC4] = {
    size: 16,
    setter: $065afaecc735fbee$var$uintAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$BOOL] = {
    size: 4,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$BOOL_VEC2] = {
    size: 8,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$BOOL_VEC3] = {
    size: 12,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$BOOL_VEC4] = {
    size: 16,
    setter: $065afaecc735fbee$var$intAttribSetter
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT_MAT2] = {
    size: 4,
    setter: $065afaecc735fbee$var$matAttribSetter,
    count: 2
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT_MAT3] = {
    size: 9,
    setter: $065afaecc735fbee$var$matAttribSetter,
    count: 3
};
$065afaecc735fbee$var$attrTypeMap[$065afaecc735fbee$var$FLOAT_MAT4] = {
    size: 16,
    setter: $065afaecc735fbee$var$matAttribSetter,
    count: 4
};
const $065afaecc735fbee$var$errorRE = /ERROR:\s*\d+:(\d+)/gi;
function $065afaecc735fbee$var$addLineNumbersWithError(src, log = '', lineOffset = 0) {
    // Note: Error message formats are not defined by any spec so this may or may not work.
    const matches = [
        ...log.matchAll($065afaecc735fbee$var$errorRE)
    ];
    const lineNoToErrorMap = new Map(matches.map((m, ndx)=>{
        const lineNo = parseInt(m[1]);
        const next = matches[ndx + 1];
        const end = next ? next.index : log.length;
        const msg = log.substring(m.index, end);
        return [
            lineNo - 1,
            msg
        ];
    }));
    return src.split('\n').map((line, lineNo)=>{
        const err = lineNoToErrorMap.get(lineNo);
        return `${lineNo + 1 + lineOffset}: ${line}${err ? `\n\n^^^ ${err}` : ''}`;
    }).join('\n');
}
/**
 * Error Callback
 * @callback ErrorCallback
 * @param {string} msg error message.
 * @param {number} [lineOffset] amount to add to line number
 * @memberOf module:twgl
 */ /**
 * Program Callback
 * @callback ProgramCallback
 * @param {string} [err] error message, falsy if no error
 * @param {WebGLProgram|module:twgl.ProgramInfo} [result] the program or programInfo
 */ const $065afaecc735fbee$var$spaceRE = /^[ \t]*\n/;
/**
 * Remove the first end of line because WebGL 2.0 requires
 * #version 300 es
 * as the first line. No whitespace allowed before that line
 * so
 *
 * <script>
 * #version 300 es
 * </script>
 *
 * Has one line before it which is invalid according to GLSL ES 3.00
 *
 * @param {string} shaderSource The source of the shader
 * @returns {{shaderSource: string, lineOffset: number}}
 * @private
 */ function $065afaecc735fbee$var$prepShaderSource(shaderSource) {
    let lineOffset = 0;
    if ($065afaecc735fbee$var$spaceRE.test(shaderSource)) {
        lineOffset = 1;
        shaderSource = shaderSource.replace($065afaecc735fbee$var$spaceRE, '');
    }
    return {
        lineOffset: lineOffset,
        shaderSource: shaderSource
    };
}
/**
 * @param {module:twgl.ProgramOptions} progOptions
 * @param {string} msg
 * @return null
 * @private
 */ function $065afaecc735fbee$var$reportError(progOptions, msg) {
    progOptions.errorCallback(msg);
    if (progOptions.callback) setTimeout(()=>{
        progOptions.callback(`${msg}\n${progOptions.errors.join('\n')}`);
    });
    return null;
}
/**
 * Check Shader status
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {number} shaderType The shader type
 * @param {WebGLShader} shader The shader
 * @param {ErrorCallback} [errFn] function to receive error message.
 * @return {string} errors or empty string
 * @private
 */ function $065afaecc735fbee$var$checkShaderStatus(gl, shaderType, shader, errFn) {
    errFn = errFn || $065afaecc735fbee$var$error;
    // Check the compile status
    const compiled = gl.getShaderParameter(shader, $065afaecc735fbee$var$COMPILE_STATUS);
    if (!compiled) {
        // Something went wrong during compilation; get the error
        const lastError = gl.getShaderInfoLog(shader);
        const { lineOffset: lineOffset, shaderSource: shaderSource } = $065afaecc735fbee$var$prepShaderSource(gl.getShaderSource(shader));
        const error = `${$065afaecc735fbee$var$addLineNumbersWithError(shaderSource, lastError, lineOffset)}\nError compiling ${$065afaecc735fbee$export$e97753eae63e4e62(gl, shaderType)}: ${lastError}`;
        errFn(error);
        return error;
    }
    return '';
}
/**
 * @typedef {Object} FullProgramSpec
 * @property {string[]} shaders the shader source or element ids.
 * @property {function(string)} [errorCallback] callback for errors
 * @property {Object.<string,number>|string[]} [attribLocations] a attribute name to location map, or array of attribute names where index = location.
 * @property {(module:twgl.BufferInfo|Object.<string,module:twgl.AttribInfo>|string[])} [transformFeedbackVaryings] If passed
 *   a BufferInfo will use the attribs names inside. If passed an object of AttribInfos will use the names from that object. Otherwise
 *   you can pass an array of names.
 * @property {number} [transformFeedbackMode] the mode to pass `gl.transformFeedbackVaryings`. Defaults to `SEPARATE_ATTRIBS`.
 * @property {ProgramCallback} [callback] callback for async program compilation.
 * @memberOf module:twgl
 */ /**
 * @typedef {string[]|module:twgl.FullProgramSpec} ProgramSpec
 * @memberOf module:twgl
 */ /**
 * @typedef {Object} ProgramOptions
 * @property {function(string)} [errorCallback] callback for errors
 * @property {Object.<string,number>|string[]} [attribLocations] a attribute name to location map, or array of attribute names where index = location.
 * @property {(module:twgl.BufferInfo|Object.<string,module:twgl.AttribInfo>|string[])} [transformFeedbackVaryings] If passed
 *   a BufferInfo will use the attribs names inside. If passed an object of AttribInfos will use the names from that object. Otherwise
 *   you can pass an array of names.
 * @property {number} [transformFeedbackMode] the mode to pass `gl.transformFeedbackVaryings`. Defaults to `SEPARATE_ATTRIBS`.
 * @property {ProgramCallback} [callback] callback for async program compilation.
 * @memberOf module:twgl
 */ /**
 * Gets the program options based on all these optional arguments
 * @param {module:twgl.ProgramOptions|string[]} [opt_attribs] Options for the program or an array of attribs names. Locations will be assigned by index if not passed in
 * @param {number[]} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {module:twgl.ProgramOptions} an instance of ProgramOptions based on the arguments passed in
 * @private
 */ function $065afaecc735fbee$var$getProgramOptions(opt_attribs, opt_locations, opt_errorCallback) {
    let transformFeedbackVaryings;
    let transformFeedbackMode;
    let callback;
    if (typeof opt_locations === 'function') {
        opt_errorCallback = opt_locations;
        opt_locations = undefined;
    }
    if (typeof opt_attribs === 'function') {
        opt_errorCallback = opt_attribs;
        opt_attribs = undefined;
    } else if (opt_attribs && !Array.isArray(opt_attribs)) {
        const opt = opt_attribs;
        opt_errorCallback = opt.errorCallback;
        opt_attribs = opt.attribLocations;
        transformFeedbackVaryings = opt.transformFeedbackVaryings;
        transformFeedbackMode = opt.transformFeedbackMode;
        callback = opt.callback;
    }
    const errorCallback = opt_errorCallback || $065afaecc735fbee$var$error;
    const errors = [];
    const options = {
        errorCallback (msg, ...args) {
            errors.push(msg);
            errorCallback(msg, ...args);
        },
        transformFeedbackVaryings: transformFeedbackVaryings,
        transformFeedbackMode: transformFeedbackMode,
        callback: callback,
        errors: errors
    };
    {
        let attribLocations = {};
        if (Array.isArray(opt_attribs)) opt_attribs.forEach(function(attrib, ndx) {
            attribLocations[attrib] = opt_locations ? opt_locations[ndx] : ndx;
        });
        else attribLocations = opt_attribs || {};
        options.attribLocations = attribLocations;
    }
    return options;
}
const $065afaecc735fbee$var$defaultShaderType = [
    "VERTEX_SHADER",
    "FRAGMENT_SHADER"
];
function $065afaecc735fbee$var$getShaderTypeFromScriptType(gl, scriptType) {
    if (scriptType.indexOf("frag") >= 0) return $065afaecc735fbee$var$FRAGMENT_SHADER;
    else if (scriptType.indexOf("vert") >= 0) return $065afaecc735fbee$var$VERTEX_SHADER;
    return undefined;
}
function $065afaecc735fbee$var$deleteProgramAndShaders(gl, program, notThese) {
    const shaders = gl.getAttachedShaders(program);
    for (const shader of shaders)if (notThese.has(shader)) gl.deleteShader(shader);
    gl.deleteProgram(program);
}
const $065afaecc735fbee$var$wait = (ms = 0)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $065afaecc735fbee$var$createProgramNoCheck(gl, shaders, programOptions) {
    const program = gl.createProgram();
    const { attribLocations: attribLocations, transformFeedbackVaryings: transformFeedbackVaryings, transformFeedbackMode: transformFeedbackMode } = $065afaecc735fbee$var$getProgramOptions(programOptions);
    for(let ndx = 0; ndx < shaders.length; ++ndx){
        let shader = shaders[ndx];
        if (typeof shader === 'string') {
            const elem = $065afaecc735fbee$var$getElementById(shader);
            const src = elem ? elem.text : shader;
            let type = gl[$065afaecc735fbee$var$defaultShaderType[ndx]];
            if (elem && elem.type) type = $065afaecc735fbee$var$getShaderTypeFromScriptType(gl, elem.type) || type;
            shader = gl.createShader(type);
            gl.shaderSource(shader, $065afaecc735fbee$var$prepShaderSource(src).shaderSource);
            gl.compileShader(shader);
            gl.attachShader(program, shader);
        }
    }
    Object.entries(attribLocations).forEach(([attrib, loc])=>gl.bindAttribLocation(program, loc, attrib));
    {
        let varyings = transformFeedbackVaryings;
        if (varyings) {
            if (varyings.attribs) varyings = varyings.attribs;
            if (!Array.isArray(varyings)) varyings = Object.keys(varyings);
            gl.transformFeedbackVaryings(program, varyings, transformFeedbackMode || $065afaecc735fbee$var$SEPARATE_ATTRIBS);
        }
    }
    gl.linkProgram(program);
    return program;
}
/**
 * Creates a program, attaches (and/or compiles) shaders, binds attrib locations, links the
 * program.
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgram(gl, [vs, fs], options);
 *     twgl.createProgram(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgram(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgram(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLShader[]|string[]} shaders The shaders to attach, or element ids for their source, or strings that contain their source
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]|module:twgl.ErrorCallback} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {WebGLProgram?} the created program or null if error of a callback was provided.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$327d24a04cd0dc17(gl, shaders, opt_attribs, opt_locations, opt_errorCallback) {
    // This code is really convoluted, because it may or may not be async
    // Maybe it would be better to have a separate function
    const progOptions = $065afaecc735fbee$var$getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
    const shaderSet = new Set(shaders);
    const program = $065afaecc735fbee$var$createProgramNoCheck(gl, shaders, progOptions);
    function hasErrors(gl, program) {
        const errors = $065afaecc735fbee$var$getProgramErrors(gl, program, progOptions.errorCallback);
        if (errors) $065afaecc735fbee$var$deleteProgramAndShaders(gl, program, shaderSet);
        return errors;
    }
    if (progOptions.callback) {
        $065afaecc735fbee$var$waitForProgramLinkCompletionAsync(gl, program).then(()=>{
            const errors = hasErrors(gl, program);
            progOptions.callback(errors, errors ? undefined : program);
        });
        return undefined;
    }
    return hasErrors(gl, program) ? undefined : program;
}
/**
 * This only works because the functions it wraps the first 2 arguments
 * are gl and any, followed by things that become programOptions
 * @private
 */ function $065afaecc735fbee$var$wrapCallbackFnToAsyncFn(fn) {
    return function(gl, arg1, ...args) {
        return new Promise((resolve, reject)=>{
            const programOptions = $065afaecc735fbee$var$getProgramOptions(...args);
            programOptions.callback = (err, program)=>{
                if (err) reject(err);
                else resolve(program);
            };
            fn(gl, arg1, programOptions);
        });
    };
}
/**
 * Same as createProgram but returns a promise
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramAsync(gl, [vs, fs], options);
 *     twgl.createProgramAsync(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramAsync(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramAsync(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @function
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLShader[]|string[]} shaders The shaders to attach, or element ids for their source, or strings that contain their source
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]|module:twgl.ErrorCallback} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {Promise<WebGLProgram>} The created program
 * @memberOf module:twgl/programs
 */ const $065afaecc735fbee$export$e84ea60b2a93dff2 = $065afaecc735fbee$var$wrapCallbackFnToAsyncFn($065afaecc735fbee$export$327d24a04cd0dc17);
/**
 * Same as createProgramInfo but returns a promise
 * @function
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderSources Array of sources for the
 *        shaders or ids. The first is assumed to be the vertex shader,
 *        the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]|module:twgl.ErrorCallback} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {Promise<module:twgl.ProgramInfo>} The created ProgramInfo
 * @memberOf module:twgl/programs
 */ const $065afaecc735fbee$export$515554c51de9b41c = $065afaecc735fbee$var$wrapCallbackFnToAsyncFn($065afaecc735fbee$export$2965a73560492a94);
async function $065afaecc735fbee$var$waitForProgramLinkCompletionAsync(gl, program) {
    const ext = gl.getExtension('KHR_parallel_shader_compile');
    const checkFn = ext ? (gl, program)=>gl.getProgramParameter(program, ext.COMPLETION_STATUS_KHR) : ()=>true;
    let waitTime = 0;
    do {
        await $065afaecc735fbee$var$wait(waitTime); // must wait at least once
        waitTime = 1000 / 60;
    }while (!checkFn(gl, program));
}
async function $065afaecc735fbee$var$waitForAllProgramsLinkCompletionAsync(gl, programs) {
    for (const program of Object.values(programs))await $065afaecc735fbee$var$waitForProgramLinkCompletionAsync(gl, program);
}
/**
 * Check a program's link status
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program Program to check
 * @param {ErrorCallback} [errFn] func for errors
 * @return {string?} errors if program is failed, else undefined
 * @private
 */ function $065afaecc735fbee$var$getProgramErrors(gl, program, errFn) {
    errFn = errFn || $065afaecc735fbee$var$error;
    // Check the link status
    const linked = gl.getProgramParameter(program, $065afaecc735fbee$var$LINK_STATUS);
    if (!linked) {
        // something went wrong with the link
        const lastError = gl.getProgramInfoLog(program);
        errFn(`Error in program linking: ${lastError}`);
        // print any errors from these shaders
        const shaders = gl.getAttachedShaders(program);
        const errors = shaders.map((shader)=>$065afaecc735fbee$var$checkShaderStatus(gl, gl.getShaderParameter(shader, gl.SHADER_TYPE), shader, errFn));
        return `${lastError}\n${errors.filter((_)=>_).join('\n')}`;
    }
    return undefined;
}
/**
 * Creates a program from 2 script tags.
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_options);
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramFromScripts(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderScriptIds Array of ids of the script
 *        tags for the shaders. The first is assumed to be the
 *        vertex shader, the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]|module:twgl.ErrorCallback} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {WebGLProgram?} the created program or null if error or a callback was provided.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$3699dca825c3297f(gl, shaderScriptIds, opt_attribs, opt_locations, opt_errorCallback) {
    const progOptions = $065afaecc735fbee$var$getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
    const shaders = [];
    for (const scriptId of shaderScriptIds){
        const shaderScript = $065afaecc735fbee$var$getElementById(scriptId);
        if (!shaderScript) return $065afaecc735fbee$var$reportError(progOptions, `unknown script element: ${scriptId}`);
        shaders.push(shaderScript.text);
    }
    return $065afaecc735fbee$export$327d24a04cd0dc17(gl, shaders, progOptions);
}
/**
 * Creates a program from 2 sources.
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_options);
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramFromSource(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderSources Array of sources for the
 *        shaders. The first is assumed to be the vertex shader,
 *        the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]|module:twgl.ErrorCallback} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {WebGLProgram?} the created program or null if error or a callback was provided.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$87c7c742dccfe3af(gl, shaderSources, opt_attribs, opt_locations, opt_errorCallback) {
    return $065afaecc735fbee$export$327d24a04cd0dc17(gl, shaderSources, opt_attribs, opt_locations, opt_errorCallback);
}
/**
 * Returns true if attribute/uniform is a reserved/built in
 *
 * It makes no sense to me why GL returns these because it's
 * illegal to call `gl.getUniformLocation` and `gl.getAttribLocation`
 * with names that start with `gl_` (and `webgl_` in WebGL)
 *
 * I can only assume they are there because they might count
 * when computing the number of uniforms/attributes used when you want to
 * know if you are near the limit. That doesn't really make sense
 * to me but the fact that these get returned are in the spec.
 *
 * @param {WebGLActiveInfo} info As returned from `gl.getActiveUniform` or
 *    `gl.getActiveAttrib`.
 * @return {bool} true if it's reserved
 * @private
 */ function $065afaecc735fbee$var$isBuiltIn(info) {
    const name = info.name;
    return name.startsWith("gl_") || name.startsWith("webgl_");
}
const $065afaecc735fbee$var$tokenRE = /(\.|\[|]|\w+)/g;
const $065afaecc735fbee$var$isDigit = (s)=>s >= '0' && s <= '9';
function $065afaecc735fbee$var$addSetterToUniformTree(fullPath, setter, node, uniformSetters) {
    const tokens = fullPath.split($065afaecc735fbee$var$tokenRE).filter((s)=>s !== '');
    let tokenNdx = 0;
    let path = '';
    for(;;){
        const token = tokens[tokenNdx++]; // has to be name or number
        path += token;
        const isArrayIndex = $065afaecc735fbee$var$isDigit(token[0]);
        const accessor = isArrayIndex ? parseInt(token) : token;
        if (isArrayIndex) path += tokens[tokenNdx++]; // skip ']'
        const isLastToken = tokenNdx === tokens.length;
        if (isLastToken) {
            node[accessor] = setter;
            break;
        } else {
            const token = tokens[tokenNdx++]; // has to be . or [
            const isArray = token === '[';
            const child = node[accessor] || (isArray ? [] : {});
            node[accessor] = child;
            node = child;
            uniformSetters[path] = uniformSetters[path] || function(node) {
                return function(value) {
                    $065afaecc735fbee$var$setUniformTree(node, value);
                };
            }(child);
            path += token;
        }
    }
}
/**
 * Creates setter functions for all uniforms of a shader
 * program.
 *
 * @see {@link module:twgl.setUniforms}
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program the program to create setters for.
 * @returns {Object.<string, function>} an object with a setter by name for each uniform
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$fe2460765a628597(gl, program) {
    let textureUnit = 0;
    /**
   * Creates a setter for a uniform of the given program with it's
   * location embedded in the setter.
   * @param {WebGLProgram} program
   * @param {WebGLUniformInfo} uniformInfo
   * @returns {function} the created setter.
   */ function createUniformSetter(program, uniformInfo, location1) {
        const isArray = uniformInfo.name.endsWith("[0]");
        const type = uniformInfo.type;
        const typeInfo = $065afaecc735fbee$var$typeMap[type];
        if (!typeInfo) throw new Error(`unknown type: 0x${type.toString(16)}`); // we should never get here.
        let setter;
        if (typeInfo.bindPoint) {
            // it's a sampler
            const unit = textureUnit;
            textureUnit += uniformInfo.size;
            if (isArray) setter = typeInfo.arraySetter(gl, type, unit, location1, uniformInfo.size);
            else setter = typeInfo.setter(gl, type, unit, location1, uniformInfo.size);
        } else if (typeInfo.arraySetter && isArray) setter = typeInfo.arraySetter(gl, location1);
        else setter = typeInfo.setter(gl, location1);
        setter.location = location1;
        return setter;
    }
    const uniformSetters = {};
    const uniformTree = {};
    const numUniforms = gl.getProgramParameter(program, $065afaecc735fbee$var$ACTIVE_UNIFORMS);
    for(let ii = 0; ii < numUniforms; ++ii){
        const uniformInfo = gl.getActiveUniform(program, ii);
        if ($065afaecc735fbee$var$isBuiltIn(uniformInfo)) continue;
        let name = uniformInfo.name;
        // remove the array suffix.
        if (name.endsWith("[0]")) name = name.substr(0, name.length - 3);
        const location1 = gl.getUniformLocation(program, uniformInfo.name);
        // the uniform will have no location if it's in a uniform block
        if (location1) {
            const setter = createUniformSetter(program, uniformInfo, location1);
            uniformSetters[name] = setter;
            $065afaecc735fbee$var$addSetterToUniformTree(name, setter, uniformTree, uniformSetters);
        }
    }
    return uniformSetters;
}
/**
 * @typedef {Object} TransformFeedbackInfo
 * @property {number} index index of transform feedback
 * @property {number} type GL type
 * @property {number} size 1 - 4
 * @memberOf module:twgl
 */ /**
 * Create TransformFeedbackInfo for passing to bindTransformFeedbackInfo.
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program an existing WebGLProgram.
 * @return {Object<string, module:twgl.TransformFeedbackInfo>}
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$ca1b1131a9f3199c(gl, program) {
    const info = {};
    const numVaryings = gl.getProgramParameter(program, $065afaecc735fbee$var$TRANSFORM_FEEDBACK_VARYINGS);
    for(let ii = 0; ii < numVaryings; ++ii){
        const varying = gl.getTransformFeedbackVarying(program, ii);
        info[varying.name] = {
            index: ii,
            type: varying.type,
            size: varying.size
        };
    }
    return info;
}
/**
 * Binds buffers for transform feedback.
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {(module:twgl.ProgramInfo|Object<string, module:twgl.TransformFeedbackInfo>)} transformFeedbackInfo A ProgramInfo or TransformFeedbackInfo.
 * @param {(module:twgl.BufferInfo|Object<string, module:twgl.AttribInfo>)} [bufferInfo] A BufferInfo or set of AttribInfos.
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$faea9f1eeaf6350d(gl, transformFeedbackInfo, bufferInfo) {
    if (transformFeedbackInfo.transformFeedbackInfo) transformFeedbackInfo = transformFeedbackInfo.transformFeedbackInfo;
    if (bufferInfo.attribs) bufferInfo = bufferInfo.attribs;
    for(const name in bufferInfo){
        const varying = transformFeedbackInfo[name];
        if (varying) {
            const buf = bufferInfo[name];
            if (buf.offset) gl.bindBufferRange($065afaecc735fbee$var$TRANSFORM_FEEDBACK_BUFFER, varying.index, buf.buffer, buf.offset, buf.size);
            else gl.bindBufferBase($065afaecc735fbee$var$TRANSFORM_FEEDBACK_BUFFER, varying.index, buf.buffer);
        }
    }
}
/**
 * Creates a transform feedback and sets the buffers
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {module:twgl.ProgramInfo} programInfo A ProgramInfo as returned from {@link module:twgl.createProgramInfo}
 * @param {(module:twgl.BufferInfo|Object<string, module:twgl.AttribInfo>)} [bufferInfo] A BufferInfo or set of AttribInfos.
 * @return {WebGLTransformFeedback} the created transform feedback
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$8ec4a27c67088db2(gl, programInfo, bufferInfo) {
    const tf = gl.createTransformFeedback();
    gl.bindTransformFeedback($065afaecc735fbee$var$TRANSFORM_FEEDBACK, tf);
    gl.useProgram(programInfo.program);
    $065afaecc735fbee$export$faea9f1eeaf6350d(gl, programInfo, bufferInfo);
    gl.bindTransformFeedback($065afaecc735fbee$var$TRANSFORM_FEEDBACK, null);
    return tf;
}
/**
 * @typedef {Object} UniformData
 * @property {string} name The name of the uniform
 * @property {number} type The WebGL type enum for this uniform
 * @property {number} size The number of elements for this uniform
 * @property {number} blockNdx The block index this uniform appears in
 * @property {number} offset The byte offset in the block for this uniform's value
 * @memberOf module:twgl
 */ /**
 * The specification for one UniformBlockObject
 *
 * @typedef {Object} BlockSpec
 * @property {number} index The index of the block.
 * @property {number} size The size in bytes needed for the block
 * @property {number[]} uniformIndices The indices of the uniforms used by the block. These indices
 *    correspond to entries in a UniformData array in the {@link module:twgl.UniformBlockSpec}.
 * @property {bool} usedByVertexShader Self explanatory
 * @property {bool} usedByFragmentShader Self explanatory
 * @property {bool} used Self explanatory
 * @memberOf module:twgl
 */ /**
 * A `UniformBlockSpec` represents the data needed to create and bind
 * UniformBlockObjects for a given program
 *
 * @typedef {Object} UniformBlockSpec
 * @property {Object.<string, module:twgl.BlockSpec>} blockSpecs The BlockSpec for each block by block name
 * @property {UniformData[]} uniformData An array of data for each uniform by uniform index.
 * @memberOf module:twgl
 */ /**
 * Creates a UniformBlockSpec for the given program.
 *
 * A UniformBlockSpec represents the data needed to create and bind
 * UniformBlockObjects
 *
 * @param {WebGL2RenderingContext} gl A WebGL2 Rendering Context
 * @param {WebGLProgram} program A WebGLProgram for a successfully linked program
 * @return {module:twgl.UniformBlockSpec} The created UniformBlockSpec
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$7b680ab060795ae5(gl, program) {
    const numUniforms = gl.getProgramParameter(program, $065afaecc735fbee$var$ACTIVE_UNIFORMS);
    const uniformData = [];
    const uniformIndices = [];
    for(let ii = 0; ii < numUniforms; ++ii){
        uniformIndices.push(ii);
        uniformData.push({});
        const uniformInfo = gl.getActiveUniform(program, ii);
        uniformData[ii].name = uniformInfo.name;
    }
    [
        [
            "UNIFORM_TYPE",
            "type"
        ],
        [
            "UNIFORM_SIZE",
            "size"
        ],
        [
            "UNIFORM_BLOCK_INDEX",
            "blockNdx"
        ],
        [
            "UNIFORM_OFFSET",
            "offset"
        ]
    ].forEach(function(pair) {
        const pname = pair[0];
        const key = pair[1];
        gl.getActiveUniforms(program, uniformIndices, gl[pname]).forEach(function(value, ndx) {
            uniformData[ndx][key] = value;
        });
    });
    const blockSpecs = {};
    const numUniformBlocks = gl.getProgramParameter(program, $065afaecc735fbee$var$ACTIVE_UNIFORM_BLOCKS);
    for(let ii = 0; ii < numUniformBlocks; ++ii){
        const name = gl.getActiveUniformBlockName(program, ii);
        const blockSpec = {
            index: gl.getUniformBlockIndex(program, name),
            usedByVertexShader: gl.getActiveUniformBlockParameter(program, ii, $065afaecc735fbee$var$UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER),
            usedByFragmentShader: gl.getActiveUniformBlockParameter(program, ii, $065afaecc735fbee$var$UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER),
            size: gl.getActiveUniformBlockParameter(program, ii, $065afaecc735fbee$var$UNIFORM_BLOCK_DATA_SIZE),
            uniformIndices: gl.getActiveUniformBlockParameter(program, ii, $065afaecc735fbee$var$UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES)
        };
        blockSpec.used = blockSpec.usedByVertexShader || blockSpec.usedByFragmentShader;
        blockSpecs[name] = blockSpec;
    }
    return {
        blockSpecs: blockSpecs,
        uniformData: uniformData
    };
}
const $065afaecc735fbee$var$arraySuffixRE = /\[\d+\]\.$/; // better way to check?
const $065afaecc735fbee$var$pad = (v, padding)=>((v + (padding - 1)) / padding | 0) * padding;
function $065afaecc735fbee$var$createUniformBlockUniformSetter(view, isArray, rows, cols) {
    if (isArray || rows) {
        cols = cols || 1;
        const numElements = view.length;
        const totalRows = numElements / 4;
        return function(value) {
            let dst = 0;
            let src = 0;
            for(let row = 0; row < totalRows; ++row){
                for(let col = 0; col < cols; ++col)view[dst++] = value[src++];
                dst += 4 - cols;
            }
        };
    } else return function(value) {
        if (value.length) view.set(value);
        else view[0] = value;
    };
}
/**
 * Represents a UniformBlockObject including an ArrayBuffer with all the uniform values
 * and a corresponding WebGLBuffer to hold those values on the GPU
 *
 * @typedef {Object} UniformBlockInfo
 * @property {string} name The name of the block
 * @property {ArrayBuffer} array The array buffer that contains the uniform values
 * @property {Float32Array} asFloat A float view on the array buffer. This is useful
 *    inspecting the contents of the buffer in the debugger.
 * @property {WebGLBuffer} buffer A WebGL buffer that will hold a copy of the uniform values for rendering.
 * @property {number} [offset] offset into buffer
 * @property {Object<string, ArrayBufferView>} uniforms A uniform name to ArrayBufferView map.
 *   each Uniform has a correctly typed `ArrayBufferView` into array at the correct offset
 *   and length of that uniform. So for example a float uniform would have a 1 float `Float32Array`
 *   view. A single mat4 would have a 16 element `Float32Array` view. An ivec2 would have an
 *   `Int32Array` view, etc.
 * @property {Object<string, function>} setters A setter for this uniform.
 *   The reason to use setters is elements of arrays are padded to vec4 sizes which
 *   means if you want to set an array of 4 floats you'd need to set 16 values
 *   (or set elements 0, 4, 8, 12). In other words
 *   `someBlockInfo.uniforms.some4FloatArrayUniform.set([0, , , , 1, , , , 2, , , , 3])`
 *   where as the setter handles just passing in [0, 1, 2, 3] either directly as in
 *   `someBlockInfo.setter.some4FloatArrayUniform.set([0, 1, 2, 3])` (not recommended)
 *   or via {@link module:twgl.setBlockUniforms}
 * @memberOf module:twgl
 */ /**
 * Creates a `UniformBlockInfo` for the specified block
 *
 * Note: **If the blockName matches no existing blocks a warning is printed to the console and a dummy
 * `UniformBlockInfo` is returned**. This is because when debugging GLSL
 * it is common to comment out large portions of a shader or for example set
 * the final output to a constant. When that happens blocks get optimized out.
 * If this function did not create dummy blocks your code would crash when debugging.
 *
 * @param {WebGL2RenderingContext} gl A WebGL2RenderingContext
 * @param {WebGLProgram} program A WebGLProgram
 * @param {module:twgl.UniformBlockSpec} uniformBlockSpec. A UniformBlockSpec as returned
 *     from {@link module:twgl.createUniformBlockSpecFromProgram}.
 * @param {string} blockName The name of the block.
 * @return {module:twgl.UniformBlockInfo} The created UniformBlockInfo
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$ba1b57ae67e32deb(gl, program, uniformBlockSpec, blockName) {
    const blockSpecs = uniformBlockSpec.blockSpecs;
    const uniformData = uniformBlockSpec.uniformData;
    const blockSpec = blockSpecs[blockName];
    if (!blockSpec) {
        $065afaecc735fbee$var$warn("no uniform block object named:", blockName);
        return {
            name: blockName,
            uniforms: {}
        };
    }
    const array = new ArrayBuffer(blockSpec.size);
    const buffer = gl.createBuffer();
    const uniformBufferIndex = blockSpec.index;
    gl.bindBuffer($065afaecc735fbee$var$UNIFORM_BUFFER, buffer);
    gl.uniformBlockBinding(program, blockSpec.index, uniformBufferIndex);
    let prefix = blockName + ".";
    if ($065afaecc735fbee$var$arraySuffixRE.test(prefix)) prefix = prefix.replace($065afaecc735fbee$var$arraySuffixRE, ".");
    const uniforms = {};
    const setters = {};
    const setterTree = {};
    blockSpec.uniformIndices.forEach(function(uniformNdx) {
        const data = uniformData[uniformNdx];
        let name = data.name;
        if (name.startsWith(prefix)) name = name.substr(prefix.length);
        const isArray = name.endsWith('[0]');
        if (isArray) name = name.substr(0, name.length - 3);
        const typeInfo = $065afaecc735fbee$var$typeMap[data.type];
        const Type = typeInfo.Type;
        const byteLength = isArray ? $065afaecc735fbee$var$pad(typeInfo.size, 16) * data.size : typeInfo.size * data.size;
        const uniformView = new Type(array, data.offset, byteLength / Type.BYTES_PER_ELEMENT);
        uniforms[name] = uniformView;
        // Note: I'm not sure what to do here. The original
        // idea was to create TypedArray views into each part
        // of the block. This is useful, for example if you have
        // a block with { mat4: model; mat4 view; mat4 projection; }
        // you'll get a Float32Array for each one suitable for
        // passing to most JS math libraries including twgl's and glMatrix.js.
        //
        // But, if you have a an array of structures, especially if that
        // array is large, you get a whole bunch of TypedArray views.
        // Every one of them has overhead and switching between them all
        // is probably a cache miss. In that case it would really be better
        // to just have one view (asFloat) and have all the setters
        // just reference the correct portion. But, then you can't easily
        // treat a matrix, or a vec4, as a standalone thing like you can
        // with all the views.
        //
        // Another problem with the views is they are not shared. With
        // uniforms you have one set of setters. With UniformBlockInfo
        // you have a set of setters *pre block instance*. That's because
        // TypedArray views can't be mapped to different buffers.
        //
        // My gut right now is if you really want the speed and compactness
        // then you should probably roll your own solution. TWGL's goal
        // here is ease of use as AFAICT there is no simple generic efficient
        // solution.
        const setter = $065afaecc735fbee$var$createUniformBlockUniformSetter(uniformView, isArray, typeInfo.rows, typeInfo.cols);
        setters[name] = setter;
        $065afaecc735fbee$var$addSetterToUniformTree(name, setter, setterTree, setters);
    });
    return {
        name: blockName,
        array: array,
        asFloat: new Float32Array(array),
        buffer: buffer,
        uniforms: uniforms,
        setters: setters
    };
}
/**
 * Creates a `UniformBlockInfo` for the specified block
 *
 * Note: **If the blockName matches no existing blocks a warning is printed to the console and a dummy
 * `UniformBlockInfo` is returned**. This is because when debugging GLSL
 * it is common to comment out large portions of a shader or for example set
 * the final output to a constant. When that happens blocks get optimized out.
 * If this function did not create dummy blocks your code would crash when debugging.
 *
 * @param {WebGL2RenderingContext} gl A WebGL2RenderingContext
 * @param {module:twgl.ProgramInfo} programInfo a `ProgramInfo`
 *     as returned from {@link module:twgl.createProgramInfo}
 * @param {string} blockName The name of the block.
 * @return {module:twgl.UniformBlockInfo} The created UniformBlockInfo
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$721ed4ead8eefe0d(gl, programInfo, blockName) {
    return $065afaecc735fbee$export$ba1b57ae67e32deb(gl, programInfo.program, programInfo.uniformBlockSpec, blockName);
}
/**
 * Binds a uniform block to the matching uniform block point.
 * Matches by blocks by name so blocks must have the same name not just the same
 * structure.
 *
 * If you have changed any values and you upload the values into the corresponding WebGLBuffer
 * call {@link module:twgl.setUniformBlock} instead.
 *
 * @param {WebGL2RenderingContext} gl A WebGL 2 rendering context.
 * @param {(module:twgl.ProgramInfo|module:twgl.UniformBlockSpec)} programInfo a `ProgramInfo`
 *     as returned from {@link module:twgl.createProgramInfo} or or `UniformBlockSpec` as
 *     returned from {@link module:twgl.createUniformBlockSpecFromProgram}.
 * @param {module:twgl.UniformBlockInfo} uniformBlockInfo a `UniformBlockInfo` as returned from
 *     {@link module:twgl.createUniformBlockInfo}.
 * @return {bool} true if buffer was bound. If the programInfo has no block with the same block name
 *     no buffer is bound.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$6c9dd56f52711760(gl, programInfo, uniformBlockInfo) {
    const uniformBlockSpec = programInfo.uniformBlockSpec || programInfo;
    const blockSpec = uniformBlockSpec.blockSpecs[uniformBlockInfo.name];
    if (blockSpec) {
        const bufferBindIndex = blockSpec.index;
        gl.bindBufferRange($065afaecc735fbee$var$UNIFORM_BUFFER, bufferBindIndex, uniformBlockInfo.buffer, uniformBlockInfo.offset || 0, uniformBlockInfo.array.byteLength);
        return true;
    }
    return false;
}
/**
 * Uploads the current uniform values to the corresponding WebGLBuffer
 * and binds that buffer to the program's corresponding bind point for the uniform block object.
 *
 * If you haven't changed any values and you only need to bind the uniform block object
 * call {@link module:twgl.bindUniformBlock} instead.
 *
 * @param {WebGL2RenderingContext} gl A WebGL 2 rendering context.
 * @param {(module:twgl.ProgramInfo|module:twgl.UniformBlockSpec)} programInfo a `ProgramInfo`
 *     as returned from {@link module:twgl.createProgramInfo} or or `UniformBlockSpec` as
 *     returned from {@link module:twgl.createUniformBlockSpecFromProgram}.
 * @param {module:twgl.UniformBlockInfo} uniformBlockInfo a `UniformBlockInfo` as returned from
 *     {@link module:twgl.createUniformBlockInfo}.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$94b2522be353a874(gl, programInfo, uniformBlockInfo) {
    if ($065afaecc735fbee$export$6c9dd56f52711760(gl, programInfo, uniformBlockInfo)) gl.bufferData($065afaecc735fbee$var$UNIFORM_BUFFER, uniformBlockInfo.array, $065afaecc735fbee$var$DYNAMIC_DRAW);
}
/**
 * Sets values of a uniform block object
 *
 * @param {module:twgl.UniformBlockInfo} uniformBlockInfo A UniformBlockInfo as returned by {@link module:twgl.createUniformBlockInfo}.
 * @param {Object.<string, ?>} values A uniform name to value map where the value is correct for the given
 *    type of uniform. So for example given a block like
 *
 *       uniform SomeBlock {
 *         float someFloat;
 *         vec2 someVec2;
 *         vec3 someVec3Array[2];
 *         int someInt;
 *       }
 *
 *  You can set the values of the uniform block with
 *
 *       twgl.setBlockUniforms(someBlockInfo, {
 *          someFloat: 12.3,
 *          someVec2: [1, 2],
 *          someVec3Array: [1, 2, 3, 4, 5, 6],
 *          someInt: 5,
 *       }
 *
 *  Arrays can be JavaScript arrays or typed arrays
 *
 *  You can also fill out structure and array values either via
 *  shortcut. Example
 *
 *     // -- in shader --
 *     struct Light {
 *       float intensity;
 *       vec4 color;
 *       float nearFar[2];
 *     };
 *     uniform Lights {
 *       Light lights[2];
 *     };
 *
 *     // in JavaScript
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       lights: [
 *         { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.1, 10] },
 *         { intensity: 2.0, color: [0, 0, 1, 1], nearFar[0.2, 15] },
 *       ],
 *     });
 *
 *   or the more traditional way
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       "lights[0].intensity": 5.0,
 *       "lights[0].color": [1, 0, 0, 1],
 *       "lights[0].nearFar": [0.1, 10],
 *       "lights[1].intensity": 2.0,
 *       "lights[1].color": [0, 0, 1, 1],
 *       "lights[1].nearFar": [0.2, 15],
 *     });
 *
 *   You can also specify partial paths
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       'lights[1]': { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.2, 15] },
 *     });
 *
 *   But you can not specify leaf array indices.
 *
 *     twgl.setBlockUniforms(someBlockInfo, {
 *       'lights[1].nearFar[1]': 15,     // BAD! nearFar is a leaf
 *       'lights[1].nearFar': [0.2, 15], // GOOD
 *     });
 *
 *  **IMPORTANT!**, packing in a UniformBlock is unintuitive.
 *  For example the actual layout of `someVec3Array` above in memory
 *  is `1, 2, 3, unused, 4, 5, 6, unused`. twgl takes in 6 values
 *  as shown about and copies them, skipping the padding. This might
 *  be confusing if you're already familiar with Uniform blocks.
 *
 *  If you want to deal with the padding yourself you can access the array
 *  buffer views directly. eg:
 *
 *      someBlockInfo.someVec3Array.set([1, 2, 3, 0, 4, 5, 6, 0]);
 *
 *  Any name that doesn't match will be ignored
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$1710cbff6680b0a4(uniformBlockInfo, values) {
    const setters = uniformBlockInfo.setters;
    for(const name in values){
        const setter = setters[name];
        if (setter) {
            const value = values[name];
            setter(value);
        }
    }
}
function $065afaecc735fbee$var$setUniformTree(tree, values) {
    for(const name in values){
        const prop = tree[name];
        if (typeof prop === 'function') prop(values[name]);
        else $065afaecc735fbee$var$setUniformTree(tree[name], values[name]);
    }
}
/**
 * Set uniforms and binds related textures.
 *
 * example:
 *
 *     const programInfo = createProgramInfo(
 *         gl, ["some-vs", "some-fs"]);
 *
 *     const tex1 = gl.createTexture();
 *     const tex2 = gl.createTexture();
 *
 *     ... assume we setup the textures with data ...
 *
 *     const uniforms = {
 *       u_someSampler: tex1,
 *       u_someOtherSampler: tex2,
 *       u_someColor: [1,0,0,1],
 *       u_somePosition: [0,1,1],
 *       u_someMatrix: [
 *         1,0,0,0,
 *         0,1,0,0,
 *         0,0,1,0,
 *         0,0,0,0,
 *       ],
 *     };
 *
 *     gl.useProgram(programInfo.program);
 *
 * This will automatically bind the textures AND set the
 * uniforms.
 *
 *     twgl.setUniforms(programInfo, uniforms);
 *
 * For the example above it is equivalent to
 *
 *     let texUnit = 0;
 *     gl.activeTexture(gl.TEXTURE0 + texUnit);
 *     gl.bindTexture(gl.TEXTURE_2D, tex1);
 *     gl.uniform1i(u_someSamplerLocation, texUnit++);
 *     gl.activeTexture(gl.TEXTURE0 + texUnit);
 *     gl.bindTexture(gl.TEXTURE_2D, tex2);
 *     gl.uniform1i(u_someSamplerLocation, texUnit++);
 *     gl.uniform4fv(u_someColorLocation, [1, 0, 0, 1]);
 *     gl.uniform3fv(u_somePositionLocation, [0, 1, 1]);
 *     gl.uniformMatrix4fv(u_someMatrix, false, [
 *         1,0,0,0,
 *         0,1,0,0,
 *         0,0,1,0,
 *         0,0,0,0,
 *       ]);
 *
 * Note it is perfectly reasonable to call `setUniforms` multiple times. For example
 *
 *     const uniforms = {
 *       u_someSampler: tex1,
 *       u_someOtherSampler: tex2,
 *     };
 *
 *     const moreUniforms {
 *       u_someColor: [1,0,0,1],
 *       u_somePosition: [0,1,1],
 *       u_someMatrix: [
 *         1,0,0,0,
 *         0,1,0,0,
 *         0,0,1,0,
 *         0,0,0,0,
 *       ],
 *     };
 *
 *     twgl.setUniforms(programInfo, uniforms);
 *     twgl.setUniforms(programInfo, moreUniforms);
 *
 * You can also add WebGLSamplers to uniform samplers as in
 *
 *     const uniforms = {
 *       u_someSampler: {
 *         texture: someWebGLTexture,
 *         sampler: someWebGLSampler,
 *       },
 *     };
 *
 * In which case both the sampler and texture will be bound to the
 * same unit.
 *
 * @param {(module:twgl.ProgramInfo|Object.<string, function>)} setters a `ProgramInfo` as returned from `createProgramInfo` or the setters returned from
 *        `createUniformSetters`.
 * @param {Object.<string, ?>} values an object with values for the
 *        uniforms.
 *   You can pass multiple objects by putting them in an array or by calling with more arguments.For example
 *
 *     const sharedUniforms = {
 *       u_fogNear: 10,
 *       u_projection: ...
 *       ...
 *     };
 *
 *     const localUniforms = {
 *       u_world: ...
 *       u_diffuseColor: ...
 *     };
 *
 *     twgl.setUniforms(programInfo, sharedUniforms, localUniforms);
 *
 *     // is the same as
 *
 *     twgl.setUniforms(programInfo, [sharedUniforms, localUniforms]);
 *
 *     // is the same as
 *
 *     twgl.setUniforms(programInfo, sharedUniforms);
 *     twgl.setUniforms(programInfo, localUniforms};
 *
 *   You can also fill out structure and array values either via
 *   shortcut. Example
 *
 *     // -- in shader --
 *     struct Light {
 *       float intensity;
 *       vec4 color;
 *       float nearFar[2];
 *     };
 *     uniform Light lights[2];
 *
 *     // in JavaScript
 *
 *     twgl.setUniforms(programInfo, {
 *       lights: [
 *         { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.1, 10] },
 *         { intensity: 2.0, color: [0, 0, 1, 1], nearFar[0.2, 15] },
 *       ],
 *     });
 *
 *   or the more traditional way
 *
 *     twgl.setUniforms(programInfo, {
 *       "lights[0].intensity": 5.0,
 *       "lights[0].color": [1, 0, 0, 1],
 *       "lights[0].nearFar": [0.1, 10],
 *       "lights[1].intensity": 2.0,
 *       "lights[1].color": [0, 0, 1, 1],
 *       "lights[1].nearFar": [0.2, 15],
 *     });
 *
 *   You can also specify partial paths
 *
 *     twgl.setUniforms(programInfo, {
 *       'lights[1]': { intensity: 5.0, color: [1, 0, 0, 1], nearFar[0.2, 15] },
 *     });
 *
 *   But you can not specify leaf array indices
 *
 *     twgl.setUniforms(programInfo, {
 *       'lights[1].nearFar[1]': 15,     // BAD! nearFar is a leaf
 *       'lights[1].nearFar': [0.2, 15], // GOOD
 *     });
 *
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$1fa517b18dd66830(setters, ...args) {
    const actualSetters = setters.uniformSetters || setters;
    const numArgs = args.length;
    for(let aNdx = 0; aNdx < numArgs; ++aNdx){
        const values = args[aNdx];
        if (Array.isArray(values)) {
            const numValues = values.length;
            for(let ii = 0; ii < numValues; ++ii)$065afaecc735fbee$export$1fa517b18dd66830(actualSetters, values[ii]);
        } else for(const name in values){
            const setter = actualSetters[name];
            if (setter) setter(values[name]);
        }
    }
}
/**
 * Alias for `setUniforms`
 * @function
 * @param {(module:twgl.ProgramInfo|Object.<string, function>)} setters a `ProgramInfo` as returned from `createProgramInfo` or the setters returned from
 *        `createUniformSetters`.
 * @param {Object.<string, ?>} values an object with values for the
 * @memberOf module:twgl/programs
 */ const $065afaecc735fbee$export$bdaefe8ae431fe00 = $065afaecc735fbee$export$1fa517b18dd66830;
/**
 * Creates setter functions for all attributes of a shader
 * program. You can pass this to {@link module:twgl.setBuffersAndAttributes} to set all your buffers and attributes.
 *
 * @see {@link module:twgl.setAttributes} for example
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {WebGLProgram} program the program to create setters for.
 * @return {Object.<string, function>} an object with a setter for each attribute by name.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$ca2da2c8098eca9b(gl, program) {
    const attribSetters = {};
    const numAttribs = gl.getProgramParameter(program, $065afaecc735fbee$var$ACTIVE_ATTRIBUTES);
    for(let ii = 0; ii < numAttribs; ++ii){
        const attribInfo = gl.getActiveAttrib(program, ii);
        if ($065afaecc735fbee$var$isBuiltIn(attribInfo)) continue;
        const index = gl.getAttribLocation(program, attribInfo.name);
        const typeInfo = $065afaecc735fbee$var$attrTypeMap[attribInfo.type];
        const setter = typeInfo.setter(gl, index, typeInfo);
        setter.location = index;
        attribSetters[attribInfo.name] = setter;
    }
    return attribSetters;
}
/**
 * Sets attributes and binds buffers (deprecated... use {@link module:twgl.setBuffersAndAttributes})
 *
 * Example:
 *
 *     const program = createProgramFromScripts(
 *         gl, ["some-vs", "some-fs");
 *
 *     const attribSetters = createAttributeSetters(program);
 *
 *     const positionBuffer = gl.createBuffer();
 *     const texcoordBuffer = gl.createBuffer();
 *
 *     const attribs = {
 *       a_position: {buffer: positionBuffer, numComponents: 3},
 *       a_texcoord: {buffer: texcoordBuffer, numComponents: 2},
 *     };
 *
 *     gl.useProgram(program);
 *
 * This will automatically bind the buffers AND set the
 * attributes.
 *
 *     setAttributes(attribSetters, attribs);
 *
 * Properties of attribs. For each attrib you can add
 * properties:
 *
 * *   type: the type of data in the buffer. Default = gl.FLOAT
 * *   normalize: whether or not to normalize the data. Default = false
 * *   stride: the stride. Default = 0
 * *   offset: offset into the buffer. Default = 0
 * *   divisor: the divisor for instances. Default = undefined
 *
 * For example if you had 3 value float positions, 2 value
 * float texcoord and 4 value uint8 colors you'd setup your
 * attribs like this
 *
 *     const attribs = {
 *       a_position: {buffer: positionBuffer, numComponents: 3},
 *       a_texcoord: {buffer: texcoordBuffer, numComponents: 2},
 *       a_color: {
 *         buffer: colorBuffer,
 *         numComponents: 4,
 *         type: gl.UNSIGNED_BYTE,
 *         normalize: true,
 *       },
 *     };
 *
 * @param {Object.<string, function>} setters Attribute setters as returned from createAttributeSetters
 * @param {Object.<string, module:twgl.AttribInfo>} buffers AttribInfos mapped by attribute name.
 * @memberOf module:twgl/programs
 * @deprecated use {@link module:twgl.setBuffersAndAttributes}
 * @private
 */ function $065afaecc735fbee$export$74da2cba014bdc09(setters, buffers) {
    for(const name in buffers){
        const setter = setters[name];
        if (setter) setter(buffers[name]);
    }
}
/**
 * Sets attributes and buffers including the `ELEMENT_ARRAY_BUFFER` if appropriate
 *
 * Example:
 *
 *     const programInfo = createProgramInfo(
 *         gl, ["some-vs", "some-fs");
 *
 *     const arrays = {
 *       position: { numComponents: 3, data: [0, 0, 0, 10, 0, 0, 0, 10, 0, 10, 10, 0], },
 *       texcoord: { numComponents: 2, data: [0, 0, 0, 1, 1, 0, 1, 1],                 },
 *     };
 *
 *     const bufferInfo = createBufferInfoFromArrays(gl, arrays);
 *
 *     gl.useProgram(programInfo.program);
 *
 * This will automatically bind the buffers AND set the
 * attributes.
 *
 *     setBuffersAndAttributes(gl, programInfo, bufferInfo);
 *
 * For the example above it is equivalent to
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
 *     gl.enableVertexAttribArray(a_positionLocation);
 *     gl.vertexAttribPointer(a_positionLocation, 3, gl.FLOAT, false, 0, 0);
 *     gl.bindBuffer(gl.ARRAY_BUFFER, texcoordBuffer);
 *     gl.enableVertexAttribArray(a_texcoordLocation);
 *     gl.vertexAttribPointer(a_texcoordLocation, 4, gl.FLOAT, false, 0, 0);
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext.
 * @param {(module:twgl.ProgramInfo|Object.<string, function>)} setters A `ProgramInfo` as returned from {@link module:twgl.createProgramInfo} or Attribute setters as returned from {@link module:twgl.createAttributeSetters}
 * @param {(module:twgl.BufferInfo|module:twgl.VertexArrayInfo)} buffers a `BufferInfo` as returned from {@link module:twgl.createBufferInfoFromArrays}.
 *   or a `VertexArrayInfo` as returned from {@link module:twgl.createVertexArrayInfo}
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$186607e23079b9e5(gl, programInfo, buffers) {
    if (buffers.vertexArrayObject) gl.bindVertexArray(buffers.vertexArrayObject);
    else {
        $065afaecc735fbee$export$74da2cba014bdc09(programInfo.attribSetters || programInfo, buffers.attribs);
        if (buffers.indices) gl.bindBuffer($065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER$1, buffers.indices);
    }
}
/**
 * @typedef {Object} ProgramInfo
 * @property {WebGLProgram} program A shader program
 * @property {Object<string, function>} uniformSetters object of setters as returned from createUniformSetters,
 * @property {Object<string, function>} attribSetters object of setters as returned from createAttribSetters,
 * @property {module:twgl.UniformBlockSpec} [uniformBlockSpec] a uniform block spec for making UniformBlockInfos with createUniformBlockInfo etc..
 * @property {Object<string, module:twgl.TransformFeedbackInfo>} [transformFeedbackInfo] info for transform feedbacks
 * @memberOf module:twgl
 */ /**
 * Creates a ProgramInfo from an existing program.
 *
 * A ProgramInfo contains
 *
 *     programInfo = {
 *        program: WebGLProgram,
 *        uniformSetters: object of setters as returned from createUniformSetters,
 *        attribSetters: object of setters as returned from createAttribSetters,
 *     }
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {WebGLProgram} program an existing WebGLProgram.
 * @return {module:twgl.ProgramInfo} The created ProgramInfo.
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$9d683a1d425bd0b2(gl, program) {
    const uniformSetters = $065afaecc735fbee$export$fe2460765a628597(gl, program);
    const attribSetters = $065afaecc735fbee$export$ca2da2c8098eca9b(gl, program);
    const programInfo = {
        program: program,
        uniformSetters: uniformSetters,
        attribSetters: attribSetters
    };
    if ($065afaecc735fbee$export$e3518b1ac7891039(gl)) {
        programInfo.uniformBlockSpec = $065afaecc735fbee$export$7b680ab060795ae5(gl, program);
        programInfo.transformFeedbackInfo = $065afaecc735fbee$export$ca1b1131a9f3199c(gl, program);
    }
    return programInfo;
}
const $065afaecc735fbee$var$notIdRE = /\s|{|}|;/;
/**
 * Creates a ProgramInfo from 2 sources.
 *
 * A ProgramInfo contains
 *
 *     programInfo = {
 *        program: WebGLProgram,
 *        uniformSetters: object of setters as returned from createUniformSetters,
 *        attribSetters: object of setters as returned from createAttribSetters,
 *     }
 *
 * NOTE: There are 4 signatures for this function
 *
 *     twgl.createProgramInfo(gl, [vs, fs], options);
 *     twgl.createProgramInfo(gl, [vs, fs], opt_errFunc);
 *     twgl.createProgramInfo(gl, [vs, fs], opt_attribs, opt_errFunc);
 *     twgl.createProgramInfo(gl, [vs, fs], opt_attribs, opt_locations, opt_errFunc);
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {string[]} shaderSources Array of sources for the
 *        shaders or ids. The first is assumed to be the vertex shader,
 *        the second the fragment shader.
 * @param {module:twgl.ProgramOptions|string[]|module:twgl.ErrorCallback} [opt_attribs] Options for the program or an array of attribs names or an error callback. Locations will be assigned by index if not passed in
 * @param {number[]|module:twgl.ErrorCallback} [opt_locations] The locations for the. A parallel array to opt_attribs letting you assign locations or an error callback.
 * @param {module:twgl.ErrorCallback} [opt_errorCallback] callback for errors. By default it just prints an error to the console
 *        on error. If you want something else pass an callback. It's passed an error message.
 * @return {module:twgl.ProgramInfo?} The created ProgramInfo or null if it failed to link or compile
 * @memberOf module:twgl/programs
 */ function $065afaecc735fbee$export$2965a73560492a94(gl, shaderSources, opt_attribs, opt_locations, opt_errorCallback) {
    const progOptions = $065afaecc735fbee$var$getProgramOptions(opt_attribs, opt_locations, opt_errorCallback);
    const errors = [];
    shaderSources = shaderSources.map(function(source) {
        // Lets assume if there is no \n it's an id
        if (!$065afaecc735fbee$var$notIdRE.test(source)) {
            const script = $065afaecc735fbee$var$getElementById(source);
            if (!script) {
                const err = `no element with id: ${source}`;
                progOptions.errorCallback(err);
                errors.push(err);
            } else source = script.text;
        }
        return source;
    });
    if (errors.length) return $065afaecc735fbee$var$reportError(progOptions, '');
    const origCallback = progOptions.callback;
    if (origCallback) progOptions.callback = (err, program)=>{
        origCallback(err, err ? undefined : $065afaecc735fbee$export$9d683a1d425bd0b2(gl, program));
    };
    const program = $065afaecc735fbee$export$87c7c742dccfe3af(gl, shaderSources, progOptions);
    if (!program) return null;
    return $065afaecc735fbee$export$9d683a1d425bd0b2(gl, program);
}
function $065afaecc735fbee$var$checkAllPrograms(gl, programs, programSpecs, noDeleteShadersSet, programOptions) {
    // check errors for everything.
    for (const [name, program] of Object.entries(programs)){
        const options = {
            ...programOptions
        };
        const spec = programSpecs[name];
        if (!Array.isArray(spec)) Object.assign(options, spec);
        const errors = $065afaecc735fbee$var$getProgramErrors(gl, program, options.errorCallback);
        if (errors) {
            // delete everything we created
            for (const program of Object.values(programs)){
                const shaders = gl.getAttachedShaders(program);
                gl.deleteProgram(program);
                for (const shader of shaders)// Don't delete it if we didn't create it.
                if (!noDeleteShadersSet.has(shader)) gl.deleteShader(shader);
            }
            return errors;
        }
    }
    return undefined;
}
/**
 * Creates multiple programs
 *
 * Note: the reason this function exists is because the fastest way to create multiple
 * programs in WebGL is to create and compile all shaders and link all programs and only
 * afterwards check if they succeeded. In that way, giving all your shaders
 *
 * @see {@link module:twgl.createProgram}
 *
 * Example:
 *
 *     const programs = twgl.createPrograms(gl, {
 *       lambert: [lambertVS, lambertFS],
 *       phong: [phongVS, phoneFS],
 *       particles: {
 *         shaders: [particlesVS, particlesFS],
 *         transformFeedbackVaryings: ['position', 'velocity'],
 *       },
 *     });
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string, module:twgl.ProgramSpec>} programSpecs An object of ProgramSpecs, one per program.
 * @param {module:twgl.ProgramOptions} [programOptions] options to apply to all programs
 * @return {Object.<string, WebGLProgram>?} the created programInfos by name
 */ function $065afaecc735fbee$export$b61153735437f1bf(gl, programSpecs, programOptions = {}) {
    // Remember existing shaders so that if there is an error we don't delete them
    const noDeleteShadersSet = new Set();
    // compile and link everything
    const programs = Object.fromEntries(Object.entries(programSpecs).map(([name, spec])=>{
        const options = {
            ...programOptions
        };
        const shaders = Array.isArray(spec) ? spec : spec.shaders;
        if (!Array.isArray(spec)) Object.assign(options, spec);
        shaders.forEach(noDeleteShadersSet.add, noDeleteShadersSet);
        return [
            name,
            $065afaecc735fbee$var$createProgramNoCheck(gl, shaders, options)
        ];
    }));
    if (programOptions.callback) {
        $065afaecc735fbee$var$waitForAllProgramsLinkCompletionAsync(gl, programs).then(()=>{
            const errors = $065afaecc735fbee$var$checkAllPrograms(gl, programs, programSpecs, noDeleteShadersSet, programOptions);
            programOptions.callback(errors, errors ? undefined : programs);
        });
        return undefined;
    }
    const errors = $065afaecc735fbee$var$checkAllPrograms(gl, programs, programSpecs, noDeleteShadersSet, programOptions);
    return errors ? undefined : programs;
}
/**
 * Creates multiple programInfos
 *
 * Note: the reason this function exists is because the fastest way to create multiple
 * programs in WebGL is to create and compile all shaders and link all programs and only
 * afterwards check if they succeeded. In that way, giving all your shaders
 *
 * @see {@link module:twgl.createProgramInfo}
 *
 * Examples:
 *
 *     const programInfos = twgl.createProgramInfos(gl, {
 *       lambert: [lambertVS, lambertFS],
 *       phong: [phongVS, phoneFS],
 *       particles: {
 *         shaders: [particlesVS, particlesFS],
 *         transformFeedbackVaryings: ['position', 'velocity'],
 *       },
 *     });
 *
 * or
 *
 *     const {lambert, phong, particles} = twgl.createProgramInfos(gl, {
 *       lambert: [lambertVS, lambertFS],
 *       phong: [phongVS, phoneFS],
 *       particles: {
 *         shaders: [particlesVS, particlesFS],
 *         transformFeedbackVaryings: ['position', 'velocity'],
 *       },
 *     });
 *
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string, module:twgl.ProgramSpec>} programSpecs An object of ProgramSpecs, one per program.
 * @param {module:twgl.ProgramOptions} [programOptions] options to apply to all programs
 * @return {Object.<string, module:twgl.ProgramInfo>?} the created programInfos by name
 */ function $065afaecc735fbee$export$fa533ee18d55b1e0(gl, programSpecs, programOptions) {
    programOptions = $065afaecc735fbee$var$getProgramOptions(programOptions);
    function createProgramInfosForPrograms(gl, programs) {
        return Object.fromEntries(Object.entries(programs).map(([name, program])=>[
                name,
                $065afaecc735fbee$export$9d683a1d425bd0b2(gl, program)
            ]));
    }
    const origCallback = programOptions.callback;
    if (origCallback) programOptions.callback = (err, programs)=>{
        origCallback(err, err ? undefined : createProgramInfosForPrograms(gl, programs));
    };
    const programs = $065afaecc735fbee$export$b61153735437f1bf(gl, programSpecs, programOptions);
    if (origCallback || !programs) return undefined;
    return createProgramInfosForPrograms(gl, programs);
}
/**
 * Creates multiple programs asynchronously
 *
 * @see {@link module:twgl.createProgramAsync}
 *
 * Example:
 *
 *     const programs = await twgl.createProgramsAsync(gl, {
 *       lambert: [lambertVS, lambertFS],
 *       phong: [phongVS, phoneFS],
 *       particles: {
 *         shaders: [particlesVS, particlesFS],
 *         transformFeedbackVaryings: ['position', 'velocity'],
 *       },
 *     });
 *
 * @function
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string, module:twgl.ProgramSpec>} programSpecs An object of ProgramSpecs, one per program.
 * @param {module:twgl.ProgramOptions} [programOptions] options to apply to all programs
 * @return {Object.<string, WebGLProgram>?} the created programInfos by name
 */ const $065afaecc735fbee$export$8df956c7665f4f14 = $065afaecc735fbee$var$wrapCallbackFnToAsyncFn($065afaecc735fbee$export$b61153735437f1bf);
/**
 * Creates multiple programInfos asynchronously
 *
 * @see {@link module:twgl.createProgramInfoAsync}
 *
 * Example:
 *
 *     const programInfos = await twgl.createProgramInfosAsync(gl, {
 *       lambert: [lambertVS, lambertFS],
 *       phong: [phongVS, phoneFS],
 *       particles: {
 *         shaders: [particlesVS, particlesFS],
 *         transformFeedbackVaryings: ['position', 'velocity'],
 *       },
 *     });
 *
 * @function
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {Object.<string, module:twgl.ProgramSpec>} programSpecs An object of ProgramSpecs, one per program.
 * @param {module:twgl.ProgramOptions} [programOptions] options to apply to all programs
 * @return {Promise<Object.<string, module:twgl.ProgramInfo>>} the created programInfos by name
 */ const $065afaecc735fbee$export$2219b5d2ded2be1a = $065afaecc735fbee$var$wrapCallbackFnToAsyncFn($065afaecc735fbee$export$fa533ee18d55b1e0);
var $065afaecc735fbee$export$7f4c6ae6cd2bdde3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createAttributeSetters: $065afaecc735fbee$export$ca2da2c8098eca9b,
    createProgram: $065afaecc735fbee$export$327d24a04cd0dc17,
    createProgramAsync: $065afaecc735fbee$export$e84ea60b2a93dff2,
    createPrograms: $065afaecc735fbee$export$b61153735437f1bf,
    createProgramsAsync: $065afaecc735fbee$export$8df956c7665f4f14,
    createProgramFromScripts: $065afaecc735fbee$export$3699dca825c3297f,
    createProgramFromSources: $065afaecc735fbee$export$87c7c742dccfe3af,
    createProgramInfo: $065afaecc735fbee$export$2965a73560492a94,
    createProgramInfoAsync: $065afaecc735fbee$export$515554c51de9b41c,
    createProgramInfos: $065afaecc735fbee$export$fa533ee18d55b1e0,
    createProgramInfosAsync: $065afaecc735fbee$export$2219b5d2ded2be1a,
    createProgramInfoFromProgram: $065afaecc735fbee$export$9d683a1d425bd0b2,
    createUniformSetters: $065afaecc735fbee$export$fe2460765a628597,
    createUniformBlockSpecFromProgram: $065afaecc735fbee$export$7b680ab060795ae5,
    createUniformBlockInfoFromProgram: $065afaecc735fbee$export$ba1b57ae67e32deb,
    createUniformBlockInfo: $065afaecc735fbee$export$721ed4ead8eefe0d,
    createTransformFeedback: $065afaecc735fbee$export$8ec4a27c67088db2,
    createTransformFeedbackInfo: $065afaecc735fbee$export$ca1b1131a9f3199c,
    bindTransformFeedbackInfo: $065afaecc735fbee$export$faea9f1eeaf6350d,
    setAttributes: $065afaecc735fbee$export$74da2cba014bdc09,
    setBuffersAndAttributes: $065afaecc735fbee$export$186607e23079b9e5,
    setUniforms: $065afaecc735fbee$export$1fa517b18dd66830,
    setUniformsAndBindTextures: $065afaecc735fbee$export$bdaefe8ae431fe00,
    setUniformBlock: $065afaecc735fbee$export$94b2522be353a874,
    setBlockUniforms: $065afaecc735fbee$export$1710cbff6680b0a4,
    bindUniformBlock: $065afaecc735fbee$export$6c9dd56f52711760
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ const $065afaecc735fbee$var$TRIANGLES = 0x0004;
const $065afaecc735fbee$var$UNSIGNED_SHORT = 0x1403;
/**
 * Drawing related functions
 *
 * For backward compatibility they are available at both `twgl.draw` and `twgl`
 * itself
 *
 * See {@link module:twgl} for core functions
 *
 * @module twgl/draw
 */ /**
 * Calls `gl.drawElements` or `gl.drawArrays`, whichever is appropriate
 *
 * normally you'd call `gl.drawElements` or `gl.drawArrays` yourself
 * but calling this means if you switch from indexed data to non-indexed
 * data you don't have to remember to update your draw call.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {(module:twgl.BufferInfo|module:twgl.VertexArrayInfo)} bufferInfo A BufferInfo as returned from {@link module:twgl.createBufferInfoFromArrays} or
 *   a VertexArrayInfo as returned from {@link module:twgl.createVertexArrayInfo}
 * @param {number} [type] eg (gl.TRIANGLES, gl.LINES, gl.POINTS, gl.TRIANGLE_STRIP, ...). Defaults to `gl.TRIANGLES`
 * @param {number} [count] An optional count. Defaults to bufferInfo.numElements
 * @param {number} [offset] An optional offset. Defaults to 0.
 * @param {number} [instanceCount] An optional instanceCount. if set then `drawArraysInstanced` or `drawElementsInstanced` will be called
 * @memberOf module:twgl/draw
 */ function $065afaecc735fbee$export$459017ad3380cbb9(gl, bufferInfo, type, count, offset, instanceCount) {
    type = type === undefined ? $065afaecc735fbee$var$TRIANGLES : type;
    const indices = bufferInfo.indices;
    const elementType = bufferInfo.elementType;
    const numElements = count === undefined ? bufferInfo.numElements : count;
    offset = offset === undefined ? 0 : offset;
    if (elementType || indices) {
        if (instanceCount !== undefined) gl.drawElementsInstanced(type, numElements, elementType === undefined ? $065afaecc735fbee$var$UNSIGNED_SHORT : bufferInfo.elementType, offset, instanceCount);
        else gl.drawElements(type, numElements, elementType === undefined ? $065afaecc735fbee$var$UNSIGNED_SHORT : bufferInfo.elementType, offset);
    } else if (instanceCount !== undefined) gl.drawArraysInstanced(type, offset, numElements, instanceCount);
    else gl.drawArrays(type, offset, numElements);
}
/**
 * A DrawObject is useful for putting objects in to an array and passing them to {@link module:twgl.drawObjectList}.
 *
 * You need either a `BufferInfo` or a `VertexArrayInfo`.
 *
 * @typedef {Object} DrawObject
 * @property {boolean} [active] whether or not to draw. Default = `true` (must be `false` to be not true). In other words `undefined` = `true`
 * @property {number} [type] type to draw eg. `gl.TRIANGLES`, `gl.LINES`, etc...
 * @property {module:twgl.ProgramInfo} programInfo A ProgramInfo as returned from {@link module:twgl.createProgramInfo}
 * @property {module:twgl.BufferInfo} [bufferInfo] A BufferInfo as returned from {@link module:twgl.createBufferInfoFromArrays}
 * @property {module:twgl.VertexArrayInfo} [vertexArrayInfo] A VertexArrayInfo as returned from {@link module:twgl.createVertexArrayInfo}
 * @property {Object<string, ?>} uniforms The values for the uniforms.
 *   You can pass multiple objects by putting them in an array. For example
 *
 *     var sharedUniforms = {
 *       u_fogNear: 10,
 *       u_projection: ...
 *       ...
 *     };
 *
 *     var localUniforms = {
 *       u_world: ...
 *       u_diffuseColor: ...
 *     };
 *
 *     var drawObj = {
 *       ...
 *       uniforms: [sharedUniforms, localUniforms],
 *     };
 *
 * @property {number} [offset] the offset to pass to `gl.drawArrays` or `gl.drawElements`. Defaults to 0.
 * @property {number} [count] the count to pass to `gl.drawArrays` or `gl.drawElements`. Defaults to bufferInfo.numElements.
 * @property {number} [instanceCount] the number of instances. Defaults to undefined.
 * @memberOf module:twgl
 */ /**
 * Draws a list of objects
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {DrawObject[]} objectsToDraw an array of objects to draw.
 * @memberOf module:twgl/draw
 */ function $065afaecc735fbee$export$f8c0340695b955d5(gl, objectsToDraw) {
    let lastUsedProgramInfo = null;
    let lastUsedBufferInfo = null;
    objectsToDraw.forEach(function(object) {
        if (object.active === false) return;
        const programInfo = object.programInfo;
        const bufferInfo = object.vertexArrayInfo || object.bufferInfo;
        let bindBuffers = false;
        const type = object.type === undefined ? $065afaecc735fbee$var$TRIANGLES : object.type;
        if (programInfo !== lastUsedProgramInfo) {
            lastUsedProgramInfo = programInfo;
            gl.useProgram(programInfo.program);
            // We have to rebind buffers when changing programs because we
            // only bind buffers the program uses. So if 2 programs use the same
            // bufferInfo but the 1st one uses only positions the when the
            // we switch to the 2nd one some of the attributes will not be on.
            bindBuffers = true;
        }
        // Setup all the needed attributes.
        if (bindBuffers || bufferInfo !== lastUsedBufferInfo) {
            if (lastUsedBufferInfo && lastUsedBufferInfo.vertexArrayObject && !bufferInfo.vertexArrayObject) gl.bindVertexArray(null);
            lastUsedBufferInfo = bufferInfo;
            $065afaecc735fbee$export$186607e23079b9e5(gl, programInfo, bufferInfo);
        }
        // Set the uniforms.
        $065afaecc735fbee$export$1fa517b18dd66830(programInfo, object.uniforms);
        // Draw
        $065afaecc735fbee$export$459017ad3380cbb9(gl, bufferInfo, type, object.count, object.offset, object.instanceCount);
    });
    if (lastUsedBufferInfo && lastUsedBufferInfo.vertexArrayObject) gl.bindVertexArray(null);
}
var $065afaecc735fbee$export$e529deb2bfd496dc = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    drawBufferInfo: $065afaecc735fbee$export$459017ad3380cbb9,
    drawObjectList: $065afaecc735fbee$export$f8c0340695b955d5
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ const $065afaecc735fbee$var$FRAMEBUFFER = 0x8d40;
const $065afaecc735fbee$var$RENDERBUFFER = 0x8d41;
const $065afaecc735fbee$var$TEXTURE_2D = 0x0de1;
const $065afaecc735fbee$var$UNSIGNED_BYTE = 0x1401;
/* PixelFormat */ const $065afaecc735fbee$var$DEPTH_COMPONENT = 0x1902;
const $065afaecc735fbee$var$RGBA = 0x1908;
const $065afaecc735fbee$var$DEPTH_COMPONENT24 = 0x81a6;
const $065afaecc735fbee$var$DEPTH_COMPONENT32F = 0x8cac;
const $065afaecc735fbee$var$DEPTH24_STENCIL8 = 0x88f0;
const $065afaecc735fbee$var$DEPTH32F_STENCIL8 = 0x8cad;
/* Framebuffer Object. */ const $065afaecc735fbee$var$RGBA4 = 0x8056;
const $065afaecc735fbee$var$RGB5_A1 = 0x8057;
const $065afaecc735fbee$var$RGB565 = 0x8D62;
const $065afaecc735fbee$var$DEPTH_COMPONENT16 = 0x81A5;
const $065afaecc735fbee$var$STENCIL_INDEX = 0x1901;
const $065afaecc735fbee$var$STENCIL_INDEX8 = 0x8D48;
const $065afaecc735fbee$var$DEPTH_STENCIL = 0x84F9;
const $065afaecc735fbee$var$COLOR_ATTACHMENT0 = 0x8CE0;
const $065afaecc735fbee$var$DEPTH_ATTACHMENT = 0x8D00;
const $065afaecc735fbee$var$STENCIL_ATTACHMENT = 0x8D20;
const $065afaecc735fbee$var$DEPTH_STENCIL_ATTACHMENT = 0x821A;
/* TextureWrapMode */ const $065afaecc735fbee$var$CLAMP_TO_EDGE = 0x812F;
/* TextureMagFilter */ const $065afaecc735fbee$var$LINEAR = 0x2601;
/**
 * The options for a framebuffer attachment.
 *
 * Note: For a `format` that is a texture include all the texture
 * options from {@link module:twgl.TextureOptions} for example
 * `min`, `mag`, `clamp`, etc... Note that unlike {@link module:twgl.TextureOptions}
 * `auto` defaults to `false` for attachment textures but `min` and `mag` default
 * to `gl.LINEAR` and `wrap` defaults to `CLAMP_TO_EDGE`
 *
 * @typedef {Object} AttachmentOptions
 * @property {number} [attachmentPoint] The attachment point. Defaults
 *   to `gl.COLOR_ATTACHMENT0 + ndx` unless type is a depth or stencil type
 *   then it's gl.DEPTH_ATTACHMENT or `gl.DEPTH_STENCIL_ATTACHMENT` depending
 *   on the format or attachment type.
 * @property {number} [format] The format. If one of `gl.RGBA4`,
 *   `gl.RGB565`, `gl.RGB5_A1`, `gl.DEPTH_COMPONENT16`,
 *   `gl.STENCIL_INDEX8` or `gl.DEPTH_STENCIL` then will create a
 *   renderbuffer. Otherwise will create a texture. Default = `gl.RGBA`
 * @property {number} [type] The type. Used for texture. Default = `gl.UNSIGNED_BYTE`.
 * @property {number} [target] The texture target for `gl.framebufferTexture2D`.
 *   Defaults to `gl.TEXTURE_2D`. Set to appropriate face for cube maps.
 * @property {number} [samples] The number of samples. Default = 1
 * @property {number} [level] level for `gl.framebufferTexture2D`. Defaults to 0.
 * @property {number} [layer] layer for `gl.framebufferTextureLayer`. Defaults to undefined.
 *   If set then `gl.framebufferTextureLayer` is called, if not then `gl.framebufferTexture2D`
 * @property {(WebGLRenderbuffer | WebGLTexture)} [attachment] An existing renderbuffer or texture.
 *    If provided will attach this Object. This allows you to share
 *    attachments across framebuffers.
 * @memberOf module:twgl
 * @mixes module:twgl.TextureOptions
 */ const $065afaecc735fbee$var$defaultAttachments = [
    {
        format: $065afaecc735fbee$var$RGBA,
        type: $065afaecc735fbee$var$UNSIGNED_BYTE,
        min: $065afaecc735fbee$var$LINEAR,
        wrap: $065afaecc735fbee$var$CLAMP_TO_EDGE
    },
    {
        format: $065afaecc735fbee$var$DEPTH_STENCIL
    }
];
const $065afaecc735fbee$var$attachmentsByFormat = {};
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH_STENCIL] = $065afaecc735fbee$var$DEPTH_STENCIL_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$STENCIL_INDEX] = $065afaecc735fbee$var$STENCIL_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$STENCIL_INDEX8] = $065afaecc735fbee$var$STENCIL_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH_COMPONENT] = $065afaecc735fbee$var$DEPTH_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH_COMPONENT16] = $065afaecc735fbee$var$DEPTH_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH_COMPONENT24] = $065afaecc735fbee$var$DEPTH_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH_COMPONENT32F] = $065afaecc735fbee$var$DEPTH_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH24_STENCIL8] = $065afaecc735fbee$var$DEPTH_STENCIL_ATTACHMENT;
$065afaecc735fbee$var$attachmentsByFormat[$065afaecc735fbee$var$DEPTH32F_STENCIL8] = $065afaecc735fbee$var$DEPTH_STENCIL_ATTACHMENT;
function $065afaecc735fbee$var$getAttachmentPointForFormat(format, internalFormat) {
    return $065afaecc735fbee$var$attachmentsByFormat[format] || $065afaecc735fbee$var$attachmentsByFormat[internalFormat];
}
const $065afaecc735fbee$var$renderbufferFormats = {};
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$RGBA4] = true;
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$RGB5_A1] = true;
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$RGB565] = true;
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$DEPTH_STENCIL] = true;
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$DEPTH_COMPONENT16] = true;
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$STENCIL_INDEX] = true;
$065afaecc735fbee$var$renderbufferFormats[$065afaecc735fbee$var$STENCIL_INDEX8] = true;
function $065afaecc735fbee$var$isRenderbufferFormat(format) {
    return $065afaecc735fbee$var$renderbufferFormats[format];
}
const $065afaecc735fbee$var$MAX_COLOR_ATTACHMENT_POINTS = 32; // even an 3090 only supports 8 but WebGL/OpenGL ES define constants for 32
function $065afaecc735fbee$var$isColorAttachmentPoint(attachmentPoint) {
    return attachmentPoint >= $065afaecc735fbee$var$COLOR_ATTACHMENT0 && attachmentPoint < $065afaecc735fbee$var$COLOR_ATTACHMENT0 + $065afaecc735fbee$var$MAX_COLOR_ATTACHMENT_POINTS;
}
/**
 * @typedef {Object} FramebufferInfo
 * @property {WebGLFramebuffer} framebuffer The WebGLFramebuffer for this framebufferInfo
 * @property {Array.<(WebGLRenderbuffer | WebGLTexture)>} attachments The created attachments in the same order as passed in to {@link module:twgl.createFramebufferInfo}.
 * @property {number} width The width of the framebuffer and its attachments
 * @property {number} height The width of the framebuffer and its attachments
 * @memberOf module:twgl
 */ /**
 * Creates a framebuffer and attachments.
 *
 * This returns a {@link module:twgl.FramebufferInfo} because it needs to return the attachments as well as the framebuffer.
 * It also leaves the framebuffer it just created as the currently bound `FRAMEBUFFER`.
 * Note: If this is WebGL2 or if you called {@link module:twgl.addExtensionsToContext} then it will set the drawBuffers
 * to `[COLOR_ATTACHMENT0, COLOR_ATTACHMENT1, ...]` for how ever many color attachments were created.
 *
 * The simplest usage
 *
 *     // create an RGBA/UNSIGNED_BYTE texture and DEPTH_STENCIL renderbuffer
 *     const fbi = twgl.createFramebufferInfo(gl);
 *
 * More complex usage
 *
 *     // create an RGB565 renderbuffer and a STENCIL_INDEX8 renderbuffer
 *     const attachments = [
 *       { format: RGB565, mag: NEAREST },
 *       { format: STENCIL_INDEX8 },
 *     ]
 *     const fbi = twgl.createFramebufferInfo(gl, attachments);
 *
 * Passing in a specific size
 *
 *     const width = 256;
 *     const height = 256;
 *     const fbi = twgl.createFramebufferInfo(gl, attachments, width, height);
 *
 * **Note!!** It is up to you to check if the framebuffer is renderable by calling `gl.checkFramebufferStatus`.
 * [WebGL1 only guarantees 3 combinations of attachments work](https://www.khronos.org/registry/webgl/specs/latest/1.0/#6.6).
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.AttachmentOptions[]} [attachments] which attachments to create. If not provided the default is a framebuffer with an
 *    `RGBA`, `UNSIGNED_BYTE` texture `COLOR_ATTACHMENT0` and a `DEPTH_STENCIL` renderbuffer `DEPTH_STENCIL_ATTACHMENT`.
 * @param {number} [width] the width for the attachments. Default = size of drawingBuffer
 * @param {number} [height] the height for the attachments. Default = size of drawingBuffer
 * @return {module:twgl.FramebufferInfo} the framebuffer and attachments.
 * @memberOf module:twgl/framebuffers
 */ function $065afaecc735fbee$export$5203e5b1731cd791(gl, attachments, width, height) {
    const target = $065afaecc735fbee$var$FRAMEBUFFER;
    const fb = gl.createFramebuffer();
    gl.bindFramebuffer(target, fb);
    width = width || gl.drawingBufferWidth;
    height = height || gl.drawingBufferHeight;
    attachments = attachments || $065afaecc735fbee$var$defaultAttachments;
    const usedColorAttachmentsPoints = [];
    const framebufferInfo = {
        framebuffer: fb,
        attachments: [],
        width: width,
        height: height
    };
    attachments.forEach(function(attachmentOptions, i) {
        let attachment = attachmentOptions.attachment;
        const samples = attachmentOptions.samples;
        const format = attachmentOptions.format;
        let attachmentPoint = attachmentOptions.attachmentPoint || $065afaecc735fbee$var$getAttachmentPointForFormat(format, attachmentOptions.internalFormat);
        if (!attachmentPoint) attachmentPoint = $065afaecc735fbee$var$COLOR_ATTACHMENT0 + i;
        if ($065afaecc735fbee$var$isColorAttachmentPoint(attachmentPoint)) usedColorAttachmentsPoints.push(attachmentPoint);
        if (!attachment) {
            if (samples !== undefined || $065afaecc735fbee$var$isRenderbufferFormat(format)) {
                attachment = gl.createRenderbuffer();
                gl.bindRenderbuffer($065afaecc735fbee$var$RENDERBUFFER, attachment);
                if (samples > 1) gl.renderbufferStorageMultisample($065afaecc735fbee$var$RENDERBUFFER, samples, format, width, height);
                else gl.renderbufferStorage($065afaecc735fbee$var$RENDERBUFFER, format, width, height);
            } else {
                const textureOptions = Object.assign({}, attachmentOptions);
                textureOptions.width = width;
                textureOptions.height = height;
                if (textureOptions.auto === undefined) {
                    textureOptions.auto = false;
                    textureOptions.min = textureOptions.min || textureOptions.minMag || $065afaecc735fbee$var$LINEAR;
                    textureOptions.mag = textureOptions.mag || textureOptions.minMag || $065afaecc735fbee$var$LINEAR;
                    textureOptions.wrapS = textureOptions.wrapS || textureOptions.wrap || $065afaecc735fbee$var$CLAMP_TO_EDGE;
                    textureOptions.wrapT = textureOptions.wrapT || textureOptions.wrap || $065afaecc735fbee$var$CLAMP_TO_EDGE;
                }
                attachment = $065afaecc735fbee$export$37b981a8c575f415(gl, textureOptions);
            }
        }
        if ($065afaecc735fbee$var$isRenderbuffer(gl, attachment)) gl.framebufferRenderbuffer(target, attachmentPoint, $065afaecc735fbee$var$RENDERBUFFER, attachment);
        else if ($065afaecc735fbee$var$isTexture(gl, attachment)) {
            if (attachmentOptions.layer !== undefined) gl.framebufferTextureLayer(target, attachmentPoint, attachment, attachmentOptions.level || 0, attachmentOptions.layer);
            else gl.framebufferTexture2D(target, attachmentPoint, attachmentOptions.target || $065afaecc735fbee$var$TEXTURE_2D, attachment, attachmentOptions.level || 0);
        } else throw new Error('unknown attachment type');
        framebufferInfo.attachments.push(attachment);
    });
    if (gl.drawBuffers) gl.drawBuffers(usedColorAttachmentsPoints);
    return framebufferInfo;
}
/**
 * Resizes the attachments of a framebuffer.
 *
 * You need to pass in the same `attachments` as you passed in {@link module:twgl.createFramebufferInfo}
 * because TWGL has no idea the format/type of each attachment.
 *
 * The simplest usage
 *
 *     // create an RGBA/UNSIGNED_BYTE texture and DEPTH_STENCIL renderbuffer
 *     const fbi = twgl.createFramebufferInfo(gl);
 *
 *     ...
 *
 *     function render() {
 *       if (twgl.resizeCanvasToDisplaySize(gl.canvas)) {
 *         // resize the attachments
 *         twgl.resizeFramebufferInfo(gl, fbi);
 *       }
 *
 * More complex usage
 *
 *     // create an RGB565 renderbuffer and a STENCIL_INDEX8 renderbuffer
 *     const attachments = [
 *       { format: RGB565, mag: NEAREST },
 *       { format: STENCIL_INDEX8 },
 *     ]
 *     const fbi = twgl.createFramebufferInfo(gl, attachments);
 *
 *     ...
 *
 *     function render() {
 *       if (twgl.resizeCanvasToDisplaySize(gl.canvas)) {
 *         // resize the attachments to match
 *         twgl.resizeFramebufferInfo(gl, fbi, attachments);
 *       }
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.FramebufferInfo} framebufferInfo a framebufferInfo as returned from {@link module:twgl.createFramebufferInfo}.
 * @param {module:twgl.AttachmentOptions[]} [attachments] the same attachments options as passed to {@link module:twgl.createFramebufferInfo}.
 * @param {number} [width] the width for the attachments. Default = size of drawingBuffer
 * @param {number} [height] the height for the attachments. Default = size of drawingBuffer
 * @memberOf module:twgl/framebuffers
 */ function $065afaecc735fbee$export$b8e6d43e27659aba(gl, framebufferInfo, attachments, width, height) {
    width = width || gl.drawingBufferWidth;
    height = height || gl.drawingBufferHeight;
    framebufferInfo.width = width;
    framebufferInfo.height = height;
    attachments = attachments || $065afaecc735fbee$var$defaultAttachments;
    attachments.forEach(function(attachmentOptions, ndx) {
        const attachment = framebufferInfo.attachments[ndx];
        const format = attachmentOptions.format;
        const samples = attachmentOptions.samples;
        if (samples !== undefined || $065afaecc735fbee$var$isRenderbuffer(gl, attachment)) {
            gl.bindRenderbuffer($065afaecc735fbee$var$RENDERBUFFER, attachment);
            if (samples > 1) gl.renderbufferStorageMultisample($065afaecc735fbee$var$RENDERBUFFER, samples, format, width, height);
            else gl.renderbufferStorage($065afaecc735fbee$var$RENDERBUFFER, format, width, height);
        } else if ($065afaecc735fbee$var$isTexture(gl, attachment)) $065afaecc735fbee$export$1d581f00cfe12937(gl, attachment, attachmentOptions, width, height);
        else throw new Error('unknown attachment type');
    });
}
/**
 * Binds a framebuffer
 *
 * This function pretty much solely exists because I spent hours
 * trying to figure out why something I wrote wasn't working only
 * to realize I forget to set the viewport dimensions.
 * My hope is this function will fix that.
 *
 * It is effectively the same as
 *
 *     gl.bindFramebuffer(gl.FRAMEBUFFER, someFramebufferInfo.framebuffer);
 *     gl.viewport(0, 0, someFramebufferInfo.width, someFramebufferInfo.height);
 *
 * @param {WebGLRenderingContext} gl the WebGLRenderingContext
 * @param {module:twgl.FramebufferInfo|null} [framebufferInfo] a framebufferInfo as returned from {@link module:twgl.createFramebufferInfo}.
 *   If falsy will bind the canvas.
 * @param {number} [target] The target. If not passed `gl.FRAMEBUFFER` will be used.
 * @memberOf module:twgl/framebuffers
 */ function $065afaecc735fbee$export$3352f23a6b33f086(gl, framebufferInfo, target) {
    target = target || $065afaecc735fbee$var$FRAMEBUFFER;
    if (framebufferInfo) {
        gl.bindFramebuffer(target, framebufferInfo.framebuffer);
        gl.viewport(0, 0, framebufferInfo.width, framebufferInfo.height);
    } else {
        gl.bindFramebuffer(target, null);
        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    }
}
var $065afaecc735fbee$export$25544aea78b18f9b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    bindFramebufferInfo: $065afaecc735fbee$export$3352f23a6b33f086,
    createFramebufferInfo: $065afaecc735fbee$export$5203e5b1731cd791,
    resizeFramebufferInfo: $065afaecc735fbee$export$b8e6d43e27659aba
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ /**
 * vertex array object related functions
 *
 * You should generally not need to use these functions. They are provided
 * for those cases where you're doing something out of the ordinary
 * and you need lower level access.
 *
 * For backward compatibility they are available at both `twgl.attributes` and `twgl`
 * itself
 *
 * See {@link module:twgl} for core functions
 *
 * @module twgl/vertexArrays
 */ const $065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER = 0x8893;
/**
 * @typedef {Object} VertexArrayInfo
 * @property {number} numElements The number of elements to pass to `gl.drawArrays` or `gl.drawElements`.
 * @property {number} [elementType] The type of indices `UNSIGNED_BYTE`, `UNSIGNED_SHORT` etc..
 * @property {WebGLVertexArrayObject} [vertexArrayObject] a vertex array object
 * @memberOf module:twgl
 */ /**
 * Creates a VertexArrayInfo from a BufferInfo and one or more ProgramInfos
 *
 * This can be passed to {@link module:twgl.setBuffersAndAttributes} and to
 * {@link module:twgl:drawBufferInfo}.
 *
 * > **IMPORTANT:** Vertex Array Objects are **not** a direct analog for a BufferInfo. Vertex Array Objects
 *   assign buffers to specific attributes at creation time. That means they can only be used with programs
 *   who's attributes use the same attribute locations for the same purposes.
 *
 * > Bind your attribute locations by passing an array of attribute names to {@link module:twgl.createProgramInfo}
 *   or use WebGL 2's GLSL ES 3's `layout(location = <num>)` to make sure locations match.
 *
 * also
 *
 * > **IMPORTANT:** After calling twgl.setBuffersAndAttribute with a BufferInfo that uses a Vertex Array Object
 *   that Vertex Array Object will be bound. That means **ANY MANIPULATION OF ELEMENT_ARRAY_BUFFER or ATTRIBUTES**
 *   will affect the Vertex Array Object state.
 *
 * > Call `gl.bindVertexArray(null)` to get back manipulating the global attributes and ELEMENT_ARRAY_BUFFER.
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @param {module:twgl.ProgramInfo|module:twgl.ProgramInfo[]} programInfo a programInfo or array of programInfos
 * @param {module:twgl.BufferInfo} bufferInfo BufferInfo as returned from createBufferInfoFromArrays etc...
 *
 *    You need to make sure every attribute that will be used is bound. So for example assume shader 1
 *    uses attributes A, B, C and shader 2 uses attributes A, B, D. If you only pass in the programInfo
 *    for shader 1 then only attributes A, B, and C will have their attributes set because TWGL doesn't
 *    now attribute D's location.
 *
 *    So, you can pass in both shader 1 and shader 2's programInfo
 *
 * @return {module:twgl.VertexArrayInfo} The created VertexArrayInfo
 *
 * @memberOf module:twgl/vertexArrays
 */ function $065afaecc735fbee$export$3a550f69329a008c(gl, programInfos, bufferInfo) {
    const vao = gl.createVertexArray();
    gl.bindVertexArray(vao);
    if (!programInfos.length) programInfos = [
        programInfos
    ];
    programInfos.forEach(function(programInfo) {
        $065afaecc735fbee$export$186607e23079b9e5(gl, programInfo, bufferInfo);
    });
    gl.bindVertexArray(null);
    return {
        numElements: bufferInfo.numElements,
        elementType: bufferInfo.elementType,
        vertexArrayObject: vao
    };
}
/**
 * Creates a vertex array object and then sets the attributes on it
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext to use.
 * @param {Object.<string, function>} setters Attribute setters as returned from createAttributeSetters
 * @param {Object.<string, module:twgl.AttribInfo>} attribs AttribInfos mapped by attribute name.
 * @param {WebGLBuffer} [indices] an optional ELEMENT_ARRAY_BUFFER of indices
 *
 * @return {WebGLVertexArrayObject|null} The created WebGLVertexArrayObject
 *
 * @memberOf module:twgl/vertexArrays
 */ function $065afaecc735fbee$export$60495ce92af393ea(gl, setters, attribs, indices) {
    const vao = gl.createVertexArray();
    gl.bindVertexArray(vao);
    $065afaecc735fbee$export$74da2cba014bdc09(setters, attribs);
    if (indices) gl.bindBuffer($065afaecc735fbee$var$ELEMENT_ARRAY_BUFFER, indices);
    // We unbind this because otherwise any change to ELEMENT_ARRAY_BUFFER
    // like when creating buffers for other stuff will mess up this VAO's binding
    gl.bindVertexArray(null);
    return vao;
}
/**
 * Creates a vertex array object and then sets the attributes
 * on it
 *
 * @param {WebGLRenderingContext} gl The WebGLRenderingContext
 *        to use.
 * @param {Object.<string, function>| module:twgl.ProgramInfo} programInfo as returned from createProgramInfo or Attribute setters as returned from createAttributeSetters
 * @param {module:twgl.BufferInfo} bufferInfo BufferInfo as returned from createBufferInfoFromArrays etc...
 * @param {WebGLBuffer} [indices] an optional ELEMENT_ARRAY_BUFFER of indices
 *
 * @return {WebGLVertexArrayObject|null} The created WebGLVertexArrayObject
 *
 * @memberOf module:twgl/vertexArrays
 */ function $065afaecc735fbee$export$69584a051cfb6414(gl, programInfo, bufferInfo) {
    return $065afaecc735fbee$export$60495ce92af393ea(gl, programInfo.attribSetters || programInfo, bufferInfo.attribs, bufferInfo.indices);
}
var $065afaecc735fbee$export$a4f7286ae77261a4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createVertexArrayInfo: $065afaecc735fbee$export$3a550f69329a008c,
    createVAOAndSetAttributes: $065afaecc735fbee$export$60495ce92af393ea,
    createVAOFromBufferInfo: $065afaecc735fbee$export$69584a051cfb6414
});
/*
 * Copyright 2019 Gregg Tavares
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ const $065afaecc735fbee$var$defaults = {
    addExtensionsToContext: true
};
/**
 * Various default settings for twgl.
 *
 * Note: You can call this any number of times. Example:
 *
 *     twgl.setDefaults({ textureColor: [1, 0, 0, 1] });
 *     twgl.setDefaults({ attribPrefix: 'a_' });
 *
 * is equivalent to
 *
 *     twgl.setDefaults({
 *       textureColor: [1, 0, 0, 1],
 *       attribPrefix: 'a_',
 *     });
 *
 * @typedef {Object} Defaults
 * @property {string} [attribPrefix] The prefix to stick on attributes
 *
 *   When writing shaders I prefer to name attributes with `a_`, uniforms with `u_` and varyings with `v_`
 *   as it makes it clear where they came from. But, when building geometry I prefer using un-prefixed names.
 *
 *   In other words I'll create arrays of geometry like this
 *
 *       const arrays = {
 *         position: ...
 *         normal: ...
 *         texcoord: ...
 *       };
 *
 *   But need those mapped to attributes and my attributes start with `a_`.
 *
 *   Default: `""`
 *
 * @property {number[]} [textureColor] Array of 4 values in the range 0 to 1
 *
 *   The default texture color is used when loading textures from
 *   urls. Because the URL will be loaded async we'd like to be
 *   able to use the texture immediately. By putting a 1x1 pixel
 *   color in the texture we can start using the texture before
 *   the URL has loaded.
 *
 *   Default: `[0.5, 0.75, 1, 1]`
 *
 * @property {string} [crossOrigin]
 *
 *   If not undefined sets the crossOrigin attribute on images
 *   that twgl creates when downloading images for textures.
 *
 *   Also see {@link module:twgl.TextureOptions}.
 *
 * @property {bool} [addExtensionsToContext]
 *
 *   If true, then, when twgl will try to add any supported WebGL extensions
 *   directly to the context under their normal GL names. For example
 *   if ANGLE_instances_arrays exists then twgl would enable it,
 *   add the functions `vertexAttribDivisor`, `drawArraysInstanced`,
 *   `drawElementsInstanced`, and the constant `VERTEX_ATTRIB_ARRAY_DIVISOR`
 *   to the `WebGLRenderingContext`.
 *
 * @memberOf module:twgl
 */ /**
 * Sets various defaults for twgl.
 *
 * In the interest of terseness which is kind of the point
 * of twgl I've integrated a few of the older functions here
 *
 * @param {module:twgl.Defaults} newDefaults The default settings.
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$2e2366488d12e20d(newDefaults) {
    $065afaecc735fbee$var$copyExistingProperties(newDefaults, $065afaecc735fbee$var$defaults);
    $065afaecc735fbee$export$81400a733c5c400b(newDefaults); // eslint-disable-line
    $065afaecc735fbee$export$13a00e79c3b46a21(newDefaults); // eslint-disable-line
}
const $065afaecc735fbee$var$prefixRE = /^(.*?)_/;
function $065afaecc735fbee$var$addExtensionToContext(gl, extensionName) {
    $065afaecc735fbee$export$e97753eae63e4e62(gl, 0);
    const ext = gl.getExtension(extensionName);
    if (ext) {
        const enums = {};
        const fnSuffix = $065afaecc735fbee$var$prefixRE.exec(extensionName)[1];
        const enumSuffix = '_' + fnSuffix;
        for(const key in ext){
            const value = ext[key];
            const isFunc = typeof value === 'function';
            const suffix = isFunc ? fnSuffix : enumSuffix;
            let name = key;
            // examples of where this is not true are WEBGL_compressed_texture_s3tc
            // and WEBGL_compressed_texture_pvrtc
            if (key.endsWith(suffix)) name = key.substring(0, key.length - suffix.length);
            if (gl[name] !== undefined) {
                if (!isFunc && gl[name] !== value) $065afaecc735fbee$var$warn$1(name, gl[name], value, key);
            } else if (isFunc) gl[name] = function(origFn) {
                return function() {
                    return origFn.apply(ext, arguments);
                };
            }(value);
            else {
                gl[name] = value;
                enums[name] = value;
            }
        }
        // pass the modified enums to glEnumToString
        enums.constructor = {
            name: ext.constructor.name
        };
        $065afaecc735fbee$export$e97753eae63e4e62(enums, 0);
    }
    return ext;
}
/*
 * If you're wondering why the code doesn't just iterate
 * over all extensions using `gl.getExtensions` is that it's possible
 * some future extension is incompatible with this code. Rather than
 * have thing suddenly break it seems better to manually add to this
 * list.
 *
 */ const $065afaecc735fbee$var$supportedExtensions = [
    'ANGLE_instanced_arrays',
    'EXT_blend_minmax',
    'EXT_color_buffer_float',
    'EXT_color_buffer_half_float',
    'EXT_disjoint_timer_query',
    'EXT_disjoint_timer_query_webgl2',
    'EXT_frag_depth',
    'EXT_sRGB',
    'EXT_shader_texture_lod',
    'EXT_texture_filter_anisotropic',
    'OES_element_index_uint',
    'OES_standard_derivatives',
    'OES_texture_float',
    'OES_texture_float_linear',
    'OES_texture_half_float',
    'OES_texture_half_float_linear',
    'OES_vertex_array_object',
    'WEBGL_color_buffer_float',
    'WEBGL_compressed_texture_atc',
    'WEBGL_compressed_texture_etc1',
    'WEBGL_compressed_texture_pvrtc',
    'WEBGL_compressed_texture_s3tc',
    'WEBGL_compressed_texture_s3tc_srgb',
    'WEBGL_depth_texture',
    'WEBGL_draw_buffers'
];
/**
 * Attempts to enable all of the following extensions
 * and add their functions and constants to the
 * `WebGLRenderingContext` using their normal non-extension like names.
 *
 *      ANGLE_instanced_arrays
 *      EXT_blend_minmax
 *      EXT_color_buffer_float
 *      EXT_color_buffer_half_float
 *      EXT_disjoint_timer_query
 *      EXT_disjoint_timer_query_webgl2
 *      EXT_frag_depth
 *      EXT_sRGB
 *      EXT_shader_texture_lod
 *      EXT_texture_filter_anisotropic
 *      OES_element_index_uint
 *      OES_standard_derivatives
 *      OES_texture_float
 *      OES_texture_float_linear
 *      OES_texture_half_float
 *      OES_texture_half_float_linear
 *      OES_vertex_array_object
 *      WEBGL_color_buffer_float
 *      WEBGL_compressed_texture_atc
 *      WEBGL_compressed_texture_etc1
 *      WEBGL_compressed_texture_pvrtc
 *      WEBGL_compressed_texture_s3tc
 *      WEBGL_compressed_texture_s3tc_srgb
 *      WEBGL_depth_texture
 *      WEBGL_draw_buffers
 *
 * For example if `ANGLE_instanced_arrays` exists then the functions
 * `drawArraysInstanced`, `drawElementsInstanced`, `vertexAttribDivisor`
 * and the constant `VERTEX_ATTRIB_ARRAY_DIVISOR` are added to the
 * `WebGLRenderingContext`.
 *
 * Note that if you want to know if the extension exists you should
 * probably call `gl.getExtension` for each extension. Alternatively
 * you can check for the existence of the functions or constants that
 * are expected to be added. For example
 *
 *    if (gl.drawBuffers) {
 *      // Either WEBGL_draw_buffers was enabled OR you're running in WebGL2
 *      ....
 *
 * @param {WebGLRenderingContext} gl A WebGLRenderingContext
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$ef86202f9bca6ee5(gl) {
    for(let ii = 0; ii < $065afaecc735fbee$var$supportedExtensions.length; ++ii)$065afaecc735fbee$var$addExtensionToContext(gl, $065afaecc735fbee$var$supportedExtensions[ii]);
}
/**
 * Creates a webgl context.
 * @param {HTMLCanvasElement} canvas The canvas tag to get
 *     context from. If one is not passed in one will be
 *     created.
 * @return {WebGLRenderingContext} The created context.
 * @private
 */ function $065afaecc735fbee$var$create3DContext(canvas, opt_attribs) {
    const names = [
        "webgl",
        "experimental-webgl"
    ];
    let context = null;
    for(let ii = 0; ii < names.length; ++ii){
        context = canvas.getContext(names[ii], opt_attribs);
        if (context) {
            if ($065afaecc735fbee$var$defaults.addExtensionsToContext) $065afaecc735fbee$export$ef86202f9bca6ee5(context);
            break;
        }
    }
    return context;
}
/**
 * Gets a WebGL1 context.
 *
 * Note: Will attempt to enable Vertex Array Objects
 * and add WebGL2 entry points. (unless you first set defaults with
 * `twgl.setDefaults({enableVertexArrayObjects: false})`;
 *
 * @param {HTMLCanvasElement} canvas a canvas element.
 * @param {WebGLContextAttributes} [opt_attribs] optional webgl context creation attributes
 * @return {WebGLRenderingContext} The created context.
 * @memberOf module:twgl
 * @deprecated
 * @private
 */ function $065afaecc735fbee$export$c7a808a518b9a146(canvas, opt_attribs) {
    const gl = $065afaecc735fbee$var$create3DContext(canvas, opt_attribs);
    return gl;
}
/**
 * Creates a webgl context.
 *
 * Will return a WebGL2 context if possible.
 *
 * You can check if it's WebGL2 with
 *
 *     twgl.isWebGL2(gl);
 *
 * @param {HTMLCanvasElement} canvas The canvas tag to get
 *     context from. If one is not passed in one will be
 *     created.
 * @return {WebGLRenderingContext} The created context.
 */ function $065afaecc735fbee$var$createContext(canvas, opt_attribs) {
    const names = [
        "webgl2",
        "webgl",
        "experimental-webgl"
    ];
    let context = null;
    for(let ii = 0; ii < names.length; ++ii){
        context = canvas.getContext(names[ii], opt_attribs);
        if (context) {
            if ($065afaecc735fbee$var$defaults.addExtensionsToContext) $065afaecc735fbee$export$ef86202f9bca6ee5(context);
            break;
        }
    }
    return context;
}
/**
 * Gets a WebGL context.  Will create a WebGL2 context if possible.
 *
 * You can check if it's WebGL2 with
 *
 *    function isWebGL2(gl) {
 *      return gl.getParameter(gl.VERSION).indexOf("WebGL 2.0 ") == 0;
 *    }
 *
 * Note: For a WebGL1 context will attempt to enable Vertex Array Objects
 * and add WebGL2 entry points. (unless you first set defaults with
 * `twgl.setDefaults({enableVertexArrayObjects: false})`;
 *
 * @param {HTMLCanvasElement} canvas a canvas element.
 * @param {WebGLContextAttributes} [opt_attribs] optional webgl context creation attributes
 * @return {WebGLRenderingContext} The created context.
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$31553aaa555c1514(canvas, opt_attribs) {
    const gl = $065afaecc735fbee$var$createContext(canvas, opt_attribs);
    return gl;
}
/**
 * Resize a canvas to match the size it's displayed.
 * @param {HTMLCanvasElement} canvas The canvas to resize.
 * @param {number} [multiplier] So you can pass in `window.devicePixelRatio` or other scale value if you want to.
 * @return {boolean} true if the canvas was resized.
 * @memberOf module:twgl
 */ function $065afaecc735fbee$export$4d986a341d0b1b6c(canvas, multiplier) {
    multiplier = multiplier || 1;
    multiplier = Math.max(0, multiplier);
    const width = canvas.clientWidth * multiplier | 0;
    const height = canvas.clientHeight * multiplier | 0;
    if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
        return true;
    }
    return false;
}


/**
 * SVT Shader
 */ const $545dedaa33bafe10$var$vert = `#version 300 es
in vec2 a_position;
in vec2 a_uv;
uniform mat3 u_matrix;
out vec2 v_uv;

void main() {
    gl_Position = vec4((u_matrix * vec3(a_position, 1.0)).xy, 0.0, 1.0);
    v_uv = a_uv;
}`;
const $545dedaa33bafe10$var$frag = `#version 300 es
precision highp float;

// uniform sampler2D u_svtCacheTexture;
uniform highp sampler2DArray u_svtCacheTexture;
uniform sampler2D u_indirectionTable;

uniform sampler2D u_fontTexture;

uniform float u_tileSize;
uniform float u_svtDepth;
uniform vec2 u_svtResolution;

// mouse hover
uniform vec2 u_mouse;
uniform vec2 u_quadSize;
uniform vec2 u_gridSize;

uniform bool u_debug;

in vec2 v_uv;
layout(location = 0) out vec4 fragColor;
layout(location = 1) out float lodValue;

float mipmapLevel(in vec2 texelCoord, in float bias) {
    vec2 dxVtc = dFdx(texelCoord);
    vec2 dyVtc = dFdy(texelCoord);
    float deltaMaxSqr = max(dot(dxVtc, dxVtc), dot(dyVtc, dyVtc));
    return 0.5 * log2(deltaMaxSqr) + bias;
}

// vec4 queryIndirectionBuffer(sampler2D indirection, vec2 texCoords, float bias) {
//     float lod = clamp(floor(mipmapLevel(texCoords * u_svtResolution, bias)), 0.0, u_svtDepth);
//     vec4 indirectionEntry = textureLod(indirection, texCoords, lod);

//     while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
//         lod += 1.0;
//         indirectionEntry = textureLod(indirection, texCoords, lod);
//     }
//     return indirectionEntry;
// }

vec4 queryIndirectionBuffer(sampler2D indirection, vec2 texCoords, float bias) {
    float lod = clamp(floor(mipmapLevel(texCoords * u_svtResolution, bias)), 0.0, u_svtDepth);
    vec4 indirectionEntry = textureLod(indirection, texCoords, lod);
    indirectionEntry.r *= 255.0;
    indirectionEntry.b *= 255.0;
    while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
        lod += 1.0;
        indirectionEntry = textureLod(indirection, texCoords, lod);
        indirectionEntry.r *= 255.0;
        indirectionEntry.b *= 255.0;
    }
    return indirectionEntry;
}

/**
 * Converts regular texture coordinates to texture coordinates in the SVT buffer texture
 * using the indirection texture.
 */
// vec2 svtTexCoords(sampler2D indirection, vec2 texCoords, float bias) {
//     float cacheSizeInTiles = float(textureSize(u_svtCacheTexture, 0).x) / u_tileSize;
//     vec4 indirectionEntry = queryIndirectionBuffer(indirection, texCoords, bias);

//     vec2 pageCoord = indirectionEntry.rg; // i, j
//     float reverseMipmapLevel = indirectionEntry.b;
//     float mipExp = exp2(reverseMipmapLevel);
//     vec2 withinPageCoord = fract(texCoords * mipExp); //* vec2(1.0, 1.0));
//     // The next line prevents bilinear filtering artifacts due to unrelated tiles being side-by-side in the cache.
//     // For each tile, we sample an area (tile_resolution - 2)^2, leaving a 1px border which should be filled with
//     // data from the adjacent tiles. However, in high resolution tiles (512, 1024, etc.), this 1 pixel is not
//     // noticeable at all if the border is not set up in the tiles.
//     withinPageCoord = (withinPageCoord * (u_tileSize - 2.0) / u_tileSize) + (1.0 / u_tileSize);
//     return (pageCoord + withinPageCoord) / cacheSizeInTiles;
// }

vec3 svtTexCoords(sampler2D indirection, vec2 texCoords, float bias) {
    vec4 indirectionEntry = queryIndirectionBuffer(indirection, texCoords, bias);
    // float layerIndex = floor(indirectionEntry.r + 0.5);
    float layerIndex = indirectionEntry.r;
    float reverseMipmapLevel = indirectionEntry.b;
    float mipExp = exp2(reverseMipmapLevel);

    // float texelSize = 1.0 / u_tileSize;
    // vec2 adjustedTexCoords = texCoords * mipExp + 0.5 * texelSize; // Offset by half texel
    // vec2 withinTileCoord = fract(adjustedTexCoords);
    // // Scale to avoid edges
    // // withinTileCoord = withinTileCoord * (1.0 - texelSize) + 0.5 * texelSize;

    // return vec3(withinTileCoord, layerIndex);

    vec2 withinTileCoord = fract(texCoords * mipExp);
    return vec3(withinTileCoord, layerIndex);
}

// vec2 svtTexCoords(sampler2D indirection, vec2 texCoords) {
//     return svtTexCoords(indirection, texCoords, 0.0);
// }

vec3 svtTexCoords(sampler2D indirection, vec2 texCoords) {
    return svtTexCoords(indirection, texCoords, 0.0);
}

void main() {    
    vec3 physicalUV = svtTexCoords(u_indirectionTable, v_uv, -0.5);

    fragColor = texture(u_svtCacheTexture, physicalUV);
    // fragColor = vec4(physicalUV.xy, physicalUV.z / float(36), 1.0);
    // fragColor = vec4(vec3(physicalUV.b / 50.0), 1.0);

    // vec4 indirectionEntry = queryIndirectionBuffer(u_indirectionTable, v_uv, 0.0);
    // float lod = clamp(floor(mipmapLevel(v_uv * u_svtResolution, 0.0)), 0.0, u_svtDepth);
    // while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
    //     lod += 1.0;
    //     indirectionEntry = textureLod(u_indirectionTable, v_uv, lod);
    // }
    // float reverseMipmapLevel = indirectionEntry.b;
    // float mipExp = exp2(reverseMipmapLevel);
    // vec2 gradX = dFdx(v_uv) * mipExp / u_tileSize;
    // vec2 gradY = dFdy(v_uv) * mipExp / u_tileSize;
    // fragColor = textureGrad(u_svtCacheTexture, physicalUV, gradX, gradY);

    // if (physicalUV.x < 0.001 ||  physicalUV.y < 0.001 ) {
    //     fragColor = vec4(0.0, 1.0, 0.0, 1.0);
    // }
    // if (physicalUV.x > 0.999 || physicalUV.y > 0.999) {
    //     fragColor = vec4(0.0, 0.0, 1.0, 1.0);
    // }

    if (u_debug) {
        vec4 indirectionEntry = queryIndirectionBuffer(u_indirectionTable, v_uv, 0.0);
        float lod = clamp(floor(mipmapLevel(v_uv * u_svtResolution, 0.0)), 0.0, u_svtDepth);
        while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
            lod += 1.0;
            indirectionEntry = textureLod(u_indirectionTable, v_uv, lod);
        }
        // float lod = clamp(floor(mipmapLevel(v_uv * u_svtResolution, 0.0)), 0.0, u_svtDepth);
        // float s = exp2(lod);
        // vec2 texelSize = vec2(1.0 / s, 1.0 / s);
        // vec2 adjustedTexCoords = v_uv - mod(v_uv, texelSize) + 0.5 * texelSize;
        // vec4 indirectionEntry = textureLod(u_indirectionTable, adjustedTexCoords, lod);

        // // Fallback to higher mipmap levels if needed
        // while (indirectionEntry.a != 1.0 && lod < u_svtDepth) {
        //     lod += 1.0;
        //     s = exp2(lod);
        //     texelSize = vec2(1.0 / s, 1.0 / s);
        //     adjustedTexCoords = v_uv - mod(v_uv, texelSize) + 0.5 * texelSize;
        //     indirectionEntry = textureLod(u_indirectionTable, adjustedTexCoords, lod);
        // }
        vec2 tileUV = fract(v_uv * exp2(indirectionEntry.b));  // local UV within the tile (0-1)

        // Render LOD text on each tile
        vec2 textSize = vec2(0.1, 0.1);
        vec2 textPos = vec2(0.5 - textSize.x / 2.0, 0.5 - textSize.y / 2.0);
        if (tileUV.x >= textPos.x && tileUV.x < textPos.x + textSize.x &&
            tileUV.y >= textPos.y && tileUV.y < textPos.y + textSize.y) {
            float charIndex = floor(u_svtDepth - lod);
            vec2 fontUV = vec2(
                (charIndex * 16.0 + (tileUV.x - textPos.x) * 16.0 / textSize.x) / 256.0,
                (tileUV.y - textPos.y) / textSize.y
            );
            vec4 textColor = texture(u_fontTexture, fontUV);
            if (textColor.a > 0.5) {
                fragColor = vec4(1.0, 1.0, 1.0, 1.0);  // White text
            }
        }
        // float level = indirectionEntry.b;
        // // Color based on LOD: red for level 0, green for 1, blue for 2
        // vec3 debugColor = vec3(0.0);
        // if (level == 0.0) debugColor.r = 1.0;
        // else if (level == 1.0) debugColor.g = 1.0;
        // else if (level == 2.0) debugColor.b = 1.0;
        // fragColor.rgb = mix(fragColor.rgb, debugColor, 0.2);

        vec2 mouseRelative = (u_mouse + u_quadSize / 2.0) / u_quadSize;
        vec2 hoveredCell = floor(mouseRelative * u_gridSize);
        vec2 cellIndex = floor(v_uv * u_gridSize);
        bool isHovered = all(equal(cellIndex, hoveredCell));
        if (isHovered) {
            fragColor.rgb = mix(fragColor.rgb, vec3(1.0, 0.0, 0.0), 0.5);
            // fragColor.rgb = vec3(1.0, 0.0, 0.0);
        }
    }
    
}`;
/**
 * Visible tile detection
 */ const $545dedaa33bafe10$var$detectFrag = `#version 300 es
precision highp float;

uniform float u_svtDepth;
uniform float u_svtDetectionScaleFactor; // = -log2(svtDetectionFactor);
uniform vec2 u_svtResolution;

in vec2 v_uv;
out vec4 fragColor;


float mipmapLevel(in vec2 texelCoord, in float bias) {
    vec2 dxVtc = dFdx(texelCoord);
    vec2 dyVtc = dFdy(texelCoord);
    float deltaMaxSqr = max(dot(dxVtc, dxVtc), dot(dyVtc, dyVtc));
    return 0.5 * log2(deltaMaxSqr) + bias;
}

void main() {
    float mip = clamp(floor(mipmapLevel(v_uv * u_svtResolution, u_svtDetectionScaleFactor)), 0.0, u_svtDepth);
    float reverseMipmapLevel = u_svtDepth - mip;
    float mipExp = exp2(reverseMipmapLevel);

    vec2 tileXY = floor(v_uv * mipExp);
    fragColor = vec4(reverseMipmapLevel, tileXY.x, tileXY.y, 1.0); // LOD, col, row, valid
}`;
/**
 * SVT Cache Debugging
 */ const $545dedaa33bafe10$var$vertDebug = `#version 300 es
in vec2 a_position;
in vec2 a_uv;

out vec2 v_uv;

void main() {
    gl_Position = vec4(a_position, 0.0, 1.0);
    v_uv = a_uv;
}`;
const $545dedaa33bafe10$var$fragDebug = `#version 300 es
precision highp float;

uniform sampler2D uAtlasTexture;
uniform vec2 uAtlasSize;
uniform vec2 uTileSize;

in vec2 v_uv;
out vec4 fragColor;

void main() {
    vec2 atlasUV = vec2(v_uv.x, 1.0 - v_uv.y);
    vec4 color = texture(uAtlasTexture, atlasUV);
    fragColor = color;
}`;
var $545dedaa33bafe10$export$2e2bcd8739ae039 = {
    vert: $545dedaa33bafe10$var$vert,
    frag: $545dedaa33bafe10$var$frag,
    detectFrag: $545dedaa33bafe10$var$detectFrag,
    vertDebug: $545dedaa33bafe10$var$vertDebug,
    fragDebug: $545dedaa33bafe10$var$fragDebug
};


class $621f3774f67738fc$export$88530751e3977073 {
    constructor(gl, quadSize, tileSize, svtDepth, svtResolution){
        this.svtDetectionFactor = 8;
        this.svtDetectionScaleFactor = -Math.log2(this.svtDetectionFactor);
        this.visibleTilesGrid = [];
        this.gl = gl;
        this.mainProgram = $065afaecc735fbee$export$2965a73560492a94(gl, [
            (0, $545dedaa33bafe10$export$2e2bcd8739ae039).vert,
            (0, $545dedaa33bafe10$export$2e2bcd8739ae039).frag
        ]);
        this.detectionProgram = $065afaecc735fbee$export$2965a73560492a94(gl, [
            (0, $545dedaa33bafe10$export$2e2bcd8739ae039).vert,
            (0, $545dedaa33bafe10$export$2e2bcd8739ae039).detectFrag
        ]);
        this.quadSize = quadSize;
        this.tileSize = tileSize;
        this.svtDepth = svtDepth;
        this.svtResolution = svtResolution;
        const halfQuadSize = quadSize / 2;
        this.quadBufferInfo = $065afaecc735fbee$export$140f5b0225138840(gl, {
            a_position: {
                numComponents: 2,
                data: [
                    -halfQuadSize,
                    -halfQuadSize,
                    halfQuadSize,
                    -halfQuadSize,
                    halfQuadSize,
                    halfQuadSize,
                    -halfQuadSize,
                    halfQuadSize
                ]
            },
            a_uv: {
                numComponents: 2,
                data: [
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]
            },
            indices: [
                0,
                1,
                2,
                0,
                2,
                3
            ]
        });
        // Visible tile detection
        this.detectionWidth = Math.floor(gl.canvas.width / this.svtDetectionFactor);
        this.detectionHeight = Math.floor(gl.canvas.height / this.svtDetectionFactor);
        this.pixels = new Float32Array(this.detectionWidth * this.detectionHeight * 4);
        this.detectionTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this.detectionTexture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA32F, this.detectionWidth, this.detectionHeight, 0, gl.RGBA, gl.FLOAT, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        this.detectionFramebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.detectionFramebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.detectionTexture, 0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        this.fontTexture = this.createFontTexture();
        for(let level = 0; level <= svtDepth; level++){
            const size = 1 << level;
            const col = [];
            for(let j = 0; j < size; j++){
                const row = new Array(size).fill(false);
                col.push(row);
            }
            this.visibleTilesGrid.push(col);
        }
    }
    detectVisibleTiles(camera) {
        const { gl: gl, quadBufferInfo: quadBufferInfo, detectionProgram: detectionProgram, detectionFramebuffer: detectionFramebuffer, detectionWidth: detectionWidth, detectionHeight: detectionHeight, svtDepth: svtDepth, svtResolution: svtResolution, pixels: pixels } = this;
        gl.bindFramebuffer(gl.FRAMEBUFFER, detectionFramebuffer);
        gl.viewport(0, 0, detectionWidth, detectionHeight);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(detectionProgram.program);
        $065afaecc735fbee$export$186607e23079b9e5(gl, detectionProgram, quadBufferInfo);
        $065afaecc735fbee$export$1fa517b18dd66830(detectionProgram, {
            u_matrix: camera.getViewProjectionMat(),
            u_svtDepth: svtDepth,
            u_svtDetectionScaleFactor: this.svtDetectionScaleFactor,
            u_svtResolution: svtResolution
        });
        $065afaecc735fbee$export$459017ad3380cbb9(gl, quadBufferInfo);
        gl.readPixels(0, 0, detectionWidth, detectionHeight, gl.RGBA, gl.FLOAT, pixels);
        const visibleTiles = new Set();
        // mark visible tiles
        for(let i = 0; i < pixels.length; i += 4){
            const level = Math.floor(pixels[i]);
            const col = Math.floor(pixels[i + 1]);
            const row = Math.floor(pixels[i + 2]);
            const valid = pixels[i + 3];
            if (valid > 0.5) this.visibleTilesGrid[level][col][row] = true;
        }
        // collect visible tiles
        for(let level = 0; level <= svtDepth; level++){
            const size = 1 << level;
            for(let col = 0; col < size; col++){
                for(let row = 0; row < size; row++)if (this.visibleTilesGrid[level][col][row]) {
                    visibleTiles.add(`level${level}/tx_${col}_${row}`);
                    this.visibleTilesGrid[level][col][row] = false;
                }
            }
        }
        return visibleTiles;
    }
    draw(camera, svtManager, debugMode, hoveredPixel) {
        const { gl: gl, mainProgram: mainProgram, quadBufferInfo: quadBufferInfo, fontTexture: fontTexture, tileSize: tileSize, svtDepth: svtDepth, svtResolution: svtResolution } = this;
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(mainProgram.program);
        $065afaecc735fbee$export$186607e23079b9e5(gl, mainProgram, quadBufferInfo);
        $065afaecc735fbee$export$1fa517b18dd66830(mainProgram, {
            u_matrix: camera.getViewProjectionMat(),
            u_svtCacheTexture: svtManager.getAtlasTexture(),
            u_indirectionTable: svtManager.getIndirectionTable(),
            u_fontTexture: fontTexture,
            u_tileSize: tileSize,
            u_svtDepth: svtDepth,
            u_svtResolution: svtResolution,
            u_cacheSize: [
                svtManager.getAtlasSize(),
                svtManager.getAtlasSize()
            ],
            u_mouse: hoveredPixel,
            u_quadSize: [
                this.quadSize,
                this.quadSize
            ],
            u_gridSize: [
                1024,
                1024
            ],
            u_debug: debugMode
        });
        $065afaecc735fbee$export$459017ad3380cbb9(gl, quadBufferInfo);
    }
    // font texture for LOD text rendering
    createFontTexture() {
        const gl = this.gl;
        const canvas = document.createElement("canvas");
        canvas.width = 256;
        canvas.height = 16;
        const ctx = canvas.getContext("2d");
        ctx.font = "16px Arial";
        ctx.fillStyle = "white";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        for(let i = 0; i < 10; i++)ctx.fillText(i.toString(), i * 16 + 8, 8);
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        return texture;
    }
}




class $216773f8dbd13adf$export$2f674e33b9ab74ba {
    constructor(debugGl, tileManager, tileSize, atlasSize){
        this.debugGl = debugGl;
        this.tileManager = tileManager;
        this.tileSize = tileSize;
        this.atlasSize = atlasSize;
        this.debugProgram = $065afaecc735fbee$export$2965a73560492a94(debugGl, [
            (0, $545dedaa33bafe10$export$2e2bcd8739ae039).vertDebug,
            (0, $545dedaa33bafe10$export$2e2bcd8739ae039).fragDebug
        ]);
        this.debugQuadBuffer = $065afaecc735fbee$export$140f5b0225138840(debugGl, {
            a_position: {
                numComponents: 2,
                data: [
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1
                ]
            },
            a_uv: {
                numComponents: 2,
                data: [
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]
            },
            indices: [
                0,
                1,
                2,
                0,
                2,
                3
            ]
        });
        this.debugAtlasTexture = debugGl.createTexture();
        debugGl.bindTexture(debugGl.TEXTURE_2D, this.debugAtlasTexture);
        debugGl.texParameteri(debugGl.TEXTURE_2D, debugGl.TEXTURE_MIN_FILTER, debugGl.LINEAR);
        debugGl.texParameteri(debugGl.TEXTURE_2D, debugGl.TEXTURE_MAG_FILTER, debugGl.LINEAR);
        debugGl.texImage2D(debugGl.TEXTURE_2D, 0, debugGl.RGBA, atlasSize, atlasSize, 0, debugGl.RGBA, debugGl.UNSIGNED_BYTE, null);
    }
    /** Renders the atlas texture on the debug canvas. */ render() {
        const { debugGl: debugGl, tileSize: tileSize, atlasSize: atlasSize, debugProgram: debugProgram, debugQuadBuffer: debugQuadBuffer, debugAtlasTexture: debugAtlasTexture } = this;
        debugGl.viewport(0, 0, debugGl.canvas.width, debugGl.canvas.height);
        debugGl.useProgram(debugProgram.program);
        $065afaecc735fbee$export$186607e23079b9e5(debugGl, debugProgram, debugQuadBuffer);
        $065afaecc735fbee$export$1fa517b18dd66830(debugProgram, {
            uAtlasTexture: debugAtlasTexture,
            uAtlasSize: atlasSize,
            uTileSize: [
                tileSize,
                tileSize
            ],
            uShowGrid: 1.0
        });
        $065afaecc735fbee$export$459017ad3380cbb9(debugGl, debugQuadBuffer);
    }
    /** Updates the debug atlas texture with new tiles */ async updateTexture(tileId, tilePath, i, j) {
        const { debugGl: debugGl, debugAtlasTexture: debugAtlasTexture, tileSize: tileSize, tileManager: tileManager } = this;
        const image = await tileManager.retrieveTile(tileId, tilePath);
        const x = i * tileSize;
        const y = j * tileSize;
        debugGl.bindTexture(debugGl.TEXTURE_2D, debugAtlasTexture);
        debugGl.texSubImage2D(debugGl.TEXTURE_2D, 0, x, y, tileSize, tileSize, debugGl.RGBA, debugGl.UNSIGNED_BYTE, image);
    }
}


const $b4e14b6b8da86996$var$fpsText = document.getElementById("fpsText");
// Debug canvas
const $b4e14b6b8da86996$var$debugCanvasContainer = document.getElementById("debugCanvasContainer");
const $b4e14b6b8da86996$var$debugCanvas = document.getElementById("debugCanvas");
const $b4e14b6b8da86996$var$debugText = document.getElementById("debugText");
const $b4e14b6b8da86996$var$debugGl = $b4e14b6b8da86996$var$debugCanvas.getContext("webgl2");
if (!$b4e14b6b8da86996$var$debugGl.getExtension('EXT_color_buffer_float')) console.error('EXT_color_buffer_float is not supported.');
// if (!debugGl.getExtension('OES_texture_float_linear')) {
//     console.error('OES_texture_float_linear is not supported.');
// }
$b4e14b6b8da86996$var$debugCanvas.width = 512;
$b4e14b6b8da86996$var$debugCanvas.height = 512;
// Main canvas
const $b4e14b6b8da86996$var$canvas = document.getElementById("canvas");
const $b4e14b6b8da86996$var$gl = $b4e14b6b8da86996$var$canvas.getContext("webgl2");
$b4e14b6b8da86996$var$gl.canvas.width = window.innerWidth;
$b4e14b6b8da86996$var$gl.canvas.height = window.innerHeight;
$b4e14b6b8da86996$var$gl.viewport(0, 0, $b4e14b6b8da86996$var$gl.canvas.width, $b4e14b6b8da86996$var$gl.canvas.height);
if (!$b4e14b6b8da86996$var$gl.getExtension('EXT_color_buffer_float')) alert('EXT_color_buffer_float is not supported.');
// if (!gl.getExtension('OES_texture_float_linear')) {
//     alert('OES_texture_float_linear is not supported.');
// }
if (!$b4e14b6b8da86996$var$gl.getExtension('EXT_texture_filter_anisotropic')) alert('EXT_texture_filter_anisotropic is not supported.');
const $b4e14b6b8da86996$var$TILE_SIZE = 1024;
const $b4e14b6b8da86996$var$QUAD_SIZE = 1024;
const $b4e14b6b8da86996$var$ATLAS_SIZE = 6144;
const $b4e14b6b8da86996$var$SVT_DEPTH = 5;
const $b4e14b6b8da86996$var$SVT_RESOLUTION = [
    $b4e14b6b8da86996$var$TILE_SIZE * 2 ** $b4e14b6b8da86996$var$SVT_DEPTH,
    $b4e14b6b8da86996$var$TILE_SIZE * 2 ** $b4e14b6b8da86996$var$SVT_DEPTH
];
const $b4e14b6b8da86996$var$camera = new (0, $238457a12dbae9c5$export$79f141de891a5fed)($b4e14b6b8da86996$var$canvas);
const $b4e14b6b8da86996$var$tileManager = new (0, $e7c30ed3aeaeed56$export$a7bc54e5e52782df)(400);
const $b4e14b6b8da86996$var$debugRenderer = new (0, $216773f8dbd13adf$export$2f674e33b9ab74ba)($b4e14b6b8da86996$var$debugGl, $b4e14b6b8da86996$var$tileManager, $b4e14b6b8da86996$var$TILE_SIZE, $b4e14b6b8da86996$var$ATLAS_SIZE);
const $b4e14b6b8da86996$var$svtManager = new (0, $2b43e43ffe2e7db0$export$b03453c3d450d2b7)($b4e14b6b8da86996$var$gl, $b4e14b6b8da86996$var$tileManager, $b4e14b6b8da86996$var$TILE_SIZE, $b4e14b6b8da86996$var$ATLAS_SIZE, $b4e14b6b8da86996$var$SVT_DEPTH);
const $b4e14b6b8da86996$var$renderer = new (0, $621f3774f67738fc$export$88530751e3977073)($b4e14b6b8da86996$var$gl, $b4e14b6b8da86996$var$QUAD_SIZE, $b4e14b6b8da86996$var$TILE_SIZE, $b4e14b6b8da86996$var$SVT_DEPTH, $b4e14b6b8da86996$var$SVT_RESOLUTION);
$b4e14b6b8da86996$var$fpsText.style.display = "block";
$b4e14b6b8da86996$var$debugText.style.display = "block";
let $b4e14b6b8da86996$var$isDebug = true;
let $b4e14b6b8da86996$var$hoveredPixel = [
    0,
    0
];
var $b4e14b6b8da86996$var$frames = 0;
var $b4e14b6b8da86996$var$startTime = performance.now();
var $b4e14b6b8da86996$var$FPSNormal = 0;
function $b4e14b6b8da86996$var$calculateFPSNormal() {
    var t = performance.now();
    var dt = t - $b4e14b6b8da86996$var$startTime;
    if (dt > 1000) {
        $b4e14b6b8da86996$var$FPSNormal = $b4e14b6b8da86996$var$frames * 1000 / dt;
        $b4e14b6b8da86996$var$frames = 0;
        $b4e14b6b8da86996$var$startTime = t;
    }
    $b4e14b6b8da86996$var$frames++;
}
function $b4e14b6b8da86996$var$draw(now) {
    // if (frames % 30 === 0) {
    const visibleTiles = $b4e14b6b8da86996$var$renderer.detectVisibleTiles($b4e14b6b8da86996$var$camera);
    for (const tileId of visibleTiles){
        const tilePath = `/tiles/${tileId}.jpg`;
        $b4e14b6b8da86996$var$svtManager.scheduleTileUpload(tileId, tilePath);
    // if (!svtManager.hasTile(tileId)) {
    //     // if (isDebug) debugRenderer.updateTexture(tileId, tilePath, layerIndex);
    // } else {
    //     svtManager.setLastAccessed(tileId, Date.now());
    // }
    }
    // }
    $b4e14b6b8da86996$var$svtManager.processUploadQueue(1);
    // if (isDebug) debugRenderer.render();
    $b4e14b6b8da86996$var$renderer.draw($b4e14b6b8da86996$var$camera, $b4e14b6b8da86996$var$svtManager, $b4e14b6b8da86996$var$isDebug, $b4e14b6b8da86996$var$hoveredPixel);
    $b4e14b6b8da86996$var$calculateFPSNormal();
    $b4e14b6b8da86996$var$fpsText.textContent = $b4e14b6b8da86996$var$FPSNormal.toFixed(1);
    requestAnimationFrame($b4e14b6b8da86996$var$draw);
}
// Event listeners
$b4e14b6b8da86996$var$canvas.addEventListener("mousedown", $b4e14b6b8da86996$var$camera.onMouseDown(()=>{}));
$b4e14b6b8da86996$var$canvas.addEventListener("wheel", $b4e14b6b8da86996$var$camera.onWheel(()=>{}));
$b4e14b6b8da86996$var$canvas.addEventListener("mousemove", (e)=>{
    const [clipX, clipY] = $b4e14b6b8da86996$var$camera.getClipSpaceMousePosition(e);
    const invMat = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).inverse($b4e14b6b8da86996$var$camera.getViewProjectionMat());
    $b4e14b6b8da86996$var$hoveredPixel = (0, $9a505479d4caa5b0$export$2e2bcd8739ae039).transformPoint(invMat, [
        clipX,
        clipY
    ]);
    $b4e14b6b8da86996$var$debugText.innerText = `[${Math.floor($b4e14b6b8da86996$var$hoveredPixel[0])}, ${Math.floor($b4e14b6b8da86996$var$hoveredPixel[1])}]`;
// draw();
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "d") {
        $b4e14b6b8da86996$var$isDebug = !$b4e14b6b8da86996$var$isDebug;
        // debugCanvasContainer.style.display = isDebug ? "block" : "none";
        $b4e14b6b8da86996$var$fpsText.style.display = $b4e14b6b8da86996$var$isDebug ? "block" : "none";
        $b4e14b6b8da86996$var$debugText.style.display = $b4e14b6b8da86996$var$isDebug ? "block" : "none";
    // draw();
    }
});
window.addEventListener("beforeunload", (e)=>{
    $b4e14b6b8da86996$var$tileManager.clearTiles() // Clear tiles from DB on window close
    ;
});
async function $b4e14b6b8da86996$var$init() {
    const level0TileId = "level0/tx_0_0";
    const tileInfo = {
        tileId: level0TileId,
        layerIndex: 0,
        lastAccessed: Date.now(),
        level: 0,
        col: 0,
        row: 0
    };
    const image = await $b4e14b6b8da86996$var$svtManager.uploadTileNow(level0TileId, `/tiles/${level0TileId}.jpg`, tileInfo);
    // svtManager.setLastAccessed(level0TileId, Infinity);
    // debugRenderer.updateTexture(level0TileId, `/tiles/${level0TileId}.png`, 0);
    requestAnimationFrame($b4e14b6b8da86996$var$draw);
}
$b4e14b6b8da86996$var$init();


//# sourceMappingURL=index.330f1561.js.map
